
[
  {
    "title": "LA BELLA ESTATE (DER SCHÖNE SOMMER)",
    "director": "Laura Luchetti",
    "country": "Italien",
    "releaseYear": 2023,
    "runtime": 111,
    "version": "OmU",
    "screeningDate": "19.03.2026",
    "readableDate": "2026-03-19",
    "screeningTime": "20:00",
    "actors": "Yile Yara Vianello, Deva Cassel, Nicolas Maupas, Alessandro Piavani, Adrien Dewitte, Cosima Centurioni u.a.",
    "subtitle": [
      "Dass die Geschichte in der Zeit des Faschismus in Italien angesiedelt ist, spielt kaum eine Rolle. Vielmehr geht es um Sexualität und ihre Befreiung, aber auch um die Begrenzung weiblicher Selbstverwirklichung:"
    ],
    "bodycopy": [
      "Eine junge Schneiderin verliebt sich in ein Aktmodell. Im Gegensatz zu ihrem Bruder ist sie auf der Suche nach einem besseren, aufregenden Leben voller Freiheiten und Grenzüberschreitungen. So nutzt sie die neue Freundschaft, um die „Muse“ verschiedener Maler zu werden. Verfilmung des ersten Romans der gleichnamigen Trilogie von Cesare Pavese."
    ],
    "image": "la bella estate.jpg"
  },
  {
    "title": "LA MAFIA NON È PIÙ QUELLA DI UNA VOLTA (DIE MAFIA IST AUCH NICHT MEHR DAS, WAS SIE MAL WAR)",
    "director": "Franco Maresco",
    "country": "Italien",
    "releaseYear": 2019,
    "runtime": 105,
    "version": "OmU",
    "screeningDate": "16.04.2026",
    "readableDate": "2026-04-16",
    "screeningTime": "20:00",
    "actors": "Letizia Battaglia, Ciccio Mira, Franco Maresco, Matteo Mannino, Cristian Mischel, Franco Zecchin, Pino Maniaci",
    "subtitle": [
      "Wenn sich die Beiden, Franco Maresco, zynisch-satirischer Beobachter der Mafia, und Letizia Battaglia, Antimafia-Fotografin, die das Bild der Mafia für die Öffentlichkeit entscheidend mitgeprägt hat, sich zusammenfinden, kann nur etwas Besonderes dabei herauskommen."
    ],
    "bodycopy": [
      "Thema dieses Dokumentarfilms ist das Verhältnis der sizilianischen Bevölkerung zur Mafia, das sie anhand der Reaktionen auf die beiden vor 25 Jahren ermordeten Antimafia-Staatsanwälte Giovanni Falcone und Paolo Borsellino untersuchen. Das Highlight des Films ist ein Antimafia-Fest, das den Ermordeten gewidmet ist. Gleichgültigkeit, offene Feindseligkeit oder absurde Ausweichmanöver zeigen die Stimmen aus dem Publikum. Damit wird das Fest zur Farce."
    ],
    "image": "la mafia non è più quella di una volta.jpg"
  },
  {
    "title": "PRIMADONNA (DAS MÄDCHEN VON MORGEN)",
    "director": "Marta Savina",
    "country": "Italien",
    "releaseYear": 2023,
    "runtime": 102,
    "version": "OmU",
    "screeningDate": "21.05.2026",
    "readableDate": "2026-05-21",
    "screeningTime": "20:00",
    "actors": "Claudia Gusmano, Fabrizio Ferracane, Francesco Colella, Manuela Ventura, Dario Aita u.a.",
    "subtitle": [
      "In den 1960er-Jahren zwingt die Logik einer patriarchal organisierten Gesellschaft ein Vergewaltigungsopfer zur Heirat des Täters – legitimiert durch die Praxis der sogenannten „Wiedergutmachungsehe“, die männliche Gewalt in soziale Ordnung überführt. Vor dem Hintergrund eines sizilianischen Dorfmilieus entfaltet der Film das Drama einer jungen Frau, die sich diesem Mechanismus widersetzt und ihren Peiniger anzeigt. Inspiriert vom historischen Fall der siebzehnjährigen Franca Viola, markiert die Erzählung einen Wendepunkt im italienischen Rechts- und Moralverständnis."
    ],
    "bodycopy": [
      "Die Protagonistin Lia, 21 Jahre alt, eigenwillig und selbstbewusst, verweigert nach anfänglichem Flirt die Beziehung zu dem Sohn eines mafiösen Großunternehmers – und wird Opfer brutaler Gewalt. Statt die „Ehre“ durch Ehe wiederherzustellen, entscheidet sie sich für den Gang vor Gericht. In klassischer Inszenierung zeichnet PRIMADONNA diesen persönlichen und juristischen Kampf nach und weitet ihn zu einer Reflexion über strukturelle Gewalt, kirchliche Einflussnahme und die Persistenz patriarchaler Normen – eine historische Fallstudie mit deutlicher Gegenwartsrelevanz."
    ],
    "image": "Primadonna.jpg"
  },
  {
    "title": "UN MONDO A PARTE (WILLKOMMEN IN DEN BERGEN)",
    "director": "Riccardo Milani",
    "country": "Italien",
    "releaseYear": 2024,
    "runtime": 113,
    "version": "OmU",
    "screeningDate": "19.02.2026",
    "readableDate": "2026-02-19",
    "screeningTime": "20:00",
    "actors": "Antonio Albanese, Virginia Raffaele, Corrado Oddi, Sergio Meogrossi, Carmelo Gentile u.a.",
    "subtitle": ["Der Grundschullehrer Michele Cortese verlasst ,Rom und bewirbt sich um seine Versetzung in das abgelegene Bergdorf Rupe in den Abruzzen. In dem kleinen Ort mit nur noch sieben Schulkindern und drei Klassenstufen – einer sogenannten „Multiklasse“ – soll er neuen Lebensmut wecken."],
    "bodycopy": ["Die resolute Kollegin Agnese steht ihm zur Seite, doch dann erreicht sie die Nachricht: Mangels Schüler droht die Schließung der Schule. Ein Wettlauf gegen die Zeit beginnt, um nicht nur die Schule, sondern auch die Zukunft der Dorfgemeinschaft zu retten.",
      "Milani verwebt Alltag, Komik und sozialen Realismus zu einem erzählerischen Gefüge, das mit leichter Hand ernste Themen berührt.", "UN MONDO A PARTE entfaltet seinen Reiz in der Spannung zwischen Tradition und Wandel, Heimat und Fremdsein. Die Kamera fangt eindrückliche Berglandschaften und atmosphärische Lichtszenen ein, in denen die Natur zum Spiegel für persönliche Entwicklungen wird. Mit Charme und Raffinesse beleuchtet der Film gesellschaftliche Herausforderungen wie Landflucht, Identität und Gemeinschaftssinn. IO SONO IN UN MONDO A PARTE ist ein Film über Ankommen, Verantwortung und die Kraft kleiner Taten in großen Lebensraumen."
    ],
    "image": "un mondo a parte.jpg"
   },
   {
    "title": "IL SOL DELL’AVVVENIRE (DAS BESTE LIEGT NOCH VOR UNS)",
    "director": "Nanni Moretti",
    "country": "Italien",
    "releaseYear": 2023,
    "runtime": 95,
    "version": "OmU",
    "screeningDate": "18.09.2025",
    "readableDate": "2025-09-18",
    "screeningTime": "20:00",
    "actors": "Nanni Moretti, Margherita Buy, Silvio Orlando, Barbora Bobulova, Mathie Amalric u.a.",
    "subtitle": ["Wer könnte ein ironischeres Porträt von Nanni Moretti zeichnen als er selbst? Mit vielen Eigenzitaten versehen schickt er sein Alter-Ego, einen Arthouse-Regisseur in der Krise, durch Rom."],
    "bodycopy": ["Gespräche mit Freunden, Dreharbeiten, die Verhandlungen mit Netflix, der Streit mit seiner an einem Mainstreamfilm arbeitenden Frau, sein Umgang mit den Kindern – vielfältig sind die Situationen und Gelegenheiten, um über Film und das Schaffen Morettis zu philosophieren und amüsant zu reflektieren. Mit einem zwinkernden Auge nimmt er sich dabei selbst nicht ganz ernst und bringt eine humoristisch-philosophische Glanzleistung, als er einen Filmset lahmlegt, um über Filmkunst mit einem Regisseur für Massenfilme zu diskutieren. Arthouse-Regisseur: Halt, was machst Du da. So geht das nicht, so hat man das ja schon tausendmal gesehen. Antwort: Was willst Du? Die Leute sind es so gewohnt, sie wollen es so sehen! Wer Moretti in seiner ironischen Art konzentriert erleben möchte, ist hier im richtigen Film."],
    "image": "ilSoldellavvenire.jpg"
  },
 {
    "title": "VERMIGLIO (VERMIGLIO)",
    "director": "Maura Delpero",
    "country": "Italien, Frankreich, Belgien",
    "releaseYear": 2024,
    "runtime": 119,
    "version": "OmU",
    "screeningDate": "18.12.2025",
    "readableDate": "2025-12-18",
    "screeningTime": "20:00",
    "actors": "Tommaso Ragno, Giuseppe De Domenico,·Roberta Rovelli,·Martina Scrinzi, Orietta Notari, Carlotta Gamba, Santiago Fondevila Sancet",
    "subtitle": ["Der Film hat neben der Kurzform des Verleihtitels auch einen Langtitel: VERMIGLIO O LA SPOSA DI MONTAGNA. Und es ist gerade der Blick aus der engen Berglandschaft in die Welt, der im Trentiner Bergdorf Vermiglio sowohl im übertragenen Sinn, als auch im realen Leben den Zusammenhalt bestimmt."],
    "bodycopy": ["Lucia, Ada und Flavia sind Schwestern und müssen sich im letzten Kriegsjahr im Heuschober verstecken, was nicht verhindert, dass Lucia von dem sizilianischen Deserteur Pietro schwanger wird. Um die Hand anhalten, Hochzeit und Kriegsende folgen kurz aufeinander und die Familie drängt Piero, zur Mutter nach Sizilien zu fahren, um ihr die frohe Botschaft seines Überlebens und der frisch geschlossenen Ehe zu überbringen. Doch Pietro wusste, warum er sich zuerst gegen die Reise gesträubt hatte. Mit seiner Abreise aber nimmt das Schicksal seinen Lauf. Wird er sein Versprechen, zurückzukehren, einhalten (können)?"],
    "image": "Vermiglio.jpg"
  },
  {
    "title": "UCCELLACCI E UCCELLINI (GROSSE VÖGEL- KLEINE VÖGEL)",
    "director": "Pier Paolo Pasolini",
    "country": "Italien",
    "releaseYear": 1965,
    "runtime": 85,
    "version": "OmU",
    "screeningDate": "20.11.2025",
    "readableDate": "2025-11-20",
    "screeningTime": "20:00",
    "actors": "Totò, Ninetto Davoli,·Femi Benussi, Rossana Di Rocco, Lena Lin Solaro u.a.",
    "subtitle": ["Vor 50 Jahren: Die Ermordung Pasolinis. Eine Gemeinschaftsveranstaltung mit der Deutsch-Italienischen Gesellschaft e.V., Düsseldorf. Vortrag von Dr. Thomas Brückner (Privatdozent) : Würdigung Pasolinis und Einführung in den Film UCCELLACCI E UCCELLINI"],
    "bodycopy": ["Pier Paolo Pasolinis Uccellacci e uccellini ist ein kraftvoller und poetischer Film, der die Zerbrechlichkeit und Schönheit der Natur sowie die komplexen Beziehungen zwischen Lebewesen erkundet. Mit seiner typischen Mischung aus sozialkritischer Tiefe und ästhetischer Raffinesse zeigt Pasolini eine Welt, in der Vögel als Symbole für Freiheit, Sehnsucht und Vergänglichkeit stehen.",
      "Ein Vater und sein Sohn gehen über eine öde Landstraße durch eine eher eintönige Landschaft. Zu ihnen gesellt sich ein philosophierender Rabe. Und im Wechsel zwischen Verbildlichung seiner Fabeln, phantastischer Realisierung der Erzählungen des Vaters sowie dessen Episoden entsteht ein nachdenklicher und dennoch unterhaltsamer Film"
    ],
    "image": "UCCELLACCI-E-UCCELLINI.jpg"
   },
   {
    "title": "PARTHENOPE (PARTHENOPE)",
    "director": "Paolo Sorrentino",
    "country": "Italien, Frankreich",
    "releaseYear": 2024,
    "runtime": 107,
    "version": "OmU",
    "screeningDate": "16.10.2025",
    "readableDate": "2025-10-16",
    "screeningTime": "20:00",
    "actors": "Celeste Dalla Porta, Dario Aita, Daniele Rienzo, Gary Oldman, Silvia Degrandi u.a.",
    "subtitle": ["Sie ist klug und ehrgeizig, attraktiv und Neapolitanerin, in den 1970er Jahren auf der seinerzeit üblichen Suche nach dem Sinn des Lebens und einem beruflichen Ziel. Diese stellt sich als holperiger heraus als erwartet. Sorrentinos Erzählung ist eine Coming-of-age-Geschichte, gemischt mit den Mythen Neapels. In ihr versucht Sorrentino seinem Gefühl und seiner Verbundenheit mit Neapel nachzugehen."],
    "bodycopy": ["Doch in vielen Punkten bleibt er an der Schönheit der Protagonistin hängen und folgt ihrer Anmut der Bewegung. Sie kann sich auch der Zuwendung der restlichen Männerwelt sicher sein. Umso schwerer fällt es ihr auf ihrem Weg ins Erwachsenenleben, Liebe und Leidenschaft zu unterscheiden und sie nutzt ihre Schönheit für das Fortkommen im Leben. Es entsteht eine Biographie, die allegorisch für den Charakter Neapels sei, meint Sorrentino. Hat er recht?"],
    "image": "Parthenope.jpg"
  },
  {
    "title": "CARO DIARIO (LIEBES TAGEBUCH…)",
    "director": "Nanni Moretti",
    "country": "Italien",
    "releaseYear": 1993,
    "runtime": 96,
    "version": "OmU",
    "screeningDate": "18.09.2025",
    "readableDate": "2025-09-18",
    "screeningTime": "20:00",
    "actors": "Nanni Moretti, Giulio Base, Carlo Mazzacurati, Jennifer Beals, Renato Carpentieri, Antonio Neiwiller u.a.",
    "subtitle": [],
    "bodycopy": ["In Form eines filmischen Tagebuchs entwickelt Nanni Moretti in drei Kapiteln sehr persönliche Gedanken über die Wechselbeziehungen von Gesellschaft und Individuum, über Kino und Fernsehen, über die kleinen und größeren \"Wunder\" des Lebens und Überlebens. Seine Vespa-Fahrt durch römische Vororte, seine Suche nach Ruhe auf den Liparischen Inseln, schließlich seine tragikomische Auseinandersetzung mit seiner Erkrankung und den ärztlichen Behandlungsversuchen gestalten sich als zeitgenössische, ebenso spielerische wie verspielte Odyssee, die geprägt ist von liebenswürdiger (Be-)Sinnlichkeit und intelligentem Witz."],
    "image": "Caro diario.jpg"
  },
  {
    "title": "L’ULTIMA NOTTE DI AMORE (DIE LETZTE NACHT IN MAILAND)",
    "director": "Andrea Di Stefano",
    "country": "Italien",
    "releaseYear": 2023,
    "runtime": 126,
    "version": "OmU",
    "screeningDate": "19.06.2025",
    "readableDate": "2025-06-19",
    "screeningTime": "20:00",
    "actors": "Pierfrancesco Favino, Linda Caridi, Antonio Gerardi, Francesco Di Leva, Martin Francisco Montero Baez u.a.",
    "subtitle": ["Ein Thriller in bester italienischer Krimitradition. Es beginnt mit einem Flug über das nächtliche Mailand und endet in der Wohnung des Polizeileutnants Amore, in der seine zweite Ehefrau Viviana gerade eine Überraschungsparty aus Anlass dessen letzten Arbeitstages organisiert. Doch Amore kann nur kurz mitfeiern, denn er wird unerwartet zu einem Unfall gerufen, der sich als Tatort mit einem toten Polizisten herausstellt. Und nichts ist mehr so, wie es beim ersten Sehen erscheint."],
    "bodycopy": ["Auslöser der Ereignisse ist ein „Gefallen“, den Amore seinem Freund und Kollegen erweist, der tief im Korruptionssumpf verwurzelt ist. Als Ersatz für einen ausgefallenen Kollegen soll er mit ihm eine Kurierfahrt machen – ein risikoarmes, rentables Geschäft – wie es scheint. Aber etwas läuft schief und es beginnt Amores ereignisreichster, sein letzter Tag."],
    "image": "Ultima notte di Amore.jpg"
  },
    {
    "title": "GLORIA! (GLORIA!)",
    "director": "Margherita Vicario",
    "country": "Italien/Schweiz",
    "releaseYear": 2024,
    "runtime": 111,
    "version": "OmU",
    "screeningDate": "15.05.2025",
    "readableDate": "2025-05-15",
    "screeningTime": "20:00",
    "actors": "Galatéa Bellugi, Carlotta Gamba, Maria Vittoria Dallastra, Sara Mafodda, Veronica Lucchesi u.a.",
    "subtitle": ["Über weibliche Rebellion und das Trennende und Vereinende der Musik. Zur Aufführung gelangen: ein Pianoforte, Quelle und Werkzeug der Rebellion, und eine Gruppe sich kratzbürstig beharkender Frauen vereinigt in der Musik zum Kampf gegen die männliche verkrustete Autorität."],
    "bodycopy": ["In einer Musikschule, die Heim für abgeschobene Bürgertöchter ist, arbeitet Teresa, eine musikalische Magd, der aber jegliches Musizieren untersagt ist. Sie entdeckt in einem Kellerraum ein verstecktes Pianoforte und bringt sich das Spielen bei. Intuitiv entwickelt sie eine musikalische Lebhaftigkeit, die sich auf die Schülerinnen überträgt und die Autorität des Kapellmeisters in seiner traditionellen Musikwelt infrage stellt. Als es darum geht, eine Musik für den Papstbesuch zu schreiben, kämpft er vergeblich mit seinem Material, während die Schülerinnen einen pompösen modernen Auftritt vorbereiten."],
    "image": "Gloria.jpg"
  },
  {
    "title": "ENNIO (ENNIO MORRICONE - DER MAESTRO)",
    "director": "Giuseppe Tornatore",
    "country": "Italien",
    "releaseYear": 2022,
    "runtime": 156,
    "version": "OmU",
    "screeningDate": "03.06.2023",
    "readableDate": "2023-06-03",
    "screeningTime": "20:00",
    "actors": "",
    "subtitle": [],
    "bodycopy": ["Giuseppe Tornatore schuf mit ENNIO ein Denkmal für Ennio Morricone, den wohl bekanntesten und erfolgreichsten Filmkomponisten des 20. Jahrhunderts. Bekannt wurde er mit SPIEL MIR DAS LIED VOM TOD auch heute noch verbinden viele seinen Namen mit den Italo-Western, für die er viele Filmmusiken geschrieben hat. In einer spannenden Szenen Folge über das Leben und Werk Morricones montiert Tornatore Interviews mit dem „Maestro“ und anderen Musikern zusammen mit Beobachtungen von Filmemachern, die mit ihm zusammengearbeitet haben.", "Glanzpunkte des Films sind bisher unbekannte Zeugnisse aus Morricones Leben, sowie Originalaufnahmen von ihm beim Arbeiten an seiner Musik und bei Konzerten. Dieses Material stammt zum Teil aus Privatarchiven, an das Tonatore nur kam, weil er mit Morricone und seiner Familie befreundet war.", "Ein Film, der nicht nur Musikfreunde begeistern wird."],
    "image": "Ennio.jpeg"
  },
 {
    "title": "GRAZIE RAGAZZI (ALLES NUR THEATER)",
    "director": "Riccardo Milani",
    "country": "Italien",
    "releaseYear": 2023,
    "runtime": 117,
    "version": "OmU",
    "screeningDate": "17.04.2025",
    "readableDate": "2025-04-17",
    "screeningTime": "20:00",
    "actors": "Antonio Albanese, Fabrizio Bentivoglio, Sonia Bergamasco, Giacomo Ferrara, Andrea Lattanzi u.a.",
    "subtitle": [],
    "bodycopy": ["Wer scheitert schon gern? Und wenn man denn auch noch zu hören bekommt, dass man keine Chance mehr habe und ein Projekt annehmen solle, das ein denkbar schlechtes Image hat – sollte man da nicht verzweifeln? Antonios Leidenschaft zur Schauspielerei ist aber zu stark, als dass er aufgeben könnte. Also nimmt er die Aufgabe an, eine Theatergruppe im Gefängnis zur Bühnenreife zu bringen.",
      "Die Begeisterung der Beteiligten lässt zu wünschen übrig, Alltagsrealitäten übertragen sich auf die Gruppendynamik. Kaum ist es Antonio gelungen, einigermaßen Interesse zu wecken, werden ihm von der Verwaltungsseite, der Politik und von seinen Kollegen Knüppel zwischen die Beine geworfen. Wird es den ersehnten Triumph geben?"
    ],
    "image": "Grazie Ragazzi.jpg"
  },
   {
    "title": "BANGLA (BANGLA)",
    "director": "Phaim Bhuiyan",
    "country": "Italien",
    "releaseYear": 2019,
    "runtime": 87,
    "version": "OmU",
    "screeningDate": "20.03.2025",
    "readableDate": "2025-03-20",
    "screeningTime": "20:00",
    "actors": "Phaim Bhuiyan, Pietro Sermonti, Carlotta Antonelli, Simone Liberati u.a.",
    "subtitle": [
      "Nicht nur Italien hat ein Migrantenproblem, sondern auch die Migranten der zweiten Generation. Der junge Muslim Phaim beschreibt es so: „Auch wenn ich etwas dunkel aussehe, ich bin Italiener, so eine Sache halb und halb, halb Italiener halb Bengali, aber 100 % Torpignattara” Torpignattara ist ein multiethnisches Viertel Roms."
    ],
    "bodycopy": [
      "Tagsüber ist er Aufseher im Museum, die Abende spielt er in einer Band.  Bei einem Auftritt lernt er Asia kennen, aufgeschlossen, lebhaft – das genaue Gegenteil von ihm. Es ist Liebe auf den ersten Blick, aber das Zusammenleben gestalte sich schwierig. Die Eltern Phaims haben eine muslimische Braut ausgeschaut und erwarten seine Zustimmung. zur Hochzeit Und dann ist da noch ein anders Problem: wie erklärt er Asia, dass ein Muslim keusch in die Ehe zu gehen hat?",
      "Originalzitat: Anche se mi vedete un po’ nero, sono Italiano, una via di mezzo, metà italiano, metà Bangla e 100% torpignattaro."
    ],

    "image": "Bangla.jpg"
  },
  {
    "title": "COMANDANTE – (DER KOMMANDANT – ENTSCHEIDUNG IM ATLANTIK)",
    "director": "Edoardo De Angelis",
    "country": "Italien/Belgien",
    "releaseYear": 2023,
    "runtime": 155,
    "version": "OmU",
    "screeningDate": "20.02.2025",
    "readableDate": "2025-02-20",
    "screeningTime": "20:00",
    "actors": "Pierfrancesco Favino, Johannes Wirix, Johan Heldenbergh, Massimiliano Rossi, Arturo Muselli, Giuseppe Brunetti, Gianluca Di Gennaro, Silvia D'Amico, Paolo Bonacelli u.a.",
    "subtitle": [
      "So einfach kann man es sich machen: „Kriegsdrama um einen autoritären Schiffskapitän, dessen Schiff und Crew für jeden Kampf vorbereitet ist.“ (Lexikon des internationalen Films)"
    ],
    "bodycopy": [
      "Der Film gehört zum Genre der U-Boot Filme: „Klaustrophobie, Gruppendynamik“, „harte Kerls“, „eingesperrt sein“ usw. neu ist hier, dass nach der Versenkung eines feindlichen Schiffes die Mannschaft nicht der See überlassen wird, sondern eine Rettung versucht wird. Wegen des autoritären Kommandanten wurde der Film in Italien auch als faschistisch bezeichnet. Ganz im Gegenteil: Er predigt Humanität und das Überwinden von Feindschaft. „Wir hätten das nicht gemacht“ sagt der feindliche Befehlshaber, „Aber wir sind Italiener“, begründet der Kommandant. Gibt es einen bissigeren Kommentar zur aktuellen Migrationspolitik Italiens?"
    ],

    "image": "Comandante.jpg"
  },
  {
    "title": "IL COLIBRÌ (DER KOLIBRI – CHRONIK EINER LIEBE)",
    "director": "Francesca Archibugi",
    "country": "Italien/Frankreich",
    "releaseYear": 2022,
    "runtime": 126,
    "version": "OmU",
    "screeningDate": "16.01.2025",
    "readableDate": "2025-01-16",
    "screeningTime": "20:00",
    "actors": "Pierfrancesco Favino, Nanni Moretti, Bérénice Bejo, Kasia Smutniak, Laura Morante u.a.",
    "subtitle": [
      "Assoziativ folgt der Film dem Leben eines Mannes, seiner unerfüllten lebenslangen Liebe, seinem nie bei sich Ankommen. Als Spielball seiner Umwelt hin- und hergeworfen entwickelt er eine erstaunliche Gelassenheit. Traumwandlerisch springt der Film durch Raum, Zeit, Situationen und Themen."
    ],
    "bodycopy": [
      "Wir begegnen Marco als kleinem und empfindlichem Kind im bürgerlichen Milieu, verfolgen seine Liebe zu Luisa, erleben seine Demütigung. Seine ältere Schwester bringt sich mit 24 Jahren um, er ist mit seinem Bruder im Streit. Dennoch wird er akademischer und praktizierende Mediziner. Seine Ehe scheitert und in der Sorge um das gemeinsame Kind findet er seine Ausgeglichenheit, aber weitere Schicksalsschläge warten. Schließlich spielt er berufsmäßig Poker. Dieses Kartenspielen ist als Fabel über Gewinn und Verlust, Erfolg und Scheitern angelegt. Trotz den überwiegend negativ klingenden Ereignissen, gelingt es Marco, eine innere Ruhe auszustrahlen, die alles Schlimme einfach abprallen lässt."
    ],

    "image": "IlColibri.jpg"
  },
  {
    "title": "SIAMO SOLO NOI (NUR WIR)",
    "director": "Marco Pejrolo",
    "country": "Italien/Deutschland",
    "releaseYear": 2023,
    "runtime": 151,
    "version": "OmU",
    "screeningDate": "19.09.2024",
    "readableDate": "2024-09-19",
    "screeningTime": "20:00",
    "actors": "Barbara Calabrese, Cristina Cozzini, Alessandra Jucca, Aida Loggiodice, Irene Rosin",
    "subtitle": [""],
    "bodycopy": [
      "Fünf alleinlebende Freundinnen haben eins gemein, jede hat eine Über-Sensibilität und trifft in jeweils anderer Variante auf eine peinliche, unreife und selbstbezogene Männerwelt, die sie fasziniert, anzieht und abstößt. Karikaturenhaft entstehen aus dieser Grundkonstellation absurd-humoristische Situationen, die der Zuschauer aus seinem Alltag kennt, seien es z.B. die Schwierigkeiten in Sachen Liebe oder die gelegentlich aufkeimende Angst vor der Einsamkeit.",
      "Das erste Mal im Italienischen Filmclub: ein Film vor seinem offiziellen Erscheinen! Aus einem Münchner Kurzfilmprojekt mit italienischen Laiendarstellern, aber einem professionellen Regisseur und Kameramann, entstand eine Komödie mit den besten Zutaten des italienischen und deutschen Humors verbunden mit einem darstellerischen Impetus, der manchen Berufsschauspieler in den Schatten stellt."
    ],

    "image": "Siamo solo noi-Nur wir.jpg"
  },

  {
    "title": "C’È ANCORA UN DOMANI (MORGEN IST AUCH NOCH EIN TAG)",
    "director": "Paola Cortellesi",
    "country": "Italien",
    "releaseYear": 2023,
    "runtime": 118,
    "version": "OmU",
    "screeningDate": "17.10.2024",
    "readableDate": "2024-10-17",
    "screeningTime": "20:00",
    "actors": "Paola Cortellesi, Valerio Mastandrea, Romana Maggiora Vergano; Emanuela Fanelli u.a.",
    "subtitle": [""],
    "bodycopy": [
      "Rekord: 19 Mal nominiert für den Davide di Donatello, Rekord: meistbesuchter Film der letzten Jahrzehnte, Rekord: größte Presseresonanz – ein solcher Film kann in dieser Rehe nicht ignoriert werden.",
      "Der Erfolg des Films dürfte eher außerfilmisch zu suchen sein. Die politische Diskussion in Italien war geprägt von Fällen des Femizids, so dass sich die Aufmerksamkeit schnell auf die häusliche Gewalt erweiterte, dem Thema dieses Films. Sie wolle auf einen schweren Missstand in unserer Gesellschaft hinweisen, sagte die Regisseurin. Das stößt auf von ihr andernorts Geäußertem: „Die Härte des Gezeigten habe ich durch Verfremdungseffekte zu mildern versucht. So bedeutet der Tanz nach den Schlägen auch so etwas wie Liebe.“ Dem ist nur schwer zu folgen und es sind nicht die einzige zum Widerspruch reizende Stelle in diesem auch unter diesem Aspekt bewegenden Film."
    ],
    "image": "un domani.jpg"
  },
  {
    "title": "LA CHIMERA (LA CHIMERA)",
    "director": "Alice Rohrwacher",
    "country": "Italien/Deutschland/Schweiz",
    "releaseYear": 2023,
    "runtime": 130,
    "version": "OmU",
    "screeningDate": "21.11.2024",
    "readableDate": "2024-11-21",
    "screeningTime": "20:00",
    "actors": "Josh O’Connor, Isabella Rossellini, Alba Rohrwacher, Carol Duarte, Vincenzo Nemolato u.a.",
    "subtitle": [""],
    "bodycopy": [
      "Nach einem Gefängnisaufenthalt kommt ein Engländer nach Hause am Tyrrhenischen Meer zurück. Er hat die Fähigkeit, archäologische Schätze zu erspüren, die sich nach dem illegalen Ausgraben rentabel verkaufen lassen. Damit ist er der Star einer Freundesgruppe, deren Solidarität aber Bruch und Rissstellen aufweist. Das Anknüpfen an seine alte Liebe ist hingegen nicht ganz so einfach.",
      "Dieser dritte Film der „tyrrhenischen Trilogie“ (neben LAZZARO FELICE und LE MERAVIGLIE) ist erneut eine Reflektion über den Einfluss der Vergangenheit auf die Gegenwart und deren Umgang mit dieser. Die handelnden Personen scheinen nicht nur im Hier und Jetzt, sondern parallel in einem magischen Ambiente zu leben und zu handeln, so dass das ganze Geschehen eine Zwei- oder Mehrdeutigkeit erhält. Traum und Imagination erhalten Wirklichkeitsstatus und die Vergangenheit wird Bestandteil der Gegenwart. Dennoch erscheint das menschliche Miteinander vom ganz normalen Alltagsleben geprägt zu sein und mäandert durch den Film."
    ],

    "image": "La chimera.jpg"
  },
  {
    "title": "IL PRIMO NATALE (ONCE UPON A TIME IN BETHLEHEM) ",
    "director": "Ficarra e Picone",
    "country": "Italien",
    "releaseYear": 2019,
    "runtime": 104,
    "version": "OmU",
    "screeningDate": "19.12.2024",
    "readableDate": "2024-12-19",
    "screeningTime": "20:00",
    "actors": "Salvatore Ficarra, Valentino Picone, Massimo Popolizio, Roberta Mattei, Giacomo Mattia u.a.",
    "subtitle": [""],
    "bodycopy": [
      "Eine Mischung aus DAS LEBEN DES BRIAN, dem französischen Film DER BESUCHER und dem Ambiente von Asterix. All dies mit deutlich italienischer Handschrift. Das Komikerduo Ficarra/Picone nutzen die Heilige Geschichte, um religiöse und gesellschaftliche Gewohnheiten „auf die Schippe zu nehmen“ und mit viel Radau und Klamauk alles durcheinander zu bringen, bis man nicht mehr weiß, wie die Ordnung einmal aussah.",
      "Ficarra als überperfektionistischer Pater Valentino und Picone als bauernschlauer, flinker Kirchendieb Salvo geraten beim Casting für ein Krippenspiel in das Jahr von Christi Geburt. In dieser fremden Kultur müssen sie sich zurechtfinden, ausgerüstet mit dem Zukunftswissen des 20. Jahrhunderts, das sich nicht immer als zuverlässig erweist, und voller Unkenntnis der Lebensgewohnheiten und Handlungsweisen der Ordnungskräfte. So bleibt es nicht aus, dass sie das Eine oder das Andere anstoßen und einführen, das wir heute als traditionell betrachten. Dabei lernt Pater Valentino, dass es hilfreicher ist, zu handeln, statt zu beten, und auf Perfektion zu bestehen. Auch Salvo beginnt seine Großspurigkeit und Ichfixierung zu verlieren. Langsam leben sie sich ein. Werden sie auch noch lernen, dass es keinen Sinn hat, im Jahre dessen Geburt die Leute nach Jesus Christus zu fragen?"
    ],
    "image": "Il primo Natale.jpg"
  },
  {
    "title": "CALCINCULO (KETTENKARUSSEL)",
    "director": "Chiara Bellosi",
    "country": "Italien",
    "releaseYear": 2022,
    "runtime": 88,
    "version": "OmU",
    "screeningDate": "18.04.2024",
    "readableDate": "2024-04-18",
    "screeningTime": "20:00",
    "actors": "Gaia Di Pietro, Andrea Carpenzano, Barbara Chichiarelli, Giandomenico Cupaiuolo u.a.",
    "subtitle": [""],
    "bodycopy": [
      "Provinz in Süditalien: die 15jährige Benedetta lebt zwischen dem Mobbing Gleichalteriger wegen ihres Übergewichts und dem weitgehenden Desinteresse der Eltern für ihre Person.",
      "Innerlich sehnt sie sich nach Liebe, und wünscht sich eine Veränderung ihrer Situation.",
      "Als ein Jahrmarkt gegenüber der Familienwohnung aufgebaut wird, lernt sie Amanda/Amando kennen. Sie/er hat kein eindeutiges Geschlecht, keine Vergangenheit und vorgeplante Zukunft, ist ohne Bindung und familiären Bezug – für Benedetta ein Traum von Freiheit.",
      "Zwischen Beiden entsteht eine fragile Beziehung, welche die Heranwachsende als Liebe missversteht, sie andererseits aber mit den positiven und negativen Seiten vermeintlicher Freiheit und Bindungslosigkeit konfrontiert.",
      "In ruhigem, fast meditativem Erzählfluss und reduzierter Bildsprache folgen präzise Beobachtungen aufeinander, die den eigentlich tristen Lebensumständen Poesie verleihen ohne den Blick auf die Realität zu verstellen."
    ],
    "image": "Calcinculo 3.jpg"
  },
  {
    "title": "RAPITO (DIE BOLOGNA-ENTFÜHRUNG - GERAUBT IM NAMEN DES PAPSTES)",
    "director": "Marco Bellocchio",
    "country": "Italien/Frankreich/Deutschland",
    "releaseYear": 2023,
    "runtime": 134,
    "version": "OmU",
    "screeningDate": "16.05.2024",
    "readableDate": "2024-05-16",
    "screeningTime": "20:00",
    "actors": "Paolo Pierobon, Barbara Ronchi,  Fabrizio Gifuni u.a.",
    "subtitle": [""],
    "bodycopy": [
      "Nach IL TRADITORE legt der inzwischen 85jährige Marco Bellocchio ein beeindruckendes Alterswerk vor: ein historischer Kostümfilm nach einer wahren Begebenheit, ein Zeitporträt, ein Thriller und eine psychologische Suche nach dem, was den Menschen prägt.",
      "RAPITO, so der italienische Titel ohne lange Umwege, sagt es: der Papst lässt aus einer jüdischen Familie gegen den wehrlosen Protest der Eltern ein angeblich getauftes Kind entführen und nach Rom bringen, um es dort christlich erziehen zu lassen.",
      "Das Kind ist intelligent und lernfähig, aber es widersetzt sich rebellisch und anarchisch den Erziehungsbemühungen der Geistlichkeit.",
      "Doch das Umfeld des Vatikans bleibt nicht ohne Wirkung."
    ],

    "image": "Rapito 4.jpg"
  },

  {
    "title": "L’OMBRA DI CARAVAGGIO (DER SCHATTEN VON CARAVAGGIO)",
    "director": "Michele Placido",
    "country": "Italien/Frankreich",
    "releaseYear": 2022,
    "runtime": 119,
    "version": "OmU",
    "screeningDate": "20.06.2024",
    "readableDate": "2024-06-20",
    "screeningTime": "20:00",
    "actors": "Riccardo Scamarcio, Louis Garrel, Isabelle Huppert, Micaela Ramazzotti u.a.",
    "subtitle": [""],
    "bodycopy": [
      "Caravaggio ist nicht nur ein gottbegnadeter Maler, sondern auch ein Raufbold, Wüstling und Rabauke, der auch Messerstechereien nicht abgeneigt ist. Orgien, sexuelle Übergriffe und Verletzungen der bürgerlichen Anstandspflichten gehören zu seinen alltäglichen Gewohnheiten. Ein Grund für den Vatikan, einen Spion auf ihn anzusetzen – Caravaggios Schatten.",
      "Michele Placido, der den Film verantwortet und selbst eine Nebenrolle spielt, gelingt es mit der Einführung des erfundenen Spions, Caravaggio aus der Sicht eines Beobachters darzustellen.",
      "Caravaggios Charakter spiegelt sich so in den Erzählungen des ausspionierten Umfeldes. Die so entstehenden Erzählungen werden durch Rückblenden illustriert.",
      "Eine ähnliche Technik hatte schon Orson Welles in seinem CITIZEN CANE angewandt, um durch einen Erzähler Abstand zur Hauptperson herzustellen und die Beobachtung des Protagonisten weniger erlebnisintensiv zu gestalten."
    ],

    "image": "L'ombra di Caravaggio 2.jpg"
  },
   {
    "title": "L’OMBRA DI CARAVAGGIO (DER SCHATTEN VON CARAVAGGIO)",
    "director": "Michele Placido",
    "country": "Italien/Frankreich",
    "releaseYear": 2022,
    "runtime": 119,
    "version": "OmU",
    "screeningDate": "20.06.2024",
    "readableDate": "2024-06-20",
    "screeningTime": "20:00",
    "actors": "Riccardo Scamarcio, Louis Garrel, Isabelle Huppert, Micaela Ramazzotti u.a.",
    "subtitle": [""],
    "bodycopy": [
      "Caravaggio ist nicht nur ein gottbegnadeter Maler, sondern auch ein Raufbold, Wüstling und Rabauke, der auch Messerstechereien nicht abgeneigt ist. Orgien, sexuelle Übergriffe und Verletzungen der bürgerlichen Anstandspflichten gehören zu seinen alltäglichen Gewohnheiten. Ein Grund für den Vatikan, einen Spion auf ihn anzusetzen – Caravaggios Schatten.",
      "Michele Placido, der den Film verantwortet und selbst eine Nebenrolle spielt, gelingt es mit der Einführung des erfundenen Spions, Caravaggio aus der Sicht eines Beobachters darzustellen.",
      "Caravaggios Charakter spiegelt sich so in den Erzählungen des ausspionierten Umfeldes. Die so entstehenden Erzählungen werden durch Rückblenden illustriert.",
      "Eine ähnliche Technik hatte schon Orson Welles in seinem CITIZEN CANE angewandt, um durch einen Erzähler Abstand zur Hauptperson herzustellen und die Beobachtung des Protagonisten weniger erlebnisintensiv zu gestalten."
    ],

    "image": "L'ombra di Caravaggio 2.jpg"
  },
  {
    "title": "COSA SARÀ (ALLES WIRD GUT)",
    "director": "Francesco Bruni",
    "country": "Italien",
    "releaseYear": 2020,
    "runtime": 101,
    "version": "OmU",
    "screeningDate": "18.01.2024",
    "readableDate": "2024-01-18",
    "screeningTime": "20:00",
    "actors": "Pierfrancesco Favino, Sofia Essaïdi, Tommaso Ragno, Francesco Di Leva, Aurora Quattrocchi u.a.",
    "subtitle": [""],
    "bodycopy": [
      "„Irgendwer muss die 5% füllen“ erwidert Bruno, als ihn die Ärztin auf die 95% Heilungschance seiner Leukämieerkrankung hinweist. Seine pessimistische Sichtweise war Ursache für den Misserfolg als Regisseur und den Abstand zu seiner Frau, sowie den Kindern. Dieses Leben ohne Erwartungen führt er auf seinen Vater zurück. Doch die von seiner optimistischen Familie getragenen Suche nach einem/r SpenderIn bringt diesbezügliche Überraschungen zu Tage."
    ],

    "image": "cosa_sara01.jpg"
  },
  {
    "title": "ATLANTIDE (ATLANTIDE)",
    "director": "Yuri Ancarani",
    "country": "Italien/Frankreich/Vereingte Staaten/Katar/Mexiko/Spanien",
    "releaseYear": 2021,
    "runtime": 100,
    "version": "OmU",
    "screeningDate": "15.02.2024",
    "readableDate": "2024-02-15",
    "screeningTime": "20:00",
    "actors": "Daniele Barison, Maila Dabalà, Bianka Berényi, Alberto Tedesco u.a.",
    "subtitle": [""],
    "bodycopy": [
      "Dieser Film hat zwar eine Handlung. Diese tritt aber zurück, um Platz zu machen für eine Sinfonie aus dem Motorengeräusch von Speedbooten, die durch Venedigs Lagunen rasen, und lauter Disco-Musik, zu der die Jungs abhängen, wenn sie mal nicht ihre Boote tunen oder Rennen fahren. Präsentiert wird dies durch ästehtisch-künstelrische Fotografie, die in ihrer Harmonie mit dem lauten minimalistischen Konzert der Geräusche in Kontrast tritt.",
      "Vordergründig erzählt wird das Leben, die Rituale der Männlichkeit und die Leidenschaft für schnelle Boote von Jugendlichen im Hinterland Venedigs, das man selbst kaum zu Gesicht bekommt."
    ],

    "image": "ATLANTIDE.jpg"
  },

  {
    "title": "ARIAFERMA (ARIAFERMA)",
    "director": "Leonardo Di Costanzo",
    "country": "Italien/Schweiz",
    "releaseYear": 2021,
    "runtime": 117,
    "version": "OmU",
    "screeningDate": "21.03.2024",
    "readableDate": "2024-03-21",
    "screeningTime": "20:00",
    "actors": "Daniele Barison, Maila Dabalà, Bianka Berényi, Alberto Tedesco u.a.",
    "subtitle": [""],
    "bodycopy": [
      "„Draußen könnten wir vielleicht Freunde sein. Hier bist Du der Verbrecher und ich habe auf Dich aufzupassen. Du bist mein Job!“ sagt sinngemäß einer der Protagonisten. Zwischen dem Häftling und seinem Bewacher hatte kurz so etwas wie Sympathie oder Verständnis aufgeleuchtet. Aber Beziehungen im Gefängnis wandeln und behaupten sich, werden aber immer wieder auf die Grundkonstellation zurückgeführt.",
      "Bei der Organisation der Räumung unberücksichtigt, bleiben 12 Gefangene in einem baufälligen Gefängnis mit einer Handvoll Wärtern ohne Infrastruktur (Küche, Krankenstation, technischer Dienst usw.) zurück. Ein Ende ist nicht abzusehen.",
      "Eine eigenartige Gruppendynamik greift um sich, Spannungen zwischen den Gefangenen und alte Konflikte bei den Wärtern brechen auf. Es entstehen aber auch Allianzen zwischen den einzelnen Menschen, die ohne die Enge nicht möglich wären.",
      "Eine interessante psychologische Studie und ein spannender Film."
    ],

    "image": "ARIAFERMA.jpg"
  },

  {
    "title": "NOSTALGIA (NOSTALGIA)",
    "director": "Mario Martone",
    "country": "Italien",
    "releaseYear": 2022,
    "runtime": 118,
    "version": "OmU",
    "screeningDate": "21.12.2023",
    "readableDate": "2023-12-21",
    "screeningTime": "20:00",
    "actors": "Pierfrancesco Favino, Sofia Essaïdi, Tommaso Ragno, Francesco Di Leva, Aurora Quattrocchi u.a.",
    "subtitle": [
      "Martone hat einen Film über die Macht der Erinnerung vorgelegt und gleichzeitig ein Porträt des lebendigen und zum Teil tristen Neapels unter der Camorra geschaffen. Im Labyrinth der Straßen wie auch in den Beziehungen der Menschen untereinander mäandert die Erzählung, Beobachtungen links und rechts des Weges mit nehmend einem tragischen Ende entgegen."
    ],
    "bodycopy": [
      "Felice ist in jungen Jahren von Neapel nach Kairo ausgewandert und zu einem ansehnlichen Vermögen gekommen. Nun kehrt er zurück in seiner Heimatstadt, um sich um die letzte Lebenszeit seiner Mutter zu kümmern. Sie findet er aber nicht mehr in ihrer Wohnung, sondern in einem Verschlag im Keller. Er versorgt sie und besorgt eine lichtdurchflutete für neapolitanische Verhältnisse luxuriöse Wohnung.",
      "Nebenbei besucht er Orte seiner Kindheit und Jugend, schwelgt in Erinnerungen und besorgt sich ein Motorrad, wie er es früher hatte, um die „alten Touren“ nachzufahren. Alles scheint wie früher zu sein.",
      "Vagabundierende, um sich schießende Jugendliche in der Nacht deuten jedoch darauf hin, dass sich etwas geändert hat. Felice erfährt, dass sein Freund aus der Jugend Mafiaboss in Neapel geworden ist und obwohl er gewarnt wird, will er ihn finden. Doch es mehren sich die Zeichen, dass man ihn hier nicht haben will, nicht zuletzt, weil er sich in der Gemeinde mit der Antimafiainitiative engagiert.",
      "Naiv zwischen den Welten agierend streift der Protagonist Ereignisse und Orte Neapels, die ein Bild der Stadt und ihrer Menschen jenseits allen Tourismus vermitteln."
    ],

    "image": "Nostalgia.jpg"
  },
  {
    "title": "L’IMMENSITÀ (MEINE FANTASTISCHE MUTTER)",
    "director": "Emanuele Crialese",
    "country": "Italien/Frankreich",
    "releaseYear": 2022,
    "runtime": 99,
    "version": "OmU",
    "screeningDate": "16.11.2023",
    "readableDate": "2023-11-16",
    "screeningTime": "20:00",
    "actors": "Penélope Cruz, Vincenzo Amato, Luana Giuliani, Elena Arvigo, Maria Chiara Goretti u.a.",
    "subtitle": [
      "Ist der Junge mit den femininen Zügen nicht in Wirklichkeit ein Mädchen? Bevor jedoch ein Film über Geschlechtsidentität beginnt, wechselt das Thema: Kinder wollen verbotenerweise ein Maisfeld durchqueren, um ein Nomadenlager zu erreichen. Der Vater wird toben, als er von der Verbotsübertretung erfährt und die Mutter wird sie schützen. Dafür nimmt sie auch die Prügel des Mannes ohne Gegenwehr hin. Die Kinder sind das Einzige, was ihr geblieben ist: vom Mann betrogen, im mittelständischen Wohlstand mit seiner bürgerlichen Enge lebend, empfindet sie die Leere ihres Hausfrauendaseins."
    ],
    "bodycopy": [
      "Luana Giuliani gibt ihr Schauspieldebüt als Adriana, einem Mädchen, das lieber ein Junge sein möchte. Ihre Rolle spielt sie auf Augenhöhe mit Penelope Cruz als Mutter in der Sackgasse ihrer persönlichen Entwicklung.",
      "Adriana erkennt in ihrer Mutter die Grenzen der Weiblichkeit in einer männlich geprägten Gesellschaft und es ist Adriana, die dazwischen geht als der Vater gewalttätig auf die Mutter losgeht. Die Familie ist für ihn Verfügungsmasse und Blitzableiter, schließlich hat sie ich seinen Vorstellungen zu beugen.",
      "Nach und nach blättert Crialese das Bild einer Familie der 70er Jahre in Italien auf und jongliert gekonnt mit den unterschiedlichsten Aspekten und Erzählsträngen. Gestützt durch die schauspielerische Leistung seiner Protagonistinnen ist ihm ein beeindruckendes Zeitportrait gelungen."
    ],

    "image": "Limmensita.jpg"
  },
  {
    "title": "L’IMMENSITÀ (MEINE FANTASTISCHE MUTTER)",
    "director": "Emanuele Crialese",
    "country": "Italien/Frankreich",
    "releaseYear": 2022,
    "runtime": 99,
    "version": "OmU",
    "screeningDate": "16.11.2023",
    "readableDate": "2023-11-16",
    "screeningTime": "20:00",
    "actors": "Penélope Cruz, Vincenzo Amato, Luana Giuliani, Elena Arvigo, Maria Chiara Goretti u.a.",
    "subtitle": [
      "Ist der Junge mit den femininen Zügen nicht in Wirklichkeit ein Mädchen? Bevor jedoch ein Film über Geschlechtsidentität beginnt, wechselt das Thema: Kinder wollen verbotenerweise ein Maisfeld durchqueren, um ein Nomadenlager zu erreichen. Der Vater wird toben, als er von der Verbotsübertretung erfährt und die Mutter wird sie schützen. Dafür nimmt sie auch die Prügel des Mannes ohne Gegenwehr hin. Die Kinder sind das Einzige, was ihr geblieben ist: vom Mann betrogen, im mittelständischen Wohlstand mit seiner bürgerlichen Enge lebend, empfindet sie die Leere ihres Hausfrauendaseins."
    ],
    "bodycopy": [
      "Luana Giuliani gibt ihr Schauspieldebüt als Adriana, einem Mädchen, das lieber ein Junge sein möchte. Ihre Rolle spielt sie auf Augenhöhe mit Penelope Cruz als Mutter in der Sackgasse ihrer persönlichen Entwicklung.",
      "Adriana erkennt in ihrer Mutter die Grenzen der Weiblichkeit in einer männlich geprägten Gesellschaft und es ist Adriana, die dazwischen geht als der Vater gewalttätig auf die Mutter losgeht. Die Familie ist für ihn Verfügungsmasse und Blitzableiter, schließlich hat sie ich seinen Vorstellungen zu beugen.",
      "Nach und nach blättert Crialese das Bild einer Familie der 70er Jahre in Italien auf und jongliert gekonnt mit den unterschiedlichsten Aspekten und Erzählsträngen. Gestützt durch die schauspielerische Leistung seiner Protagonistinnen ist ihm ein beeindruckendes Zeitportrait gelungen."
    ],

    "image": "Limmensita.jpg"
  },
  {
    "title": "WELCOME VENICE",
    "director": "Andrea Segre",
    "country": "Italien",
    "releaseYear": 2021,
    "runtime": 103,
    "version": "OmU",
    "screeningDate": "19.10.2023",
    "readableDate": "2023-10-19",
    "screeningTime": "20:00",
    "actors": "Paolo Pierobron , Andrea Pennacchi, Anna Bellato, Giuliana Musso, Sara Lazzaro, Roberto Citran u.a.",
    "bodycopy": [
      "Beim Stichwort Venedig fallen einem/r selten Strandkrabben ein, sondern eher Touristenströme, die zur Vertreibung der Einheimischen führen.",
      "Die Brüder Pietro und Alvise müssen sich mit beidem auseinandersetzen. Sie sind Krabbenfischer in der Lagune von Venedig. Pietro möchte dies trotz zunehmender Schwierigkeiten bleiben, während Alvise gerne Kapital aus dem Elternhaus schlagen möchte, um ins lukrativere Immobiliengeschäft umzusteigen. Er nimmt Kontakt mit Immobilienhaien auf, die die Stadt dominieren, und setzt die ganze Familie diesem Konflikt aus.",
      "WELCOME VENICE zeigt authentisch ein vor den Touristen verborgenes Venedig, wie man es sonst nie zu sehen bekommt. Dieses Venedig befindet sich an einem Wendepunkt, da viele Einheimische sich entscheiden müssen, wie ihr Leben weitergehen soll: wollen sie weiter in der Lagunenstadt wohnen, in meist bescheidenen Häusern oder diese teuer an Touristen verkaufen und mit dem relativ großen Vermögen im Wohlstand andernorts? Für den Abschluss des Films hat Segre ein fulminantes und unvergessliches Filmbild geschaffen.",
      "Von Andrea Segre zeigte der Italienische Filmclub 2014 dessen Film IO SONO LI (VENEZIANISCHE FREUNDSCHAFT)."
    ],
    "image": "welcome_venice.jpg"
  },
  {
    "title": "IO STO BENE (WAS AM ENDE BLEIBT)",
    "director": "Donato Rotunno",
    "country": "Belgien/Deutschland/Italien/Luxemburg",
    "releaseYear": 2020,
    "runtime": 94,
    "version": "OmU",
    "screeningDate": "21.09.2023",
    "readableDate": "2023-09-21",
    "screeningTime": "20:00",
    "actors": "Renato Carpentieri,·Sara Serraiocco, Alessio Lapice, Marie Jung, Vittorio Nastri u.a.",
    "subtitle": [
      "Es gibt seltene Tage, an denen man anders aus dem Leben herauskommt, als man morgens in ihn hineingegangen ist. So geht es auch Antonio und Mary, die sich zufällig kennen lernen, Vertrauen zueinander entwickeln und von ihren jeweiligen Erfahrungen entscheidende Impulse für ihr Leben bekommen."
    ],
    "bodycopy": [
      "Mary ist eine orientierungslose Künstlerin, Antonio ein alter Mann, der mit dem Leben hadert und über den Tod seiner Frau nicht hinwegkommt. In Rückblenden erzählt der Film von den Dingen, die den beiden im Leben wichtig sind und die sie geprägt haben. Langsam entdecken sie Schnittstellen und stellen fest, dass sie zwar zwei Generationen trennt, aber viele Probleme nur ein anderes Gewand haben."
    ],
    "image": "Io sto bene.jpg"
  },
  {
    "title": "BAARÌA (BAARIA) ",
    "director": "Giuseppe Tornatore",
    "country": "Italien",
    "releaseYear": 2009,
    "runtime": 151,
    "version": "OmU",
    "screeningDate": "15.06.2023",
    "readableDate": "2023-06-15",
    "screeningTime": "20:00",
    "actors": "Francesco Scianna, Margareth Madè, Nicole Grimaudo, Angela Molina, Gaetano Aronica, Alfio Sorbello, Enrico Lo Verso, Nino Frassica, Laura Chiatti, Michele Placido, Giorgio Faletti Corteccia u.a.",
    "subtitle": [
      "Wir zeigen den Film begleitend zum Morricone-Schwerpunkt in der Black Box."
    ],
    "bodycopy": [
      "In einem Interview vom 03.10.2011 äußerte Ennio Morricone auf die Frage, mit welchem Regisseur er gegenwärtig am liebsten zusammenarbeite: Giuseppe Tornatore. Und in der Tat verbindet die Beiden eine jahrzehntelange konstruktive Zusammenarbeit, die es in dieser Intensität in Morricones Leben wohl nur noch mit Sergio Leone gegeben hat. „Ich mag es, wenn Regisseure loslassen können und den Fluss des Filmes passagenweise der Musik überlassen. Nur wenige haben den Mut dazu.“",
      "Im Mittelpunkt des Films steht Bagheria, ein kleiner Ort in der Nähe von Palermo, in dem das Leben dreier Generationen ausgebreitet wird. Nebenbei entsteht so ein Bild der italienischen Geschichte von unten: Faschismus, Zweiter Weltkrieg, italienischer Kommunismus, aber auch des gesellschaftlichen Wandels der Nachkriegszeit, Mafia inklusive. Fast zu viel für einen Film. Gut, dass Morricones Filmmusik sortiert, kommentiert, strukturiert und stützt.",
      "BAARÌA war der erste italienische Film seit 18 Jahren, der das renommierte Filmfest in Venedig eröffnen durfte."
    ],
    "image": "Baaria.jpg"
  },
  {
    "title": "LE OTTO MONTAGNE (ACHT BERGE)",
    "director": "Felix van Groeningen, Charlotte Vandermeersch",
    "country": "Italien/Belgien/Frankreich",
    "releaseYear": 2022,
    "runtime": 148,
    "version": "OmU",
    "screeningDate": "18.05.2023",
    "readableDate": "2023-05-18",
    "screeningTime": "20:00",
    "actors": "Alessandro Borghi, Luca Marinelli, Filippo Timi, Elena Lietti, Gualtiero Burzi u.a.",
    "subtitle": [
      "Die acht Berge kommen erst relativ spät im Film vor: Angetrunken albern Bruno und Pietro über ein Gleichnis, dass dieser aus Nepal mitgebracht hat: die Welt sei ein Kreis, umgeben von acht Bergen und in der Mitte sei ein großer Berg. Wer denn nun mehr von der Welt wüsste, lautet die Frage: derjenige, der die acht Berge bereist hat oder der Andere, der auf seinem Berg in der Mitte auf die Welt herabgeblickt hat. Erst später begreifen die beiden, dass sie es sind, von denen das Gleichnis spricht."
    ],
    "bodycopy": [
      "Als Kind kommt Pietro mit seinen Eltern aus Turin in ein Dorf in den Bergen in Urlaub und freundet sich mit Bruno, dem einzigen Kind am Ort, an. Auch die Eltern mögen Bruno und wollen ihn aufnehmen, damit er in der Stadt zur Schule gehen und eine Chance haben solle. Dessen Vater aber ist dagegen und nimmt ihn als Wanderarbeiter am Bau mit. Pietro kommt erst nach dem Tod seines Vaters in das Dorf zurück und wird von Bruno zu seinem Erbe in den Bergen gebracht: ein verfallenes Haus, das er versprochen hatte, für Pietros Vater wieder aufzubauen. Zusammen packen sie jetzt diese Aufgabe an und ihre alte Freundschaft belebt sich wieder.",
      "Aber ihre Lebenskonzepte unterscheiden sich zu sehr. So versucht Bruno mit einer Almkäserei sein Glück und Pietro findet seine große Liebe in Nepal. Dennoch drängt es ihn immer wieder zurück zu Bruno und zwischen den beiden entwickelt sich eine Vertrautheit, die einem jeweiligen Miterleben des anderen Schicksals gleichkommt. Materiell scheitern beide am Aufbau eines Lebenskonzepts, aber die tiefe Freundschaft ist ihnen Erfüllung genug – bis das Schicksal zuschlägt."
    ],
    "image": "otto montagne.png"
  },
  {
    "title": "COME UN GATTO IN TANGENZIALE (WIE EINE KATZE AUF DER STADTAUTOBAHN)",
    "director": "Riccardo Milani",
    "country": "Italien",
    "releaseYear": 2020,
    "runtime": 98,
    "version": "OmU",
    "screeningDate": "20.04.2023",
    "readableDate": "2023-04-20",
    "screeningTime": "20:00",
    "actors": "Paola Cortellesi, Antonio Albanese, Sonia Bergamasco, Luca Angeletti, Antonio D’Ausilio u.a.",
    "subtitle": [
      "Wissen Politiker eigentlich, was sie tun und für wen? Giovanni ist von seiner politischen Arbeit überzeugt. Er leitet einen „Think tank“, der für die EU eine Studie über die sozial problematischen Vororte Roms erarbeiten und Maßnahmen vorschlagen soll. Nichts davon versteht Monica, die dort lebt und täglich vielschichtige Probleme zu lösen hat. Der Film lässt die beiden unvereinbaren Charaktere aufeinandertreffen und weiß trefflich humoristische Funken aus der Begegnung zu schlagen. Vom nahe an den Klamauk gehendem Spaß bis zum kabarettistisch-geistreichen Witz wird die Skala des Humors ausgelotet und auf leichte Art ein durchaus ernsthaftes Thema reflektiert."
    ],
    "bodycopy": [
      "Giovannis Welt ist in Ordnung und er legt viel Wert darauf, dass das so bleibt. Daher unterhält er eine freundschaftliche Beziehung zu seiner von ihm geschiedenen Frau und versucht seine Tochter zu verstehen. Als diese mit Alessio aus dem berüchtigten Stadtteil Bastogi, eine feste Freundschaft eingeht, folgt er ihnen besorgt und trifft auf Monica mit ihrem vulkanartigen Temperament, der Mutter des Jungen. Beide Eltern sind von der klassenübergreifenden Freundschaft nicht begeistert, wenn auch aus unterschiedlichen Gründen. Sie verbünden sich aber, um den Kindern ihre Idee auszureden. Als das nicht gelingt, suchen auch die unterschiedlich sozialisierten Familien Kontakt zueinander und lernen, dass gleiche Worte sehr unterschiedliche Bedeutungen haben können: Freizeit, Entspannung, Einladung zum Essen, Solidarität usw. Zwei Lebenswelten beginnen sich zu durchdringen und es entsteht eine <<Reibung>>, aus der die humoristischen Funken des Filmes schlagen."
    ],
    "image": "come un gatto.jpg"
  },
  {
    "title": "A CHIARA (CHIARA)",
    "director": "Jonas Carpignano",
    "country": "Italien/Frankreich",
    "releaseYear": 2021,
    "runtime": 122,
    "version": "OmU",

    "screeningDate": "16.03.2023",
    "readableDate": "2023-03-16",
    "screeningTime": "20:00",
    "actors": "Swamy Rotolo, Claudio Rotolo, Grecia Rotolo, Antonio Rotolo Uno, Koudous Seihon u.a.",
    "subtitle": [
      "",
      "Wie fühlt sich eine 15jährige Jugendliche, wenn deren Vater nach ihrer festlichen Geburtstagsfeier aus dem Haus verschwindet, Personen hektisch ums nächtliche Haus laufen, die Polizei sich bemerkbar macht, das Familienauto explodiert und andere merkwürdige Dinge passieren: ist ihr Vater in N‘drangheta-Verbindungen verstrickt? Von der Mutter gibt es keine Erklärungen. Kurz darauf erschient ein Fahndungsaufruf nach dem Vater im Fernsehen. Jetzt fordert Chiara Aufklärung, sie will die ganze Wahrheit wissen. Schnell erkennt sie, dass sie diese selbst ermitteln muss. Dabei rennt sie gegen eine Mauer des Schweigens an und familiäre und freundschaftliche Bindungen bekommen auf einmal eine andere Bedeutung."
    ],
    "bodycopy": [
      "Capignano thematisiert die Strukturen und Handlungen der mafiaähnlichen Organisationen, aus dem selten betrachteten Blickwinkel der familiären Bindungen. Aus der Perspektive der 15jährigen Chiara verliert der Zuschauer mit ihr seine Unbedarftheit und erkennt mit der Zeit die von den Tätern und Beteiligten nicht oder zu spät erkannten Folgen ihrer Taten für die ihnen nahestehenden Personen. Gerade der eingeengte Blick Chiaras auf das Geschehen ermöglicht dem Zuschauer eine intensivere und erweiterte Erkenntnis.",
      ""
    ],
    "image": "a chiara.jpg"
  },
  {
    "title": "A CASA TUTTI BENE (ZU HAUSE IST ES AM SCHÖNSTEN)",
    "director": "Gabriele Muccino",
    "country": "Italien",
    "releaseYear": 2018,
    "runtime": 105,
    "version": "OmU",
    "screeningDate": "16.12.2021",
    "readableDate": "2021-12-16",
    "screeningTime": "20:00",
    "actors": "Stefania Sandrelli, Carolina Crescentini, Stefano Accorsi, Gianmarco Tognazzi, Sandra Milo u.a.",
    "subtitle": [
      "Familientreffen sind im Film häufig geprägt durch gestörte Beziehungen, Heuchelei und verdrängte Konflikte. Nicht anders bei Gabriele Muccino. Nur dass er eine vielköpfige Familie durch eine Sturmflut auf der Insel Ischia festsetzt. Das bringt nicht nur die Pläne jedes Einzelnen durcheinander, sondern schafft breiten Raum, die verschiedenen Personen zu charakterisieren und die Verhältnisse zwischen ihnen auszuloten. Es entstehen vielzählige Handlungsstränge, die in einer dramaturgisch virtuosen Weise aneinander vorbei oder sich kreuzend und verknüpfend choreographiert werden."
    ],
    "bodycopy": [
      "Alba (Stefania Sandrelli) und Pietro (Ivano Marescotti) wollen Goldene Hochzeit feiern und laden die komplette Familie ein. Doch in ihrer Vorfreude haben sie das Temperament ihrer Familie unterschätzt: da gibt es die auf die Ex ihres Mannes eifersüchtige Ehefrau, sowie den nur an seine Geliebte in Paris denkenden und die Flirtversuche seiner  Frau nicht bemerkenden Ehemann, weiterhin den schüchternen Schwiegersohn, der eine Romanze mit seiner Cousine beginnt und viele andere. Sie sind verbunden in Liebe und Sympathie, Eifersucht und Neid, Sehnsüchten und Träumen - auch ein Seitensprung steht auf dem Programm. Ein Labyrinth der Leidenschaften in paradiesischem Ambiente."
    ],
    "image": "a-casa-tutti-bene.jpg"
  },
  {
    "title": "A CIASCUNO IL SUO (ZWEI SÄRGE AUF BESTELLUNG)",
    "director": "Elio Petri",
    "country": "Italien",
    "releaseYear": 1967,
    "runtime": 99,
    "version": "OmitU",
    "screeningDate": "02.06.2010",
    "readableDate": "2010-06-02",
    "screeningTime": "20:00",
    "actors": "Gian Maria Volonté, Irene Papas, Gabriele Ferzetti, Salvo Randone, Luigi Pistillim, Laura Nucci",
    "subtitle": [""],
    "bodycopy": [
      "Elio Petris freie Umsetzung des Romans von Leonardo Sciascia: Nachdem bei einer Jagd zwei Männer erschossen werden, versucht der Gymnasiallehrer Laurana (GianMaria Volontè) den sonderbaren Verwicklungen des Falles nachzugehen. Sexuelle Tabus, kriminelle Verwicklungen und politische Machenschaften treffen aufeinander."
    ],
    "image": "a-ciascuno-il-suo.jpg"
  },
  {
    "title": "A.C.A.B. - ALL COPS ARE BASTARDS (A.C.A.B. - ALL COPS ARE BASTARDS)",
    "director": "Stefano Sollima",
    "country": "Italien/Frankreich",
    "releaseYear": 2012,
    "runtime": 110,
    "version": "OmU",
    "screeningDate": "20.09.2018",
    "readableDate": "2018-09-20",
    "screeningTime": "20:00",
    "actors": "Pierfrancesco Favino, Filippo Nigro, Marco Giallini, Eugenio Mastrandrea, Domenico Diele, Andrea Sartoretti, Roberta Spagnuolo",
    "subtitle": [
      "Wie fühlt man sich als Polizist, wenn ihm eine erregte Horde von Skinheads, linke Ultras oder alkoholisierte Fußballhooligans „All Cops are Bastards“ („Alle Bullen sind Bastards“) entgegenrufen und es gilt, die Ordnung aufrecht zu erhalten? Man ist angewiesen auf die Unterstützung der Kollegen und dies solidarisiert – eine nicht nur berufliche Bindung, die auch Mal aus dem Ruder laufen kann."
    ],
    "bodycopy": [
      "Cobra, Nero und Mazinga sind Mitglieder einer italienischen Spezialeinheit und vertreten die Staatsgewalt bei Massenausschreitungen jeglicher Art. Dabei sind sie nicht zimperlich und auch Unbeteiligte bekommen gelegentlich den Schlagstock zu spüren. Es ist eine Welt aus Hass, Gewalt und Gegengewalt entstanden, die auch das Privatleben prägt. Auf der anderen Seite steht ein intensives persönliches Verstehen und Vertauen, eine abgeschottete Welt mit eigener Dynamik, die verbissen gegen Vorgesetzte und Außenstehende verteidigt wird. In diese Welt wird ein junger Rekrut versetzt, wodurch die gewohnten Strukturen auf den Prüfstand gestellt werden.",
      "Stefano Sollima, Sohn des Italowestern- und Kriminalfilmregisseur Sergio Sollima, lässt in diesem Film das Entstehen von Gewalt und Gegengewalt, blindem und verursachtem Hass, aber auch Solidarität und Freundschaft erlebbar werden und bedient sich den Elementen einer Bildersprache, die er einige Jahre später in SUBURRA zur vorläufigen Reife entwickelt hat."
    ],
    "image": "acab.jpg"
  },
  {
    "title": "Accattone (Wer nie sein Brot mit Tränen aß)",
    "director": "Pier Paolo Pasolini",
    "country": "Italien",
    "releaseYear": 1961,
    "runtime": 116,
    "version": "OmU",
    "screeningDate": "04.02.2011",
    "readableDate": "2011-02-04",
    "screeningTime": "20:00",
    "actors": "Franco Citti, Franca Pasut, Silvana Corsini, Adele Cmbria, Paola Guidi, Adriana Asti",
    "subtitle": [""],
    "bodycopy": [
      "Mit ACCATONE beschreibt Pasolini die Welt erstmals mit und in der Sprache des Films. Dabei verwandelt er die Episodenstruktur des Neorealismus in die hermetische Geschlossenheit der Tragödie. Die Fabel des kleinen römischen Zuhälters Accatone wird als Passionsgeschichte mit den Mitteln des Kinos der Poesie erzählt."
    ],
    "image": "accattone.jpg"
  },
  {
    "title": "Agata e la tempesta (Agatha und der Sturm)",
    "director": "Silvio Soldini",
    "country": "Italien",
    "releaseYear": 2004,
    "runtime": 118,
    "version": "OmU",
    "screeningDate": "15.09.2005",
    "readableDate": "2005-09-15",
    "screeningTime": "19:30",
    "actors": "Licia Maglietta, Giuseppe Battiston, Silvana Bosi, Emilio Soffrizzi, Marina Massironi, Claudio Santamaria, Gisela Volodi, Ann Eleonora Jargensen, Remo Remotti, Monica Nappo, Carlo Luca De Ruggieri",
    "subtitle": [""],
    "bodycopy": [
      "Nach „Brot und Tulpen“ hat Soldini eine neue Komödie mit Licia Maglietta in der Hauptrolle gedreht. Als dynamische Buchhändlerin Agata platzt sie vor Energie und mit ihr die elektrischen Lampen. Drunter und drüber geht es, als sie sich in einen 13 Jahre jüngeren Mann verliebt und ihr Bruder Gustav erfährt, dass er als Kind adoptiert und seine wirkliche Mutter ihn quasi „verkauft“ hat. So lernen beide den verträumten Schürzenjäger Romeo kennen, der sich als dessen Bruder entpuppt. Eine Konstellation, in der Lebenskonzepte aus der Bahn geraten, aber auch die Erfüllung verdrängter Wünsche auf einmal möglich erscheint."
    ],
    "image": "agata.jpg"
  },
  {
    "title": "Agostino d’Ippona",
    "director": "Roberto Rossellini",
    "country": "Italien",
    "releaseYear": 1972,
    "runtime": 117,
    "version": "OmitU",
    "screeningDate": "06.06.2007",
    "readableDate": "2007-06-06",
    "screeningTime": "19:00",
    "actors": "Dary Berkani, Virginio Gazzolo, Cesare Barbetti, Bruno Cattaneo, Leonardo Fioravanti",
    "subtitle": ["Werkschau: Roberto Rossellini"],
    "bodycopy": [
      "Der heilige Augustus war 395-430 Bischof von Hippo im heutigen Algerien. Es ist dieDer heilige Augustus war 395-430 BDarsischof von Hippo im heutigen Algerien. Es ist dieZeit des Übergangs. 410 war es zum „Sacco di Roma“ gekommen und das RömischeReich trudelte seinem Untergang entgegen. 431, ein Jahr nach Augustus Tod, eroberndie Vandalen Hippo und errichten eine hundertjährige Herrschaft. Rossellini nutztdiesen historischen Hintergrund und thematisiert die Rolle der Religion und ihrerVertreter im politischen Kontext."
    ],
    "image": "agostinodippona.png"
  },
  {
    "title": "Alla luce del sole",
    "director": "Roberto Faenza",
    "country": "Italien",
    "releaseYear": 2005,
    "runtime": 90,
    "version": "OmitU",
    "screeningDate": "01.04.2009",
    "readableDate": "2009-04-01",
    "screeningTime": "20:00",
    "actors": "Luca Zingaretti, Alessia Goria, Corrado Fortuna, Giovanna Bozzolo, Francesco Foti, Piero Nicosia",
    "subtitle": ["Werkschau: Roberto Faenza"],
    "bodycopy": [
      "Als Giuseppe Puglisi 1990 eine Pfarrei in Palermo übernimmt, widmet er sich den verwahrlosten Kindern. 2 Jahre lang baut er ein Gemeindezentrum auf und holt immer mehr Kinder von der Straße. Sein Kampf um das Wichtigste, wie der Kanalanschluss und die Gesundheitsvorsorge für die Schule bringt ihn in Konflikt mit der Mafia. Im Umfeld der Morde an Falcone und Borsellino kommt es zur entscheidenden Auseinandersetzung. Faenza drehte den Film nach authentischem Archivmaterial."
    ],
    "image": "alla-luce-del-sole.jpg"
  },
  {
    "title": "Allonsanfan (Allonsanfan)",
    "director": "Paolo e Vittorio Taviani",
    "country": "Italien",
    "releaseYear": 1974,
    "runtime": 106,
    "version": "OmitU",
    "screeningDate": "06.04.2011",
    "readableDate": "2011-04-06",
    "screeningTime": "20:00",
    "actors": "Marcello Mastroianni, Lea Massari, Mimsy Farmer, Claudio Cassinelli, Laura Betti, Benjamin Lev, Bruno Cirino, Stanko Molnar, Luisa De Santis, Biagio Pelligra, Renato De Carmine, Michael Berger",
    "subtitle": [""],
    "bodycopy": [
      "Die Jahre der Restauration. Der adlige Fulvio wurde als Revolutionär wegen einesangeblichen Verrats eingekerkert. Nach seiner Entlassung sehnt er sich nachzurückgezogener Ruhezeit in der Villa der Familie zusammen mit seiner Geliebten. Während er von der Flucht nach Amerika träumt, will sie ihn zusammen mit den Exkämpfern zum Aufbruch nach Süditalien drängen. So beginnen sich die Ereignisse zu überschlagen und Fulvios Unfähigkeit, sich zu entscheiden, endet in einer Tragödie."
    ],
    "image": "allonsanfan.jpg"
  },
  {
    "title": "ALLONSANFAN (ALLONSANFAN)",
    "director": "Paolo und Vittorio Taviani",
    "country": "Italien",
    "releaseYear": 1974,
    "runtime": 110,
    "version": "OmU",
    "screeningDate": "19.12.2013",
    "readableDate": "2013-12-19",
    "screeningTime": "20:00",
    "actors": "Marcello Mastroianni, Lea Massari, Mimsy Farmer, Claudio Cassinelli, Laura Betti, Benjamin Lev, Bruno Cirino, Stanko Molnar, Luisa De Santis, Biagio Pelligra, Renato De Carmine, Michael Berger",
    "subtitle": [""],
    "bodycopy": [
      "Die Jahre der Restauration. Der adlige Fulvio wurde als Revolutionär wegen eines angeblichen Verrats eingekerkert. Nach seiner Entlassung sehnt er sich nach zurückgezogener Ruhezeit in der Villa der Familie zusammen mit seiner Geliebten. Während er von der Flucht nach Amerika träumt, will sie ihn zusammen mit den Exkämpfern zum Aufbruch nach Süditalien drängen. So beginnen sich die Ereignisse zu überschlagen und Fulvios Unfähigkeit, sich zu entscheiden, endet in einer Tragödie."
    ],
    "image": "allonsanfan.jpg"
  },
  {
    "title": "Amarcord (Fallinis Amarcord)",
    "director": "Federico Fellini",
    "country": "Italien/Frankreich",
    "releaseYear": 1973,
    "runtime": 127,
    "version": "OmU",
    "screeningDate": "18.03.2010",
    "readableDate": "2010-03-18",
    "screeningTime": "20:00",
    "actors": "Magali Noël, Pupella Maggio, Bruno Zanin, Armando Brancia, Nando Orfei, Gianfilippo Carcano, Josiane Tanzilli, Maria Antonietta Beluzzi, Giuseppe Ianigro, Stefano Proietti, Luigi Rossi",
    "subtitle": ["90 Jahre Fellini (20.01.1920-31.10.1993)"],
    "bodycopy": [
      "„Amarcord“ bedeutet im Dialekt der Romagna: „Ich erinnere mich“. Auch wenn Fellini sein Leben lang jeden autobiografischen Einfluss bestritt, liegt der persönliche Bezug auf der Hand: Aus der staunenden Perspektive eines 16jährigen Jungen präsentiert er ein Panoptikum skurriler, sowohl amüsanter als auch erschreckender Episoden und entwickelt daraus die Atmosphäre Riminis im Faschismus der 30er Jahre."
    ],
    "image": "amarcord.gif"
  },
  {
    "title": "Amarcord (Fellinis Amarcord)",
    "director": "Federico Fellini",
    "country": "Italien/Frankreich",
    "releaseYear": 1973,
    "runtime": 127,
    "version": "OmU",
    "screeningDate": "15.12.2005",
    "readableDate": "2005-12-15",
    "screeningTime": "19:30",
    "actors": "Magali Noël, Pupella Maggio, Bruno Zanin, Armando Brancia, Nando Orfei, Gianfilippo Carcano, Josiane Tanzilli, Maria Antonietta Beluzzi, Giuseppe Ianigro, Stefano Proietti, Luigi Rossi",
    "subtitle": ["90 Jahre Fellini (20.01.1920-31.10.1993)"],
    "bodycopy": [
      "„Amarcord“ bedeutet im Dialekt der Romagna: „Ich erinnere mich“. Auch wenn Fellini sein Leben lang jeden autobiografischen Einfluss bestritt, liegt der persönliche Bezug auf der Hand: Aus der staunenden Perspektive eines 16jährigen Jungen präsentiert er ein Panoptikum skurriler, sowohl amüsanter als auch erschreckender Episoden und entwickelt daraus die Atmosphäre Riminis im Faschismus der 30er Jahre."
    ],
    "image": "amarcord.jpg"
  },
  {
    "title": "Amnesia",
    "director": "Gabriele Salvatores",
    "country": "Italien",
    "releaseYear": 2002,
    "runtime": 111,
    "version": "OmitU",
    "screeningDate": "04.11.2009",
    "readableDate": "2009-11-04",
    "screeningTime": "20:00",
    "actors": "Diego Abantantuono, Sergio Rubini, Martina Stella, Bebo Storti, Juanjo Puigcorbé, Rubén Ochandiano, Maria Jurado, Antonia San Juan, Ian McNeice, Alessandra Martines",
    "subtitle": [
      "Werkschau: Ein Fall für zwei Gabriele Salvatores (Regisseur) und Diego Abantantuono (Schauspieler)"
    ],
    "bodycopy": [
      "Amnesia è la megadiscoteca, dove si intreccia il destino di tre uomini: un registra di film porno, che riceve la visita della figlia 17enne sul set, Angelino, che gestisce un bar e spaccia droga, e il capo della polizia locale che ha più da lottare con il figlio ribelle che con la criminalità."
    ],
    "image": "amnesia.jpg"
  },
  {
    "title": "Andiamo (Andiamo)",
    "director": "Thomas Crecelius",
    "country": "Italien/Deutschland",
    "releaseYear": 2004,
    "runtime": 94,
    "version": "OmU",
    "screeningDate": "18.08.2005",
    "readableDate": "2005-08-18",
    "screeningTime": "19:30",
    "actors": [""],
    "subtitle": [
      "Noto: Nicht nur die barocke Pracht bröckelt, auch die Zukunftsaussichten der Jugendlichen nach dem Abitur sind nicht rosig. So stellt sich für sie die Frage, zu bleiben oder in den Norden zu gehen. In einer Mischung aus Erzählung und Dokumentation versucht der Film von Thomas Crecelius dem Phänomen des italienischen Südens nachzugehen. Herausgekommen ist das Porträt der Stadt Noto und seiner Bewohner, die für einen oft übersehenen Teil des italienischen Lebens stehen."
    ],
    "bodycopy": [""],
    "image": "andiamo.jpg"
  },
  {
    "title": "Angela (Angela)",
    "director": "Roberta Torre",
    "country": "Italien",
    "releaseYear": 2002,
    "runtime": 95,
    "version": "OmU",
    "screeningDate": "02.06.2004",
    "readableDate": "2004-06-02",
    "screeningTime": "19:30",
    "actors": " Andrea Di Stefano, Donatella Finocchiaro, Mario Pupella",
    "subtitle": [""],
    "bodycopy": [
      "Angela ist in Ballarò, dem Markt-Viertel Palermos auf­gewachsen. Mit zwanzig heiratet sie Saro. Das junge Pärchen schlägt sich mit Drogenhandel und schnel­len Geschäften durch. Als sie Masino begegnet, der zum rechten Arm ihres Mannes wird, beginnt sie mit ihm eine leiden­schaftliche Affäre."
    ],
    "image": "Angela.jpg"
  },
  {
    "title": "ANNI FELICI  (ANNI FELICI - BARFUSS DURCHS LEBEN)",
    "director": "Daniele Luchetti",
    "country": "Italien",
    "releaseYear": 2014,
    "runtime": 101,
    "version": "OmU",
    "screeningDate": "21.01.2016",
    "readableDate": "2016-01-21",
    "screeningTime": "20:00",
    "actors": "Kim Rossi Stuart, Martina Gedeck, Micaela Ramazzotti, Nicolò Cavagna",
    "subtitle": [""],
    "bodycopy": [
      "Sie streiten und versöhnen sich: Guido, der (Lebens)künstler ist wirtschaftlich von seiner Frau Serena abhängig, was ihn nicht hindert, sexuelle Abenteuer einzugehen und sie zu demütigen - bis diese die Avancen der Galeristin Helke zu beantworten beginnt. Zusammengehalten wird die Familie durch die Söhne Paolo und Dario, der in diesem Film von den „glücklichen Jahren der Familie“ erzählt."
    ],
    "image": "anni-felici.jpg"
  },
  {
    "title": "Anno Uno – Alcide de Gasperi",
    "director": "Roberto Rossellini",
    "country": "Italien",
    "releaseYear": 1974,
    "runtime": 118,
    "version": "OmitU",
    "screeningDate": "02.05.2007",
    "readableDate": "2007-05-02",
    "screeningTime": "19:00",
    "actors": "Luigi Vannucchi, Dminique Darel, Corrado Olmi, Renato Montanari, Tino Bianchi, Rita Forzano, Valeria Sabel, Paolo Bonacelli, Francesco Di Federico, Omero Antonutti, Renato Scarpa",
    "subtitle": ["Werkschau: Roberto Rossellini"],
    "bodycopy": [
      "In seinen historischen Fernsehproduktionen hat der späte Rossellini wieder zu seineralten Schaffenskraft zurückgefunden. Anhand historischer Persönlichkeiten lässt er Epochen aufscheinen und stellt die Frage nach der Verantwortung der politisch Handelnden. Alcide de Gasperi leistete unter dem Schutz des Vatikans Widerstand gegen Mussolini und wurde einer der Väter des „neuen Italiens“. Der Film beschreibtdie Zeit ab 1945, dem Jahr der Befreiung, bis zu seinem Tod 1954."
    ],
    "image": "anno-uno.jpg"
  },
  {
    "title": "Appunti di viaggio per un film sull'India (Notizen für einen Film über Indien)",
    "director": "Pier Paolo Pasolini",
    "country": "Italien",
    "releaseYear": 1968,
    "runtime": 35,
    "version": "OmU",
    "screeningDate": "14.03.2011",
    "readableDate": "2011-03-14",
    "screeningTime": "20:00",
    "actors": "Pier Paolo Pasolini",
    "subtitle": ["Mit: Pier Paolo Pasolini"],
    "bodycopy": [
      "Ein Reisetagebuch, die Schilderung des Versuchs, einen Film nach einer Legende aus der indischen Mythenwelt zu drehen: die Geschichte eines Maharadschas, der seinen Körper den vom Hungertod bedrohten Tigerjungen hingibt. Pasolini interviewt repräsentative Personen aus den verschiedenen gesellschaftlichen Gruppierungen."
    ],
    "image": "Appunti.jpg"
  },
  {
    "title": "Appunti per un'Orestiade africana (Notizen für eine afrikanische Orestie)",
    "director": "Pier Paolo Pasolini",
    "country": "Italien",
    "releaseYear": 1970,
    "runtime": 65,
    "version": "OmU",
    "screeningDate": "27.02.2011",
    "readableDate": "2011-02-27",
    "screeningTime": "15:00",
    "actors": "Pier Paolo Pasolini, Gato Barbieri, Marcelli Melis",
    "subtitle": [""],
    "bodycopy": [
      "Der Versuch einer Transposition der ORESTIE des Aischylos in das moderne Afrika. Auf der Suche nach möglichen Drehorten und Figuren führt Pasolini ein filmisches Notizbuch."
    ],
    "image": "Orestiade.jpg"
  },
  {
    "title": "ASMARINA (ASMARINA)",
    "director": "Alan Maglio, Medhin Paolos",
    "country": "Italien",
    "releaseYear": 2015,
    "runtime": 69,
    "version": "OmenU",
    "screeningDate": "15.01.2017",
    "readableDate": "2017-01-15",
    "screeningTime": "20:00",
    "actors": "",
    "subtitle": [
      "Ein nahezu vergessenes Erbe postkolonialer Zeit: die über fast ein halbes Jahrhundert erfolgte Integration der eritreischen und äthiopischen Volksgruppen in das soziale und kulturelle Leben Italiens."
    ],
    "bodycopy": [
      "Alan Maglio und Medhin Paolos präsentieren in ihrem Dokumentarfilm Erinnerungen aus der Habescha-Volksgruppe in Mailand, zeigen persönliche Schicksale und untersuchen die verschiedenen Formen der Identität, Migration und des Einlebens in der Fremde.",
      "Herausgekommen ist die Geschichte über eine ethnische Minderheit in Italien: das alltägliche Leben der dort Geborenen und derjenigen, die schon lange im Land leben oder als Flüchtlinge gerade erst angekommen sind."
    ],
    "image": "asmarina.jpg"
  },
  {
    "title": "AZZURRE (AZZURRO)",
    "director": "Denis Rabaglia",
    "country": "Schweiz/Italien/Frankreich",
    "releaseYear": 2000,
    "runtime": 82,
    "version": "OmU",
    "screeningDate": "19.01.2006",
    "readableDate": "2006-01-19",
    "screeningTime": "19:30",
    "actors": "Paolo Villaggio, Francesca Pipoli, Marie-Cristine Barrault, Jean-Luc Bideau, Renato Scarpa, Julien Boisselier",
    "subtitle": [""],
    "bodycopy": [
      "Nach seinem Herzinfarkt will der 75-jährige Giuseppe zurück in die Schweiz reisen, in der er 30 Jahre als Vorarbeiter gearbeitet hatte. Kurzerhand nimmt er seine siebenjährige blinde Enkelin Carla mit, um von seinem ehemaligen Chef das Geld für deren Augenoperation zu erbitten. Als kurzer Ausflug geplant, entwickelt sich diese Reise zu einem Aufbruch in Giuseppes Vergangenheit mit Begegnungen, die sich manchmal nicht nur die blinde Carla anfänglich nicht erklären kann."
    ],
    "image": "azzurro.jpg"
  },
  {
    "title": "BASILICATA COAST TO COAST",
    "director": "Rocco Papaleo",
    "country": "Italien",
    "releaseYear": 2010,
    "runtime": 92,
    "version": "OmitU",
    "screeningDate": "04.04.2012",
    "readableDate": "2012-04-04",
    "screeningTime": "20:00",
    "actors": "Alessandro Gassman, Paolo Briguglia, Max Gazzè, Rocco Papaleo, Giovanna Mezzogiorno",
    "subtitle": [""],
    "bodycopy": [
      "Als eine Band zu einem Festival eingeladen wird, will sie als Werbegag die Basilikata „coast to coast“ durchqueren. Dokumentieren soll das die unsichere Journalistin Tropea. Ein romantisches Raodmovie mit einem ironischen Blick auf die Gruppendynamik von überforderten Menschen, die sich das aber nicht eingestehen wollen."
    ],
    "image": "basilicata-coast-to-coast.jpg"
  },
  {
    "title": "BELLA E PERDUTA (EINE REISE DURCH ITALIEN)",
    "director": "Pietro Marcello",
    "country": "Italien",
    "releaseYear": 2015,
    "runtime": 87,
    "version": "OmU",
    "screeningDate": "15.12.2016",
    "readableDate": "2016-12-15",
    "screeningTime": "20:00",
    "actors": "Tommaso Cestrone, Sergio Vitolo, Gesuino Pittalis, Maurizio Braucci",
    "subtitle": [""],
    "bodycopy": [
      "Bilder aus einer Sagen- und Theaterwelt treffen auf Dokumentaraufnahmen des heutigen Italiens und eine poetische Erzählung voller melancholischer Bilder: Pulcinella soll den Büffel Sarchiapone retten und zieht mit ihm durch ein archaisch geprägtes Italien. Ein Narr und ein Büffel erleben Freundschaft und Vertrauen, aber auch die Zerrissenheit eines Landes."
    ],
    "image": "bella-e-perduta.jpg"
  },
  {
    "title": "BELLUSCONE. UNA STORIA SICILIANA (BELLUSCONE - WARUM DIE ITALIENER BERLUSCONI LIEBEN)",
    "director": "Franco Maresco",
    "country": "Italien",
    "releaseYear": 2014,
    "runtime": 95,
    "version": "OmU",
    "screeningDate": "06.07.2015",
    "readableDate": "2015-07-06",
    "screeningTime": "20:00",
    "actors": "",
    "subtitle": [""],
    "bodycopy": [
      "Es sind Marescos schräge Protagonisten, die Berlusconi, in Sizilien nur „Belluscone“ genannt, seine Stimmen sichern. Die Straßen Palermos erscheinen in den Bildern Marescos als mafiöse Parallelwelt, in der eine Hand die andere wäscht – und aus der es kein Entrinnen gibt. Maresco macht in erschreckender Weise deutlich, wie das System der Mafia im Kleinen funktioniert."
    ],
    "image": "belluscone.jpg"
  },
  {
    "title": "Buonanotte Topolino (Bye-bye Berlusconi)",
    "director": "Jan Henrik Stahlberg",
    "country": "Deutschland",
    "releaseYear": 2005,
    "runtime": 89,
    "version": "OmU",
    "screeningDate": "26.04.2006",
    "readableDate": "2006-04-26",
    "screeningTime": "19:30",
    "actors": "Maurizio Antonini, Lucia Chiarla, Pietro Bontempo, Pietro Ragusa, Tullio Sorrentino, Fabio Bezzi, Franco Lei, Oscar Stahlberg",
    "subtitle": [""],
    "bodycopy": [
      "Kann man ohne dessen Einwilligung einen Spielfilm über Berlusconi drehen? Man kann, wenn man dessen Namen nicht erwähnt und der Film als Satire zu erkennen ist. Diese reale Vorgabe hat Stahlberg umgesetzt, indem filmisch vom Problem erzählt, einen solchen Film zu machen: Die Geschichte wird in die Welt von Topolino (=Micky-Maus) verschoben und der Name des Protagonisten mit einem Piepton überblendet. Neben dem beim Filmteam zunehmenden Verfolgungswahn sehen wir einen satirischen Film über Berlusconi entstehen, der auf wahren Begebenheiten beruht."
    ],
    "image": "buonanotte-topolino.jpg"
  },
  {
    "title": "Buongiorno, notte (Der Fall Aldo Moro)",
    "director": "Marco Bellocchio",
    "country": "Italien",
    "releaseYear": 2003,
    "runtime": 106,
    "version": "OmU",
    "screeningDate": "18.09.2008",
    "readableDate": "2008-09-18",
    "screeningTime": "19:00",
    "actors": "Maya Sansa, Roberto Herlitzka, Luigi Lo Cascio, Paolo Briguglia, Pier Giorgio Bellocchio, Giovanni Calcagno, Giulio Bosetti",
    "subtitle": ["Entführung und Ermordung von ALDO MORO:"],
    "bodycopy": [
      "Der christdemokratische Politiker Aldo Moro wurde 1978 von den linksterroristischen Roten Brigaden ermordet. Er war mehrfach Minister und von 1963 bis 1968 und 1974 bis 1976 Ministerpräsident Italiens. Umstritten war seine Befürwortung des „Historischen Kompromiss“, dem Eintritt der kommunistischen Partei PCI in die Regierungskoalition mit der christdemokratischen Democrazia Cristiana. Am 16. März 1978 entführten die Roten Brigaden Aldo Moro. Nach 55 Tagen Gefangenschaft wurde er tot im Kofferraum eines Pkws aufgefunden.",
      "Bellocchio wagt in dieser Rekonstruktion der 55-tägigen Gefangenschaft Aldo Moros eine psychologische Studie von Menschen, die in Ausnahmesituationen aufeinander stoßen. Anhand der Berichte von Ermittlern, an der Tat Beteiligten und Archivrecherchen wird die Gefangenschaft Aldo Moros aus der Sicht des einzigen weiblichen Mitglieds der Gruppe erzählt, die gegen den Willen der anderen anfängt, Kontakt zum Gefangenen aufzunehmen. Dem Film wurde seine unpolitische Haltung vorgeworfen, die andererseits aber neue Sichtweisen auf die menschliche Seiten der „Bleiernen Zeit“ ermöglicht."
    ],
    "image": "buongiorno-notte.jpg"
  },
  {
    "title": "Cadaveri eccellenti (Die Macht und ihr Preis)",
    "director": "Francesco Rosi",
    "country": "Italien/Großbritannien",
    "releaseYear": 1976,
    "runtime": 112,
    "version": "OmitU",
    "screeningDate": "01.11.2006",
    "readableDate": "2006-11-01",
    "screeningTime": "18:00",
    "actors": "Lino Ventura, Tino Carraro, Paolo Bonacelli, Alain Cuny, Maria Carta, Luigi Pistilli, Max von Sydow, Charles Vanet, Marcel Bozzuffi, Tina Aumonr, Fernando Rey",
    "subtitle": [""],
    "bodycopy": [
      "„Cadaveri eccellenti“: Das sind prominente Opfer der Mafia - Repräsentanten des Staates, Politiker und Journalisten. Lino Ventura kommt in der Rolle des Polizeiinspektors Rogas einer gigantischen Verschwörung auf die Spur und gerät dabei selbst in Gefahr. Nach dem Roman von Leonardo Sciascia drehte Rosi einen Thriller über die Verstrickung von organisierter Kriminalität und Politik. Damit traf Rosi den Nerv der Zeit und wurde selbst von der Staatsanwaltschaft verfolgt."
    ],
    "image": "caos-calmo.jpg"
  },
  {
    "title": "CAOS CALMO (Stilles Chaos)",
    "director": "Antonello Grimaldi",
    "country": "Italien/Großbritannien",
    "releaseYear": 2007,
    "runtime": 112,
    "version": "OmU",
    "screeningDate": "20.05.2010",
    "readableDate": "2010-05-20",
    "screeningTime": "20:00",
    "actors": " Nanni Moretti, Alessandro Gassman, Isabella Ferrari, Hippolyte Girardot, Silvio Orlando, Roman Polanski",
    "subtitle": [""],
    "bodycopy": [
      "Ein Trauma: Während Pietro (Nanni Moretti) eine Frau am Strand rettet, stirbt seine Frau zu Hause ohne Hilfe. Seine erfolgreiche Tätigkeit als Pay-TV-Manager gerät in den Hintergrund und er ist nur noch für seineTochter da. Nach dem Ferienende bringt er sie zur Schule und wartet auf einer Parkbank vor dem Eingang. Im Laufe der Wochen und Monate wird dieser Ort sein Lebensmittelpunkt: Passanten und Menschen aus seinem Leben kommen vorbei, Geschäftspartner (u.a. Roman Polanski) stricken ihre Intrigen … während Pietro auf dem Weg zu sich selbst ist."
    ],
    "image": "caos-calmo.jpg"
  },
  {
    "title": "Casomai (Trauen wir uns?!)",
    "director": "Alessandro D'Alatri",
    "country": "Italien",
    "releaseYear": 2002,
    "runtime": 114,
    "version": "OmU",
    "screeningDate": "18.06.2009",
    "readableDate": "2009-06-18",
    "screeningTime": "20:00",
    "actors": " Stefania Rocca, Fabio Volo, Rino Manni, Sara D’Amario",
    "subtitle": [""],
    "bodycopy": [
      "Tommaso und Stefania wollen heiraten. Aber sind sie für ihr zukünftiges Glück allein verantwortlich? Der Priester Don Livio hat seine Zweifel. So inszeniert er eine Hochzeit, die allen Erwartungen widerspricht. Er scheint sich mehr um die Gäste als um das Paar zu kümmern, denn liegt es nicht an ihnen, ob die Ehe gelingt?"
    ],
    "image": "caso-mai.jpg"
  },
  {
    "title": "CASOMAI (Trauen wir uns?!)I",
    "director": "Alessandro D'Alatri",
    "country": "Italien",
    "releaseYear": 2002,
    "runtime": 114,
    "version": "OmU",
    "screeningDate": "21.08.2004",
    "readableDate": "2004-08-21",
    "screeningTime": "19:30",
    "actors": " Stefania Rocca, Fabio Volo, Rino Manni, Sara D’Amario",
    "subtitle": [""],
    "bodycopy": [
      "Der Wunsch eines Paares und die unkonventionellen Ideen eines Priesters sind Gegenstand eines der ungewöhnlichsten Hochzeitsfilme der Filmgeschichte.",
      "Tommaso und Stefania wollen heiraten. Aber sind sie für ihr zukünftiges Glück wirklich allein verantwortlich? Der Priester Don Livio hat da so seine Zweifel. Wie ein moderner Don Camillo inszeniert er eine Hochzeit, die allen Erwartungen widerspricht und sich mehr um die Gäste als das Paar zu kümmern scheint. Denn sind nicht sie es, die für das Gelingen oder Scheitern dieser zukünftigen Ehe verantwortlich sind?",
      "Bei allen geistreichen und humoristischen Wendungen, die dieser Film im Verlauf immer wieder nimmt, behandelt er mit Leichtigkeit ein existenzielles Thema unserer modernen Zeit: Beziehungsfähigkeit, Verantwortung für sich und den anderen und das Wahrnehmen der leisen Töne in einer immer „lauter“ werdenden Welt.",
      "Beim Filmfestival „Cinema! Italia 2003” erhielt dieser Film nicht nur bundesweit den Publikumspreis: er war auch der Favorit des Düsseldorfer Publikums."
    ],
    "image": "casomai.jpg"
  },
  {
    "title": "Cento giorni a Palermo (Die 100 Tage von Palermo)",
    "director": "Giuseppe Ferrara",
    "country": "Italien/Frankreich",
    "releaseYear": 1983,
    "runtime": 93,
    "version": "S",
    "screeningDate": "11.06.2010",
    "readableDate": "2010-06-11",
    "screeningTime": "20:00",
    "actors": "Lino Ventura, Giuliana ",
    "subtitle": [""],
    "bodycopy": [
      "Der Film beschreibt das Bemühen des Generals Dalla Chiesa (LinoVentura), der trotz seiner Verdienste im Kampf gegen die Brigate Rosse von den Politikern in das Amt des Polizeichefs von Palermo gedrängt wird. Als dem Staat verpflichteter und in die Institutionen vertrauender Staatsbeamter nimmt er diese ihm ursprünglich fremde Rolle als Mafiaermittler an, muss aber im Laufe seiner mit Energie vorangetriebenen Ermittlungen feststellen, dass er immer mehr zwischen die Mühlräder verschiedener Interessen gerät und schließlich jeglichen Rückhalt zu verlieren droht."
    ],
    "image": "cento-giorni-a-palermo.jpg"
  },
  {
    "title": "CENTOCHIODI (Hundert Nägel)",
    "director": "Ermanno Olmi",
    "country": "Italien",
    "releaseYear": 2007,
    "runtime": 92,
    "version": "OmU",
    "screeningDate": "17.05.2012",
    "readableDate": "2012-05-17",
    "screeningTime": "20:00",
    "actors": " Raz Degan, Luna Bendandi, Michele Zattara, Amina Syed, Andrea Lanfredi, Damiano Scaini, Franco Andreani, Angela Fornacciari, Ylenia Mezzani",
    "subtitle": [""],
    "bodycopy": [
      "Mit hundert Nägeln hat der Professor die Bücher auf Boden und Tische der Bibliothek genagelt. Jetzt lebt er bescheiden in einer Hütte und wird langsam von den Nachbarn zum Heiligen stilisiert."
    ],
    "image": "centochiodi.jpg"
  },
  {
    "title": "CESARE DEVE MORIRE (CÄSAR MUSS STERBEN)",
    "director": "Paolo und Vittorio Taviani",
    "country": "Italien",
    "releaseYear": 2012,
    "runtime": 76,
    "version": "OmU",
    "screeningDate": "17.10.2013",
    "readableDate": "2013-10-17",
    "screeningTime": "20:00",
    "actors": "Häftlinge eines römischen Gefängnisses",
    "subtitle": [""],
    "bodycopy": [
      "Der Mord an einem Tribun – gespielt von Mördern und Verbrechern? Das hohe Kulturgut Shakespeare, der Vertreter eines intellektuellen Freiheitsbegriffs, inszeniert in einem Gefängnis unter ständiger Bewachung? Kann Kunst wirklich den Einzelnen verändern?",
      "Aus dem Doku-Drama der Brüder Taviani ist ein optimistisches Bekenntnis zur Kunst und Kultur geworden, mit der die Welt verändert werden kann – wenn auch manchmal nur ein wenig."
    ],
    "image": "cesare-deve-morire.jpg"
  }, 
  {
    "title": "Rose e pistole (Rosen und Pistolen)",
    "director": "Carla Apuzzo",
    "country": "Italia",
    "releaseYear": 1998,
    "runtime": 81,
    "version": "OmU",
    "screeningDate": "21.05.2004",
    "readableDate": "2004-05-21",
    "screeningTime": "19:30",
    "actors": "Anna Anunirati, Duccio Giordano, Luigi Petrucci",
    "subtitle": [""],
    "bodycopy": [
      "Zwischen Bagnoli und den Campi Flegrei sind Rosa und Angelo, zwei Zwanzigjährige, auf der Flucht vor ihrem Ehemann, denn der reiche Metzger Pappalardo hat einen Killer engagiert..."
    ],
    "image": "../../rose-e-pistole.jpg"
  },
  {
    "title": "CHI SALVERÀ LE ROSE (FÜR DICH SOLL’S EWIG ROSEN GEBEN)",
    "director": "Cesare Furesi",
    "country": "Italien",
    "releaseYear": 2017,
    "runtime": 103,
    "version": "OmU",
    "screeningDate": "17.01.2019",
    "readableDate": "2019-01-17",
    "screeningTime": "20:00",
    "actors": " Carlo Delle Piane, Caterina Murino, Lando Buzzanca, Antonio Careddu, Guenda Goria, Philippe Leroy, Massimiliano Buzzanca, Eleonora Vallone",
    "subtitle": [
      "Der italienische Titel „Chi salverà le rose“ (de: „Wer wird die Rosen retten“) und der deutsche Titel des Films „Für Dich soll‘s ewig Rosen geben“ beschreiben metaphorisch den thematischen Bogen der Filmerzählung: Es geht um die Liebe im Alter und das Zerbröseln biographischer Erfolge, aber auch um die Perspektive auf Neues und das Bemühen um die Bereinigung familiärer Beziehungen. Zwischen melancholischem Rückblick und optimistischer Lebensgestaltung präsentiert der Film eine berührende Geschichte zweier gealterter Herren, deren Liebe zueinander ungebrochen ist, und ihrem Weg, mit den aktuell kritischen Bedingungen zurecht zu kommen."
    ],
    "bodycopy": [
      "Giulio genießt seine Rolle als Gentleman. Den Anwaltsberuf hatte er seit Jahrzehnten für ein Leben mit Claudio, seiner großen Liebe, aufgegeben. Als Pokerspieler hat er lange Zeit das aufwendige Leben der Beiden finanziert. Doch die Zeiten sind vorbei und nach und nach musste der Verkauf des Inventars für das notwendige Geld sorgen.",
      "Das Personal des gemeinsamen Anwesens ist vor Jahren entlassen worden und Claudio ist krank an sein Bett gebunden. Er glaubt, das alte Leben ginge so weiter, denn Giulio spielt ihm eine heile Welt vor und bringt ihm als Liebeszeichen jeden Tag eine frische Rose. Doch die Illusion lässt sich nicht mehr lange aufrechterhalten: die Rosen kränkeln und die finanziellen Sorgen sind erdrückend.",
      "Wird er Hilfe von Kind und Enkel erwarten dürfen? Das Verhältnis zu seiner Tochter Valeria ist angespannt, während sein Enkel Marco, Valerias Sohn, ihn und Claudio abgöttisch verehrt.",
      "Also macht sich Giulio daran, alte Konflikte aus dem Weg zu räumen und seine Beziehung zu Valeria neu zu gestalten. Aber auch mit Marco läuft nicht alles reibungslos."
    ],
    "image": "chi-salvera-le-rose.jpg"
  },
  {
    "title": "Chora (CHora)",
    "director": "Lorenzo Adorisio",
    "country": "Italien",
    "releaseYear": 2004,
    "runtime": 15,
    "version": "OmU",
    "screeningDate": "03.07.2010",
    "readableDate": "2010-07-03",
    "screeningTime": "20:00",
    "actors": "Valeria Sabel, Dario Gioncardi",
    "subtitle": [
      "Untertitelt vom Workshop Filmuntertitelung des Instituts für Romanistik und des Studiengangs Literaturübersetzen der Heinrich-Heine-Universität Düsseldorf."
    ],
    "bodycopy": [
      "Der dreizehnjährige Giulio und seine Großmutter haben ein sehr inniges Verhältnis. Bei einem gemeinsamen Kurzbesuch im kalabresischen Heimatdorf der Großmutter verstirbt diese plötzlich. Auf der Suche nach einem Telefon irrt Giulio verloren durch die Straßen dieser für ihn fremden Heimat und findet dabei einen Teil seiner selbst.",
      "Mit seinem vielfach prämierten Kurzfilm thematisiert der Regisseur Lorenzo Adorisio das ambivalente Verhältnis vieler Migranten zu ihrer Heimat infolge der italienischen Binnenmigration und trifft damit den Nerv der Zeit.",
      "In Anwesenheit des Regisseurs Lorenzo Adorisio."
    ],
    "image": "chora.png"
  },
  {
    "title": "Ciao Aracà (Ciao Aracà)",
    "director": "Daniel Chisholm",
    "country": "Deutschland",
    "releaseYear": 2019,
    "runtime": 63,
    "version": "OmU",
    "screeningDate": "17.09.2020",
    "readableDate": "2020-09-17",
    "screeningTime": "20:00",
    "actors": "Es treten auf: ehemalige und aktuelle Bewohner von Aracà",
    "subtitle": [
      "Ein Dorf in Italien steht am Rande des Verfalls, aber seine alternden Einwohner treten ihrer Zukunft mutig entgegen, während die nächste Generation um das Überleben im ländlichen Kontext kämpft."
    ],
    "bodycopy": [
      "Aracà, ein Dorf in den ligurischen Bergen, ist in Bewegung. Alternde Landwirte und ihre Familien müssen eine Vielzahl schwieriger Probleme angehen: Der Verlust traditioneller Anbaumethoden, globalisierte Agrarmärkte, eine Abwanderung junger Menschen und ein Zustrom von Außenstehenden, die billige Immobilien aufkaufen. Trotz dieser existenziellen Herausforderungen begegnen sie der Zukunft mit Anmut, Würde, Stoizismus und einem schelmischen Sinn für Humor.",
      "Gleichzeitig suchen ihre verbliebenen Nachkommen nach Möglichkeiten, den Niedergang des ländlichen Raums aufzuhalten, indem sie in neue Weinreben, Geräte zur Weinherstellung, die Verjüngung von Olivenhainen, die neuesten landwirtschaftlichen Maschinen und eine bessere Vermarktung investieren. Obwohl sie erkannt haben, dass Qualität und Herkunft von grundlegender Bedeutung sind, bleiben ihre Erfolgschancen ungewiss.",
      "CIAO ARACÀ dokumentiert das Leben der Bauern und ihrer Familien. Mit Sorgfalt und Einfühlungsvermögen werden die Kämpfe einer kleinen Gemeinde mit Industrialisierung und Globalisierung beleuchtet, ohne die ebenfalls vorhandenen Perspektiven aus den Augen zu verlieren."
    ],
    "image": "ciaoaraca.png"
  },
  {
    "title": "CIPOLLA COLT (ZWIEBEL-JACK RÄUMT AUF)",
    "director": "Enzo G. Castellari (als Enzo Girolami)",
    "country": "Italien/Spanien/Deutschland",
    "releaseYear": 1975,
    "runtime": 91,
    "version": "OmU",
    "screeningDate": "25.09.2016",
    "readableDate": "2016-09-25",
    "screeningTime": "16:30",
    "actors": " Franco Nero, Sterling Hayden, Martin Balsam, Emma Cohen, Leo Anchóriz, Romano Puppo",
    "subtitle": [""],
    "bodycopy": [
      "In dieser parodistischen Western-Komödie legt sich Franco Nero (Django) als Zwiebelfarmer mit einem Ölmagnaten an, der ihm nach Land und Leben trachtet. Elemente der Commedia dell’arte und der Commedia all’italiana verbinden sich mit der Slapstick-Tradition. Der Film ironisiert die vorausgegangene Phase der Klamaukfilme des Genres."
    ],
    "image": "cipolla-colt-1.jpg"
  },
  {
    "title": "Concorrenza sleale",
    "director": "Ettore Scola",
    "country": "Italien",
    "releaseYear": 2001,
    "runtime": 106,
    "version": "OmitU",
    "screeningDate": "04.06.2008",
    "readableDate": "2008-06-04",
    "screeningTime": "19:00",
    "actors": "Diego Abantantuono, Sergio Castellitto, Gérard Depardieu, Antonella Attili, Elio Germano, Sabrina Impiacciatore, Rolando Ravello",
    "subtitle": ["Werkschau: Ettore Scola"],
    "bodycopy": [
      "Eine tragikomischer Film mit Starbesetzung (u.a Diego Abantantuono, Sergio Castellitto, Gérard Depardieu). Umberto und Leone betreiben zwei benachbarte Geschäfte und tragen ihre Konkurrenz mit kleinen Streichen, Schabernack und Frotzeleien aus. Doch die Situation ändert sich mit der Einführung der Rassegesetze 1938, denn Leone ist Jude. Auf einmal ist nichts mehr wie es war. Verpassen Sie nicht die Gelegenheit: Für den Film gibt es keinen Deutschlandvertrieb!"
    ],
    "image": "concorrenza-sleale.jpg"
  },
  {
    "title": "Concorso di colpa",
    "director": "Claudio Fragasso",
    "country": "Ittalien",
    "releaseYear": 2003,
    "runtime": 95,
    "version": "OmitU",
    "screeningDate": "07.01.2009",
    "readableDate": "2009-01-07",
    "screeningTime": "20:00",
    "actors": "Francesco Nuti, Alessandro Benvenuti, Antonella Ponziani, Luca Lionello, Massimo Bonetti, Lorenzo Balducci, Felicia Della Corte, Luigi Maria Burruano",
    "subtitle": [""],
    "bodycopy": [
      "Was hat ein Routinefall in Zeiten des „No-global“ mit der Vergangenheit zu tun? Ein Kommissar muss sich bei seinen Ermittlungen nicht nur mit seinem Sohn auseinandersetzen. Er muss auch erfahren, dass er seiner Vergangenheit nicht entgehen kann. Cineasten sollten pünktlich sein: Selten wurde zu Beginn eines Films in einer wenige Minuten dauernden Sequenz Filmgeschichte so vielgestaltig zitiert. Damit weckt der Film Erwartungen, wird er sie erfüllen?"
    ],
    "image": "concorso-di-colpa.jpg"
  },
  {
    "title": "COSA VOGLIO DI PIÙ (Was will ich mehr)",
    "director": "Silvio Soldini",
    "country": "Italien",
    "releaseYear": 2006,
    "runtime": 121,
    "version": "OmU",
    "screeningDate": "17.11.2011",
    "readableDate": "2011-11-17",
    "screeningTime": "20:00",
    "actors": "Alba Rohrwacher, Pierfrancesco Favino, Giuseppe Battiston, Teresa Saponangelo, Fabio Troiano, Tatiana Lepore, Adriana De Guilmi, Gigio Alberti, Ninni Bruschetta, Clelia Piscitello, Carla Chiarelli",
    "subtitle": [""],
    "bodycopy": [
      "Soldini widmet er sich in diesem Film den Aspekten von Paarbeziehungen, Liebe und Sexualität auf seriöse, teilweise dramatisch schwermütige Art, jenseits seines Erzählstils in „Brot und Tulpen“: Anna und Domenico leben jeweils in konsolidierten Familienverhältnissen, die aber infrage gestellt werden, als sich die beiden begegnen. Was als sexuelles Abenteuer begann, wird Liebe und Abhängigkeit. Hin- und hergerissen zwischen ihren Gefühlen für einander einerseits und für ihre Familien andererseits begeben sie sich auf die Suche nach einer aussichtslos scheinenden Lösung."
    ],
    "image": "cosa-voglio-di-piu.jpg"
  },
  {
    "title": "Cristo si è fermato a Eboli (Christus kam nur bis Eboli)",
    "director": "Francesco Rosi",
    "country": "Italien",
    "releaseYear": 1979,
    "runtime": 145,
    "version": "OmitU",
    "screeningDate": "06.12.2006",
    "readableDate": "2006-12-06",
    "screeningTime": "18:00",
    "actors": " Gian Maria Volonté, Lea Massari, Alain Cuny, Irene Papas, Paolo Bonacelli, François Simon, Francesco Càllari, Antonio Allocca",
    "subtitle": ["Werkschau: Francesco Rosi"],
    "bodycopy": [
      "Rosis Verfilmung des gleichnamigen autobiografischen Weltbestsellers von Carlo Levi über dessen von den Faschisten angeordnetem Exil in Aliano (1935/36). Der Ort, so sagen die Bewohner, sei so abgelegen, dass selbst das Christentum hier nur als ein Aberglaube unter vielen angekommen sei. Der Film beschreibt einen Alltag,der aus der Welt gefallen scheint: das Elend der Bauern, das Desinteresse für Politik, die Abwesenheit bildungsbürgerlicher Kultur und die Lächerlichkeit des sich wichtig nehmenden faschistischen Bürgermeisters."
    ],
    "image": "cristo-si-e-fermato-a-eboli.jpg"
  },
  {
    "title": "DICKTATORSHIP: FALLO E BASTA (DICKTATORSHIP – MACHO MADE IN ITALY)",
    "director": "Gustav Hofer und Luca Ragazzi",
    "country": "Italien",
    "releaseYear": 2019,
    "runtime": 90,
    "version": "OmU",
    "screeningDate": "16.09.2021",
    "readableDate": "2021-09-16",
    "screeningTime": "20:00",
    "actors": "Es treten auf: Gustav Hofer und Luca Ragazzi mit Fachleuten verschiedener Bereiche.",
    "subtitle": [
      "Zweifelsfrei sind wir in einem Film von Gustav Hofer und Luca Ragazzi: der Eine immer mit dem Finger in der Wunde des kranken Italiens, der Andere ein Verteidiger des „Bella Italia“.  Im Gespräch kommt die Frage auf, wie sich Trump, Erdogan und Co. trotz Frauenfeindlichkeit an der Macht behaupten können, und Hofer behauptet gegenüber dem skeptischen Ragazzi, dies ließe sich an einem Ort der Welt erklären: Italien.",
      "In ihrem Disput über den Machismo fördern sie aber amüsant Zustände zu Tage, die eigentlich zum Heulen sind, behandeln leichtfüßig schwergewichtige Probleme und entdecken manche unerwartete Kuriosität der Männerdominanz."
    ],
    "bodycopy": [
      "In ITALY-LOVE IT OR LEAVE IT gingen die beiden Autoren zum großen Vergnügen unseres Publikums den Missständen Italiens humorvoll auf den Grund. In ihrem neuen Film untersuchen sie die Verbindung von Sexualität und Macht oder wie sie es ausdrücken, die drei „P“: Penis, Power, Politik. An aussagekräftigen Orten oder bei einer gewöhnlichen Gondelfahrt reflektieren die Beiden mit ihren Positionen das globale phallozentrische System am Beispiel Italiens, das 887 Bezeichnungen für den Penis kennen soll.",
      "Auf ihrer Reise besuchen sie Experten verschiedener Fachbereiche, mit denen sie die angeschnittenen Probleme vertiefen oder Lösungen für ihre Streitthemen suchen.",
      "Ein Dokumentarfilm der besonderen Art für Freunde der unterhaltsamen Belehrung, für Menschen, die in scheinbar bekannten Argumenten neue Facetten entdecken wollen und natürlich für alle, denen Frauenrechte am Herzen liegen.",
      "Der Film lief in Deutschland auf dem Nuremberg International Film Festival in der Sektion Internationales Forum und hat auch im Ausland an zahlreichen Festivals teilgenommen"
    ],
    "image": "dicktatorship-5.jpg"
  },
  {
    "title": "Dimenticare Palermo (Palermo vergessen)",
    "director": "Francesco Rosi",
    "country": "Italien/Frankreich",
    "releaseYear": 1989,
    "runtime": 100,
    "version": "OmitU",
    "screeningDate": "21.10.2010",
    "readableDate": "2010-10-21",
    "screeningTime": "20:00",
    "actors": "James Belushi, Mimi Rogers, Joss Ackland, Vittorio Gassman, Philippe Noiret, Vyto Ruginis, Carolina Rosi, Marco Leonardi, Tiziana Stella, Salvatore Borgese",
    "subtitle": ["Geschichte der Mafia – Mafiageschichten"],
    "bodycopy": [
      "Ein italienischstämmiger US-Politiker begibt sich als wahltaktischen Gründen in seine„Heimat“. Dort macht ihm die Mafia unmissverständlich deutlich, dass sie dessen Legalisierungspolitik für harte Drogen für geschäftsschädigend hält. Rosi gelingt es dabei, eine ständige Atmosphäre der Bedrohung zu schaffen, obwohl er auf klassische, äußere Spannungsmomente verzichtet. Die Mafia ist ständig anwesend, aber weder zu sehen noch zu greifen. Den US-Filmstars James Belushi und Mimi Rogers gelingt es dabei hervorragend, die Ratlosigkeit des Fremden im Umgang mit dem Phänomen Mafia deutlich zu machen."
    ],
    "image": "dimenticare-palermo-1.jpg"
  },
  {
    "title": "DIVORZIO ALL'ITALIANA (SCHEIDUNG AUF ITALIENISCH)",
    "director": "Pietro Germi",
    "country": "Italien",
    "releaseYear": 1961,
    "runtime": 105,
    "version": "OmU",
    "screeningDate": "19.04.2018",
    "readableDate": "2018-04-19",
    "screeningTime": "20:00",
    "actors": "Marcello Mastroianni, Daniela Rocca, Stefania Sandrelli, Leopoldo Trieste, Angela Cardile, Odoardo Spadaro, Margherita Girelli, Lando Buzzanca, Pietro Tordi, Ugo Torrente",
    "subtitle": [
      "In Zeiten, in denen die Scheidung verboten ist, das Töten aus verletzter Ehre aber nahezu straflos bleibt, kann man schon mal auf verquere Ideen kommen. Das ist der Stoff, aus dem der Filmklassiker von Pietro Germi seine komödiantischen Funken schlägt."
    ],
    "bodycopy": [
      "Aus der Ehe des Barons Cefalù (Marcello Mastoianni) ist die Luft raus und sein Herz schlägt für die junge Angela (Stefania Sandrelli). Nachdem er in der Phantasie schon mehrfach seine Frau umgebracht hat, kommt er, angeregt durch einen Zeitungsartikel, auf die Idee, sie mit einem Liebhaber zu verkuppeln. Als dieser Plan endlich gelingt, ein Maler mit ihr durchbrennt und er dem Paar nachreist, läuft jedoch alles anders als vorgesehen."
    ],
    "image": "divorzio-allitaliana.jpg"
  },
  {
    "title": "Divorzio all'italiana (Scheidung auf Italienisch)",
    "director": "Pietro Germi",
    "country": "Italia",
    "releaseYear": 1961,
    "runtime": 120,
    "version": "OmitU",
    "screeningDate": "07.06.2006",
    "readableDate": "2006-06-07",
    "screeningTime": "18:00",
    "actors": "Marcello Mastroianni, Daniela Rocca, Stefania Sandrelli, Lando Buzzanca, Leopoldo Trieste, Odoardo Spadaro, Saro Archidiacono",
    "subtitle": [""],
    "bodycopy": [
      "Scheidung gesetzlich verboten, „Mord aus Leidenschaft“ aber gesetzlich toleriert: Was liegt da näher, als seine Frau in den Ehebruch zu treiben, sie dann aus „verletzter Ehre“ zu töten und nach kurzer Strafe die attraktive Geliebte und Cousine zu ehelichen. Eine schwarze Komödie und ein Pamphlet gegen das damalige italienische Ehe- und Strafrecht."
    ],
    "image": "divorzio.jpg"
  },
  {
    "title": "DJANGO (DJANGO)",
    "director": "Sergio Corbucci",
    "country": "Italien/Spanien",
    "releaseYear": 1966,
    "runtime": 91,
    "version": "OmU",
    "screeningDate": "15.09.2016",
    "readableDate": "2016-09-15",
    "screeningTime": "20:00",
    "actors": " Franco Nero, José Canalejas, José Bódalo, Loredana Nusciak, Ángel Álvarez, Gino Pernice, Simón Arriaga, Giovanni Ivan Scratuglia",
    "subtitle": [""],
    "bodycopy": [
      "In den Kampf zweier Banditenbanden mischt sich ein Fremder ein, der ein Maschinengewehr in einem Sarg hinter sich herzieht: Django. „Der eigentümlich konstruierte, überaus spannende und brutale Italowestern erwies sich als ein so überragender kommerzieller Erfolg, dass er eine wahre Django-Flut auslöste.“ (Filmdienst)"
    ],
    "image": "django-2.jpg"
  },
  {
    "title": "Dogman (Dogman)",
    "director": "Matteo Garrone",
    "country": "Italien/Frankreich",
    "releaseYear": 2018,
    "runtime": 102,
    "version": "OmU",
    "screeningDate": "21.03.2019",
    "readableDate": "2019-03-21",
    "screeningTime": "20:00",
    "actors": "Marcello Fonte, Edoardo Pesce, Nunzia Schiano, Adamo Dionisi, Alida Baldari Calabria, Francesco Acquaroli, Gianluca Gobbi, Aniello Arena",
    "subtitle": [
      "Den Kampf gegen die Camorra kann man nicht gewinnen- oder vielleicht doch? Wenn Matteo Garrone (GOMORRHA) von ihm in seinem neuen Film erzählt, ist etwas Besonderes zu erwarten. Allein der Ort, an dem sich fast der ganze Film bewegt, sind pittoreske Ruinen, die einen Verfremdungseffekt erzeugen, aber auch das soziale Umfeld kennzeichnen. Man sollte wissen, dass es diesen Ort wirklich gibt: Villaggio Coppola an der Kampanischen Küste, inmitten eines Naturschutzgebietes."
    ],
    "bodycopy": [
      "Protagonist ist der etwas naive Hundefriseur Marcello, der sich am Anfang des Films mit einem Kampfhund auseinanderzusetzen hat, der sich nicht waschen lassen will. Aber Marcello „überzeugt“ihn und wir sehen, wie der Hund das Föhnen sichtlich genießt. Mit seinem stärkeren und deutlich größeren Freund Simone, der zu Wutausbrüchen neigt, sich bei seinen kleinkriminellen Aktionen irrational verhält und Marcello mit hineinzieht, hat er es nicht so einfach. Er muss sich von ihm, wie alle Ladenbesitzer um seinen Hundefriseursalon herum, drangsalieren lassen. Und dann ist da noch seine Tochter, die er vergöttert und die ihren Vater liebt: es könnte ein glückliches Zusammenleben sein, wären da nicht die prekären finanziellen Umstände und der emotionale und physische Terror Simones, der Drogengeschäfte für die Camorra unterhält. Als er einen dümmlich geplanten Einbruch begeht, geht Marcello für ihn ins Gefängnis. Aber als er herauskommt, zeigt sich Simone gleichgültig. Es beginnt ein ungleicher Kampf, den der schmächtige Marcello nur verlieren kann – oder gibt es einen anderen Weg?"
    ],
    "image": "dogman.jpg"
  },
  {
    "title": "Domani (Der Tag danach)",
    "director": "Francesca Archibugi",
    "country": "Italien",
    "releaseYear": 2001,
    "runtime": 88,
    "version": "OmU",
    "screeningDate": "22.04.2004",
    "readableDate": "2004-04-22",
    "screeningTime": "19:30",
    "actors": "Marco Baliani, Ornella Muti, David Bracci, Valerio Mastandrea",
    "subtitle": [""],
    "bodycopy": [
      "Nach dem Erdbeben 1997 in Umbrien findet ein ganzes Dorf, nach anfänglichem Chaos, die Lust am Leben, die Gefühle und das Lachen wieder."
    ],
    "image": "Domani.jpg"
  },
  {
    "title": "Domenica (Domenica)",
    "director": "Wilma Labate",
    "country": "Italien",
    "releaseYear": 2001,
    "runtime": 95,
    "version": "OmU",
    "screeningDate": "28.04.2004",
    "readableDate": "2004-04-28",
    "screeningTime": "19:30",
    "actors": "Claudio Amendola, Annabella Sciorra, Domenica Giuliano, ",
    "subtitle": [""],
    "bodycopy": [
      "Ein Polizeikommissar und eine Waise laufen einen Tag lang durch die Straßen Neapels. In einem Wirrwarr flüchtiger Begebenheiten führt das Mädchen den Kommissar durch die Gassen eines armen, geheimnisvollen, unschuldigen und verfluchten Neapels."
    ],
    "image": "Domenica.jpg"
  },
  {
    "title": "Dopo mezzanotte (Die zweite Hälfte der Nacht)",
    "director": "Davide Ferrario",
    "country": "Italia",
    "releaseYear": 2004,
    "runtime": 92,
    "version": "OmU",
    "screeningDate": "19.01.2012",
    "readableDate": "2012-01-19",
    "screeningTime": "20:00",
    "actors": "Giorgio Pasotti, Francesca Inaudi, Fabio Troiano, Francesca Picozza, Gianpiero Perone, Ivan Negro, Silvo Orlando (Stimme aus dem Off)",
    "subtitle": [""],
    "bodycopy": [
      "Der Nachtwächter Martino, der sich im Filmmuseum Turin häuslich eingerichtet hat, findet sich auf einmal mit einer Fremden auf der Flucht konfrontiert, der er nach und nach filmgeschichtliche Liebeserklärungen macht."
    ],
    "image": "dopo-mezzanotte.jpg"
  },
  {
    "title": "DOPO MEZZANOTTE (DIE ZWEITE HÄLFTE DER NACHT)",
    "director": "Davide Ferrario",
    "country": "Italien",
    "releaseYear": 2004,
    "runtime": 92,
    "version": "OmU",
    "screeningDate": "16.05.2014",
    "readableDate": "2014-05-16",
    "screeningTime": "2:00",
    "actors": " Giorgio Pasotti, Francesca Inaudi, Fabio Troiano, Francesca Picozza, Gianpiero Perone, Ivan Negro, Silvo Orlando (Stimme aus dem Off)",
    "subtitle": ["Höhepunkte aus 10 Jahren „Italienischer Filmclub“"],
    "bodycopy": [
      "Amanda, die Freundin des Autodiebes Angelo gerät auf der Flucht nachts ins Filmmuseum Turin, in dem sich der Nachtwächter Martino häuslich eingerichtet hat. Nachts fühlt er sich dort als Herr über die Kinoträume, die er auf einmal mit einer Unbekannten teilen muss. Eine poetische Hommage an die Filmgeschichte und eine ungewöhnliche Liebesgeschichte."
    ],
    "image": "dopo-mezzanotte.jpg"
  },
  {
    "title": "DRAMMA DELLA GELOSIA. TUTTI I PARTICOLARI IN CRONACA (Eifersucht auf Italienisch)",
    "director": "Ettore Scola",
    "country": "Italien/Spanien",
    "releaseYear": 1970,
    "runtime": 107,
    "version": "OmU",
    "screeningDate": "19.06.2008",
    "readableDate": "2008-06-19",
    "screeningTime": "19:00",
    "actors": "Monica Vitti, Marcello Mastroianni, Giancarlo Giannini, Marisa Marlini, Manolo Zardo, Hercules Cortes, Gioia Desideri, Juan Diego, Bruno Scipioni, Serafina Serratosa",
    "subtitle": ["Werkschau: Ettore Scola"],
    "bodycopy": [
      "Eine Tragikomödie im Rom der späten 60er Jahre. Witzig und satirisch nimmt Scola die italienischen Lebensgewohnheiten und Geschlechterbeziehungen ins Visier. Der verheiratete Maurer Oreste (Marcello Mastroianni) verliebt sich in Adelaine (Monica Vitti), die er auf einer politischen Demonstration kennen gelernt hat. Aber die entscheidet sich für den charmanten Nello (Giancarlo Giannini) - mit tödlichen Folgen."
    ],
    "image": "fabiettomariasaverio.jpg"
  },
  {
    "title": "È STATA LA MANO DI DIO (DIE HAND GOTTES)",
    "director": "Paolo Sorrentino",
    "country": "Italien/USA",
    "releaseYear": 2021,
    "runtime": 130,
    "version": "OmU",
    "screeningDate": "17.03.2022",
    "readableDate": "2022-03-17",
    "screeningTime": "20:00",
    "actors": "Filippo Scotti, Toni Servillo, Teresa Saponangelo, Louisa Ranieri, Renato Carpentieri, u.a.",
    "subtitle": [
      "Fußball-WM 1986: ein vermeintlicher Kopfball Diego Maradonas stellt sich im Nachhinein als Handspiel heraus. Es sei die Hand Gottes gewesen, die den Ball gelenkt habe, rechtfertigte sich der Fußballer. Auch wenn dieser Satz titelgebend war: der Film handelt nicht nur vom Fußball. Vordergründig ist er eine Auseinandersetzung Sorrentinos mit seiner Kindheit und Jugend in Neapel: im Mittelpunkt der Filmerzählung steht der Junge Fabietto und seine exzentrische Familie. Den Hintergrund bildet der Wechsel Maradonas zum vom Abstieg bedrohten SSC Napoli. Und Maradona wird es später sein, der Fabietto indirekt das Leben rettet. Wie im wahren Leben Sorrentinos. Dass es sich daher um den persönlichsten Film Sorrentinos (FAZ) handeln soll, er gar ein narzisstischer Exzess (SWR) sei, scheint übertrieben. Durch das Erzählen einer Familiengeschichte mit dem Fokus auf das Fußballgeschehen wird Atmosphäre und Geist einer inzwischen vergangenen Epoche einschließlich ihrer Mythen und Legenden wieder zum Leben erweckt."
    ],
    "bodycopy": [
      "Durch die interpretierenden Augen des pubertierenden Fabietto betrachtet Sorrentino die Realität in dessen Familie. So lässt er ihn und uns Neapel und seine Menschen kennenlernen: beispielsweise behauptet seine Tante Patrizia vom Schutzheiligen der Stadt im Rolls-Royce auf der Straße aufgegabelt worden zu sein, um sie dem kleinen Mönch, der legendären neapolitanischen Figur, vorzustellen; ihr Mann vermutet jedoch, sie sei bei ihrem Liebhaber gewesen und schlägt sie windelweich. Die Familie beobachtend lernt Fabietto die Machohaftigkeit Neapels der 80er Jahre kennen, und erfährt etwas über die Legenden und Mythen der Stadt, die immer wieder für Ausreden herhalten müssen. Weil sein Vater ihm eine Dauerkarte für den SSC Neapel geschenkt hat, ist er bei einem Spiel mit Maradona im Stadion als ein Unglück seine Eltern tötet. Neapel hingegen ist im Maradona-Fieber, das Sorrentino nutzt, um diesem Fußballstar zu huldigen.",
      "Der Film erhielt den Großen Preis der Jury bei den Filmfestspielen in Venedig."
    ],
    "image": "fabiettomariasaverio.jpg"
  },
  {
    "title": "Edipo re (Bett der Gewalt)",
    "director": "Pier Paolo Pasolini",
    "country": "Italien",
    "releaseYear": 1967,
    "runtime": 104,
    "version": "OmitU",
    "screeningDate": "05.08.2009",
    "readableDate": "2009-08-05",
    "screeningTime": "20:00",
    "actors": "Franco Citti, Silvana Mangano, Alida Valli, Carmelo Bene, Julian Beck, Luciano Bartoli",
    "subtitle": ["Werkschau: Pier Paolo Pasolini"],
    "bodycopy": [
      "Entgegen unserem durch die Psychoanalyse geprägten Blick dominiert bei Pasolini im Ödipusstoff nicht der Inzest, vielmehr lotet er den Vatermord als allegorisches und gesellschaftliches Thema aus und erzählt ihn in zwei Varianten. Angelehnt an den klassischen Stoff widmet sich die eine dem Blick auf das archaische Geschehen, während die andere, angesiedelt zwischen 1920 und 1960, auf die sozialgesellschaftliche Aktualität des Ödipus-Motivs verweist."
    ],
    "image": "edipo-re.jpg"
  },
  {
    "title": "Ein Dorf in Europa",
    "director": "Robert Krieg und Monika Nolte",
    "country": "Deutschland",
    "releaseYear": 2007,
    "runtime": 90,
    "version": "OmU",
    "screeningDate": "17.01.2008",
    "readableDate": "2008-01-17",
    "screeningTime": "19:00",
    "actors": "",
    "subtitle": ["Premiere"],
    "bodycopy": [
      "Ein Dorf nördlich von Rom: Wie in einem Mikrokosmos spiegelt sich hier die Entwicklung Europas. In den 20er Jahren zieht es die Männerin die USA, nach dem Krieg sorgt die Suche der neorealistischen Regisseure nach Statisten für einen kleinen Aufschwung. Heute ist das Dorf eine Schlafstadt Roms, die Landwirtschaft spielt kaum noch eine Rolle. Inzwischen leben hier Menschen aus 20 Nationen, mehrere Hundert als illegale Arbeitskräfte des grauen Arbeitsmarktes. Der Blick auf Europa als Ganzes verstellt oft die Sicht, was dies für die Menschen „ganz unten“ bedeutet. Dem versucht der Film nachzugehen.",
      "Eine Kooperation mit der Filmwerkstatt Düsseldorf."
    ],
    "image": "ein-dorf-in-europa.jpg"
  },
  {
    "title": "EUFORIA (EUFORIA)",
    "director": "Valeria Golino",
    "country": "Italien",
    "releaseYear": 2018,
    "runtime": 110,
    "version": "OmU",
    "screeningDate": "14.10.2021",
    "readableDate": "2021-10-14",
    "screeningTime": "20:00",
    "actors": "Riccardo Scamarcio, Valerio Mastandrea, Isabella Ferrari, Valentina Cervi, Jasmine Trinca u.a.",
    "subtitle": [
      "Sicherlich ist es nicht einfach, sich um den krebserkrankten größeren Buder zu kümmern. Insbesondere wenn dieser es nie aus seinem Provinznest herausgeschafft und berufliche Karriere gemacht hat, man selbst aber als bekennender Schwuler im Wohlstand in Rom lebend die Erfolgsleiter hochgestiegen ist. Aber auch für den „Bekümmerten“ ist das neue mondäne Umfeld und die Rolle als Empfänger brüderlicher Fürsorge nur schwer zu ertragen. Valeria Golino, hierzulande eher als Schauspielerin bekannt, lotet die Facetten einer scheinbar verschütteten Beziehung aus, in der sich die ursprünglichen Entscheidungsmechanismen umdrehen sollen: Nicht der Erkrankte soll über seine letzten Monate bestimmen, vielmehr will der jüngere Bruder das für ihn übernehmen. Aber die dadurch verletzten Gefühle fordern zunehmend ihr Recht."
    ],
    "bodycopy": [
      "Matteo steht gerne im Mittelpunkt, liebt das römische Partyleben und residiert in einem luxuriösen Penthaus. Da ist es für ihn selbstverständlich, seinen älteren Bruder Ettore bei sich aufzunehmen, als er von dessen Krebsdiagnose erfährt. Der hingegen hat sein Leben in dem kleinen Dorf, in dem beide aufgewachsen sind, als Schullehrer verbracht und wird von ständigen Versagensängsten geplagt. Ettore zieht bei Matteo ein, aber ein vertrautes Zusammenleben ist schwer aufzubauen, da Matteos Leben von beruflichen Pflichten, gesellschaftlicher Repräsentation und Pflege von Freundschaften geprägt ist, sodass sich Ettore bald als marginalisiert empfindet und zu reagieren beginnt.",
      "Matteo muss lernen und feststellen, dass auch eine „Provinzmaus“ Werte und Empfindungen hat, die trotz Erkrankung Lebensqualität schaffen können. Ein Lernprozess, der in einem Schlussbild endet, für das allein es sich lohnt, den Film zu sehen."
    ],
    "image": "euforia.jpg"
  },
  {
    "title": "FACCIA A FACCIA (VON ANGESICHT ZU ANGESICHT)",
    "director": "Sergio Sollima",
    "country": "Italien/Spanien",
    "releaseYear": 1967,
    "runtime": 112,
    "version": "OmU",
    "screeningDate": "03.09.2016",
    "readableDate": "2016-09-03",
    "screeningTime": "19:00",
    "actors": "Gian Maria Volontè, Tomas Milian, William Berger, Jolanda Modio, Gianni Rizzo, Carole André, Ángel del Pozo",
    "subtitle": [""],
    "bodycopy": [
      "Ein Duell der anderen Art: der vom Banditen Bennet als Geisel genommene Fletcher findet immer mehr Gefallen am kriminellen Leben, während der Verbrecher auf den rechten Weg zurück findet. FACCIA A FACCIA ist nach RESA DEI CONTI der zweite Teil von Sollimas Western-Trilogie und gilt als einer der tiefgründigsten Italo-Western. So wirft er u.a. Fragen zur Relativität moralischer Fragen im kriminellen Umfeld auf."
    ],
    "image": "faccia-a-faccia-2.jpg"
  },
  {
    "title": "FAI BEI SOGNI (TRÄUM WAS SCHÖNES)",
    "director": "Marco Bellocchio",
    "country": "Italien/Frankreich",
    "releaseYear": 2016,
    "runtime": 134,
    "version": "OmU",
    "screeningDate": "15.03.2018",
    "readableDate": "2018-03-15",
    "screeningTime": "20:00",
    "actors": "Bérénice Bejo, Valerio Mastandrea, Fabrizio Gifuni, Miriam Leone, Guido Caprino, Roberto Herlitzka, Barbara Ronchi",
    "subtitle": [
      "Wie geht ein gerade mal neunjähriger Junge damit um, wenn er ahnt, dass sich die geliebte Mutter umgebracht hat und ihm die Erwachsenen dies erst in Raten beizubringen versuchen. Er trägt es sein ganzes Leben mit sich herum und fragt sich, was wirklich an diesem schicksalhaften Tag passierte."
    ],
    "bodycopy": [
      "Als Massimo die Wohnung des verstorbenen Vaters ausräumen muss, stößt er auf Hinterlassenschaften, die ihn sein eigenes Leben in Erinnerung zurückrufen, ihn aber auch mit seinem Kindheitstrauma konfrontieren.",
      "Als renommierter Journalist zu arbeiten und über Andere zu berichten war vielleicht notwendig, um sich vor sich selbst verstecken zu können, unfähig eine emotional tiefe Verbindung einzugehen oder sich zu verlieben.",
      "Jetzt verursacht ihm das endgültige Aufräumen Panikattacken und so lernt er die bezaubernde Internistin Elisa kennen. Eine Chance, die Dämonen der Vergangenheit zu vertreiben? Massimo muss sich seiner eigenen Wahrheit stellen."
    ],
    "image": "fai-bei-sogni.jpg"
  },
  {
    "title": "FAVOLACCE (BAD TALES / ES WAR EINMAL EIN TRAUM)",
    "director": "Fabio D'Innocenzo, Damiano D'Innocenzo",
    "country": "Italien",
    "releaseYear": 2020,
    "runtime": 96,
    "version": "OmU",
    "screeningDate": "19.01.2023",
    "readableDate": "2023-01-19",
    "screeningTime": "20:00",
    "actors": "Elio Germano, Barbara Chichiarelli, Lino Musella, Gabriel Montesi, Max Malatesta u.a.",
    "subtitle": [
      "Elio Germano, Barbara Chichiarelli, Lino Musella, Gabriel Montesi, Max Malatesta u.a."
    ],
    "bodycopy": [
      "Eine Familie, Kinder, ein Siedlungshaus, Nachbarn – mit Familie, Kindern, einem Siedlungshaus, Nachbarn mit Familie … so geht das bis zum Bildrand und scheint darüber hinaus zu reichen. Das Leben spielt sich, jeder für sich, aber von allen einsehbar, auf dem Streifen Grundstück ab, das als Terrasse und Garten fungieren muss. Gelegentlich kommt man zusammen, grillt und trinkt gemeinsam, streitet sich gelegentlich und scheut nicht die Lächerlichkeit im Versuch sich wichtig zu machen. Da kann man schon mal ins Zentrum der Aufmerksamkeit geraten, wenn man ein aufblasbares Planschbecken am Haus aufbaut und die Nachbarn einlädt, nach Belieben vorbeizukommen. Mit der spießbürgerlichen Ruhe ist es damit vorbei. Der neue alte Status Quo muss wiederhergestellt werden.",
      "Die Kinder beobachten, weitgehend unbeachtet, das Treiben der Erwachsenen – die Kamera folgt ihrem Blick und erzählt große Teile des Films auf Kinderaugenhöhe. Die Kinder ihrerseits versuchen die Erwachsenenwelt zu karikieren, aber auch zu kopieren, immer auf der Suche nach einem eigenen Weg und jederzeit den Erwachsenen ausgeliefert. So entsteht ein böses Portrait des modernen italienischen Spießbürgertums. Im wahrsten Sinne eine FAVOLACCIA (unübersetzbare Wertung des Wortes Märchen/Geschichte in Richtung bösartig, widerlich, unangenehm, hässlich)."
    ],
    "image": "favolacce.jpg"
  },
  {
    "title": "Figli di Annibale (Hannibals Kinder)",
    "director": "Davide Ferrario",
    "country": "Italien",
    "releaseYear": 1997,
    "runtime": 93,
    "version": "OmU",
    "screeningDate": "20.10.2005",
    "readableDate": "2005-10-20",
    "screeningTime": "19:30",
    "actors": "Diego Abantantuono, Silvio Orlando, Flavio Insinna, Valentina Cervi, Ugo Conti",
    "subtitle": [""],
    "bodycopy": [
      "Was kann einem heruntergekommenen Unternehmer Besseres passieren, als entführt zu werden? Auch wenn der Entführer eigentlich in die Schweiz will – es geht ab in den Süden mit Ziel Afrika. Wozu ist man Unternehmer, wenn man das Heft nicht in die Hand nimmt? Zu beiden gesellen sich dessen Tochter und die blinde Schwester des Entführers. So weit so gut. Kompliziert wird es, als sich ein Polizist in den Unternehmer verliebt und die Reise „begleitet“. Eine erstklassig besetzte Dialogkomödie „al dente“."
    ],
    "image": "figli-di-annibale.jpg"
  },
  {
    "title": "FIGLIA MIA (MEINE TOCHTER)",
    "director": "Laura Bispuri",
    "country": "Italien/Deutschland/Schweiz",
    "releaseYear": 2018,
    "runtime": 100,
    "version": "OmU",
    "screeningDate": "18.10.2018",
    "readableDate": "2018-10-18",
    "screeningTime": "20:00",
    "actors": "Valeria Golino, Alba Rohrwacher, Sara Casu, Michele Carboni, Udo Kier",
    "subtitle": [
      "Ein Mädchen im Spannungsfeld zweier Mütter, der leiblichen und derjenigen, die sie mit Liebe aufgezogen hat. Eine Frauenfreundschaft, die sich in einer massiven Krise bewähren muss. Ein Kind lernt, sich von der Erwachsenenwelt zu emanzipieren und Verantwortung zu übernehmen. Dieser Film verbindet diese Erzählstränge zu einer bewegenden Geschichte."
    ],
    "bodycopy": [
      "Tina ist die Mutter der 10-jährigen Vittoria, glaubt diese zumindest. Gemeinsam unterstützen sie die etwas chaotische, in prekären Verhältnissen lebende und partyliebende Angelica. Als der Pleitegeier über Angelicas Hab- und Gut kreist, möchte sie sich vor ihrem Wegzug von Vittoria, in Wirklichkeit ihre leibliche Tochter, verabschieden. So verbringen die beiden mit der Zustimmung von Tina immer mehr Zeit miteinander und Vittoria erkennt, während sie mit Angelica herumstromert, langsam die wahren Verhältnisse. Zur Katastrophe kommt es, als ein Gläubiger sich mit Gewalt Angelicas Pferd holen will, während Vittoria in der Wildnis ihre Angst überwindet und in ein Erdloch klettert, in dem Angelica einen Schatz vermutet. Aber jeder Katastrophe wohnt ein Anfang inne – und so lässt das offene Ende viel Platz für Hoffnungen."
    ],
    "image": "figlia-mia.jpg"
  },
  {
    "title": "FILM D’AMORE E D’ANARCHIA OVVERO STAMATTINA ALLE 10 IN VIA DEI FIORI NELLA NOTA CASA DI TOLLERANZA... (LIEBE UND ANARCHIE)",
    "director": "Lina Wertmüller",
    "country": "Italien",
    "releaseYear": 1973,
    "runtime": 124,
    "version": "OmU",
    "screeningDate": "18.07.2013",
    "readableDate": "2013-07-18",
    "screeningTime": "20:00",
    "actors": "Giancarlo Giannini, Mariangela Melato, Eros Pagni, Elena Fiore, Lina Polito, Pina Cei",
    "subtitle": ["Lina Wertmüller zum 85. Geburtstag"],
    "bodycopy": [
      "Der naive Bauer Tonino kommt nach Rom, um Mussolini umzubringen. Zur Tarnung in einem Bordell einquartiert verwirrt ihn nicht nur die Größe der Stadt, sondern auch die Verführungskünste seiner weiblichen Mitbewohnerinnen. Nachdem er die Gelegenheit zum Attentat in den Armen seiner Geliebten verschlafen hat, gerät er bei einer Razzia in Panik."
    ],
    "image": "film-damore.jpg"
  },
  {
    "title": "FILM D’AMORE E D’ANARCHIA, OVVERO STAMATTINA ALLE 10 IN VIA DEI FIORI NELLA NOTA CASA DI TOLLERANZA ... (Liebe und Anarchie)",
    "director": "Lina Wertmüller",
    "country": "Italia/Francia",
    "releaseYear": 1973,
    "runtime": 125,
    "version": "OmU",
    "screeningDate": "20.11.2008",
    "readableDate": "2008-11-20",
    "screeningTime": "19:00",
    "actors": "Giancarlo Giannini, Mariangela Melato, Lina Polito, Eros Pagni, Pina Cei, Elena Fiore ",
    "subtitle": ["Lina Wertmüller zum 80. Geburtstag"],
    "bodycopy": [
      "Der naive Bauernbursche Tunin will Mussolini ermorden und wird von seinem Kontaktmann in einem Bordell einquartiert. Hier trifft er auf die Liebe seines Lebens. Irritiert durch diese neuen Erfahrungen und nicht vertraut mit der „großen Stadt“ Rom, verpasst er die Gelegenheit zum Attentat, was die Faschisten aber nicht hindert, ihn zu verfolgen.„Mächtige Politik, zärtliche Romanze, bitterböse Farce und melodramatische Tragödie, dazu die grandiose Musik von Nino Rota und Carlo Savina: große Kinounterhaltung mit großem Hintergrund“."
    ],
    "image": "film-damore.jpg"
  },
  {
    "title": "Francesco (Franziskus)",
    "director": "Liliana Cavani",
    "country": "Italien/Deutschland",
    "releaseYear": 1989,
    "runtime": 130,
    "version": "OmU",
    "screeningDate": "20.12.2005",
    "readableDate": "2005-12-20",
    "screeningTime": "19:00",
    "actors": "Mickey Rourke, Helena Bonham Carter, Andréa Ferrèol, Nikolaus Dutsch, Peter Berling, Mario Adorf",
    "subtitle": ["Werkschau: Mario Adorf"],
    "bodycopy": [
      "Der Film erzählt die Geschichte des heiligen Franz von Assisi, des Gründers des Franziskaner-Ordens. Als Francesco Bernadone 1182 geboren verließ er unverstanden das wohlhabende Elternhaus und begab sich unter die Armen und Kranken, um mit ihnen zu leben. Lange ringt er um die Anerkennung seiner Bewegung durch den Vatikan. Nachdem er diese erhalten hat, verzweifelt er am Wunsch seiner Anhänger nach „Regeln“ und zieht auf der Suche nach Erleuchtung in die Wälder.Mario Adorf spielt eine Nebenrolle als Kardinal Ugolino Di Segni."
    ],
    "image": "franziskus.jpg"
  },
  {
    "title": "FUOCOAMMARE (SEEFEUER)",
    "director": "Gianfranco Rosi",
    "country": "Italien/Frankreich",
    "releaseYear": 2016,
    "runtime": 114,
    "version": "OmU",
    "screeningDate": "21.09.2017",
    "readableDate": "2017-09-21",
    "screeningTime": "20:00",
    "actors": "Samuele Pucillo, Mattias Cucina, Samuele Caruana, Pietro Bartolo, Giuseppe Fragapane, Maria Signorello, Francesco Paterna, Francesco Mannino, Maria Costa",
    "subtitle": [
      "Was verbinden Bootsflüchtlinge und spielende Kinder? Die Insel Lampedusa: für die einen dramatisch zu erreichender Fluchtort, für die anderen vertraute Heimat. Gianfranco Rosi erzählt diese Inselrealitäten in teilweise spektakulär und teilweise banal wirkenden Bildern."
    ],
    "bodycopy": [
      "So entsteht das impressionistische Bild zweier Wirklichkeiten auf der Insel, die sich zwar berühren, aber unterschiedlicher kaum sein könnten: ein fast müßiggängerischer, unaufgeregter Alltag und um das Überleben kämpfende Menschen unter inhumanen Bedingungen. Der Dokumentarfilm ist das Ergebnis einjähriger Beobachtungen der Ereignisse am Ort."
    ],
    "image": "fuocoammare.jpg"
  },
  {
    "title": "Fuori dal mondo (Nicht von dieser Welt)",
    "director": "Giuseppe Piccioni",
    "country": "Italien",
    "releaseYear": 1999,
    "runtime": 101,
    "version": "OmU",
    "screeningDate": "16.12.2004",
    "readableDate": "2004-12-16",
    "screeningTime": "19:30",
    "actors": "Margherita Buy, Silvio Orlando, Carolina Freschi, Marina Massironi, Giuliana Lojodice, Francesco Foti",
    "subtitle": [""],
    "bodycopy": [
      "Was passiert, wenn sich eine Novizin mit einem Baby wiederfindet, das ihr ein Jogger in den Arm gedrückt hat? Sie sucht die Mutter. Ein Kassenbon im Pullover, in den das Baby eingewickelt ist, führt sie zu Ernesto, der misanthropisch eine Reinigung leitet und sich wenig für seine Mitmenschen interessiert. Das beginnt sich nach und nach zu ändern, als er den Pullover als seinen Eigenen erkennt und sich an eine kurze Episode mit einer Angestellten erinnert: War das nicht ungefähr vor neun Monaten?",
      "Während die Novizin Caterina immer mehr mütterliche Gefühle entdeckt und das Baby aus dem Krankenhaus entführt, wo es auf seine zukünftigen Adoptiveltern wartet, beginnt Ernesto aus seiner geschlossenen Welt aufzutauchen.",
      "Auf der Suche nach Teresa, der Mutter des Babys, reiben sich die beiden Lebenskonzepte, die außerhalb der Welt zu stehen scheinen, sowohl aneinander als auch an der Alltagswirklichkeit Mailands. Langsam scheint sich eine Romanze anzubahnen ... aber Piccioni gelingt es, jedes Abgleiten in Rührseligkeit und die gewohnten Klischees zu vermeiden und zeichnet ein sensibles Bild zweier Aussenseiter aus der Mitte unserer Gesellschaft."
    ],
    "image": "fuori-dam-mondo.jpg"
  },
  {
    "title": "Generazione 1000 euro (Die 1000-Euro-Generation)",
    "director": "Massimo Vernier",
    "country": "Italien",
    "releaseYear": 2009,
    "runtime": 101,
    "version": "OmitU",
    "screeningDate": "07.12.2011",
    "readableDate": "2011-12-07",
    "screeningTime": "20:00",
    "actors": "Alessandro Tiberi, Valentina Lodovini, Carolina Crescentini, Francesco Mandelli, Francesca Inaudi, Paolo Villaggio",
    "subtitle": ["150 Jahre Italien"],
    "bodycopy": [
      "Was nützt der beste Abschluss und Leidenschaft für Mathematik bei einem prekären Arbeitsverhältnis in einem Marketingunternehmen in ständiger Reorganisation? Marco hat sich in einer Wohnung mit seinem besten Freund, einem modernen Lebenskünstler,eingerichtet und man könnte sich weiter durchwursteln – gäbe es da nicht die attraktive Vizedirektorin und eine neue Mitbewohnerin, die Marcos Leben immer wieder in neue Richtungen treiben lassen. Amüsante Kommödie zu einem ernsten Thema: den prekären Lebensbedingungen der jungen Generation in Italien,"
    ],
    "image": "generazione-1000-euro.jpg"
  },
  {
    "title": "GENERAZIONE MILLE EURO (DIE 1000-EURO-GENERATION)",
    "director": "Massimo Vernier",
    "country": "Italien",
    "releaseYear": 2009,
    "runtime": 101,
    "version": "OmU",
    "screeningDate": "17.01.2013",
    "readableDate": "2013-01-17",
    "screeningTime": "20:00",
    "actors": "Alessandro Tiberi, Valentina Lodovini, Carolina Crescentini, Francesco Mandelli",
    "subtitle": [""],
    "bodycopy": [
      "Prekäre Arbeitsverhältnisse und arrangierte Wohnverhältnisse beeinflussen auch das Beziehungsleben. Tragisch und komisch: das Bild der jungen Generation wird leicht und amüsant dargestellt, ohne sich den Problemen zu verschließen."
    ],
    "image": "generazionemilleeuro.jpg"
  },
  {
    "title": "GENITORI & FIGLI: AGITARE BENE PRIMA DELL’USO",
    "director": "Giovanni Veronesi",
    "country": "Italien",
    "releaseYear": 2010,
    "runtime": 106,
    "version": "OmitU",
    "screeningDate": "02.05.2012",
    "readableDate": "2012-05-02",
    "screeningTime": "20:00",
    "actors": " Margherita Buy, Silvio Orlando, Michele Placido, Luciana Littizzetto",
    "subtitle": [""],
    "bodycopy": [
      "Aufgehängt am Aufsatzthema „Genitori e figli: istruzioni per l’uso“ erzählt Nina von ihren Beobachtungen und legt humoristisch viele Absurditäten im Zusammenlebeneben der Generationen frei. Der Zuschauer verlässt das Kino amüsiert und mit vielen neuen Eindrücken."
    ],
    "image": "genitori-e-figli.jpg"
  },
  {
    "title": "Gente di Roma",
    "director": "Ettore Scola",
    "country": "Italien",
    "releaseYear": 2003,
    "runtime": 93,
    "version": "OmU",
    "screeningDate": "17.04.2008",
    "readableDate": "2008-04-17",
    "screeningTime": "19:00",
    "actors": "Giorgio Colangeli, Antonello Fassari, Silvia Scola u.a.",
    "subtitle": ["Werkschau: Ettore Scola"],
    "bodycopy": [
      "Scolas humorvoll-melancholische Hommage an „seine Stadt“ Rom. Ein fiktiver Dokumentarfilm, der virtuos den Marotten der Mitmenschen nachgeht, aber auch den philosophischen Hintergrund des Alltags auslotet. Angesiedelt zwischen Absurdität und Poesie gelingt es Scola eine Stadt und ihre Bewohner zu zeichnen, der und denen seine ganze Sympathie gilt. Ein ruhiges und gleichzeitig belebendes „Alterswerk“, das hoffentlich nicht das letzte dieses Altmeisters ist."
    ],
    "image": "gente-di-roma.jpg"
  },
  {
    "title": "Gianni e le donne (GIANNI UND DIE FRAUEN)",
    "director": "Gianni Di Gregorio",
    "country": "Italien",
    "releaseYear": 2011,
    "runtime": 89,
    "version": "OmU",
    "screeningDate": "19.07.2012",
    "readableDate": "2012-07-19",
    "screeningTime": "20:00",
    "actors": "Gianni Di Gregorio, Valeria De Franciscis, Alfonso Santagata, Elisabetta Piccolomini, Valeria Cavalli",
    "subtitle": [""],
    "bodycopy": [
      "Kommödie des Selbstdarstellers Gianni Di Gregorio, in der er erotische Phantasien eines gealterten Mannes in einer Umwelt karikiert, die aus Ehe, Hundausführen und Freunde bewundern besteht."
    ],
    "image": "gianni-e-le-donne.jpg"
  },
  {
    "title": "GINGER E FRED (GINGER UND FRED)",
    "director": "Federico Fellini",
    "country": "Italien",
    "releaseYear": 1986,
    "runtime": 125,
    "version": "OmU",
    "screeningDate": "18.12.2018",
    "readableDate": "2018-12-18",
    "screeningTime": "20:00",
    "actors": "Marcello Mastroianni, Giulietta Masina, Franco Fabrizi, Friedrich von Ledebur, Augusto Poderosi, Martin Maria Blau, Jacques-Henri Lartigue",
    "subtitle": [
      "Wer einen Film mit Ginger Rogers und Fred Astaire erwartet, könnte falscher nicht liegen. Zwar sind die Protagonisten (Giulietta Masina als Amelia Bonetti und Marcello Mastroianni als Pippo Botticella) Nachahmer des berühmten Stepptänzerpaares, aber erzählt wird von einer abstrusen Fernsehshow, in der die beiden eine unklare Rolle spielen sollen. Mit diesem Film hat Fellini wieder einmal eines seiner Lieblingsthemen aufgegriffen: das Lächerlichmachen des Fernsehens auf hohem Niveau."
    ],
    "bodycopy": [
      "Die Zeit, als Pippo und Amelia liiert waren und mit ihren Stepptanznummern im Stile Fred Astairs und Ginger Rogers mehr oder weniger Erfolg hatten, ist in den 80er Jahren (der Entstehungszeit des Films) lang vorbei und seit ihrer Trennung in den 50ern haben sie sich weder gesehen, noch zusammen gearbeitet. Erst die gemeinsame Einladung zu einer Fernsehshow führt die beiden wieder zusammen und so warten sie, welche Rolle sie in der Produktion eigentlich spielen sollen. Währenddessen zieht an ihnen die Welt des Fernsehens in Form skurriler Gestalten vorbei, die als Gäste der Show auftreten sollen, und schnell deutlich machen, dass die Beiden Teil einer Freakshow werden sollen. Amelia, dafür blind, besteht auf ihrem Künstlerinnenanspruch, während Pippo sich von vorneherein distanziert: es mache es nur wegen des Geldes. Eine Generalprobe in einem nicht genutzten Raum lässt das Schlimmste für den Auftritt vor der Kamera befürchten. Und dann kommt es zum „großen Auftritt“."
    ],
    "image": "ginger-e-fred.jpg"
  },
  {
    "title": "GIORNI E NUVOLE (Tage und Wolken)",
    "director": "Silvio Soldini",
    "country": "Italien/Schweiz",
    "releaseYear": 2007,
    "runtime": 115,
    "version": "OmU",
    "screeningDate": "19.03.2009",
    "readableDate": "2009-03-19",
    "screeningTime": "20:00",
    "actors": "Margherita Buy, Antonio Albanese, Giuseppe Battiston, Alba Rohrwacher, Carla SIgnoris, Fabio Troiano",
    "subtitle": [""],
    "bodycopy": [
      "So schnell ist das schöne Leben vorbei: Von den Partnern aus dem Job gedrängt, muss der Mitinhaber des Unternehmens seinen luxuriösen Lebensstandard aufgeben und mit seiner Frau in die Vorstadt ziehen. Schnell fasst diese in den neuen Umständen Fuß, während er cholerisch und desorientiert in Selbstmitleid versinkt. Wie in allen seinen Filmen lotet Soldini die menschlichen Beziehungen aus und probiert sich an neuen Erzählformen aus."
    ],
    "image": "giorni-e-nuvole.jpg"
  },
  {
    "title": "Giovanni Falcone  (Im Netz der Mafia)",
    "director": "Giuseppe Ferrara",
    "country": "Italien",
    "releaseYear": 1993,
    "runtime": 124,
    "version": "OmitU",
    "screeningDate": "01.12.2010",
    "readableDate": "2010-12-01",
    "screeningTime": "20:00",
    "actors": " Michele Placido, Anna Bonaiuto, Giancarlo Giannini, Massimo Bonetti, Nello Riviè, Gianni Musi, Marco Leto, Paolo De Giorgio",
    "subtitle": ["Geschichte der Mafia – Mafiageschichten"],
    "bodycopy": [
      "Giuseppe Ferrara geht in seinem dokumentarischen Spielfilm GIOVANNI FALCONE den Hintergründen der Ermordung des Antimafia-Staatsanwalts nach und zeigt, wie die Verfolgungsbehörden im wörtlichen Sinne „in den Untergrund“ gehen müssen, um sich vor Verrat zu schützen. (Wir zeigen die ungekürzte Fassung)."
    ],
    "image": "giovanni-falcone.jpg"
  },
  {
    "title": "GIULIA IN OTTOBRE (Julia im Oktober)",
    "director": "Silvio Soldini",
    "country": "Italien",
    "releaseYear": 1985,
    "runtime": 60,
    "version": "OmU",
    "screeningDate": "15.01.2009",
    "readableDate": "2009-01-15",
    "screeningTime": "20:00",
    "actors": "Carla Chiarelli, Roberto Casali, Giuseppe Cederna, Daniela Morelli, Andrea Novicov, Moni Ovadia",
    "subtitle": ["Werkschau Silvio Soldini"],
    "bodycopy": [
      "Dieser nur wenigen „Eingeweihten“ bekannte Low-Budget-Filmstammt aus der frühen Schaffenszeit dieses erfolgreichen Regisseurs. Er erzählt von fünf Tagen im Leben einer Frau: Nach dem Abbruch ihrer Liebesbeziehung versucht sie einen Neubeginn in ihrer altgewohnten Umgebung. Bereits in diesem Film tastet sich Soldini in die Bilder- und Erzählwelt vor, für die er später berühmt werden soll.  Der Film wurde in Deutschland im Forum der Berlinale unter falschem Regisseursnamen aufgeführt und verschwand dann in den Archiven."
    ],
    "image": "giulia-in-ottobre.jpg"
  },
  {
    "title": "GIULIA NON ESCE LA SERA (Giulia geht abends nie aus)",
    "director": "Giuseppe Piccioni",
    "country": "Italien",
    "releaseYear": 2009,
    "runtime": 105,
    "version": "OmU",
    "screeningDate": "15.03.2012",
    "readableDate": "2012-03-15",
    "screeningTime": "20:00",
    "actors": "Valerio Mastandrea, Valeria Golino, Sonia Bergamasco, Domiziana Cardinali, Jacopo Domenicucci, Chiara Nicola, Sara Tosti",
    "subtitle": [""],
    "bodycopy": [
      "Geschichte einer zerbrechlichen Liebe. Der Schriftsteller Guido, für sein neues Projekt von der Familie getrennt, verliebt er sich in eine Schwimmlehrerin. Die geht aber Abends nie aus. Ein Film voller Rätsel."
    ],
    "image": "giulia-non-esce-la-sera.jpg"
  },
{
    "title": "GLI ANNI PIÙ BELLI (ALLES WAS UNS GLÜCKLICH MACHT)",
    "director": "Gabriele Muccino",
    "country": "Italien",
    "releaseYear": 2019,
    "runtime": 129,
    "version": "OmU",
    "screeningDate": "15.09.2022",
    "readableDate": "2022-09-15",
    "screeningTime": "20:00",
    "actors": "Pierfrancesco Favino, Micaela Ramazzotti, Claudio Santamaria, Kim Rossi Stuart u.a.",
    "subtitle": [
      "Gefühlt kommt jedes Jahrzehnt ein generationsumspannender Film in die italienischen Kinos, der das Schicksal von Gruppen (politische Aktivisten, Familien, Kollegen usw.) oder Einzelpersonen über die Zeitläufe erzählt. Hier sind es vier Freunde, die wir in der Schule, bei der ersten Liebe, dem Weg in den Beruf und die eigene Familie, dem Durchleben unvermeidlicher Lebenskrisen, Trennung und Wiederfinden beobachtend folgen."
    ],
    "bodycopy": [
      "„Wir alle werden von der Zeit geformt. Wir glauben die Kontrolle über unser Leben zu haben - doch die verstreichende Zeit, die uns immer mehr verändert, zieht in Wahrheit die Fäden in unserem Leben. Sie lässt uns Dinge hinnehmen, die uns in jungem Alter inakzeptabel erschienen. Sie raubt uns die Illusionen, sie ernüchtert uns und verzaubert uns doch unverhofft immer wieder aufs Neue, so dass wir uns wieder wie Jugendliche fühlen, obwohl wir es nicht mehr sind. Die Zeit prägt die Figuren dieses Films, formt und verwandelt sie auf eine Art und Weise, die sich ihrer Kontrolle entzieht.“ (Gabriele Muccino in einem Interview)"
    ],
    "image": "gli-anni-piu-belli-03.jpg"
  },
  {
    "title": "GOMORRA (Gomorrha - Reise in das Reich der Camorra)",
    "director": "Matteo Garrone",
    "country": "Italien",
    "releaseYear": 2008,
    "runtime": 136,
    "version": "OmU",
    "screeningDate": "18.11.2010",
    "readableDate": "2010-11-18",
    "screeningTime": "20:00",
    "actors": "Toni Servillo, Gianfelice Imparato, Maria Nazionale, Salvatore Cantalupo, Gigio Morra, Salvatore abruzzese, Marco Macor, Ciro Petrone, Salvatore Ruocco",
    "subtitle": ["Geschichte der Mafia – Mafiageschichten"],
    "bodycopy": [
      "Seit dem Erscheinen seiner Camorradokumentation GOMORRA ist das Leben Roberto Savianos bedroht und er lebt verborgen in Polizeikasernen und anversteckten Orten. Matteo Garrone hat versucht, die im Buch unter Nennung von Namen und Ereignissen detailreiche Darstellung einer mafiösen Gesellschaft in einen dokumentarisch geprägten Spielfilm zu übertragen. Auch wenn dabei viele Einzelheiten auf der Strecke bleiben und das Krimiartige in den Vordergrund tritt: alle geschilderten Ereignisse entsprechen der Realität – auch wenn der Zuschauer es oftmals nicht glauben kann."
    ],
    "image": "gomorra.jpg"
  },
  {
    "title": "GOMORRA (GOMORRHA - REISE IN DAS REICH DER CAMORRA)",
    "director": "Matteo Garrone",
    "country": "Italien",
    "releaseYear": 2008,
    "runtime": 136,
    "version": "OmU",
    "screeningDate": "20.03.2014",
    "readableDate": "2014-03-20",
    "screeningTime": "20:00",
    "actors": "Toni Servillo, Gianfelice Imparato, Maria Nazionale, Salvatore Cantalupo, Gigio Morra, Salvatore abruzzese, Marco Macor, Ciro Petrone, Salvatore Ruocco",
    "subtitle": ["Höhepunkte aus 10 Jahren „Italienischer Filmclub“"],
    "bodycopy": [
      "Seit dem Erscheinen seiner Camorradokumentation GOMORRA ist das Leben Roberto Savianos bedroht und er lebt verborgen in Polizeikasernen und anversteckten Orten. Matteo Garrone hat versucht, die im Buch unter Nennung von Namen und Ereignissen detailreiche Darstellung einer mafiösen Gesellschaft in einen dokumentarisch geprägten Spielfilm zu übertragen. Auch wenn dabei viele Einzelheiten auf der Strecke bleiben und das Krimiartige in den Vordergrund tritt: alle geschilderten Ereignisse entsprechen der Realität – auch wenn der Zuschauer es oftmals nicht glauben kann."
    ],
    "image": "gomorra2.jpg"
  },
  {
    "title": "Gorbaciof",
    "director": "Stefano Incerti",
    "country": "Italien",
    "releaseYear": 2010,
    "runtime": 81,
    "version": "OmitU",
    "screeningDate": "07.03.2012",
    "readableDate": "2012-03-07",
    "screeningTime": "20:00",
    "actors": "Toni Servillo, Mi Yang, Geppy Gleijeses, Gaetano Bruno, Nello Mascia, Salvatore Ruocco",
    "subtitle": [""],
    "bodycopy": [
      "Der leidenschaftliche Spieler Gorbaciof ist Buchhalter im Gefängnis Poggioreale in Neapel . Als er feststellt, dass der Vater seiner großen Liebe Lila, eine junge Chinesin, seine Spielschulden nicht bezahlen kann, unterschlägt er Geld. Ein Drama beginnt. Eine in Filmbildern erzählte Liebesgeschichte, miterlebbar auch ohne Verstehen der wenigen Dialoge."
    ],
    "image": "gorbaciof.jpg"
  },
  {
    "title": "GRUPPO DI FAMIGLIA IN UN INTERNO (GEWALT UND LEIDENSCHAFT)",
    "director": "Luchino Visconti",
    "country": "Italien/Frankreich",
    "releaseYear": 1974,
    "runtime": 121,
    "version": "OmU",
    "screeningDate": "22.01.2022",
    "readableDate": "2022-01-22",
    "screeningTime": "19:00",
    "actors": "Burt Lancaster, Helmut Berger, Silvana Mangano u.a.",
    "subtitle": [
      "Eine Kooperation des Teams „Neu restauriert“ mit dem „Italienischen Filmclub“ (beide Filmmuseum)",
      "In einem prachtvollen Haus mit einer in die Jahre gekommenen Ausstattung lebt ein alter Professor, zurückgezogen und allein mit seinen Gemälden, Bildern, Büchern, Kunstgegenständen und Erinnerungen. Er hat sich mit den Jahren immer weiter isoliert, vermietet jedoch widerwillig die in seinem Palazzo leerstehende Wohnung. Die jungen Bewohner*innen konfrontieren ihn mit einer aufwühlenden, modernen Welt stellen damit seine Ruhe und Zurückgezogenheit infrage. Insbesondere mit dem jungen Konrad, einem ehemaligen „1968er“, freundete er sich in einem väterlichen Verhältnis an."
    ],
    "bodycopy": [
      "„Es ist die Geschichte eines Intellektuellen. Durch den Kontakt mit einer Gruppe junger Leute voller Vitalität und Unvernunft, die nur daran interessiert sind, alles das wegzufegen, was vor ihnen da war, bekommt der alte Mann das ganze Gewicht seiner Einsamkeit zu spüren.“ (Luchino Visconti)",
      "Die Ausstattung spielt in dem Film eine entscheidende Rolle. Visconti zeichnet das Familienbild mit penibler Genauigkeit, als würde er ein Gemälde im Stil des 18. Jahrhunderts malen. Detailverliebtheit und Präzision sind in jeder Einstellung zu spüren.",
      "Die Restaurierung des Films entstand 2013 im Centro sperimentale di Cinematografia – Cineteca Nazionale, Rom."
    ],
    "image": "gewalt-und-leidenschaft.jpg"
  },
  {
    "title": "HABEMUS PAPAM (HABEMUS PAPAM – EIN PAPST BÜXT AUS)",
    "director": "Nani Moretti",
    "country": "Italien/Frankreich",
    "releaseYear": 2011,
    "runtime": 104,
    "version": "OmU",
    "screeningDate": "20.12.2012",
    "readableDate": "2012-12-20",
    "screeningTime": "20:00",
    "actors": "Michel Piccoli, Nanni Moretti, Renato Scarpa, Jerzy Stuhr, Franco Graziosi, Camillo Milli, Roberto Nobile, Ulrich von Dobschütz, Gianluca Gobbi, Margherita Buy",
    "subtitle": [""],
    "bodycopy": [
      "Der neue gewählte Papst zweifelt, ob er seiner Aufgabe gewachsen sein wird, entflieht und mischt sich unter die Bewohner Roms, während der Vatikan um Fassung und Lösungen ringt."
    ],
    "image": "habemus-papam.jpg"
  },
  {
    "title": "Heaven",
    "director": "Tom Tykwer",
    "country": "Deutschland/USA/Frankreich",
    "releaseYear": 2000,
    "runtime": 97,
    "version": "OmU",
    "screeningDate": "18.11.2004",
    "readableDate": "2004-11-18",
    "screeningTime": "19:30",
    "actors": "Cate Blanchett, Giovanni Ribisi, Remo Girone, Stefania Rocca",
    "subtitle": [""],
    "bodycopy": [
      "Ein deutscher Regisseur, ein polnischer Drehbuchautor, ein US-Produzent (Miramax): Ist das ein Film für den italienischen Filmclub?",
      "Wenn an der Seite von Cate Blanchett namhafte italienische Filmschauspieler die tragenden Rollen übernehmen, ein großer Teil des Films in italienischer Sprache gedreht wurde und Turin und die Toskana eine wichtige Rolle spielen: warum nicht.",
      "Tom Tykwer („Lola rennt”) hat das Drehbuch des verstorbenen polnischen Regisseurs Kieslowski (Drei Farben „Rot“-„Weiß“-„Blau“) verfilmt. Herausgekommen ist ein Film zwischen Thriller, Kammerspiel und eine Annäherung an die spirituelle Tradition Europas.",
      "Filippas Rache am Drogenboss, den sie für den Tod ihres Mannes verantwortlich macht, fällt durch unglückliche Umstände eine Familie zum Opfer. Als sich bei der Verhaftung herausstellt, dass Filippa nur englisch spricht, bietet sich der junge Carabiniere Filippo als Dolmetscher an. Spontan verliebt er sich in Filippa und will ihr zur Flucht verhelfen. Anfänglich nutzt Filippa diese bedingungslose Hilfsbereitschaft leidenschaftslos aus, doch als die Flucht durch einen Eisenbahntunnel in die toskanische Landschaft führt, beginnt für beide die Suche nach dem gemeinsamen „Paradies“, alles eingefangen in beeindruckenden und symbolträchtigen Bildern."
    ],
    "image": "heaven.jpg"
  },
  {
    "title": "I cento passi (100 Schritte)",
    "director": "Marco Tullio Giordana",
    "country": "Italien",
    "releaseYear": 2000,
    "runtime": 114,
    "version": "OmU",
    "screeningDate": "15.01.2004",
    "readableDate": "2004-01-15",
    "screeningTime": "19:30",
    "actors": "Luigi Lo Cascio, Luigi Maria Burruano, Paolo Bruglia, Lucia Sardo",
    "subtitle": [""],
    "bodycopy": [
      "Am 9. Mai 1978 wird die Leiche von Aldo Moro gefunden. Aufgrund dieser Nachricht nimmt die Öffentlichkeit kaum den Tod von Peppino Impastato wahr, der am gleichen Tag von der Mafia in die Luft gesprengt wurde. Erst heute bemüht sich die italienische Justiz, dieses Verbrechen zu verfolgen.",
      "Seine Eltern hatten Impastatos Mafia-Karriere schon vorbereitet, doch er entschied sich anders. Die 100 Schritte, die das Haus seiner Eltern von dem des örtlichen Mafiabosses trennen, bezeichnen Abstand und Nähe zur kriminellen Vereinigung. Eltern, Freunde, Nachbarn sind eng mit der Mafia verflochten und können Impastato anfänglich noch vor den Folgen seiner wütenden Ausbrüche gegen die „ehrenwerte Gesellschaft“ schützen. Als er jedoch eine Radiostation gründet und zu einem wichtigen Protagonisten der  „Lotta Continua“ (linksradikale Bewegung) wird, mehren sich die Warnungen, die er alle in den Wind schlägt.",
      "Mit seiner chronologischen Aufarbeitung des „Falles Impastato“ stellt sich Giordana in die Tradition des italienischen Politkinos der 60er und 70er Jahre, auf das er durch das Zitieren von Rosis „Le mani sulla città“ ausdrücklich Bezug nimmt."
    ],
    "image": "cento-passi.jpg"
  },
  {
    "title": "I cento passi (100 Schritte)",
    "director": "Marco Tullio Giordana",
    "country": "Italien",
    "releaseYear": 2000,
    "runtime": 114,
    "version": "OmU",
    "screeningDate": "21.04.2005",
    "readableDate": "2005-04-21",
    "screeningTime": "19:30",
    "actors": "Luigi Lo Cascio, Luigi Maria Burruano, Lucia Sardo, Paolo Briguglia, Tony Sperandeo, Andrea Tidona",
    "subtitle": ["Werkschau Luigi Lo Cascio"],
    "bodycopy": [
      "Giuseppe „Peppino“ Impastato lehnt sich gegen die mafiösen Strukturen in seinem Heimatdorf auf, gründet eine Radiostation, verletzt das Gesetz des Schweigens und fällt schließlich selbst einem Attentat zum Opfer.Giuseppe „Peppino“ Impastato lehnt sich gegen die mafiösen Strukturen in seinem Heimatdorf auf, gründet eine Radiostation, verletzt das Gesetz des Schweigens und fällt schließlich selbst einem Attentat zum Opfer.Veranstaltungshinweis: Konzert von PIPPO POLLINA & Palermo Acoustics Quartett am 09.04.2005 um 20.00 Uhr im Haus der Jugend, Lacombletstraße 10, DüsseldorfPippo Pollina ist mit Leoluca Orlando befreundet und wird im Konzert ein Lied ausdrücklich diesem Film widmen."
    ],
    "image": "cento-passi.jpg"
  },
  {
    "title": "I CENTO PASSI (100 Schritte)",
    "director": "Marco Tullio Giordana",
    "country": "Italien",
    "releaseYear": 2000,
    "runtime": 114,
    "version": "OmU",
    "screeningDate": "16.12.2010",
    "readableDate": "2010-12-16",
    "screeningTime": "20:00",
    "actors": "Luigi Lo Cascio, Luigi Maria Burruano, Lucia Sardo, Paolo Briguglia, Tony Sperandeo, Andrea Tidona",
    "subtitle": ["Geschichte der Mafia – Mafiageschichten"],
    "bodycopy": [
      "Giuseppe Impastato konnte unter den Augen der Mafia lange Zeit sein Antimafiaradio betreiben – 100 Schritte trennen sein Elternhaus vom Haus des Mafiabosses. Eine Entfernung, die sinnbildlich für Abstand und Nähe seiner Eltern, Freunde und Nachbarn zur Mafia steht. Erst als Impastato anbetracht der offensichtlichen Wirkungslosigkeit seines Handelns die Provokationen immer weiter treibt, schlägt die Mafia zurück. Das pathetisch-optimistische Ende des Films wäre zehn Jahre nach seinem Entstehen so wohl nicht mehr möglich."
    ],
    "image": "cento-passi.jpg"
  },
  {
    "title": "I clowns (Die Clowns)",
    "director": "Federico Fellini",
    "country": "Italien",
    "releaseYear": 1970,
    "runtime": 92,
    "version": "OmitU",
    "screeningDate": "03.03.2010",
    "readableDate": "2010-03-03",
    "screeningTime": "20:00",
    "actors": "Riccardo Billi, Gigi Reder, Tino Scotti, Leopoldo Valentini, Fanfulla, Sandro Merli, Carlo Rizzo",
    "subtitle": ["90 Jahre Fellini (20.01.1920-31.10.1993)"],
    "bodycopy": [
      "Das ganze Leben ist ein großer Zirkus und nichts ist lebensechter als die Clowns. Diese angebliche Reportage über die zum Aussterben verurteilten Zirkus-Clowns (die tatsächlich im Auftrag des italienischen Fernsehens entstanden ist) ist für Fellini Anlass, ein Panoptikum skurriler, grotesker und ausgefallener Figuren zu präsentieren, die in ihrer Absonderheit aber gerade das zutiefst Menschliche zutage fördern."
    ],
    "image": "i-clowns.jpg"
  },
  {
    "title": "I compagni (Die Peitsche im Genick)",
    "director": "Mario Monicelli",
    "country": "Italien/Frankreich",
    "releaseYear": 1963,
    "runtime": 124,
    "version": "OmitU",
    "screeningDate": "04.05.2011",
    "readableDate": "2011-05-04",
    "screeningTime": "20:00",
    "actors": "Marcello Mastroianni, Renato Salvatori, Annie Giranrdot, François Périer, Raffaella Carrà, Gabriella Giorgetlli, Folco Lulli, Bernard Blier",
    "subtitle": ["150 Jahre Italien"],
    "bodycopy": [
      "Die Situation in den Spinnereien sind unerträglich, die Lebensbedingungen der Arbeiter sind mehr als mies. Nachdem alle Verhandlungen zur Senkung der Arbeitszeit auf 13 Tagesstunden scheitern, kommt es zum Streik. Als dieser mit einer Fabrikbesetzung eskaliert, greift das Militär ein. Ein hervorragend fotografierter Film über die Geburt der Arbeiterbewegung in Italien."
    ],
    "image": "i-compagni.jpg"
  },
  {
    "title": "I giorni dell'abbandono",
    "director": "Roberto Faenza",
    "country": "Italien",
    "releaseYear": 2005,
    "runtime": 96,
    "version": "OmitU",
    "screeningDate": "06.05.2009",
    "readableDate": "2009-05-06",
    "screeningTime": "20:00",
    "actors": "Margherita Buy, Luca Zingaretti, Goran Bregovic, Alessia Goria, Geo Lionello, Gaia Bermani Amarai, Sara Santostasi, Simone Della Croce",
    "subtitle": ["Werkschau: Roberto Faenza"],
    "bodycopy": [
      "Als Olga von Mauro wegen seiner jungen Geliebten verlassen wird und sich allein um ihre zwei Söhne und einen Hund kümmern muss, fällt sie in ein tiefes Loch. Das Gefühl der Verlassenheit führt zu einer Spirale, die sie immer weiter von der Realität entfernt. Ein mit Margherita Buy, Luca Zingaretti und Goran Bregovic (als Nachbar) erstrangig besetzter „Seelenkrimi“ („thriller dell’anima“)."
    ],
    "image": "i-giorni-dellabbandono.jpg"
  },
  {
    "title": "I mostri (Die Monster)",
    "director": "Dino Risi",
    "country": "Italien",
    "releaseYear": 1963,
    "runtime": 117,
    "version": "OmU",
    "screeningDate": "03.07.2010",
    "readableDate": "2010-07-03",
    "screeningTime": "20:00",
    "actors": "Ugo Tognazzi, Vittorio Gassman, Ricky Tognazzi, Lando Buzzanca, Michéle Mercier, Marisa Merlini, Rika Dialina",
    "subtitle": [
      "Untertitelt vom Workshop Filmuntertitelung des Instituts für Romanistik und des Studiengangs Literaturübersetzen der Heinrich-Heine-Universität Düsseldorf."
    ],
    "bodycopy": [
      "In zwanzig Episoden skizziert Dino Risi die italienische Wohlstandsgesellschaft der 1960er Jahre. Mal ironisch, mal zynisch karikiert er das Verhalten von kleinen Gaunern, Ehemännern und –frauen, Abgeordneten und anderen alltäglichen „Monstern“ auf humorvolle Weise."
    ],
    "image": "imostri.png"
  },
  {
    "title": "I racconti di Canterbury (Pasolinis tolldreiste Geschichten)",
    "director": "Pier Paolo Pasolini",
    "country": "Italien/Frankreich",
    "releaseYear": 1972,
    "runtime": 110,
    "version": "OmU",
    "screeningDate": "04.03.2011",
    "readableDate": "2011-03-04",
    "screeningTime": "20:00",
    "actors": "Hugh Griffith, Laura Betti, Ninetto Davoli, Franco Citti, Josephine Chaplin, Alan Webb, Pier Paolo Pasolini, Vernon Dobtcheff, Adrian Street, Michael Balfour, Jenny Runacre, Tom Baker",
    "subtitle": [""],
    "bodycopy": [
      "Das ist sozusagen der zweite Teil von Pasolinis Verfilmung der deftigsten Geschichten mittelalterlicher Weltliteratur. Wieder die gleiche Saftigkeit wie in seinem Film DECAMERON. Pasolini malt das mit viel Geschmack am derben Ungeschmack aus."
    ],
    "image": "I racconti di Canterbury.jpg"
  },
  {
    "title": "I soliti ignoti (Diebe haben’s schwer)",
    "director": "Mario Monicelli",
    "country": "Italien",
    "releaseYear": 1958,
    "runtime": 85,
    "version": "OmU",
    "screeningDate": "02.08.2006",
    "readableDate": "2006-08-02",
    "screeningTime": "18:00",
    "actors": "Vittorio Gassman, Marcello Mastroianni, Carlo Pisacane, Tiberio Murgia, Renato Salvatori, Totò, Memmo Carotenuto, Rosaria Rory, Carla Gravina, Claudia CArdinale, Gina Rovere, Gina Amendola, Elvira Tonelli",
    "subtitle": [""],
    "bodycopy": [
      "Eine seltene Gelegenheit zum Wiedersehen mit dem berühmten italienischen Komiker Totò. Eine Gruppe von Kleinkriminellen versucht ins örtliche Pfandbüro einzubrechen. Wie es sich für eine „commedia all’italiana“ gehört, geht es dabei turbulent zu. Dieser hochkarätig besetzte Film mit Vittorio Gassmann, Marcello Mastroianni, Claudia Cardinale u.a. hat vielfach in die Filmgeschichte ausgestrahlt."
    ],
    "image": "i-soliti-ignoti.jpg"
  },
  {
    "title": "I vicerè",
    "director": "Roberto Faenza",
    "country": "Italien/Spanien/Deutschland/USA",
    "releaseYear": 2007,
    "runtime": 120,
    "version": "OmitU",
    "screeningDate": "03.06.2009",
    "readableDate": "2009-06-03",
    "screeningTime": "20:00",
    "actors": "Alessandro Preziosi, Lando Buzzanca, Cristiana Capotondi, Guido Caprino, Assumpta Serna, Magdalena Grochowska, Sebastiano Lo Monaco, Lucia Bosè, Anna Marcello",
    "subtitle": ["Werkschau: Roberto Faenza"],
    "bodycopy": [
      "Von der Presse als „neuer GATTOPARDO“ gefeiert (was Faenza zurückweist) erzählt der Film eine sizilianische Familiengeschichte. Vom tyrannischen Familienoberhaupt über ein lasterhaftes Kloster bis zur korrupten Politik in einer Umbruchzeit wird ein Gesellschaftsbild am Ende des 19. Jahrhunderts gezeichnet. Beeindruckende Ausstattung und neuste Filmtechnik lässt ein historisches Catania entstehen, das den Vergleich mit Visconti nicht zu scheuen braucht."
    ],
    "image": "i-vicere.jpg"
  },
  {
    "title": "Identificazione di una donna ( Identifikation einer Frau)",
    "director": "Michelangelo Antonioni",
    "country": "Italien/Frankreich",
    "releaseYear": 1982,
    "runtime": 125,
    "version": "OmitU",
    "screeningDate": "03.10.2007",
    "readableDate": "2007-10-03",
    "screeningTime": "19:00",
    "actors": "Thomas Milian, Daniela Silverio, Christine Boisson, Lara Wendelm Veronica Lazar, Enrica Fico, Marcel Bozzuffi, Gianpaolo Saccarola",
    "subtitle": ["In Gedenken an Michelangelo Antonioni"],
    "bodycopy": [
      "Einer von Antonionis letzten „großen“ Filmen: Bei der Suche nach der idealen Frau für seine Filme und für sein Leben begegnet ein Regisseur zwei Frauen. Er verliebt sich, doch mangelndes Verständnis zwischen den Geschlechtern und das Verwechseln von Fiktion und Realität lässt jedwede Beziehung scheitern. Letztendlich erweist sich die Suche nach der „idealen Frau“ als Suche nach der eigenen Identität."
    ],
    "image": "identificazione.jpg"
  },
  {
    "title": "Ieri, oggi, domani (Gestern, heute und morgen)",
    "director": "Vittorio De Sica",
    "country": "Italien",
    "releaseYear": 1963,
    "runtime": 118,
    "version": "OmU",
    "screeningDate": "19.05.2011",
    "readableDate": "2011-05-19",
    "screeningTime": "20:00",
    "actors": "Sophia Loren, Marcello Mastroianni, Armando Trovajoli, Tina Pica, Gianni Ridolfi, Gennario Di Gregorio",
    "subtitle": ["Hommage an Vittorio De Sica"],
    "bodycopy": [
      "Eine mit Marcello Mastoianni und Sophia Loren hochkarätig besetzte Episodenkomödie. „Gestern“ versucht sich in Neapel eine Schwarzhändlerin durch „Kindersegen“ vor dem Gefängnis zu bewahren, „Heute“ versucht eine Industriellengattin in Mailand ihr Glück mit einem heruntergekommenen Liebhaber und „Morgen“ führt ein Callgirl in Rom einen Priesteranwärter auf den „rechten Weg“ zurück. Eine humoristische Reflexion über das Frauenbildder 60er-Jahre."
    ],
    "image": "ieri-oggi-domani.jpg"
  },
  {
    "title": "Il bacio di Tosca (Der Kuss der Tosca)",
    "director": "Daniel Schmid",
    "country": "Schweiz",
    "releaseYear": 1984,
    "runtime": 87,
    "version": "OmU",
    "screeningDate": "17.12.2009",
    "readableDate": "2009-12-17",
    "screeningTime": "20:00",
    "actors": null,
    "subtitle": [
      "„Italienische Portraits“ - Dokumentarfilme zu italienischen Themen"
    ],
    "bodycopy": [
      "Ein Film zwischen Dokumentation und Fiktion über die Menschen indem von Verdi 1896 gegründeten Altenheim für Musiker und Sänger, denen die große Karriere versagt blieb. In ihren kleinen Zimmern träumen sie von ihren „großen“ Auftritten und leben in einer Welt der Musik – ein Leben, das kein Bühnenautor interessanter gestalten könnte. „Es bildet sich eine Art Zwischenrealität heraus; denn wenn man sich dreißig Jahre lang etwas eingebildet hat, dann wird man zudem, ob es stattgefunden hat oder nicht“ (Regisseur Daniel Schmid über den Film)."
    ],
    "image": "il-bacio-di-tosca.jpg"
  },
  {
    "title": "Il caimano (Der Italiener)",
    "director": "Nanni Moretti",
    "country": "Italien/Frankreich",
    "releaseYear": 2006,
    "runtime": 112,
    "version": "OmU",
    "screeningDate": "21.02.2008",
    "readableDate": "2008-02-21",
    "screeningTime": "19:00",
    "actors": "Silvio Orlando, Margherita Buy, Jasmine Trinca, Michele Placido, Elio De Capitani, Toni Bertorelli, Anna Bonaiuto",
    "subtitle": [""],
    "bodycopy": [
      "Die italienische Filmkritik sah in diesem Film Morettis Abrechnung mit Berlusconi. Doch er zeigt mehr: den Zustand des heutigen Italien. Das Prekariat ist in der Mittelschicht angekommen: Der mittelklassige Filmproduzent muss sich irgendwie durchschlagen, die Freunde entfernen sich. Das Apolitische regiert Italien: Der Produzent merkt nicht, dass es sich beim angebotenen Thriller-Drehbuch um die Geschichte Berlusconis handelt und macht sich damit lächerlich. Denn wen interessiert das Thema noch? Verzweifelt kämpft der Produzent um diesen Film, denn er sieht darin seine letzte Chance."
    ],
    "image": "il-caimano.jpg"
  },
  {
    "title": "IL CAPITALE UMANO (DIE SÜSSE GIER)",
    "director": "Paolo Virzì",
    "country": "Italien",
    "releaseYear": 2013,
    "runtime": 109,
    "version": "OmU",
    "screeningDate": "15.10.2015",
    "readableDate": "2015-10-15",
    "screeningTime": "20:00",
    "actors": " Fabrizio Bentivoglio, Matilde Gioli, Valeria Bruni-Tedeschi, Guglielmo Pinelli: Massimiliano Bernaschi, Fabrizio Gifuni, Gigio Alberti, ",
    "subtitle": [""],
    "bodycopy": [
      "Ein kleiner Immobilienmakler träumt von Erfolg und Reichtum, eine reiche Ehefrau ringt um Anerkennung und die Wiederbelebung eines Theaters und eine junge Teenagerin sucht nach ihrer Identität und der wahren Liebe. Und ein Autounfall hat Einfluss auf alle drei Biographien."
    ],
    "image": "il-capitale-umano.jpg"
  },
  {
    "title": "IL CARATTERE ITALIANO. LA STORIA DI UNA GRANDE ORCHESTRA ITALIANA. (DIE ITALIENISCHE ART. DIE GESCHICHTE EINES GROßEN ITALIENISCHEN ORCHESTERS)",
    "director": "Angelo Bozzolini",
    "country": "Deutschland/Italien",
    "releaseYear": 2013,
    "runtime": 100,
    "version": "OmU",
    "screeningDate": "01.03.2015",
    "readableDate": "2015-03-01",
    "screeningTime": "12:00",
    "actors": null,
    "subtitle": [""],
    "bodycopy": [
      "Das Orchestra dell'Accademia Nazionale di Santa Cecilia spielt am 3.3.2015 in der Tonhalle Düsseldorf. Zur Einstimmung zeigen wir diesen Dokumentarfilm über die Geschichte des Orchesters, dessen Mitglieder und ihre Musik.",
      "Mit aktuellen Aufnahmen und Archivschätzen wird ein Porträt des Orchesters gezeichnet. Der Film lässt den Zuschauer miterleben, wie eine Aufführung entsteht. Er lernt die Musiker und ihre Musik kennen, fiebert mit ihnen der Aufführung entgegen und erlebt die Erleichterung und Freude nach dem Schlussapplaus."
    ],
    "image": "die-italienische-art.jpg"
  },
  {
    "title": "Il caso Aldo Moro (Die Affäre Aldo Moro)",
    "director": "Giuseppe Ferrara",
    "country": "Italien",
    "releaseYear": 1986,
    "runtime": 112,
    "version": "OmitU",
    "screeningDate": "03.09.2008",
    "readableDate": "2008-09-03",
    "screeningTime": "19:00",
    "actors": "Gian Maria Volonté, Margarita Lozano, Mattia Sbraia, Bruno Zanin, Consuelo Ferrara, Enrico Maria Modugno, Enrica Rosso",
    "subtitle": [
      "Entführung und Ermordung von ALDO MORO: Der christdemokratische Politiker Aldo Moro wurde 1978 von den linksterroristischen Roten Brigaden ermordet. Er war mehrfach Minister und von 1963 bis 1968 und 1974 bis 1976 Ministerpräsident Italiens. Umstritten war seine Befürwortung des „Historischen Kompromiss“, dem Eintritt der kommunistischen Partei PCI in die Regierungskoalition mit der christdemokratischen Democrazia Cristiana. Am 16. März 1978 entführten die Roten Brigaden Aldo Moro. Nach 55 Tagen Gefangenschaft wurde er tot im Kofferraum eines Pkws aufgefunden."
    ],
    "bodycopy": [
      "Ferrara versucht 8 Jahre nach dem Attentat eine Rekonstruktion der verwickelten Ereignisse. Dabei rückt er die Figur Aldo Moros in den Mittelpunkt und bemüht sich um eine genaue visuelle Darstellung anhand authentischen Materials. Ihm gelingt es, die politische Dimension deutlich werden zu lassen, scheitert aber zwangsläufig an der Darstellung der (bis heute größtenteils ungeklärten) politischen Hintergründe. Der Film erregte bei seinem Erscheinen Zorn im politischen Establishment, da erneut die Frage aufgeworfen wurde, ob Christdemokarten und Kommunisten alles taten, Moros Leben zu retten."
    ],
    "image": "il-caso-aldo-moro.jpg"
  },
  {
    "title": "Il ciclone (Amore, amore)",
    "director": "Leonardo Pieraccion",
    "country": "Italien",
    "releaseYear": 1996,
    "runtime": 90,
    "version": "OmU",
    "screeningDate": "16.09.2004",
    "readableDate": "2008-09-03",
    "screeningTime": "19:00",
    "actors": "Leonardo Pieraccioni, Lorenza Fortezza, Massimo Ceccherini, Paolo Hendel, Natalia Estrada, Barbara Enrichi, Alessandro Haber, Tosca D’Aquino, Bebedetta Mazzini",
    "subtitle": [""],
    "bodycopy": [
      "Beschaulich geht es zu in dem Dorf in der toskanischen Provinz, in dem der junge Buchhalter Levante Quarini mit seiner Familie inmitten idyllischer Sonnenblumenfelder lebt. Das Ausrichten einer phantasievollen Antennenkonstruktion und ein kleiner unschuldiger Flirt im Dorfladen sind das Aufregendste, was das Leben zu bieten hat.",
      "Bis auf einmal ein Kleinbus im Dorf „strandet“ und fünf Flamencotänzerinnen das Leben von Levantes Familie gründlich auf- und durcheinanderwirbeln. Auf einmal raucht Vater Osvaldo Joints in der Küche und schnarcht im Flamenco-Rhytmus, Levantes leicht beschränkter Bruder läuft nur noch mit ehrfürchtig heruntergeklappter Kinnlade herum und seine lesbische Schwester Selvaggia beginnt, hemmungslos mit der kurvigen Tänzerin Penelope zu flirten. Dass Levante schließlich der atemberaubend schönen Caterina verfällt, kann niemanden verwundern.",
      "Diese romantische, episodenreiche Komödie im Flamencorhytmus sorgt für Spaß und gute Laune und konnte in dieser Leichtigkeit wohl nur in Italien entstehen."
    ],
    "image": "il-ciclone.jpg"
  },
  {
    "title": "IL COLORE NASCOSTO DELLE COSE (DIE VERBORGENEN FARBEN DER DINGE)",
    "director": "Silvio Soldini",
    "country": "Italien/Schweiz",
    "releaseYear": 2017,
    "runtime": 116,
    "version": "OmU",
    "screeningDate": "20.06.2019",
    "readableDate": "2019-06-20",
    "screeningTime": "20:00",
    "actors": "Valeria Golino, Adriano Giannini, Arianna Scommegna, Laura Adriani, Anna Ferzetti, Andrea Pennacchi, Beniamino Marcone, Italo Amerighi",
    "subtitle": [
      "Dass man auch blind gut zurechtkommen kann, wenn man sich darauf einrichtet, ist dem erfolgreichen Werbemann Teo befremdlich, ist er doch disorganisiert und bekommt sein Leben nicht in den Griff: trotz schöner Freundin, mit der er zusammenziehen will, luxuriösem Appartment und vielversprechenden Karriereaussichten ist er unzufrieden. Da verspricht das Date mit einer blinden Osteopatin einen neuen Kick."
    ],
    "bodycopy": [
      "Emma hingegen hat ihr Leben im Griff und ist nach der Trennung von ihrem Ehemann zu neuen Versuchen bereit. Aber sie weiß auch, was sie will. Das wiederum verunsichert Teo, der von der Welt der Behinderten zunehmend irritiert, aber auch fasziniert wird. Je mehr sich Emma und Teo näher kommen und vertrauter werden, desto mehr gelingt es diesem, eine neue Welt zu entdecken. Doch Emma durchschaut Teos Doppelspiel und Entscheidungsschwäche. Eine gemeinsame Zukunft ist auf einmal infrage gestellt.",
      "Nachdem Silvio Soldini (BROT UND TULPEN) einen Dokumentarfilm über den Alltag von Sehbehinderten gedreht hatte (DIFFERENT EYES, 2014), wollte er seine Erfahrungen unbedingt in eine Spielfilmhandlung einbringen, um das Leben mit einer Behinderung einem breiteren Publikum vertraut zu machen. Valeria Golino ist dabei die perfekte Emma: „„Auch wenn Sie es nicht glauben: Während der Dreharbeiten war ich blind! Ich schwöre es: Ich war blind! Wenn irgendetwas im Weg stand, bin ich davor gelaufen [...]“"
    ],
    "image": "il-colore-nascoste-delle-cose.jpg"
  },
  {
    "title": "IL COLPO DEL CANE (DER GANZ GROSSE COUP)",
    "director": "Fulvio Risuleo",
    "country": "Italien",
    "releaseYear": 2019,
    "runtime": 93,
    "version": "OmU",
    "screeningDate": "15.12.2022",
    "readableDate": "2022-12-15",
    "screeningTime": "20:00",
    "actors": "Eduardo Pesce, Silvia D’Amico, Daphne Scoccia, Anna Bonaiuto u.a.",
    "subtitle": [
      "Internationales Filmfestival Rotterdam",
      "An sich legt der Stoff ein Drama nahe: Das Prekariat sozial randständiger Jugendlicher und junger Menschen zwingt zum Arrangement und Improvisation und öffnet die Bereitschaft, sich auf kriminelle Machenschaften einzulassen. Wenn die Geschichte jedoch auf den Hund kommt, kann daraus auch eine leichte, humorvolle Erzählung werden, vor allem wenn es sich um eine reinrassige französische Bulldogge mit Freiheitsdrang handelt, die von einer älteren Dame geliebt und verhätschelt wird."
    ],
    "bodycopy": [
      "Dogsitter: leicht verdientes Geld, denken Rana und Marti und versprechen einer reichen alten Dame, sich fürsorglich um Ugo, ihren Hund, zu kümmern. Dass der seinen eigenen Kopf hat, bekommen die beiden ja noch in den Griff, aber dann winkt die Chance auf ein saftiges Extrageld. Dr. Mopsi, ein Tierarzt, der Rana im Park anspricht, ist begeistert von Ugo und möchte ihn gerne für seine Tierzucht nutzen. Es dauere nicht lange, er bringe Ugo mit seiner Hündin gleicher Rasse zusammen, die beiden hätten Spaß miteinander und dann könnte Ugo zurück nach Hause. Einige größere Geldscheine helfen über erste Bedenken hinweg und dann … ist Ugo auf einmal gekidnappt. Aber auch der Entführer hat seine Probleme mit Ugo und mit seinem Auftraggeber, der hinter der ganzen Aktion steckt.",
      "„In seinem zweiten Spielfilm beweist Risuleo wieder sein Geschick, skurrile und haarsträubende Situationen zu schaffen. Und er zeigt auch wieder die übersehenen Seiten seines geliebten Rom. Wie bei allen guten Komödien ist der Grundton unausweichlich tragisch“."
    ],
    "image": "il-colpo-del-cane-1024x576.jpg"
  },
  {
    "title": "IL COMPAGNO DON CAMILLO (Genosse Don Camillo)",
    "director": "Luigi Comencini",
    "country": "Italien",
    "releaseYear": 1965,
    "runtime": 109,
    "version": "OmU",
    "screeningDate": "19.07.2007",
    "readableDate": "2007-07-19",
    "screeningTime": "17:00",
    "actors": "Fernandel, Gino Cervi, Leda Gloria, Saro Urzì, Ganni Garko, Marco Tulli, Silla Bettini, Graziella Granata, Alessandro Gottlieb, Paul Müller",
    "subtitle": ["Die Familie Comencini"],
    "bodycopy": [
      "Erst zwingt Don Camillo seinen Rivalen Peppone durch Eintritt in die kommunistische Partei, ihn als Funktionär mit nach Moskau zu nehmen und sorgt dort für einige Unruhe. Als Peppone aber als Geistlicher mit in die USA reisen will, legt Don Camillo natürlich andere Maßstäbe an. Der letzte fertig gestellte Film der „Don Camillo und Peppone“-Reihe. Bei der Verfilmung des sechsten Films verstarb Fernandel. Dieser Film ist ein typisches Beispiel für die vielen erfolgreichen populären Filme, die das Filmwerk Luigi Comencinis prägen."
    ],
    "image": "il-compagno-don-camillo.jpg"
  },
  {
    "title": "Il Decameron (Dekameron)",
    "director": "Pier Paolo Pasolini",
    "country": "Italien",
    "releaseYear": 1971,
    "runtime": 112,
    "version": "OmenU",
    "screeningDate": "01.03.2011",
    "readableDate": "2011-03-01",
    "screeningTime": "20:00",
    "actors": "Franco Citti, Ninetto Davoli, Jovan Jovanović, Angela Luce, Pier Paolo Pasolini, Giuseppe Zigaina, Vincenzo Amato, Guido Alberti, Giacomo Rizzo, Monique van Vooren, Elisabetta Genovese, Silvana Mangano",
    "subtitle": [
      "Eine Kooperation der Deutsch-Italienischen Gesellschaft e.V. – Dante Alighieri _ Düsseldorf mit dem Italienischen Filmclub",
      "IL DECAMERON bildet zusammen mit I RACCONTI DI CANTERBURY und I racconti di Canterbury (Pasolinis tolldreiste Geschichten) Pasolinis Trilogie des Lebens.  Für diese werden drei strukturell ähnliche literarische Werke aus unterschiedlichen Epochen und Kulturkreisen vereinigt, um unterhaltsam wesentlichen existenziellen Fragen des Individuums und seiner Rolle in der Gesellschaft nachzugehen."
    ],
    "bodycopy": [
      "Inspiriert von Boccaccios Novellensammlung thematisiert Pasolini in IL DECAMERON mit acht Geschichten die menschliche Geschlechtlichkeit und Sinnesfreude in einer düsteren archaischen Welt. Das Leben der einfachen Leute ist ständig bedroht durch überall lauernde Gewalt und ihre Lebensfreude bricht sich Bahn in sexueller Triebbefriedigung",
      "Abweichend von Boccaccios Rahmenhandlung mit Pestflüchtigen, die sich Geschichten erzählen, präsentiert Pasolini die acht Episoden in der Figur eines Schülers von Giotto.",
      "Begleitet wird der Film durch einen Einführungsvortrag der Kunst- und Filmwissenschaftlerin Donatella Chiancone-Schneider: IL DECAMERON wird unter kunst- und filmhistorischen Aspekten erläutert, im Kontext der Filmografie Pasolinis vorgestellt und mit seinen literarischen und malerischen Vorlagen verglichen."
    ],
    "image": "ildecameron.jpg"
  },
  {
    "title": "IL DECAMERON (DECAMERON)",
    "director": "Pier Paolo Pasolini",
    "country": "Italien",
    "releaseYear": 1971,
    "runtime": 116,
    "version": "OmU",
    "screeningDate": "05.10.2022",
    "readableDate": "2022-10-05",
    "screeningTime": "19:00",
    "actors": "Franco Citti, Ninetto Davoli, Jovan Jovanović, Angela Luce, Pier Paolo Pasolini, Giuseppe Zigaina, Vincenzo Amato, Guido Alberti, Giacomo Rizzo, Monique van Vooren, Elisabetta Genovese, Silvana Mangano",
    "subtitle": [""],
    "bodycopy": [
      "Leute, die der Allegorie fernstehen, so heißt es, haben diesmal sein Interesse gefesselt, haben seine Aufmerksamkeit auf die temperamentgeladene süditalienische Ursprünglichkeit gelenkt, die er in furioser Komödiantik sich austoben lässt."
    ],
    "image": "ildecameron.jpg"
  },
  {
    "title": "Il deserto dei Tartari (Die Tartarenwüste)",
    "director": "Valerio Zurlini",
    "country": "Italien/Frankreich",
    "releaseYear": 1976,
    "runtime": 150,
    "version": "OmitU",
    "screeningDate": "01.02.2006",
    "readableDate": "2006-02-01",
    "screeningTime": "19:30",
    "actors": "Giuliano Gemma, Giancarlo Maestri, Luciano Melani, Luigi Vannucchi, Alberto Lionello, Gino La Monica, Massimo Foschi, ROberto Villa, Gianna Piaz",
    "subtitle": [""],
    "bodycopy": [
      "In der beim Erdbeben 2003 stark zerstörten iranischen Stadt Bam gedrehte Verfilmung des bekannten Romans von Dino Buzzati mit beeindruckender Filmmusik von Ennio Morricone. Ein junger Offizier wird in ein Fort am Rande der Wüste versetzt und wartet mit Spannung darauf, sich mit dem Feind messen zu können. Darüber vergisst er sein Leben und stirbt, ohne gekämpft zu haben."
    ],
    "image": "il-deserto-dei-tartari.jpg"
  },
  {
    "title": "IL DESERTO ROSSO (DIE ROTE WÜSTE)",
    "director": "Michelangelo Antonioni",
    "country": "Italien/Frankreich",
    "releaseYear": 1964,
    "runtime": 117,
    "version": "OmU",
    "screeningDate": "05.05.2022",
    "readableDate": "2022-05-05",
    "screeningTime": "20:00",
    "actors": "Monica Vitti, Richard Harris, Carlo Chionetti, Xenia Valderi, Rita Renior, Lili Rheims, Aldo Grotti, Valerio Bartoleschi, Emanuela Pala Carboni u.a. ",
    "subtitle": [
      "Eine Kooperation des Teams „Neu restauriert“ mit dem „Italienischen Filmclub“ (beide Filmmuseum)",
      " Giuliana, die Ehefrau des Ingenieurs Ugo, kommt mit den drastischen Veränderungen ihrer industrialisierten und übertechnisierten Umwelt nicht zurecht und durchlebt eine schwere Krise. Hauptschauplatz ist das Kraftwerk der Industriestadt Ravenna."
    ],
    "bodycopy": [
      " Giulianas Leiden wird in IL DESERTO ROSSO als physisches Phänomen mit visuellen und farblichen Metaphern wie auch in Traumsequenzen versinnbildlicht. Regisseur Michelangelo Antonioni sprach davon, die Farbe einzusetzen, um Gemütszustände zu formen, wie es die Stimmungsmusik macht – dabei sollten die Zuschauer*innen auch selbst angesprochen werden. Der Filmkritiker Andrew Sarris bemerkt, dass „die rot angestrichenen Rohre und Geländer… als Struktur von Giulianas Beklemmung dienen.“ Antonioni schuf dadurch eine Studie über eine Frau, deren gestörte Wahrnehmung auch eine gesellschaftspolitische Botschaft enthält: Das industrielle Ambiente, die „rote Wüste“ in der sie lebt, ist repräsentativ für die Kargheit des Gefühlslebens, das die Menschen zunehmend belastet. ",
      " Restaurierung in 4K ausgehend von den Bild- und Tonnegativen, die von RTI-Mediaset zur Verfügung gestellt wurden. Die Farbkorrektur wurde im Fotocinema-Labor von Kameramann Luciano Tovoli überwacht, um die Chromatik und den fotografischen Ton wiederherzustellen, die damals von Michelangelo Antonioni und vom Kameramann Carlo di Palma gewünscht wurden. Der Erwerb und die Restaurierung des Tons wurden im Labor des Centro Sperimentale di Cinematografia – Cineteca Nazionale in Rom unter der Leitung von Federico Savina durchgeführt."
    ],
    "image": "desertorosso-04.jpg"
  },
  {
    "title": "Il Divo (Der Göttliche)",
    "director": "Paolo Sorrentino",
    "country": "Italien/Frankreich",
    "releaseYear": 2008,
    "runtime": 110,
    "version": "OmU",
    "screeningDate": "19.08.2010",
    "readableDate": "2010-08-19",
    "screeningTime": "20:00",
    "actors": "Toni Servillo, Anna Bonaiuto, Giulio Bosetti, Flavio Bucci, Carlo Buccirosso, Paolo Graziosi, Giorgio Colangeli, Alberto Cracco",
    "subtitle": [""],
    "bodycopy": [
      "Ein menschelndes Porträt des italienischen Politikers Giulio Andreotti, dem Kontakte zur Mafiaorganisationen nie nachgewiesen werden konnten. Er verstand es, sich während seiner aktiven Zeit geschickt im Machtgefüge der Politik zu bewegen und die „richtigen Fäden zu ziehen“. Zwischen 1972 und 1992 war er sieben mal Ministerpräsident. Orientiert am Stil der Königsdramen versucht der Film den Spannungsbogen von Mensch und Macht auszuloten und spart nicht mit Anspielungen auf das marode politische System Italiens."
    ],
    "image": "il-divo.jpg"
  },
  {
    "title": "Il figlio più piccolo",
    "director": "Pupi Avati",
    "country": "Italien",
    "releaseYear": 2010,
    "runtime": 104,
    "version": "OmitU",
    "screeningDate": "04.01.2012",
    "readableDate": "2012-01-04",
    "screeningTime": "20:00",
    "actors": "Christian De Sica, Laura Morante, Luca Zingaretti, Nicola Nocella, Marcello Maietta, Maurizio Battista, Massimo Bonetti, Pino Calabresi",
    "subtitle": [""],
    "bodycopy": [
      "Als sein Unternehmen bedroht scheint, erinnert sich der Unternehmer Baietti an seine Frau, die ihn vor 18 Jahren mit deren zwei Söhnen am Tag der Hochzeit verlassen hat. Den dümmlich-naiven jüngsten Sohn als Nachfolger in seinem Pleiteunternehmen einzusetzen, könnte ihn retten. Komödie, die das teilweise prekäre Unternehmertum Italiens auf die Schippe nimmt."
    ],
    "image": "il-figlio-piu-piccolo.jpg"
  },
  {
    "title": "Il fiore delle Mille e una notte (Erotische Geschichten aus 1001 Nacht)",
    "director": "Pier Paolo Pasolini",
    "country": "Italien",
    "releaseYear": 1974,
    "runtime": 129,
    "version": "OmU",
    "screeningDate": "05.03.2011",
    "readableDate": "2011-03-05",
    "screeningTime": "20:00",
    "actors": " Ninetto Davoli, Franco Citti, Franco Merli, Tessa Bouché, Ines Pellegrini, Margaret Clementi, Luigina Rocchi, Alberto Argentino, Francesco Paolo Governale, Salvatore Sapienza, Franca Sciutto",
    "subtitle": [""],
    "bodycopy": [
      "Von den drei Filmen der „Trilogie des Lebens“ ist dies der gelungenste. Der Reigen erotischer Abenteuer gipfelt immer wieder in Nacktheiten und Geschlechtlichkeiten, die wirklich ahnen lassen, was Pasolini als Ausdruck einer „Freude des Lebens“ vorgeschwebt haben mag."
    ],
    "image": "Il fiore.jpg"
  },
  {
    "title": "Il Gattopardo (Der Leopard)",
    "director": "Luchino Visconti",
    "country": "Italien/Frankreich",
    "releaseYear": 1963,
    "runtime": 180,
    "version": "OmU",
    "screeningDate": "08.03.2020",
    "readableDate": "2020-03-08",
    "screeningTime": "16:00",
    "actors": "Burt Lancaster, Claudia Cardinale, Alain Delon, Paolo Stoppa u.a.",
    "subtitle": [
      " Schon bald nach seinem Erscheinen 1958 zählte Tomasi di Lampedusas „Il Gattopardo“, der von den gesellschaftlichen Umbrüchen des 19. Jahrhunderts berichtet, zur Weltliteratur. Bereits vier Jahre später,1962, hatte Luchino Visconti aus dem Romanstoff einen Film geschaffen, der fester Teil der Filmgeschichte ist. Er erzählt die Geschichte des Übergangs von der feudalen zur bürgerlichen Macht mit filmischen Mitteln; in Bildern von blühender Pracht und morbidem Glanz."
    ],
    "bodycopy": [
      "Der alternde Fürst Don Fabrizio, Principe di Salina (Burt Lancaster), sieht die Erosion der Macht der Adelsgeschlechter kommen und verweigert die Mitarbeit am neuen Königreich Italien. Gleichzeitig fördert er die Eheschließung seines Neffen Tancredi (Alain Delon) mit Angelica (Claudia Cardinale), der Tochter des Bürgermeisters. Visconti inszeniert das Zusammentreffen der alten und neuen Gesellschaft in einem großen Ball, dessen Choreographie unvergesslich ist. Mit kritischer Sympathie folgt der Film der letzten Lebensphase des Fürsten. Legendär ist der Satz des Romans, mit dem Tancredi seinem Onkel den Wandel der Zeitenläufe erklärt: „Es muss sich alles ändern, damit es bleibt, wie es ist.“",
      "„Ein bewegendes historisches und gesellschaftliches Panoramabild von faszinierender Schönheit und analytischer Schärfe“ (Lexikon des Internationalen Films)"
    ],
    "image": "Il gattopardo.jpg"
  },
  {
    "title": "Il Gattopardo (Der Leopard)",
    "director": "Luchino Visconti",
    "country": "Italien/Frankreich/Großbritannien",
    "releaseYear": 1963,
    "runtime": 180,
    "version": "OmitU",
    "screeningDate": "02.11.2005",
    "readableDate": "2005-11-02",
    "screeningTime": "17:30",
    "actors": "Burt Lancaster, Alain Delon, Claudia Cardinale, Paolo Stoppa, Rina Morelli, Lucilla MOrlacchi, Romolo Valli, Terence Hill, Pierre Clémenti, Serge Reggiani, Maurizio Merli, Giuliano Gemma, Ida Galli, Ottavia Piccolo",
    "subtitle": [""],
    "bodycopy": [
      "Das einzige Werk Tommasi di Lampedusas, „Il Gattopardo“, ist in die Literaturgeschichte eingegangen. Und Visconti hat eine kongeniale filmische Entsprechung geschaffen. Beschrieben wird der Umbruch Siziliens zwischen 1860 und 1862 vor dem Hintergrund des Kampfes Garibaldis für ein geeintes Italien. Das Adelsgeschlecht der Salinas gerät zwischen Tradition und aufstrebendem Bürgertum unter Druck."
    ],
    "image": "il-gattopardo.gif"
  },
  {
    "title": "IL GENERALE DELLA ROVERE (Der falsche General)",
    "director": "Roberto Rossellini",
    "country": "Italien",
    "releaseYear": 1959,
    "runtime": 138,
    "version": "OmU",
    "screeningDate": "21.06.2007",
    "readableDate": "2007-06-21",
    "screeningTime": "19:00",
    "actors": "Vittorio de Sica, Hannes Messemer, Giovanna Ralli, Sandra Milo, Anne Vernon, Vittorio Capriol, Kurt Selge, Giuseppe Roselli, Nando Angelini, Herbert Fischer",
    "subtitle": [""],
    "bodycopy": [
      "Rossellini stellt seinen ersten männlichen Hauptdarsteller De Sica vor eine existenzielle Entscheidung: Der Schwindler und Lebenskünstler Bardone beutet im Winter 1943 während der deutschen Besatzung in Genua seine Landleute skrupellos aus. Als die SS ihn als V-Mann in die Rolle des getöteten, mit der Resistenza sympathisierenden Generals Della Rovere zwingt, muss er zwischen Verrat und eigenem Tod entscheiden. Gezeigt wird die ursprüngliche Fassung Rossellinis, die 6 Minuten länger als die Kinofassung ist."
    ],
    "image": "il-generale-della-rovere.jpg"
  },
  {
    "title": "IL GENERALE DELLA ROVERE (DER FALSCHE GENERAL)",
    "director": "Roberto Rossellini",
    "country": "Itaien",
    "releaseYear": 1959,
    "runtime": 138,
    "version": "OmU",
    "screeningDate": "17.04.2014",
    "readableDate": "2014-04-17",
    "screeningTime": "20:00",
    "actors": "Vittorio de Sica, Hannes Messemer, Giovanna Ralli, Sandra Milo, Anne Vernon, Vittorio Capriol, Kurt Selge, Giuseppe Roselli, Nando Angelini, Herbert Fischer",
    "subtitle": ["Höhepunkte aus 10 Jahren „Italienischer Filmclub“"],
    "bodycopy": [
      "Rossellini stellt seinen ersten männlichen Hauptdarsteller De Sica vor eine existenzielle Entscheidung: Der Schwindler und Lebenskünstler Bardone beutet im Winter 1943 während der deutschen Besatzung in Genua seine Landleute skrupellos aus. Als die SS ihn als V-Mann in die Rolle des getöteten, mit der Resistenza sympathisierenden Generals Della Rovere zwingt, muss er zwischen Verrat und eigenem Tod entscheiden. Gezeigt wird die ursprüngliche Fassung Rossellinis, die 6 Minuten länger als die Kinofassung ist."
    ],
    "image": "il-generale-della-rovere.jpg"
  },
  {
    "title": "Il giorno della civetta (Der Tag der Eule)",
    "director": "Damiano Damiani",
    "country": "Italien/Frankreich",
    "releaseYear": 1967,
    "runtime": 104,
    "version": "OmitU",
    "screeningDate": "03.03.2010",
    "readableDate": "2010-03-03",
    "screeningTime": "20:20",
    "actors": "Claudia Cardinale, Franco Nero, Lee J. Cobb, Nehemiah Persoff, Serge Reggiani, Tano Cimarosa, Ennio Balbo",
    "subtitle": ["Geschichte der Mafia – Mafiageschichten"],
    "bodycopy": [
      "Dieser nach einem Roman von Leonardo Sciascia entstandene Film behandelt die Unmöglichkeit polizeilicher Ermittlungen angesichts der Omertà (ein hauptsächlich in Sizilien weit verbreitetes Phänomen, über Gesehenes und Erlebtes zu schweigen), des gegenseitigen Misstrauens und einer „Überwachungsgesellschaft im Schatten“."
    ],
    "image": "il-giorno-della-civetta.jpg"
  },
  {
    "title": "IL GIOVEDÌ (DER DONNERSTAG)",
    "director": "Dino Risi",
    "country": "Italien",
    "releaseYear": 1963,
    "runtime": 110,
    "version": "OmU",
    "screeningDate": "19.02.2015",
    "readableDate": "2015-02-19",
    "screeningTime": "20:00",
    "actors": " Walter Chiari, Michéle Mercier, Roberto Ciccolini, Silvio Bagolini, Umberto D'Orsi, «Die Kessler-Zwillinge»",
    "subtitle": [""],
    "bodycopy": [
      "Als ein Mann seinen Sohn Jahre nach der Scheidung das erst Mal wiedersehen kann, spielt er ihm Wohlstand vor, um ihn zu beeindrucken. Der Junge durchschaut das Spiel aber schnell und ermöglicht so eine Annäherung."
    ],
    "image": "il-giovedi-1.png"
  },
  {
    "title": "IL GIOVEDÌ (DER DONNERSTAG)",
    "director": "Dino Risi",
    "country": "Italien",
    "releaseYear": 1963,
    "runtime": 110,
    "version": "OmU",
    "screeningDate": "16.05.2013",
    "readableDate": "2013-05-16",
    "screeningTime": "20:00",
    "actors": " Walter Chiari, Michéle Mercier, Roberto Ciccolini, Silvio Bagolini, Umberto D'Orsi, «Die Kessler-Zwillinge»",
    "subtitle": [""],
    "bodycopy": [
      "Nach der Scheidung hatte Dino seinen Sohn jahrelang nicht gesehen und möchte ihn beim ersten Treffen beeindrucken. So spielt er ihm einen wohlhabenden Lebensstil vor, dessen Falschheit der Junge langsam durchschaut."
    ],
    "image": "il-giovedi-1.jpg"
  },
  {
    "title": "IL GRIDO (DER SCHREI)",
    "director": "Michelangelo Antonioni",
    "country": "Italien/USA",
    "releaseYear": 1957,
    "runtime": 111,
    "version": "OmU",
    "screeningDate": "21.05.2015",
    "readableDate": "2015-05-21",
    "screeningTime": "20:00",
    "actors": "Steve Cochran, Alida Valli, Dorian Gray, Pina Boldrini, Betsy Blair, Lynn Shaw, Gabriella Pallotta, Mirna Girardi",
    "subtitle": [""],
    "bodycopy": [
      "Ein verkanntes Meisterwerk Antonionis. Ein Arbeiter streift, von seiner Lebensgefährtin verlassen, mit seiner kleinen Tochter durch die Poebene. Begegnungen mit anderen Frauen verstärken seine Depression. Der Film folgt dem Protagonisten auf seinem Weg in den Abgrund und zeichnet dabei das melancholische Porträt einer Landschaft.Ein verkanntes Meisterwerk Antonionis. Ein Arbeiter streift, von seiner Lebensgefährtin verlassen, mit seiner kleinen Tochter durch die Poebene. Begegnungen mit anderen Frauen verstärken seine Depression. Der Film folgt dem Protagonisten auf seinem Weg in den Abgrund und zeichnet dabei das melancholische Porträt einer Landschaft."
    ],
    "image": "il-grido.jpg"
  },
  {
    "title": "Il ladro di bambini (Gestohlene Kinder)",
    "director": "Gianni Amelio",
    "country": "Italien/Frankreich/Schweiz",
    "releaseYear": 1992,
    "runtime": 122,
    "version": "OmU",
    "screeningDate": "19.08.2004",
    "readableDate": "2004-08-19",
    "screeningTime": "19:30",
    "actors": "Enrico Lo Verso, Valentina Scalici, Giuseppe Ieracitano, Florence Darel, Marina Golovine, Fabio Alessandrini, Agostino Zumbo, Vitalba Andrea",
    "subtitle": [""],
    "bodycopy": [
      "Nachdem ihre Mutter verhaftet wurde, bekommt der Carabiniere Antonio die Aufgabe, die Kinder Rosetta und Luciano von Mailand nach Caltanissetta zu bringen. Während der langen Reise entsteht aus anfänglichem Misstrauen Zutraulichkeit. Gleichzeitig ist der Film ein sensibles Porträt Italiens der 90er Jahre."
    ],
    "image": "ladro-di-bambini.jpg"
  },
  {
    "title": "Il mestiere delle armi (Der Medici krieger)",
    "director": "Ermanno Olmi",
    "country": "Italien/Frankreich/Deutschland",
    "releaseYear": 2001,
    "runtime": 105,
    "version": "OmU",
    "screeningDate": "06.12.2003",
    "readableDate": "2003-12-06",
    "screeningTime": "19:30",
    "actors": "Hristo Jivkov, Sergio Grammatico, Fabio Giubbani, Sandra Ceccarelli, Dessy Tenekedjieva, Dimitar Ratchkov",
    "subtitle": [""],
    "bodycopy": [
      "Winter 1526. Italien wird durch ein gewaltiges Heer bedroht. Kaiser Karl V. entsandte seine Landsknechte unter Führung des Generals Georg von Frundsberg nach Italien, um den mit Frankreich verbündeten Kirchenstaat anzugreifen. Die Päpstlichen Truppen unter ihrem Befehlshaber Generale della Rovere stellen sich den Kaiserlichen entgegen, allen voran der militärisch brillante Capitano der gefürchteten Schwarzen Banden: Giovanni de’ Medici",
      "Der Film beginnt mit seiner Aufbahrung und faltet rückblickend seine Geschichte auf, in der Heldenmut und moderne Kriegstechnik konkurrieren. Olmi hat keinen gewöhnlichen Historienfilm geschaffen, sondern einen Ablauf archaischer, ruhiger, zum Teil meditativer Bilder, in der das Menschliche in den Vordergrund rückt. Der Film wurde mit 9 „Donatellos“ (italienische „Oscars“) ausgezeichnet."
    ],
    "image": "2003-12-medici-kriegerdepdf-adobeacrobatstandard2017.jpg"
  },
  {
    "title": "IL PALIO (Das Rennen von Siena)",
    "director": "John Appel",
    "country": "Niederlande",
    "releaseYear": 2004,
    "runtime": 88,
    "version": "OmU",
    "screeningDate": "16.07.2009",
    "readableDate": "2009-07-16",
    "screeningTime": "20:00",
    "actors": null,
    "subtitle": [
      "„Italienische Portraits“ - Dokumentarfilme zu italienischen Themen"
    ],
    "bodycopy": [
      "Jedes Jahr ist es der Höhepunkt in Siena: „Il Palio“, das berühmte Pferderennen in der historischen Kulisse der Stadt. Zehn der sechzehn Stadtteile treten gegeneinander an – und neben dem Gewinnen geht es nicht zuletzt geht um Ehre und Ansehen. Der Film verfolgt anhand des Civitta-Viertels die Vorbereitungen des Palio und ist nahe bei den Erwartungen und Gefühlen der Teilnehmer. Unterhaltsam und unkommentiert zeigt dieser Film einen besonderen Aspekt der „Vita italiana“, in der sich Individualität, Tradition, Geschäftemacherei und Religion zu einer einmaligen Mischung verbinden."
    ],
    "image": "il-palio.jpg"
  },
  {
    "title": "IL PARADISO DEL PAVONE (PFAUENPARADIES)",
    "director": "Laura Bispuri",
    "country": "Italien/Deutschland",
    "releaseYear": 2021,
    "runtime": 88,
    "version": "OmU",
    "screeningDate": "17.11.2022",
    "readableDate": "2022-11-17",
    "screeningTime": "20:00",
    "actors": "Dominique Sanda, Alba Rohrwacher, Maya Sansa, Carlo Cerciello, Fabrizio Ferracane Manfredi u.a.",
    "subtitle": [
      "So verschieden die beiden Filme sind, der im Oktober 2022 gezeigte Film Nanni Morettis TRE PIANI und Laura Bispuris IL PARADISO DEL PAVONE, sie behandeln doch das gleiche Thema: Der Mensch in seiner Beziehung zu sich selbst, seinen Partnern und seinem Umfeld. Wo Moretti den konservativ-narrativen Weg des filmischen Erzählens gewählt hat, ist bei Bispuri die beschriebene Situation trotz realistischer Darstellung enigmatisch und metaphorisch."
    ],
    "bodycopy": [
      "Die Irritation des Zuschauers beginnt mit einem Pfau, der als Haustier mit zu einem Fest gebracht wird. Langsam kommen die Gäste an, niemand scheint sich über den Pfau zu wundern. Der wiederum verliebt sich in eine gemalte weiße Taube, was ihn einem tragischen Schicksal entgegenführt. Mit den von einem der Gäste am Ende des Films ausgesprochenen Satz: „Wir alle hätten der Pfau seien können.“ erschließt sich das bisher Gesehene: einem kurzem eingebildetem, aber tiefempfundenen Glück folgt der mehr oder weniger schwere Absturz.",
      "Bei der bestimmenden Mutter sind die Protagonisten zu Gast, sie wollen ihren Erfolg herausstreichen, sei er persönlicher oder geschäftlicher Art. Freundschaft und Solidarität wird erklärt, aber Formulierung und Stimme verraten schon deren Haltlosigkeit. So zerbricht der vage Schein der Harmonie, die Paare verteidigen ihre Zweisamkeit, gehen sich aber untereinander an, aus der Not entstehen neue Allianzen von kurzer Dauer, neue Konstellationen scheinen sich zu bilden, sind aber brüchig und Neurosen gewinnen die Überhand. Dazwischen ein junges Mädchen, das als Einzige Mitgefühl mit dem Pfau zeigt."
    ],
    "image": "261268.jpg"
  },
  {
    "title": "Il partigiano Johnny",
    "director": "Guido Chiesa",
    "country": "Italien",
    "releaseYear": 2000,
    "runtime": 127,
    "version": "OmitU",
    "screeningDate": "07.09.2011",
    "readableDate": "2011-09-07",
    "screeningTime": "20:00",
    "actors": "Stefano Dionisi, Fabrizio Gifuni, Andrea Prodan, Alberto Gimignani, Giuseppe Cederna, Umberto Orsini, Chiara Muti, Lina Bernardi, Tony Bertorelli, Claudio Amendola, Barbara Lerici",
    "subtitle": ["150 Jahre Italien"],
    "bodycopy": [
      "Eine beeindruckende Geschichte des Partisanenkampfes in Italien. Der Student für englische Literatur Johnny desertiert und zieht sich nach seiner Rückkehr ins Heimatdorf zum Studium in ein Haus in den Bergen zurück. Als sein Freund ums Leben kommt, will er als Partisan in vorderer Front kämpfen und wird, ohne politische Überzeugung, von unterschiedlich orientierten „Kampfgruppen“ aufgenommen, bleibt im Grunde aber ein Einzelkämpfer."
    ],
    "image": "il-partigiano-jonny.jpg"
  },
  {
    "title": "Il più bel giorno della mia vita (Der schönste Tag in meinem Leben)",
    "director": "Cristina Comencini",
    "country": "Italien/Großbritannien",
    "releaseYear": 2002,
    "runtime": 102,
    "version": "OmU",
    "screeningDate": "19.01.2005",
    "readableDate": "2005-01-19",
    "screeningTime": "19:30",
    "actors": "Virna Lisi, Margherita Buy, Sandra Ceccarelli, Luigi Lo Cascio, Marco Baliani, Marco Quaglia",
    "subtitle": [""],
    "bodycopy": [
      "Grossmutter Irene lebt in einem Haus voller Erinnerungen und die Familienzusammenkünfte mit ihren drei Kindern Sara, Rita und Claudio sind ihr Ein und Alles. Dabei übersieht sie, dass deren Leben nicht so harmonisch verläuft, wie sie es sich vorstellt. Dieses brüchige Bild wird von Ritas kleiner Tochter Chiara genaustens registriert. Mit der Videokamera, ein Geschenk zur ersten Kommunion, spürt sie dem familiären Reigen aus Desorientierung, Geheimnissen und Sehnsüchten nach."
    ],
    "image": "il-piu-bel-girno-della-mia-vita-1.png"
  },
  {
    "title": "IL PIÙ BEL GIORNO DELLA MIA VITA (Der schönste Tag in meinem Leben)",
    "director": "Cristina Comencini",
    "country": "Italien/Frankreich",
    "releaseYear": 1969,
    "runtime": 99,
    "version": "OmU",
    "screeningDate": "23.02.2011",
    "readableDate": "2011-02-23",
    "screeningTime": "20:00",
    "actors": "Virna Lisi, Margherita Buy, Sandra Ceccarelli, Luigi Lo Cascio, Marco Baliani, Marco Quaglia",
    "subtitle": ["Die Familie Comencini"],
    "bodycopy": [
      "Großmutter Irene lebt in einem Haus voller Erinnerungen und dieGroßmutter Irene lebt in einem Haus voller Erinnerungen und dieFamilienzusammenkünfte mit ihren drei Kindern Sara, Rita undClaudio sind ihr Ein und Alles. Dabei übersieht sie, dass deren Lebennicht so harmonisch verläuft, wie sie es sich vorstellt. Dieses brüchigeGeflecht registriert Ritas kleine Tochter Chiara genaustens mit derVideokamera, ein Geschenk zur ersten Kommunion. Unter anderemdurch die Augen des Kindes zeigt sich Cristina Comencini als sensibleAnalytikerin familiärer und gesellschaftlicher Verhältnisse."
    ],
    "image": "il-piu-bel-girno-della-mia-vita-1.png"
  },
  {
    "title": "Il porcile (Der Schweinestall)",
    "director": "Pier Paolo Pasolini",
    "country": "Italien/Frankreich",
    "releaseYear": 1969,
    "runtime": 99,
    "version": "OmU",
    "screeningDate": "23.02.2011",
    "readableDate": "2011-02-23",
    "screeningTime": "20:00",
    "actors": "Pierre Clémenti, Jean-Pierre Léaud, Alberto Lionello, Ugo Tognazzi, Marco Ferreri, Anne Wiazemsk<, Ninetto Davoli",
    "subtitle": [""],
    "bodycopy": [
      "Eine Attacke auf unsere Konsumgesellschaft in abgründigen Gleichnissen: Pasolini entwickelt eine für ihn neue, fratzenhafte Komik, über deren Giftigkeit einem das Lachen vergeht."
    ],
    "image": "Il porcile.jpg"
  },
  {
    "title": "Il postino (Der Postmann)",
    "director": "Michael Radford",
    "country": "Italien",
    "releaseYear": 1994,
    "runtime": 109,
    "version": "OmU",
    "screeningDate": "28.06.2009",
    "readableDate": "2009-06-28",
    "screeningTime": "20:00",
    "actors": "Philippe Noiret, Massimo Troisi, Maria Grazia Cucinotta, Renato Scarpa, Linda Moretti, Mariano Rigillo, Anna Bonaiuti, Simona Caparrini",
    "subtitle": [
      "Fünf Highlights aus fünf Jahren „Italienischer Filmclub“ in der Black Box"
    ],
    "bodycopy": [
      "Die Geschichte der langsam wachsenden Freundschaft zwischen dem in Italien im Exillebenden chilenischen Dichter Pablo Neruda und seinem Postboten. Einfühlsam beschrieben und hervorragend fotografiert ist dieser Film ein Genuss für die Sinne und berührt durch seine Menschlichkeit."
    ],
    "image": "il-postino.jpg"
  },
  {
    "title": "IL POSTINO (Der Postmann)",
    "director": "Michael Radford",
    "country": "Italien",
    "releaseYear": 1994,
    "runtime": 109,
    "version": "OmU",
    "screeningDate": "19.05.2007",
    "readableDate": "2007-05-19",
    "screeningTime": "19:00",
    "actors": "Philippe Noiret, Massimo Troisi, Maria Grazia Cucinotta, Renato Scarpa, Linda Moretti, Mariano Rigillo, Anna Bonaiuti, Simona Caparrini",
    "subtitle": [""],
    "bodycopy": [
      "Die Geschichte der langsam wachsenden Freundschaft zwischen dem in Italien im Exil lebenden chilenischen Dichter Pablo Neruda und seinem Postboten hat bei Erscheinen das Publikum begeistert und steht ganz oben auf der Liste der Publikumswünsche. Einfühlsam beschrieben und hervorragend fotografiert ist dieser Film ein Genuss für die Sinne und berührt durch seine Menschlichkeit. Letztendlich steckt die Poesie im Leben eines jeden Menschen – er muss nur lernen, sie zu entdecken und zum Klingen zu bringen."
    ],
    "image": "il-postino.jpg"
  },
  {
    "title": "IL ROSSO E IL BLU (ROT UND BLAU)",
    "director": "Giuseppe Piccioni",
    "country": "Italien",
    "releaseYear": 2012,
    "runtime": 98,
    "version": "OmU",
    "screeningDate": "16.06.2016",
    "readableDate": "2016-06-16",
    "screeningTime": "20:00",
    "actors": "",
    "subtitle": [""],
    "bodycopy": [
      "Die neuste Komödie von Giuseppe Piccioni („Fuori dal mondo“, „Luce dei miei occhi”) nimmt die Schulwelt auf die Schippe. Ein Kosmos verschiedener Lehrertypen treffen auf Streber, Rebellen und viel Pubertät."
    ],
    "image": "il-rosso-e-il-blu.jpg"
  },
  {
    "title": "IL TRADITORE (IL TRADITORE: ALS KRONZEUGE GEGEN DIE COSA NOSTRA)",
    "director": "Marco Bellocchio",
    "country": "Italien/Frankreich/Deutschland/Brasilien",
    "releaseYear": 2019,
    "runtime": 153,
    "version": "OmU",
    "screeningDate": "20.01.2022",
    "readableDate": "2022-01-20",
    "screeningTime": "20:00",
    "actors": "Pierfrancesco Favino, Maria Fernanda Candido, Nicola Calì, Luigi Lo Cascio u.a.",
    "subtitle": [
      "Der heutige Film erzählt vom Wendepunkt in der Geschichte der „klassischen sizilianischen Mafia“. In den achtziger Jahren prägen Machtkämpfe der Clans den mafiösen Alltag der Cosa Nostra. Richter Falcone versucht eine Schneise in diese kriminellen Verflechtungen zu schlagen. Tommaso Buscetta, im Krieg der Cosa Nostra immer mehr isoliert, trifft nach seiner Verhaftung auf Falcone, fasst Vertrauen und konvertiert zum Kronzeugen: der Maxi Prozess kann beginnen."
    ],
    "bodycopy": [
      "In seinem Alterswerk greift Bellocchio in moderner Art auf die Tradition des italienischen politischen Films zurück und schildert nicht nur in eindrücklicher Weise die Struktur der Cosa Nostra, die historische Entwicklung zum Maxiprozess und dessen Ablauf, sondern thematisiert auch die Bindungswirkung der Mitgliedschaft in einem Clan, die seelischen und psychischen Probleme des Verrats und den Zwist zwischen der Einsicht, das Richtige zu tun, aber auch seine Familie damit zu gefährden. Über den Film schwebt dabei das bei diesem Thema unvermeidliche Misstrauen eines jeden gegen jeden.",
      "Bellocchio gelingt es, einen ausdifferenzierten Kosmos in atmosphärischer Dichte nahe am Protagonisten vorzustellen, und legt gleichzeitig die Strukturen der organisierten Kriminalität offen, unter denen Italien jahrzehntelang gelitten hat und teilweise immer noch leidet."
    ],
    "image": "il-traditore-3.jpg"
  },
  {
    "title": "Il Vangelo secondo Matteo (Das erste Evangelium - Matthäus)",
    "director": "Pier Paolo Pasolini",
    "country": "Italien/Frankreich",
    "releaseYear": 1964,
    "runtime": 131,
    "version": "OmU",
    "screeningDate": "18.02.2011",
    "readableDate": "2011-02-18",
    "screeningTime": "20:00",
    "actors": "Enrique Irazoqui, Margherita Caruso, Susanna Pasolini, Marcello Morante, Rossana di Rocco, Mario Socrate, Alessandro Chierici",
    "subtitle": [""],
    "bodycopy": [
      "Pasolini filmt das Matthäus-Evangelium als gälte es, einen neorealistischen Film über den Mezzogiorno zu drehen. Er unterschlägt weder den sozial-revolutionären noch den religiösen Gehalt des Evangeliums."
    ],
    "image": "Il Vangelo.jpg"
  },
  {
    "title": "Il Vedovo",
    "director": "Dino Risi",
    "country": "Italien",
    "releaseYear": 1959,
    "runtime": 86,
    "version": "OmitU",
    "screeningDate": "05.11.2008",
    "readableDate": "2008-11-05",
    "screeningTime": "18:00",
    "actors": "Alberto Sordi, Franca Valeri, Livio Lorenzon, Leonora Ruffo, Nando Bruno, Nanda Primavera, Mario Passante, Enzo Petito",
    "subtitle": ["In Gedenken an Dino Risi"],
    "bodycopy": [
      "Unternehmerisches Selbstverständnis und wirtschaftlicher Erfolg von Alberto Nardi fallen auseinander. So wünscht er sich den Tod seiner reichen Ehefrau, die ihn wie einen unterhaltsamen Clown behandelt. Seine Hoffnung wächst, als sie bei einem Zugunglück ums Leben gekommen sein soll. Tatsächlich ist sie nie in den Zug gestiegen. Als er dies erfährt, wachsen in ihm diabolische Pläne ... - Dini Risi zeigt ein engebrochenen Mann und schreckt auch vor makabrem Humor nicht zurück. Ein Zeitbild der „italienischen Moralität“ der 50er Jahre."
    ],
    "image": "il-vedovo.jpg"
  },
  {
    "title": "Il Vedovo",
    "director": "Dino Risi",
    "country": "Italien",
    "releaseYear": 1959,
    "runtime": 86,
    "version": "OmitU",
    "screeningDate": "04.08.2010",
    "readableDate": "2010-08-05",
    "screeningTime": "28:00",
    "actors": "Alberto Sordi, Franca Valeri, Livio Lorenzon, Leonora Ruffo, Nando Bruno, Nanda Primavera, Mario Passante, Enzo Petito",
    "subtitle": ["Werkschau: Dino Risi"],
    "bodycopy": [
      "Wenn die Geschäfte schlecht laufen, kann man es ja mal mit männlicher Verführungskraft versuchen und eine neue „Gesellschaftsform“ ausprobieren: Witwer. Aber wer bei den Geschäften Schwierigkeiten hat, wird auch bei einem solchen “Unternehmen“ sicher mit Problemen zu kämpfen haben.Wenn die Geschäfte schlecht laufen, kann man es ja mal mit männlicher Verführungskraft versuchen und eine neue „Gesellschaftsform“ ausprobieren: Witwer. Aber wer bei den Geschäften Schwierigkeiten hat, wird auch bei einem solchen “Unternehmen“ sicher mit Problemen zu kämpfen haben."
    ],
    "image": "il-vedovo2.jpg"
  },
  {
    "title": "Il vento di sera (Der Wind abends)",
    "director": "Andrea Adriatico",
    "country": "Italien",
    "releaseYear": 2004,
    "runtime": 92,
    "version": "OmU",
    "screeningDate": "15.05.2006",
    "readableDate": "2006-05-15",
    "screeningTime": "20:30",
    "actors": "Corso Salani, Francesca Mazza, Luca Levi, Paolo Porto, Giovanni Lindo Ferretti, Ivano Marescotti, Sergio Romano, Alessandro Fullin, Fabio Valletta",
    "subtitle": [""],
    "bodycopy": [
      "Weil Luca zufällig in ein politisches Attentat gerät, wird er erschossen. Dies löst bei seinem Freund Paolo einen Schock aus und verzweifelt zieht es durch das nächtliche Bologna. Seinen Begegnungen mit Menschen lassen einen kleinen italienischen Mikrokosmos entstehen, der das Verhältnis von Leben und Tod, Liebe und Begehren auslotet. „Der Mensch hängt an einem dünnen Lebensfaden wie Blätter, die “ein Windhauch davontragen könnte” (Berlinale-Katalog)."
    ],
    "image": "il-vento-di-sera.jpg"
  },
  {
    "title": "IL VENTO FA IL SUO GIRO (Der Wind zieht seinen Weg)",
    "director": "Giorgio Diritti",
    "country": "Italien",
    "releaseYear": 2006,
    "runtime": 110,
    "version": "OmU",
    "screeningDate": "15.10.2009",
    "readableDate": "2009-10-15",
    "screeningTime": "20:00",
    "actors": "hierry Toscan, Alessandra Agosti, Dario Anghilante, Giovanni Foresti",
    "subtitle": [""],
    "bodycopy": [
      "Festivals, das Engagement mutiger Kinobetreiber und die Begeisterung des Publikums machte diesen Film zum Erfolg – nach vielen Ablehnungen der kommerziellen Filmindustrie. Mit geringen Mitteln beeindruckend fotografiert, erzählt dieser Film von der Ankunft eines „Aussteigers“ mit seiner Schafherde in einem noch archaisch geprägten Dorf, das seine Rettung im Tourismus sucht und ihn mit seinem Käsereiprojekt begeistert empfängt. Aber es entstehen Konflikte und schließlich gewinnt die moderne Welt Oberwasser."
    ],
    "image": "Il vento fa il suo giro.jpg"
  },
  {
    "title": "Il viaggio di Capitan Fracassa (Die Reise des Capitan Fracassa)",
    "director": "Ettore Scola",
    "country": "Italien",
    "releaseYear": 1990,
    "runtime": 132,
    "version": "OmitU",
    "screeningDate": "07.05.2008",
    "readableDate": "2008-05-07",
    "screeningTime": "19:00",
    "actors": "Vincent Perez, Emmanuelle Béart, Massimo Troisi, Ornella Muti, Lauretta Masiero, Toni Ucci, Massimo Wertmüller",
    "subtitle": ["Werkschau: Ettore Scola"],
    "bodycopy": [
      "Das Leben – ein Theater“. In wenigen Filmen hat Scola dieses Motto seines Filmschaffens so wörtlich genommen. Eine Theatertruppe nimmt im 17 Jh. einen jungen Adligen mit, für den die Begegnung mit dem Theater zu Befreiung wird. In der Rolle des Capitan Fracassa führt er die Truppe mit ihrem Stück zum Erfolg. Erzählte Theatertheorie oder Lebensphilosophie im Harlekinkostüm – Scola überlässt diese Entscheidung dem Zuschauer."
    ],
    "image": "il-viaggio-di-capitan-fracassa.jpg"
  },
  {
    "title": "IN GRAZIA DI DIO (EIN NEUES LEBEN)",
    "director": "Edoardo Winspeare",
    "country": "Italien",
    "releaseYear": 2014,
    "runtime": 129,
    "version": "OmU",
    "screeningDate": "17.11.2016",
    "readableDate": "2016-11-17",
    "screeningTime": "20:00",
    "actors": "Celeste Casciaro, Laura Licchetta, Anna Boccadamo, Gustavo Caputo, Barbara de Matteis, Amerigo Russo, Angelico Ferrarese, Antonio Carluccio",
    "subtitle": [""],
    "bodycopy": [
      "Die Schließung der eigenen Fabrik bedeutet für Adeles Familie den Weg in die Schuldenfalle. Sie zieht mit Schwester und Tochter zur Mutter auf das kleine bäuerlich genutzte Stück Land und haust mit ihnen im Schuppen. Die Verwirklichung ihrer Träume und Wünsche rückt in immer weitere Ferne, als sie beginnen, sich durch Kleinbauernarbeit und Tauschhandel ein neues Leben aufzubauen."
    ],
    "image": "in-grazia-di-dio.jpg"
  },
  {
    "title": "In nome del popolo italiano (Abend ohne Alibi)",
    "director": "Dino Risi",
    "country": "Italien",
    "releaseYear": 1971,
    "runtime": 103,
    "version": "OmitU",
    "screeningDate": "01.12.2007",
    "readableDate": "2007-12-01",
    "screeningTime": "19:00",
    "actors": "Ugo Tognazzi, Vittorio Gassman, Ely Galleani, Yvonnw Furneaux, Pietro Tondi, Simonetta Stefanelli, Franco Angrisano, Rebnato Baldini, Pietro Nuti, Checco Durante",
    "subtitle": ["In Gedenken an Dino Risi"],
    "bodycopy": [
      "Ein Richter trifft bei seinen Ermittlungen über den merkwürdigen Todeines Mädchens auf einen skrupellosen Unternehmer, der für die Tatzeit kein Alibi hat. Hingerissen zwischen Zweifeln an dessen Täterschaft ermittelt er Indizien, um sich und andere von dessen Schuld zu überzeugen. Bis er schließlich entlastendes Material findet und zu einer Entscheidung kommen muss. Eine an einigen Stellen langatmige, aber thematisch intensive Komödie über den moralischen Konflikt des Individuums zwischen empfundener moralischer Verantwortung und juristischer Wahrheitsfindung."
    ],
    "image": "in-nome-del-popolo-italiano.jpg"
  },
  {
    "title": "INCOMPRESA (MISSVERSTANDEN)",
    "director": "Asia Argento",
    "country": "Italien/Frankreich",
    "releaseYear": 2014,
    "runtime": 110,
    "version": "OmU",
    "screeningDate": "16.07.2015",
    "readableDate": "2015-07-16",
    "screeningTime": "20:00",
    "actors": "Giulia Salerno, Charlotte Gainsbourg, Gabriel Garko, Carolina Poccioni, Anna Lou Castoldi, Alice Pea, Andrea Pittorino, Riccardo Russo, Sofia Patron, Max Gazzè, Justin Pearson",
    "subtitle": [""],
    "bodycopy": [
      "Geschichte der neunjährigen Außenseiterin Aria, die von ihren sich streitenden Eltern nicht wahrgenommen wird, während sie die Schwester verwöhnen. Auch in der Schule stößt sie mit ihren Anliegen auf Unverständnis. So streunt sie durch die Straßen Roms und schließt Freundschaft mit einer schwarzen Straßenkatze."
    ],
    "image": "incompresa.jpg"
  },
  {
    "title": "INDAGINE SU UN CITTTADINO AL DI SOPRA DI OGNI SOSPETTO (Ermittlungen gegen einen über jeden Verdacht erhabenen Bürger)",
    "director": "Elio Petri",
    "country": "Italien",
    "releaseYear": 1970,
    "runtime": 110,
    "version": "OmitU",
    "screeningDate": "07.04.2010",
    "readableDate": "2010-04-07",
    "screeningTime": "20:00",
    "actors": "Gian Maria Volonté, Florinda Bolkan, Gianni Santuccio, Sergio Tramonti, Massimo Foschi, Salvo Randone, Orazio Orlando, Arturo Dominici, Aldo Rendine, Aleka Paizi",
    "subtitle": [""],
    "bodycopy": [
      "Am Tag seiner Berufung ermordert der Leiter der Mordkomission Roms (Gian Maria Volontè) bei erotischen Spielen seine Geliebte Augusta Terzi (Florinda Bolkan) und übernimmt die Untersuchung seiner eigenen Schuld. Er will sich und der Weltbeweisen, dass er als mächtiger Mann über jeden Verdacht und Anklage erhaben ist."
    ],
    "image": "indagine.jpg"
  },
  {
    "title": "Intervista",
    "director": "Federico Fellini",
    "country": "Italien",
    "releaseYear": 1986,
    "runtime": 107,
    "version": "OmitU",
    "screeningDate": "06.01.2010",
    "readableDate": "2010-01-06",
    "screeningTime": "20:00",
    "actors": "Anika Ekberg, Marcello Mastroianni, Federico Fellini, Sergio Rubini",
    "subtitle": ["90 Jahre Fellini (20.01.1920-31.10.1993)"],
    "bodycopy": [
      "Fellini und sein Cinecittà: Ein Interview für japanische Journalisten ist ihm Anlass zum Rückblick auf sein 40jähriges Filmschaffen. Beginnend mit den 40er Jahren, in denen er unerfahren in Cinecitta ankommt, folgt er Schauspielern, Fotografen, Technikern, Kostümbildern, allen die dem Kino Leben einhauche und es zur Traumfabrik machen."
    ],
    "image": "invervista.jpg"
  },
  {
    "title": "IO E LEI (FÜR IMMER EINS)",
    "director": "Maria Sole Tognazzi",
    "country": "Italien",
    "releaseYear": 2015,
    "runtime": 102,
    "version": "OmU",
    "screeningDate": "16.03.2017",
    "readableDate": "2017-03-16",
    "screeningTime": "20:00",
    "actors": "Margherita Buy, Sabrina Ferilli, Fausto Maria Sciarappa, Alessia Barela, Domenico Diele, Ennio Fantastichini, Massimiliano Gallo, Anna Bellato, Antonio Zavatteri, Emanuel Caserio",
    "subtitle": [
      "Vordergründig wird die Geschichte zweier mittelalter lesbischer Frauen erzählt. Aber es geht auch um die Belastbarkeit der Liebe, die Frage der persönlichen Identität und Aufrichtigkeit und nicht zuletzt um eine Lebenskrise in der Mitte des Lebens."
    ],
    "bodycopy": [
      "Obwohl Federica und Marina schon seit Jahren zusammen leben, hat Federica Probleme damit, sich öffentlich zu der Beziehung zu bekennen. Sie hat ihren Mann seinerzeit verlassen, um mit Marina zusammen zu leben und fürchtet sich vor der Reaktion der Umwelt, während diese offen mit ihrer Leidenschaft umgeht. Sie glaubt an die feste gemeinsame Beziehung, aber Federica gerät in eine Krise. Ein Wendepunkt deutet sich an.",
      "Ein sensibler und berührender Film mit Starbesetzung: Margherita Buy als Federica und Sabrina Ferilli als Marina."
    ],
    "image": "io-e-lei.jpg"
  },
  {
    "title": "IO E TE (ICH UND DU)",
    "director": "Bernardo Bertolucci",
    "country": "Italien",
    "releaseYear": 2012,
    "runtime": 97,
    "version": "OmU",
    "screeningDate": "18.12.2014",
    "readableDate": "2014-12-18",
    "screeningTime": "20:00",
    "actors": " Jacopo Olmo Antinori, Tea Falco, Sonia Bergamasco, Veronica Lazar, Tommaso Ragno, Pippo Delbono, Carlo Cozzani, Alessandra Vanzi",
    "subtitle": [""],
    "bodycopy": [
      "Das neuste Beziehungskammerspiel Bertoluccis: Statt am Schulausflug teilzunehmen, zieht sich Lorenzo heimlich in den Keller zurück. Seine Auszeit wird jäh gestört, als seine vor Jahren von zu Hause ausgezogene ältere Halbschwester unvermittelt einen Fluchtraum beansprucht und seine Unterstützung einfordert."
    ],
    "image": "io-e-te.jpg"
  },
  {
    "title": "Io non ho paura (Ich habe keine Angst)",
    "director": "Gabriele Salvatores",
    "country": "Italien/Spanien/Großbritannien",
    "releaseYear": 2003,
    "runtime": 105,
    "version": "OmU",
    "screeningDate": "18.03.2004",
    "readableDate": "2004-03-18",
    "screeningTime": "19:30",
    "actors": "Giuseppe Cristiano; Mattia Di Pierro; Aitana Sánchez-Gijón, Dino Abbrescia",
    "subtitle": [""],
    "bodycopy": [
      "Wehende Weizenfelder, eine übersichtliche, sonnenbeschienene Landschaft ohne Bäume in Süditalien. Aber unter dieser scheinbar friedlichen Oberfläche ist ein Geheimnis verborgen.",
      "Als der 11-jährige Michele im Weizenfeld einen Abgrund entdeckt, lüftet er nicht nur dieses Geheimnis, auch die den Kindern intakt erscheinende Erwachsenenwelt gerät aus den Fugen.",
      "Michele überwindet seine Bestürzung, findet dadurch einen neuen Freund, lernt Verantwortung kennen und indem er sich seinem Vater widersetzt, gewinnt er die Unabhängigkeit, um an dieser Erfahrung zu reifen.",
      "„Io non ho paura“ wird konsequent aus der Perspektive der Kinder erzählt, die Kamera bleibt mit ihnen auf Augenhöhe. Dennoch ist er kein Kinderfilm, sondern eine poetische Parabel über Verdrängtes und ans Licht Drängendes und über eine Landschaft, die die Menschen prägt.",
      "Dazu sagte der Produzent des Films, Riccardo Tozzi, das Team habe keinen typisch italienischen Film über Kinder im Süden drehen wollen, es sollte keine realistische, psychologische, lokal bestimmbare Geschichte werden. Am Anfang habe die Vision eines internationalen Films gestanden: episch, symbolisch und mit großartigen Bildern."
    ],
    "image": "io-non-ho-paura.png"
  },
  {
    "title": "Io non ho paura (Ich habe keine Angst)",
    "director": "Gabriele Salvatores",
    "country": "Italien/Spanien/Großbritannien",
    "releaseYear": 2003,
    "runtime": 109,
    "version": "OmU",
    "screeningDate": "15.03.2007",
    "readableDate": "2007-03-15",
    "screeningTime": "19:00",
    "actors": "Giuseppe Cristiano; Mattia Di Pierro; Aitana Sánchez-Gijón, Dino Abbrescia",
    "subtitle": [""],
    "bodycopy": [
      "Im März 2004 hatten wir leider nicht genug Platz für alle Besucher. Daher wiederholen wir den Film in einer kleinen Salvatores-Werkschau. Salvatores erzählt hier die Geschichte eines zehnjährigen Jungen, dessen Spiel auf einmal gefährlicher Ernst wird, als er zufällig auf ein Verbrechen stößt und nach und nach die Verstrickungen entdeckt, die auch zu seiner eigenen Familie führen. Nach dem Thriller von Niccolò Ammaniti gedreht, ist ein Film über das Erwachsenwerden entstanden, aber auch ein Porträt Süditaliens und seiner spezifischen Kriminalität."
    ],
    "image": "io-non-ho-paura2.jpg"
  },
  {
    "title": "IO SO CHE TU SAI CHE IO SO (ICH WEIß, DASS DU WEIßT, DASS ICH ES WEIß)",
    "director": "Alberto Sordi",
    "country": "Italien",
    "releaseYear": 1982,
    "runtime": 112,
    "version": "OmU",
    "screeningDate": "29.06.2013",
    "readableDate": "2013-06-29",
    "screeningTime": "20:00",
    "actors": "Alberto Sordi, Monica Vitti, Micaela Pignatelli, Salvatore Jacono, Isabella De Bernardi, Giuseppe Mannajuolo, Ivana Monti",
    "subtitle": [""],
    "bodycopy": [
      "Durch eine Verwechslung wird Fabio Bonettis Frau Livia drei Wochen lang von Privatdetektiven beschattet. Für das dadurch entstandene Filmmaterial interessiert sich der Bankangestellte herzlich wenig, hat er doch die ehrlichste Frau der Welt. Als Livia aber versucht den Film verschwinden zu lassen, wird Fabios Interesse geweckt. Stück für Stück sieht er ihn sich an und muss erkennen: Selbst die ehrlichste Frau hat ihre Geheimnisse...",
      "Dieser Film wurde als Hommage zum zehnten Todestag des Schauspielers und Regisseurs Alberto Sordi ausgewählt. Nach der Vorführung lädt der Workshop Filmuntertitelung der romanistischen Fakultät der Universität Düsseldorf, Fachbereich Literaturübersetzungen, zu einem Umtrunk ein."
    ],
    "image": "io-so-che-tu-sai.png"
  },
  {
    "title": "IO SONO L’AMORE (I AM LOVE)",
    "director": "Luca Guadagnino",
    "country": "Italien",
    "releaseYear": 2009,
    "runtime": 119,
    "version": "OmU",
    "screeningDate": "20.09.2012",
    "readableDate": "2012-09-20",
    "screeningTime": "20:00",
    "actors": "Tilda Swinton, Flavio Parenti, Alba Rohrwacher, Diane Fieri, Maria Paiato, Edoardo Gabbriellini, Waris Ahluwalia, Gabriele Ferzetti, Marisa Berenson",
    "subtitle": [""],
    "bodycopy": [
      "Zuerst sind es seine Kochkünste, dann ist es Antonio selbst, der Emmas Leidenschaft entfacht und sie aus der langweiligen Ehe mit dem Oberhaupt einer Modedynastie ausbrechen lässt. Das löst wiederum einen Generationenkonflikt in der Unternehmerfamilie aus, in dem unterschiedliche Wertvorstellungen aufeinanderprallen."
    ],
    "image": "io-sono-lamore.jpg"
  },
  {
    "title": "IO SONO LI (VENEZIANISCHE FREUNDSCHAFT)",
    "director": "Andrea Segre",
    "country": "Italien/Frankreich",
    "releaseYear": 2011,
    "runtime": 98,
    "version": "OmU",
    "screeningDate": "20.11.2014",
    "readableDate": "2014-11-20",
    "screeningTime": "20:00",
    "actors": "Tao Zhao, Rade Šerbedžija, Marco Paolini, Roberto Citran, Giuseppe Battiston, Giordano Bacci, Spartaco Mainardi, Zhong Cheng, Wang Yuan, Amleto Voltolina, Andrea Pennacchi",
    "subtitle": [""],
    "bodycopy": [
      "Li soll ohne Erfahrung als attraktive Exotin eine der chinesischen Mafia gehörende venezianische Bar auf Vordermann bringen. Doch die Venezianer feinden sie an, mit Ausnahme des alten Bepi, der selbst vor 30 Jahren als Migrant nach Venedig kam. Von der chinesischen Mafia und den Venezianern misstrauisch beäugt, beginnt sich zwischen den beiden Zuneigung zu entwickeln."
    ],
    "image": "io-sono-li.jpg"
  },
  {
    "title": "ITALY - LOVE IT OR LEAVE IT (ITALY - LOVE IT OR LEAVE I)",
    "director": "Gustav Hofer und Luca Ragazz",
    "country": "Italien/Deutschland",
    "releaseYear": 2011,
    "runtime": 75,
    "version": "OmU",
    "screeningDate": "21.11.2013",
    "readableDate": "2013-11-21",
    "screeningTime": "20:00",
    "actors": "Gustav Hofer, Luca Ragazz",
    "subtitle": [""],
    "bodycopy": [
      "Gustav und Luca litten in ihrem letzten Film unter den intoleranten Positionen zur Homo-Ehe in Italien. Inzwischen hat sich das Leiden auf die Situation im Land übertragen und es stellt sich die Frage, wo leben – weiter unter südlicher Sonne oder doch lieber in Berlin. Zur Beantwortung begeben sie sich auf die Reise durch ein Land der Widersprüche, des Unbegreiflichen, aber auch des Menschlichen und Faszinierenden. Herausgekommen ist ein Roadmovie, das unterhaltsam das aktuelle Italien aus subjektiver Sicht porträtiert."
    ],
    "image": "italy-love-it-or-leave-it.jpg"
  },
  {
    "title": "L'albero degli zoccoli (Der Holzschubaum)",
    "director": "",
    "country": "Italien",
    "releaseYear": 1977,
    "runtime": 179,
    "version": "OmitU",
    "screeningDate": "05.07.2006",
    "readableDate": "2006-07-05",
    "screeningTime": "17:30",
    "actors": "Luigi Ornaghi, Francesca Moriggi, Omar Brignoli, Antonio Ferrari, Teresa Brescianini, Giuseppe Brignoli, Carlo Rota, Pasqualina Brolis, Massimo Fratus, Francesca Villa",
    "subtitle": [""],
    "bodycopy": [
      "Ein Portrait des bäuerlichen Lebens bergamaskischer Landpächter am Ende des 19. Jahrhunderts. In einer außerordentlich schönen Bildsprache beschreibt Olmi mit Laiendarstellern das beschwerliche Leben und die sozialen Ungerechtigkeiten. Sein Blick gilt aber auch der Naturverbundenheit und tiefen Gläubigkeit der Menschen."
    ],
    "image": "lalbero-degli-zoccoli.jpg"
  },
  {
    "title": "L'avventura (Die mit der Liebe spielen)",
    "director": "Michelangelo Antonioni",
    "country": "Italien/Frankreich",
    "releaseYear": 1959,
    "runtime": 143,
    "version": "OmitU",
    "screeningDate": "07.11.2007",
    "readableDate": "2007-11-07",
    "screeningTime": "19:00",
    "actors": "Monica Vitti, Gabriele Ferzetti, Lea Massari, Esmeralda Ruspoli, James Addams, Dominique Blanchar",
    "subtitle": ["In Gedenken an Michelangelo Antonioni"],
    "bodycopy": [
      "Der erste Film von Antonionis „italienischer Trilogie“ wurde wegen seiner neuen Erzählweise und Filmsprache zum Lehrwerk für viele Filmkünstler und verhalf Antonioni zum Durchbruch. Auf einem Jachtausflug verschwindet Anna beim Besuch einer Insel. Ihr leichtlebiger Verlobte und ihre Freundin machen sich erfolglos auf die Suche. Langsam entsteht zwischen beiden eine Beziehung, es gelingt ihnen aber nicht,eine tragfähige gemeinsame Zukunft aufzubauen."
    ],
    "image": "avventura.jpg"
  },
  {
    "title": "L'eclisse (Liebe 1962)",
    "director": "Michelangelo Antonioni",
    "country": "Italien/Frankreich",
    "releaseYear": 1961,
    "runtime": 122,
    "version": "OmitU",
    "screeningDate": "05.12.2007",
    "readableDate": "2007-12-05",
    "screeningTime": "19:00",
    "actors": "Alain Delon, Monica Vitti, Francesco Rabal, Louis Seigner, Lilla Brignone, Rossana Rory, Mirella Ricciardi",
    "subtitle": ["In Gedenken an Michelangelo Antonioni"],
    "bodycopy": [
      "Der Abschlussfilm der „italienischen Trilogie“ ist seit langer Zeit nur noch selten im Kino zu sehen und daher eine kleine „Rarität“. Piero (Alain Delon) und Vittoria (Monica Vitti) versuchen in diesem Film, die Liebe zu finden. Doch schon die mächtige Säule, die sich bei ihrer ersten Begegnung im Filmbild zwischen sie stellt, deutet die Entfremdung an, mit der sie zu kämpfen haben."
    ],
    "image": "eclisse.jpg"
  },
  {
    "title": "L'estate di Martino",
    "director": "Massimo Natale",
    "country": "Italien",
    "releaseYear": 2010,
    "runtime": 80,
    "version": "OmitU",
    "screeningDate": "06.03.2012",
    "readableDate": "2012-03-06",
    "screeningTime": "20:00",
    "actors": "Treat Williams, Luigi Ciardo, Matilde Maggio",
    "subtitle": [""],
    "bodycopy": [
      "Im politisch aufgeheizten Sommer 1980 bricht der schüchterne Martino mit seinen Freunden in eine von den US-Amerikanern abgesperrte Bucht ein. Zufällig lernt er einen Offizier kennen, überwindet seine politischen Vorurteile und lässt sich von ihm das Surfen beibringen. Er entdeckt seine Fähigkeiten, stärkt sein Selbstbewusstsein und findet seine erste Liebe."
    ],
    "image": "lestate-di-martino.jpg"
  },
  {
    "title": "L‘AVVENTURA (Die mit der Liebe spielen)",
    "director": "Michelangelo Antonioni",
    "country": "Italien/Frankreich",
    "releaseYear": 1960,
    "runtime": 143,
    "version": "OmU",
    "screeningDate": "15.07.2010",
    "readableDate": "2010-07-15",
    "screeningTime": "20:00",
    "actors": "Monica Vitti, Gabriele Ferzetti, Lea Massari, Esmeralda Ruspoli, James Addams, Dominique Blanchar",
    "subtitle": [""],
    "bodycopy": [
      "Filmwunsch der Künstlerin Ana TorfsFilmwunsch der Künstlerin Ana Torfs begleitend zu ihrer Ausstellung ALBUM/TRACKS A im K21 (27.02.2010 bis 18.07.2010).",
      "Der erste Film von Antonionis „italienischer Trilogie“ wurde wegen seiner neuen Erzählweise und Filmsprache zum Lehrwerk für viele Filmkünstler und verhalf Antonioni zum Durchbruch. Auf einem Jachtausflug verschwindet Anna beim Besuch einer Insel. Ihr leichtlebiger Verlobte und ihre Freundin machen sich erfolglos auf die Suche. Langsam entsteht zwischen beiden eine Beziehung, es gelingt ihnen aber nicht, eine tragfähige gemeinsame Zukunf taufzubauen."
    ],
    "image": "lavventura.jpg"
  },
  {
    "title": "L’ inverno (Winter)",
    "director": "Nina Di Majo",
    "country": "Italien",
    "releaseYear": 2001,
    "runtime": 97,
    "version": "OmU",
    "screeningDate": "19.05.2004",
    "readableDate": "2004-05-19",
    "screeningTime": "19:30",
    "actors": "Valeria Bruni Tedeschi, Valeria Golino, Fabrizio Gifuni, Yorgo Voyagis, Paolo Paolini",
    "subtitle": [""],
    "bodycopy": [
      "In einer post-industriellen Metropole Norditaliens treffen zwei Paare aufeinander, die in ihrem Egoismus gefangen sind, unfähig, Beziehungen aufzubauen und zu kommunizieren."
    ],
    "image": "l-inverno.jpg"
  },
  {
    "title": "L’ULTIMO CAPODANNO (Die entfesselte Silvesternacht)",
    "director": "Marco Risi",
    "country": "Italien",
    "releaseYear": 1998,
    "runtime": 99,
    "version": "OmU",
    "screeningDate": "12.04.2007",
    "readableDate": "2007-04-12",
    "screeningTime": "19:30",
    "actors": "Monica Bellucci, Alessandro Haber, Francesca D'Aloja, Claudio Santamaria, Marco Giallini, Ricky Memphis, Giorgio Tirabassi, Natale Tulli",
    "subtitle": [""],
    "bodycopy": [
      "Marco Risi ist bekannt für seine sensiblen,sozialkritischen Filme (Mery per sempre, Ragazzi fuori). Mit diesem Film wechselt er jedoch seine Erzählweise. Eine entfesselte Geschichte in einem modernen römischen Wohnkomplex. Die verschiedensten Personen und Gruppen erleben auf groteske Art und Weise die letzten Stunden vor dem Jahreswechsel. Mit Anleihen bei der Commedia all’italiana und reichhaltigen Zitaten aus der Filmgeschichte und allen möglichen Genres hat Risi einen schrägen Film geschaffen, der mit seinen schrillen und obsessiven Bildern an Fellini erinnert. Die Handlung besteht aus sich parallel entwickelnden, zum Teil ineinander greifenden Episoden: Während eine Frau erfährt, dass ihr Mann sie betrügt und auf tödliche Rache sinnt, sucht eine Gräfin nebenan sexuelle Befriedigung in den Armen eines Gigolos. Ein Anwalt lässt sich in einer anderen Wohnung von einer Domina „verwöhnen“, während anderswo eine Frau einen Selbstmordversuch mit Tabletten unternimmt. Und dann sind da noch zwei drogenabhängige Jugendliche auf einer Ladung Dynamit.Je näher Mitternacht kommt, desto mehr steuert alles auf eine chaotische Apokalypse zu. Ein Feuerwerk gerät außer Rand und Band und die sexuellen Spielchen des Anwalts werden brutal von seinen Gangster-Mandanten unterbrochen. Dieser Film wurde bisher in keinem deutschen Kino gezeigt. Nutzen Sie die Gelegenheit, diesen aus dem Rahmen fallenden Film kennen zu lernen."
    ],
    "image": "lultimo-capodanno.jpg"
  },
  {
    "title": "L’UOMO IN PIÙ (DER MANN IM ABSEITS)",
    "director": "Paolo Sorrentino",
    "country": "Italien",
    "releaseYear": 2001,
    "runtime": 100,
    "version": "OmU",
    "screeningDate": "18.04.2019",
    "readableDate": "2019-04-18",
    "screeningTime": "20:00",
    "actors": " Toni Servillo, Andrea Renzi, Nello Mascia, Ninni Bruschetta, Angela Goodwin, Roberto De Francesco, Enrica Rosso, Italo Celoro",
    "subtitle": [
      "Künstlername: Tony. Wirklicher Name: Antonio Pisapia. Geboren am 15. August 1934 in Neapel. Popmusik-Sänger.",
      "Name : Antonio Pisapia. Geboren am 15. August 1949 in Narni Scalo. Profifußballer.",
      "Charakterlich könnten die Beiden nicht unterschiedlicher sein: der Eine ist launisch, zynisch, größenwahnsinnig und egozentrisch, der Andere schüchtern, bescheiden, besessen und mürrisch. Aber nicht nur Zufälle schlagen eine Brücke zwischen ihnen, auch schicksalhafte Ereignisse verbinden ihre beruflichen und privaten Leben.",
      "Schon in seinem ersten Langspielfilm erzählt Paolo Sorrentino (LA GRANDE BELLEZZA) mit seinem Stammschauspieler Toni Servillo versteckt in schön fotografierten Bildern von der Tragödie des von Lebenseinschnitten geprägten Individuums."
    ],
    "bodycopy": [
      "1980 treffen wir Tony nach einem triumphalen Konzert und Antonio nach einem Tor, das seine Mannschaft für den UEFA-Pokal qualifiziert hat – beide sind auf der Höhe Ihres Erfolges. Aber all das ist nur von kurzer Dauer: Tony muss sich wegen der Vergewaltigung eines jungen Mädchens verantworten, Antonio verletzt sich im Training die Bänder, was das Ende seiner Karriere bedeutet.",
      "1984 sieht ihre Situation ganz anders aus: Tony wurde vom Vorwurf der Vergewaltigung freigesprochen, doch seine Reputation ist so beschädigt, dass er vereinsamt auf heruntergekommenen Straßenfesten sein Leben fristet – Antonio hat die Stelle des Trainers übernommen, aber für ihn scheint es weder auf dem noch außerhalb des Fußballfeldes einen Platz zu geben. Eines Tages begegnen sich Tony und Antonio, ihre Blicke treffen sich wortlos und jeder zieht kommentarlos von dannen. Aber ihre Wege werden sich in einem tragischen Moment wieder kreuzen."
    ],
    "image": "un-uomo-in-piu.jpg"
  },
  {
    "title": "La battaglia di Algeri (Die Schlacht um Algier)",
    "director": "Gillo Pontecorvo",
    "country": "Italien/Algerien",
    "releaseYear": 1965,
    "runtime": 121,
    "version": "OmenU",
    "screeningDate": "21.07.2005",
    "readableDate": "2005-07-21",
    "screeningTime": "19:30",
    "actors": "Brahim Haggiag, Saadi Yacef, Jean Martin, Tommaso Neri, Michéle Kerbash, Samia Kerbash, Ugo Paletti, Fusia El Kader, Franco Morici, Mohamed Ben Kassen",
    "subtitle": [""],
    "bodycopy": [
      "Algerien 1957: Die Franzosen sind entschlossen, ihre letzte Kolonie trotz des blutigen Widerstands der “Nationalen Befreiungsfront“ (FLN) nicht aufzugeben. Ein auch nach 40 Jahren aktueller Film, der viel über das Entstehen von gewaltsamen Konflikten erzählt. Obwohl der Film 1966 in Venedig den Goldenen Löwen 1966 erhielt, wurde die Aufführung in Frankreich verboten und zum ersten Mal im letzten Jahr in Cannes aufgeführt."
    ],
    "image": "battaglia-di-algeri.jpg"
  },
  {
    "title": "La battaglia di Algeri (Die Schlacht um Algier)",
    "director": "Gillo Pontecorvo",
    "country": "Italien",
    "releaseYear": 1965,
    "runtime": 123,
    "version": "OmitU",
    "screeningDate": "06.09.2006",
    "readableDate": "2006-09-06",
    "screeningTime": "18:00",
    "actors": "Brahim Haggiag, Saadi Yacef, Jean Martin, Tommaso Neri, Michéle Kerbash, Samia Kerbash, Ugo Paletti, Fusia El Kader, Franco Morici, Mohamed Ben Kassen",
    "subtitle": [""],
    "bodycopy": [
      " Algerien 1957: Die Franzosen sind entschlossen, ihre letzte Kolonie trotz des blutigen Widerstands der “Nationalen Befreiungsfront“ (FLN) nicht aufzugeben. Ein nach 40 Jahren noch aktueller Film, der das Entstehen von gewaltsamen Konflikten darstellt und von der US-Regierung für ihre Strategie im Irak analysiert wurde. Goldener Löwe 1966, Aufführungsverbot in Frankreich. Nach der neuen „Premiere“ in Cannes 2004 großer Erfolg in den USA, Frankreich und Italien."
    ],
    "image": "la-battaglia-di-algeri.jpg"
  },
  {
    "title": "La bestia nel cuore (Die Bestie im Herzen)",
    "director": "Cristina Comencini",
    "country": "Italien/Großbritannien/Frankreich/Spanien",
    "releaseYear": 2005,
    "runtime": 120,
    "version": "OmitU",
    "screeningDate": "01.08.2007",
    "readableDate": "2007-08-01",
    "screeningTime": "19:00",
    "actors": "Giovanna Mezzogiorno, Luigi Lo Cascio, Alessio Boni, Stefania Rocca, Angela Finocchiaro, Giuseppe Battiston",
    "subtitle": ["Die Familie Comencini"],
    "bodycopy": [
      "Sabina wird von Albträumen geplagt und als sie von ihrer Schwangerschaft erfährt, brechen Erinnerungslücken auf. Der Besuch bei ihrem Bruder in den USA wird zu einer Reise in die eigene Vergangenheit, bei der sich hinter der scheinbar heilen Oberfläche der bürgerlichen Familienwelt Abgründe auftun. Ihre Kindheit birgt ein Geheimnis, das die Geschwister traumatisiert hat und bis heute nachwirkt."
    ],
    "image": "la-bestia-nel-cuore.jpg"
  },
  {
    "title": "LA CICCIOLINA. GÖTTLICHE SKANDALNUDEL",
    "director": "Alessandro Melazzini",
    "country": "Deutschland/Frankreich",
    "releaseYear": 2016,
    "runtime": 54,
    "version": "OmU",
    "screeningDate": "05.12.2018",
    "readableDate": "2018-12-05",
    "screeningTime": "20:00",
    "actors": "Ilona Staller (Cicciolina), Michele Lo Foco, Filippo Ceccarelli, Marco Gregoretti, Gianfranco Spadaccia, Jeff Koons",
    "subtitle": [""],
    "bodycopy": [
      "Entlang der Biographie Ilona Stallers wird das Phänomen der von ihr verkörperten Pornostarikone Cicciolina beleuchtet. In Ungarn 1951 geboren ebnete eine Hochzeit ihren Weg nach Italien, wo sie sich in den 70er Jahren schnell zur Sex-Pop-Ikone entwickelte. Ihren Ruhm und ihren Ruf nutzte sie, um 1987 als Abgeordnete für die Partito Radicale ins Italienische Parlament einzuziehen. Das sorgte für ungeheures internatonales Aufsehen und veränderte den Umgang in der italienischen Politik. Dabei waren Cicciolinas Gesetzesinitiative nicht provokant, sondern eher konstruktiv (Tierschutz, Umweltschutz, Situation von Häftlingen u.ä.). Über einen geschäftlichen Kontakt lernte sie Jeff Koons kennen, den sie heiratete, mit ihm einen Sohn zeugte und ihn zu vom Kunstmarkt teuer bezahlten Kunstwerken inspirierte.. Nach dem Scheitern der nur kurzen Ehe und ihrem Abschied aus der Pornobranche  ist sie international politisch tätig.",
      "Zum Abschluss wirft der Film die Frage auf, ob Cicciolina durch die Fixierung des Wahlkampfs auf ihre Person und ihre Showtalente die Wahrnehmung der Politiker in der Öffentlichkeit so verändert hat, dass der Weg für den Entertainer und Medienexperten Berlusconi frei wurde."
    ],
    "image": "la-cicciolina.jpg"
  },
  {
    "title": "La decima vittima (Das zehnte Opfer)",
    "director": "Elio Petri",
    "country": "Italien/Frankreich",
    "releaseYear": 1965,
    "runtime": 90,
    "version": "OmU",
    "screeningDate": "17.06.2010",
    "readableDate": "2010-06-17",
    "screeningTime": "20:00",
    "actors": " Marcello Mastroianni, Ursula Andress, Elsa Martinelli, Luce Bonifassy, Salvo Randone, Massimo Serato, Mio Quesada, Jacques Herlin",
    "subtitle": [
      "Studenten der HH-Universität haben die Untertitelung eines italienischen Films abgeschlossen und auf einen in Deutschland unberechtigterweise kaum bekannten Regisseur hingewiesen: Elio Petri (siehe auch Filme in der Mittwoch-Reihe „Cinema italiano“)."
    ],
    "bodycopy": [
      "In diesem Film nimmt er Entwicklungen vorweg, die auch heute noch aktuell sind. Bildlich Pop-Art, Informal und Konzeptart verbindend, schickt er Ursula Andress und Marcello Mastroianni in einen tödlichen Regeln unterliegenden Zweikampf. Über Medien vermittelt, soll dies kollektive Aggression und damit Kriege vermeiden. Beste Unterhaltung wie bei James Bond und Hitchcock, mit dessen Tiefgründigkeit und einem Hauch vorweggenommenen Fassbinder („Welt am Draht“)."
    ],
    "image": "la-decima-vittima.jpg"
  },
  {
    "title": "LA DEUTSCHE VITA (LA DEUTSCHE VITA)",
    "director": "Alessandro Cassigoli, Tania Masi",
    "country": "Deutschland",
    "releaseYear": 2013,
    "runtime": 60,
    "version": "OmU",
    "screeningDate": "19.03.2015",
    "readableDate": "2015-03-19",
    "screeningTime": "20:00",
    "actors": " Alessandro Cassigoli, Giovanni Pane, Emanuele Lami",
    "subtitle": [""],
    "bodycopy": [
      "Wie fühlt es sich an, wenn man auf einmal merkt, Immigrant zu sein? Dieser Frage geht Alessandro Cassigoli in der italienischen Gemeinde Berlins nach und trägt Erfahrungen zusammen, in denen sich viele in Deutschland lebende Italiener wiederfinden."
    ],
    "image": "la-deutsche-vita.jpg"
  },
  {
    "title": "La famiglia (Die Familie)",
    "director": "Ettore Scola",
    "country": "Italien",
    "releaseYear": 1987,
    "runtime": 140,
    "version": "OmitU",
    "screeningDate": "02.04.2008",
    "readableDate": "2008-04-02",
    "screeningTime": "19:00",
    "actors": "Emanuele Lamaro, Andrea Occhipinti, Vittorio Gassman, Cecilia Dazzi, Stefania Sandrelli, Jo Champa, Fanny Ardant, Joska Versari, Massimo Dapporto, Carlo Dapporto, Ottavia Piccolo",
    "subtitle": ["Werkschau: Ettore Scola"],
    "bodycopy": [
      "80 Jahre Familiengeschichte – eine Welt im Kleinen. Dass draußen zwei Weltkriege stattfinden und die technische Revolution die Welt verändert, spiegelt sich nur in kleinen Ereignissen. Carlo, anfänglich das jüngste, schließlich das älteste Familienmitglied, erzählt seine Erinnerungen – die zum Teil auch Erinnerungen Scolas an seine Familie widerspiegeln. Gezeigt wird die vollständige Fassung."
    ],
    "image": "la-famiglia.jpg"
  },
  {
    "title": "La finestra di fronte (Was soll ich tun ?)",
    "director": "Ferzan Özpetek",
    "country": "Italia/Gran Bretagna/Turchia/Portogallo",
    "releaseYear": 2003,
    "runtime": 106,
    "version": "OmU",
    "screeningDate": "16.04.2009",
    "readableDate": "2009-04-16",
    "screeningTime": "20:00",
    "actors": "Giovanna Mezzogiorno, Massimo Girotti, Raoul Bova, Filippo Nigro, Serra Yilmaz, Maria Grazie Bon, Benedetta Gargari",
    "subtitle": [
      "Fünf Highlights aus fünf Jahren „Italienischer Filmclub“ in der Black Box"
    ],
    "bodycopy": [
      "Giovanna hat sich unglücklich in ihrem Familienleben eingerichtet und fühlt sich vondem jungen Mann angezogen, den sie jeden Abend in seiner Wohnung beobachtet. Erst als ein verwirrter alter Mann in ihren Alltag tritt, wird die Suche nach dessen Vergangenheit für Giovanna zur Suche nach ihren eigenen Gefühlen."
    ],
    "image": "la-finestra-di-fronte.jpg"
  },
  {
    "title": "La finestra di fronte (Was soll ich tun ?)",
    "director": "Ferzan Özpetek",
    "country": "Italien/Großbritannien/Türkei/Portugal",
    "releaseYear": 2003,
    "runtime": 106,
    "version": "OmU",
    "screeningDate": "17.11.2005",
    "readableDate": "2005-11-17",
    "screeningTime": "19:30",
    "actors": "Giovanna Mezzogiorno, Massimo Girotti, Raoul Bova, Filippo Nigro, Serra Yilmaz, Maria Grazie Bon, Benedetta Gargari",
    "subtitle": [""],
    "bodycopy": [
      "Mit einem Blick aus dem Fenster ist es nicht getan, man muss die Wohnung schon verlassen, wenn das Leben sich ändern soll.Giovanna hat sich unglücklich in ihrem Familienleben eingerichtet und fühlt sich von dem jungen Mann angezogen, den sie jeden Abend in seiner Wohnung gegenüber beobachtet. Erst als ein verwirrter alter Mann unvermittelt in ihren Alltag tritt, wird die Suche nach dessen Vergangenheit für Giovanna zur Suche nach ihren eigenen Gefühlen und einem neuen Leben im alten."
    ],
    "image": "la-finestra-di-fronte.jpg"
  },
  {
    "title": "La forza del passato",
    "director": "Piergiorgio Gay",
    "country": "Italien",
    "releaseYear": 2002,
    "runtime": 98,
    "version": "OmitU",
    "screeningDate": "02.01.2008",
    "readableDate": "2008-01-02",
    "screeningTime": "19:00",
    "actors": "Sergio Rubini, Bruno Ganz, Valeria Moriconi, Mariangela D'Abbraccio, Sandra Ceccarelli, Giuseppe Battiston, Aleksander Krosl, Barbara Cerar",
    "subtitle": ["Filmort: Triest"],
    "bodycopy": [
      "Kennt man wirklich den Menschen, der das eigene Leben wie kein anderer prägte: den eigenen Vater? Gianni Orzan (Sergio Rubini) hat sich mehr oder weniger unglücklich in seinem Leben eingerichtet, als nach dem Tod seines Vaters der unheimliche Bogliasco (Bruno Ganz) auftaucht, der scheinbar alles über sein Leben weiß und von einem Vater erzählt, den Gianni so nie gekannt hat."
    ],
    "image": "la-forza-del-passato.jpg"
  },
  {
    "title": "La Gabbianella e il Gatto (Wie Kater Zorbas der kleinen Möwe das Fliegen beibrachte)",
    "director": "Enzo D'Alò",
    "country": "Italien",
    "releaseYear": 1999,
    "runtime": 78,
    "version": "OF",
    "screeningDate": "29.05.2004",
    "readableDate": "2004-05-29",
    "screeningTime": "15:00",
    "actors": "Regisseur, Drehbuchschreiber und Zeichner: Enzo D'Alò",
    "subtitle": [""],
    "bodycopy": [
      "Kengah, einer im Sterben liegenden ölverschmierten Möwe, gelingt es, Ihr Ei dem Kater Zorbas anzuvertrauen und ihm drei Bedingungen abzuringen:",
      "Er wird das Ei nicht essen. Er wird es pflegen und hüten bis es sich öffnet. Er wird dem Neugeborenen das Fliegen beibringen",
      "Die verwaiste Möwe erhält von der ganzen Katzengemeinschaft den Namen Fortunata. Die Kleine wird sich kennenlernen müssen und begreifen, dass sie keine Katze ist, um das Fliegen lernen zu können."
    ],
    "image": "gabianellagatto.jpg"
  },
  {
    "title": "LA GATTA CENERENTOLA (CINDERELLA THE CAT)",
    "director": "Ivan Cappiello, Marino Guarnieri, Alessandro Rak, Dario Sansone",
    "country": "Italien",
    "releaseYear": 2017,
    "runtime": 86,
    "version": "OmU",
    "screeningDate": "17.10.2019",
    "readableDate": "2019-10-17",
    "screeningTime": "20:00",
    "actors": "Massimiliano Gallo, Maria Pia Calzone, Alessandro Gassmann, Renato Carpentieri ",
    "subtitle": [
      "Wer sagt denn, dass Zeichentrickfilme nur etwas für Kinder sind? Auch wenn „Cinderella“ im Titel ein Märchen erwarten lässt: es handelt sich um einen Film, der sich ausschließlich an Erwachsene richtet. In Abwandlung der gleichnamigen Geschichte aus Giambattista Basiles Sammlung „Pentameron“ (1634/36) wird vom Scheitern einer Utopie und deren Untergang in Korruption, Gewalt und mafiösen Strukturen erzählt, aber auch davon, dass es im dunkelsten Geschehen eine Hoffnung gibt, aus der sich ungeahnte Ereignisse entwickeln."
    ],
    "bodycopy": [
      "Die Megarida ist ein Schiff (und Schauplatz des Films), das der Vater der jungen Mia als reicher Visionär und Wissenschaftler als Versprechen einer besseren Zukunft errichtet hatte. Seitdem der Vater seine Utopie vor 15 Jahren mit ins Grab nahm, liegt es in der Bucht von Neapel fest. Mia ist seitdem ihrer Stiefmutter ausgeliefert, die mit ihren sechs hinterlistigen Töchtern einen florierenden Drogenhandel unterhält und Mia wie einen Dienstboten behandelt. Doch plötzlich wird Mia für die kriminellen Partner der Stiefmutter wichtig und ihr Schicksal scheint vorgezeichnet. Doch Mia gibt nicht auf und findet auf einmal Verbündete aus der Zeit ihres Vaters.",
      "Diese auf einem Kreuzfahrtschiff im Hafen eines futuristischen Neapels spielende Geschichte, ist in einem comicartigen Zeichenstil erzählt, holographische Erinnerungen Mias werden wie Rückblenden eingesetzt, so dass sich die Erzählebenen der Gegenwart und Vergangenheit durchdringen und gegenseitig kommentieren. Ein in jeder Hinsicht spannender Film und ein Rausch für die Sinne."
    ],
    "image": "la-gatta-cenerentola.png"
  },
  {
    "title": "LA GRANDE BELLEZZA (DIE GROSSE SCHÖNHEIT)",
    "director": "Paolo Sorrentino",
    "country": "Italien/Frankreich",
    "releaseYear": 2013,
    "runtime": 142,
    "version": "OmU",
    "screeningDate": "18.09.2014",
    "readableDate": "2014-09-18",
    "screeningTime": "20:00",
    "actors": "Toni Servillo, Carlo Verdone, Sabrina Ferilli, Carlo Buccirosso ",
    "subtitle": [""],
    "bodycopy": [
      "Er ist der Star römischer Partys der Möchtegern-High-Society und Pseudo-Intellektuellen: Jep Gamberdella (Toni Servillo). Doch auch ein Genussmensch und Lebemann kommt gelegentlich ins Nachdenken – so begleitet er die Leere und Oberflächlichkeit dieser Gesellschaft mit zynischen und ironischen Kommentaren bis ihn sein 65 Geburtstag über seine Vergangenheit und Zukunft sinnieren lässt. (Oscar und Golden Globe 2014, 4 Auszeichnungen beim Europäischen Filmpreis 2013)-"
    ],
    "image": "la-grande-bellezza.png"
  },
  {
    "title": "La grande guerra (Man nannte es den großen Krieg)",
    "director": "Mario Monicelli",
    "country": "Italien/Frankreich",
    "releaseYear": 1959,
    "runtime": 100,
    "version": "OmitU",
    "screeningDate": "01.06.2011",
    "readableDate": "2011-06-01",
    "screeningTime": "20:00",
    "actors": "Alberto Sordi, VittorioGassman, Silvana Magano, Romolo Valli",
    "subtitle": ["150 Jahre Italien"],
    "bodycopy": [
      "Komödie um zwei Drückeberger im ersten Weltkrieg. Da es Oreste und Giovanni nicht gelungen ist, sich dem Kriegseinsatz zu entziehen, gilt es an der Front, gefährliche Situationen zu vermeiden. Schließlich in Österreichische Gefangenschaft geraten, sterben sie als Feiglinge, ermöglichen aber ihrer Armee den Sieg."
    ],
    "image": "la-grande-guerra.jpg"
  },
  {
    "title": "LA MAFIA UCCIDE SOLO D’ESTATE (DIE MAFIA MORDET NUR IM SOMMER)",
    "director": "Pif (Pierfrancesco Diliberto)",
    "country": "Italien",
    "releaseYear": 2013,
    "runtime": 90,
    "version": "OmU",
    "screeningDate": "19.05.2016",
    "readableDate": "2016-05-19",
    "screeningTime": "20:00",
    "actors": "Cristiana Capotondi, Pif, Ginevra Antona, Claudio Gioè, Ninni Bruschetta, Alex Bisconti, Maurizio Marchetti, Rosario Lisma, Barbara Tabita",
    "subtitle": [""],
    "bodycopy": [
      "Aufwachsen und Lieben im Palermo der Mafia. Eine zwanzigjährige Geschichte aus kindlicher Sicht. Arturo wächst in dieser faszinierenden und gleichzeitig schrecklichen Stadt auf, in der sowohl Platz ist für Leidenschaft wie für ein Lächeln."
    ],
    "image": "la-mafia-uccide.jpg"
  },
  {
    "title": "La meglio gioventù (Die besten Jahre)",
    "director": "Marco Tullio Giordana",
    "country": "Italien",
    "releaseYear": 2003,
    "runtime": 366,
    "version": "OmU",
    "screeningDate": "21.05.2005",
    "readableDate": "2005-05-21",
    "screeningTime": "17:00",
    "actors": "Alessio Boni, Luigi Lo Cascio, Jasmine Trinca, Adriana Asti, Sonia Bergamasco, Fabrizio Gifuni, Maya Sansa, Camilla Filippi, Valentina Carnelutti",
    "subtitle": ["Werkschau: Luigi Lo Cascio"],
    "bodycopy": [
      "Die Geschichte der Familie Carati von 1966 bis heute vor dem Hintergrund einer politisch aufregenden Zeit in Italien. Fast beiläufig vollziehen sich die Ereignisse und dennoch hinterlassen sie unmerklich tiefe Spuren in den handelnden Personen.Die Geschichte der Familie Carati von 1966 bis heute vor dem Hintergrund einer politisch aufregenden Zeit in Italien. Fast beiläufig vollziehen sich die Ereignisse und dennoch hinterlassen sie unmerklich tiefe Spuren in den handelnden Personen.Der Erfolg bei Festivals und beim Publikum brachte diesen für das Fernsehen produzierten und dort nicht gezeigten Film in die Kinosäle und auf diesem Umweg auch auf die heimischen Bildschirme."
    ],
    "image": "la-meglio-gioventu-1.png"
  },
  {
    "title": "LA MEGLIO GIOVENTÙ (DIE BESTEN JAHRE)",
    "director": "Marco Tullio Giordana",
    "country": "Italien",
    "releaseYear": 2003,
    "runtime": 366,
    "version": "OmU",
    "screeningDate": "22.03.2014",
    "readableDate": "2014-03-22",
    "screeningTime": "17:00",
    "actors": "Alessio Boni, Luigi Lo Cascio, Jasmine Trinca, Adriana Asti, Sonia Bergamasco, Fabrizio Gifuni, Maya Sansa, Camilla Filippi, Valentina Carnelutti",
    "subtitle": [
      "10° anniversario: i maggiori successi del Club del Cinema Italiano"
    ],
    "bodycopy": [
      "Zeitgeschichte in persönlichen, vernetzten Biografien zu erzählen, hat Reitz mit seinem HEIMAT-Projekt in Deutschland unternommen. Einem ähnlichen Konzept folgt Marco Tullio Giordana in Italien: Ausgehend von der Aufbruchzeit und Solidarität der 1960er Jahre verfolgt er die Mitglieder der Familie Carati in Rom und beschreibt deren Weg über mehr als 40 Jahre. In dieser Zeit trifft jedes Familienmitglied eigene Lebensentscheidungen, die stark von der politischen Entwicklung beeinflusst sind. So entsteht ein historisches Bild der italienischen Gesellschaft in ihren Widersprüchen als unterhaltsames, spannendes, dramaturgisch dicht inszeniertes und mit über 20 nationalen und internationalen Preisen ausgezeichnetes Filmkunstwerk.",
      "„Es sagt sich so leicht, man habe im Kino nicht bloß einen Film gesehen, sondern eine Erfahrung gemacht. Diesmal ist es wahr.“ (FAZ)"
    ],
    "image": "la-meglio-gioventu-10.jpg"
  },
  {
    "title": "La mia generazione (La mia generazione)",
    "director": "Wilma Labate",
    "country": "Italien",
    "releaseYear": 1996,
    "runtime": 95,
    "version": "OmU",
    "screeningDate": "26.04.2004",
    "readableDate": "2004-04-26",
    "screeningTime": "19:30",
    "actors": "Stefano Accorsi, Claudio Amendola, Francesca Neri",
    "subtitle": [""],
    "bodycopy": [
      "Braccio, ein politischer Gefangener, wird von einer Sonderhaftanstalt auf  Sizilien nach Mailand überführt. Sein anfängliches Misstrauen gegenüber dem Carabiniere, der ihn begleitet und menschlich behandelt, schwindet im Verlauf der Reise."
    ],
    "image": "la mia generazione.jpg"
  },
  {
    "title": "La paranza dei bambini (Der Clan der Kinder)",
    "director": "Claudio Giovanesi",
    "country": "Italien",
    "releaseYear": 2019,
    "runtime": 105,
    "version": "OmU",
    "screeningDate": "15.10.2020",
    "readableDate": "2020-10-15",
    "screeningTime": "20:00",
    "actors": " Francesco Di Napoli, Viviana Aprea, Mattia Piano Del Balzo, Renato Carpentieri u.a.",
    "subtitle": [
      "Erneut im Programm, da die Veranstaltung im 1.HJ wegen des Corona Virus ausgefallen ist.",
      "Die verschobene Aufführung dieses Films ermöglicht den Vergleich der “ klassischen sizilianischen Mafia“, Thema des im nächsten Monat gezeigten Films IL TRADITORE, mit der hier gezeigten „neuen neapolitanischen Camorra“. Die „klassischen“ Bosse kümmerten sich noch persönlich um die Erpressung von Schutzgeldern, Einbrüche und Drogenverkauf an die Abhängigen. Nachdem dieses Geschäft weitgehend nach dem Delegationsprinzip organisiert haben, treten nach der Verhaftung einiger lokaler Bosse an deren Stelle kriminelle Jugendbanden, die in die bestehenden Strukturen eindringen und das entstehende Vakuum füllen. Für die alten Bosse sind sie ein Rekrutierungsfeld für den Nachwuchs. Sie hingegen organisieren Prostitution und Drogenhandel im großen Stil, sowie den Übergang zur legalen Wirtschaft."
    ],
    "bodycopy": [
      "Der 15-jährige Nicola lebt noch bei seiner Mutter, tastet sich in der Liebe voran und macht mit seinen Kumpeln das Sanità-Viertel in Neapel unsicher. Als er erleben muss, wie seine Mutter von Schutzgelderpressern gedemütigt wird, verbünden er und seine Freunde sich mit Agostino, Sprössling eines ehemals mächtigen Camorra-Clans, der die Entwicklungen der Zeit verpasst hat und bedeutungslos geworden ist. Mit dem Überfall auf ein Juweliergeschäft will sich die Gruppe die Mittel für Markenklamotten und einen luxuriösen Auftritt verschaffen. Doch der lokale Capo nimmt ihnen die Beute ab, unterbindet den Kontakt zu Agostino und lässt sie Marihuana verkaufen. Nach und nach unterstützen sie den Capo auch bei der Schutzgelderpressung und dem Verkauf härterer Drogen: endlich haben sie das so sehr gewünschte Geld.",
      "Als bei einer Polizeiaktion auch der Capo verhaftet wird, wittern die Jugendlichen ihre Chance. Mit geringen Erfahrungen aber viel Elan versuchen sie, sich in den camorristischen Strukturen ihren Weg zu bahnen."
    ],
    "image": "paranzadeibambini048586f7044erounded.jpg"
  },
  {
    "title": "LA PAROLA AMORE ESISTE (IST LIEBE NUR EIN WORT?)",
    "director": "Mimmo Calopresti",
    "country": "Italien/Frankreich",
    "releaseYear": 1998,
    "runtime": 84,
    "version": "OmU",
    "screeningDate": "20.06.2012",
    "readableDate": "2012-06-20",
    "screeningTime": "20:00",
    "actors": " mit Valeria Bruni-Tedeschi, Fabrizio Bentivoglio, Gerard Depardieu, Valeria Milillo, Marina Confalone, Daria Nicolodi",
    "subtitle": [""],
    "bodycopy": [
      "Wenn sich französische und italienische Filmsprache verbinden, kommt eine Komödie mit Tiefgang dabei heraus. Eine psychisch labile Frau entscheidet, sich in einen Cellolehrer zu verlieben und löst damit Verwicklungen aus, die das Thema Liebe unterhaltsam variieren."
    ],
    "image": "la-parola-amore-esiste.jpg"
  },
  {
    "title": "LA PAZZA GIOIA (DIE ÜBERGLÜCKLICHEN)",
    "director": "Paolo Virzì",
    "country": "Italien/Frankreich",
    "releaseYear": 2016,
    "runtime": 118,
    "version": "OmU",
    "screeningDate": "20.04.2017",
    "readableDate": "2017-04-20",
    "screeningTime": "20:00",
    "actors": " Valeria Bruni Tedeschi, Micaela Ramazzotti, Valentina Carnelutti, Marco Messeri, Anna Galiena, Tommaso Ragno, Bob Messini, Sergio Albelli, Marisa Borini",
    "subtitle": [
      "Nach TUTTA LA VITA DAVANTI und IL CAPITALE UMANO erzählt Paolo Virzì in diesem Roadmovie von der verrückten Freundschaft zweier sehr verschiedener Frauen."
    ],
    "bodycopy": [
      "Die Gräfin und Quasselstrippe Maria Beatrice verliert wegen der Beziehung zu einem Berufsverbrecher ihre gesellschaftliche Reputation. Als sie während der psychologischen Behandlung in einer Klinik die Außenseiterin Donatella kennenlernt, nutzen die Beiden die Gelegenheit, auszubrechen. Mit einer Schar Psychologen auf den Fersen touren sie durch die Toskana und freunden sich an. Zwischen bipolaren Glücksschüben, manischer Zielstrebigkeit und zwanghafter Furchtlosigkeit verstehen sie sich besser als sonst jemand es könnte.",
      "Virzìs Film ist voller Lebensfreude und gleichzeitig ein gewitztes Zeitbild italienischer Gegenwart."
    ],
    "image": "la-pazza-gioia.jpg"
  },
  {
    "title": "La pivellina (La pivellina)",
    "director": "Tizza Covi und Rainer Frimmel",
    "country": "Österreich/Italien",
    "releaseYear": 2009,
    "runtime": 100,
    "version": "OmU",
    "screeningDate": "15.12.2011",
    "readableDate": "2011-12-15",
    "screeningTime": "20:00",
    "actors": "Patrizia Gerardi, Walter Saabel, Tairo Caroli, Asia Crippa",
    "subtitle": [""],
    "bodycopy": [
      "Ein berührender Dokumentarspielfilm. Covi/Frimmel haben mit einigen ihrer Projekte das Leben von Kleinzirkusdarstellern begleitet und nutzen diese Erfahrung nun, um eine fiktive Handlung von Wanderzirkusmenschen spielen zu lassen, die sich innerhalb der Erzählhandlung selbst spielen. Herausgekommen ist nicht nur die herzzerreißende Geschichte eines Findelkindes, das in diesem Ambiente das erste mal Liebe erfährt und das „Herzstück“ der Truppe wird, sondern auch das Porträt einer Schaustellergemeinschaft am Rande des Existenzminimums."
    ],
    "image": "la-pivellina.jpg"
  },
  {
    "title": "La rabbia (Der Zorn)",
    "director": "Pier Paolo Pasolini",
    "country": "Italien",
    "releaseYear": 1963,
    "runtime": 53,
    "version": "OmU",
    "screeningDate": "09.03.2011",
    "readableDate": "2011-03-09",
    "screeningTime": "18:00",
    "actors": "Giorgio Bassani, Renato Guttuso",
    "subtitle": [""],
    "bodycopy": [
      "Ein Montagefilm mit der Wut oder dem Zorn Pasolinis. Einem Zorn gegen die bürgerliche Welt, Barbarei und Intoleranz, gegen Vorurteile und Banalität. Ein außerordentliches Dokument, das implizit ein weiteres Mal die Autonomie der Schöpfung, der Poesie, der Kultur bewies."
    ],
    "image": "la_rabbia.jpg"
  },
  {
    "title": "La ragazza del Lago (Das Mädchen vom See)",
    "director": "Andrea Molaioli",
    "country": "Italien",
    "releaseYear": 2007,
    "runtime": 91,
    "version": "OmitU",
    "screeningDate": "04.03.2009",
    "readableDate": "2009-03-04",
    "screeningTime": "20:00",
    "actors": " Toni Servillo, Valeria Golino, Fabrizio Gifuni, Anna Bonaiuto, Omero Antoniutti, Marco Baliani, Denis Fasolo, Sara D'Amario",
    "subtitle": [""],
    "bodycopy": [
      "Ursprünglich sollte Kommissar Sanzio sich nur um das Verschwinden einer Sechsjährigen in Norditalien kümmern. Dann aber stellt sich heraus, dass der Fall eng mit der am Ufer eines Sees gefundenen Leiche einer schönen Frau verbunden ist. Auf einmal bekommt die scheinbare Harmonie und Friedlichkeit der Verhältnisse um den romantischen See ein neues Gesicht."
    ],
    "image": "la-ragazza-del-lago.jpg"
  },
  {
    "title": "LA RAGAZZA NELLA NEBBIA (DER NEBELMANN)",
    "director": "Donato Carrisi",
    "country": "Italien/Deutschland/Frankreich",
    "releaseYear": 2017,
    "runtime": 97,
    "version": "OmU",
    "screeningDate": "16.10.2019",
    "readableDate": "2019-10-16",
    "screeningTime": "20:00",
    "actors": "Toni Servillo, Alessio Boni, Jean Reno, Lorenzo Richelmy, Galatea Ranzi, Michela Cescon, Daniela Piazza, Thierry Toscan, Ekaterina Buscemi",
    "subtitle": [
      "Im Krimiland Italien (Gianrico Carofiglio, Andrea Camilleri, Donna Leon, Veit Heinichen u.a) hat sich der Autor Donato Carrisi aufgemacht, seinen Bestseller LA RAGAZZA NELLA NEBBIA zu verfilmen. Herausgekommen ist eine aus Rückblenden und Erinnerungen aufgebaute, weitgehend aber chronologisch erzählte Geschichte, die bis zum Schluss rätselhaft bleibt. Sie spielt virtuos mit den Elementen der äußeren Erscheinung und dem tatsächlichen Inhalt und selbst als die Handlungsfäden schließlich zusammenfinden, alles geklärt scheint, nimmt die Erzählung erneut eine unerwartete Wendung. "
    ],
    "bodycopy": [
      "Toni Servillo, Alessio Boni, Jean Reno: der Film wartet nicht nur mit namhaften Stars auf, ihm gelingt es auch, die literarische Vorlage in ein visuelles Erlebnis zu verwandeln.",
      "In einem nur durch eine dort endende Straße erreichbaren Bergdorf in den italienischen Alpen ist ein Mädchen verschwunden. Erinnerungen an ein ähnliches Ereignis vor Jahrzehnten werden wach. Alle Hoffnungen liegen auf Agente Vogel, der hingegen selbstherrlich Verdächtige den Medien präsentiert und an seinem Image arbeitet, das durch seinen letzten Fall etwas ramponiert wurde.",
      "Wer ist der Täter – das ist hier nicht die Frage. Vielmehr stehen die möglichen und sich bei Gelegenheit verwirklichenden Abgründe der gezeigten Personen im erzählerischen Blickfeld. Nicht nur wird genretypisch hinter die bürgerliche Fassade geschaut, sondern dem inneren Antrieb des Einzelnen nachgegangen."
    ],
    "image": "la-ragazza-nella-nebbia.jpg"
  },
  {
    "title": "LA RESA DEI CONTI (DER GEHETZTE DER SIERRA MADRE)",
    "director": "Sergio Sollima",
    "country": "Italien/Spanien",
    "releaseYear": 1966,
    "runtime": 110,
    "version": "OmU",
    "screeningDate": "02.09.2016",
    "readableDate": "2016-09-02",
    "screeningTime": "21:15",
    "actors": "Lee Van Cleef, Tomas Milian, Walter Barnes, Nieves Navarro, Gérard Herter, Maria Granada, Roberto Camardiel, Ángel del Pozo, Luisa Rivelli",
    "subtitle": [""],
    "bodycopy": [
      "Der Kopfgeldjäger Corbett wird auf den vermeintlichen Mädchenmörder Cuchillo angesetzt. Als er diesen nach einigen Widrigkeiten findet, begreift er dessen Unschuld und beide suchen den wahren Täter. Die spannende Geschichte, beeindruckende Darsteller und die hervorragenden Landschaftsaufnahmen machen diesen Film zu einem der großen Klassiker des Genres. Der berühmte Soundtrack – von Quentin Tarantino 2009 in INGLORIOUS BASTERDS wiederverwendet – stammt von Ennio Morricone."
    ],
    "image": "la-resa-dei-conti.jpg"
  },
  {
    "title": "La ricotta (Der Weichkäse)",
    "director": "Pier Paolo Pasolini",
    "country": "Italien/Frankreich",
    "releaseYear": 1963,
    "runtime": 35,
    "version": "OmU",
    "screeningDate": "09.03.2011",
    "readableDate": "2011-03-09",
    "screeningTime": "18:00",
    "actors": "Orson Wells, Mario Cipriani, Laura Betti, Edmonda Aldini, Vittorio La Paglia, Maria Bernardini",
    "subtitle": [""],
    "bodycopy": [
      "La RICOTTA ist eine Episode des Films RoGoPaG, dessen andere Episoden von Roberto Rossellini, Jean-Luc Godard und Ugo Gregoretti gedreht worden sind. Pasolini hat ein Ensemble von Figuren versammelt, die es ihm erlaubt, auf engstem Raum ein Universum satirischer Kritik, sarkastischen Humors und ästhetisch-politischer Definition zu entwickeln"
    ],
    "image": "la ricotta.jpg"
  },
  {
    "title": "LA SCONOSCIUTA (Die Unbekannte)",
    "director": "Giuseppe Tornatore",
    "country": "Italien",
    "releaseYear": 2006,
    "runtime": 121,
    "version": "OmU",
    "screeningDate": "18.08.2011",
    "readableDate": "2011-08-18",
    "screeningTime": "20:00",
    "actors": " Xenia Rappoport, Michela Placido, Claudia Gerini, Margherita Buy, Pierfrancesco Favino, Piera Degli Espositi, Clara Dossena, Angela Molina",
    "subtitle": [""],
    "bodycopy": [
      "Der Meister von „Cinema Paradiso“ erzählt mit diesem Film die Geschichte einer mit dunkler Vergangenheit in Triest auftauchenden Ukrainerin, die sich systematisch in den Haushalt eines Juweliers mit gescheiterter Ehe und siechendem Kind einschleicht. Abgründe tuen sich auf. Im Hintergrund angedeutete traumatisierende Erlebnisse aus Menschenhandel, Prostitution und Migration treffen auf Familienkonflikte des italienischen Mittelstandes. Der Film hat auf diversen Festivals zahlreiche Auszeichnungen erhalten."
    ],
    "image": "la-sconosciuta.jpg"
  },
  {
    "title": "LA SIGNORA SENZA CAMELIE (DIE DAME OHNE KAMELIEN)",
    "director": "Michelangelo Antonioni",
    "country": "Italien/Frankreich",
    "releaseYear": 1953,
    "runtime": 105,
    "version": "OmU",
    "screeningDate": "17.03.2016",
    "readableDate": "2016-03-17",
    "screeningTime": "20:00",
    "actors": " Lucia Bosé, Gino Cervi, Andrea Checchi, Ivan Desny, Monica Clay, Alain Cuny, Anna Carena, Enrico Glori, Laura Tiberti",
    "subtitle": [""],
    "bodycopy": [
      "Aufstieg und Fall: Vom Ladentisch für den Film wegengagierte Verkäuferin heiratet einen Produzenten, endet aber als mittelmäßige Schauspielerin und Geliebte eines Diplomaten. Antonionis Abrechnung mit dem Filmgeschäft und der Glitzerwelt des Konsums."
    ],
    "image": "la-signora-senza-camelie.jpg"
  },
  {
    "title": "LA SOLITUDINE DEI NUMERI PRIMI (Die Einsamkeit der Primzahlen)",
    "director": "Saverio Costanzo",
    "country": "Italien/Deutschland/Frankreich",
    "releaseYear": 2010,
    "runtime": 119,
    "version": "OmU",
    "screeningDate": "18.03.2012",
    "readableDate": "2012-03-18",
    "screeningTime": "20:00",
    "actors": " Alba Rohrwacher, Luca Marinelli, Isabella Rosselini, Arianna Nastro, MArtina Albano, Vittorio Lomartire, Tommaso Neri, Aurora Ruffino, Giorgia Pizzo",
    "subtitle": [""],
    "bodycopy": [
      "Zwei in ihrer Seelenverletzung verwandte Personen lernen sich kennen und empfinden eine unerklärliche Anziehung füreinander. Obwohl sie ihr Leben teilen, gelingt beiden nicht, ihre jeweilige Einsamkeit zu überwinden, bis die Lebensumstände sie örtlich trennen. Werden sie „Primzahlen“ bleiben oder gibt es Hoffnung auf eine „Zusammensetzung“?"
    ],
    "image": "la-solitudine-dei-numeri-primi.jpg"
  },
  {
    "title": "La stanza del figlio (Das Zimmer meines Sohnes (La stanza del figlio)Das Zimmer meines Sohnes)",
    "director": "Nanni Moretti",
    "country": "Italien",
    "releaseYear": 2001,
    "runtime": 100,
    "version": "OmU",
    "screeningDate": "15.11.2012",
    "readableDate": "2012-11-15",
    "screeningTime": "20:00",
    "actors": "Nanni Moretti, Laura Morante, Silvio Orlando, Jasmine Trinca, Giuseppe Sanfelice, Sofia Vigliar",
    "subtitle": [""],
    "bodycopy": [
      "Der Tod des Sohnes beim Tauchen wirft einen Psychiater aus der Bahn, weil er statt mit ihm zu joggen einen Patienten besucht hatte. Die Trauerarbeit verändert seine berufliche und familiäre Existenz. Er verfällt immer mehr in Selbstmitleid, bis ein Mädchen mit Fotos auftaucht, mit denen sein Sohn ihr sein Zimmer zeigen wollte."
    ],
    "image": "la-stanza-del-figlio.jpg"
  },
  {
    "title": "La  (La terra)",
    "director": "Sergio Rubini",
    "country": "Italien",
    "releaseYear": 2006,
    "runtime": 112,
    "version": "OmU",
    "screeningDate": "19.11.2009",
    "readableDate": "2009-11-19",
    "screeningTime": "20:00",
    "actors": "Sergio Rubini, Fabrizio Bentivoglio, Paolo Briguglia, Massimo Venturiello",
    "subtitle": [""],
    "bodycopy": [
      "Kulturkonflikt im eigenen Land: Luigi hat in jungen Jahren seine apulische Heimat verlassen und Karriere als Universitätsprofessor gemacht. Doch nun soll der Familiensitz in Mesagne verkauft werden. Angereist, um seine Unterschrift zu leisten, begegnet er einem Geflechtaus Intrigen, nie ausgetragenen Konflikten und unerwarteten Gefühlen. Im Hintergrund zieht der kriminelle Tonino seinen Strippen und erpresst das ganze Dorf. In der Rolle des Luigi: Fabrizio Bentivoglio, einer der populärsten italienischen Schauspieler."
    ],
    "image": "la-terra.jpg"
  },
  {
    "title": "LA TERRA DEI SANTI (DAS LAND DER HEILIGEN)",
    "director": "Fernando Muraca",
    "country": "Italien",
    "releaseYear": 2015,
    "runtime": 89,
    "version": "OmU",
    "screeningDate": "18.01.2018",
    "readableDate": "2018-01-18",
    "screeningTime": "20:00",
    "actors": "Valeria Solarino, Daniela Marra, Lorenzo Indovina, Ninni Bruschetta",
    "subtitle": [
      "„Wie wäre es, wenn wir der Mafia die Kinder wegnehmen würden?“ Mit diesem kühnen Vorschlag will die Staatsanwältin Vittoria den Einfluss der Frauen in der Mafia angreifen. Zwar bestimmen patriarchalische Strukturen die kriminelle Organisation, aber es sind die Frauen, die ihre Kinder auf die zu erwartende Rolle vorbereiten"
    ],
    "bodycopy": [
      "Caterina ist die Ehefrau des untergetauchten 'Ndrangheta-Bosses Alfredo und hat ihren Sohn Pasquale für eine Zukunft an der Spitze des Clans erzogen. Ihre jüngere Schwester Assunta hat im Bandenkrieg bereits ihren Mann verloren und sieht ihren Sohn Giuseppe den Weg seines Vaters einschlagen. Dennoch muss sie gegen ihren Willen auf Anordnung Alfredos ihren Schwager Nando heiraten. In diese geschlossene Gesellschaft bricht Vittoria ein, eine Staatsanwältin aus Norditalien. Vittoria hat ein Ziel: das Schweigen der Frauen zu brechen.",
      "„Häufig sind Filme über die Mafia und die 'Ndrangheta nichts anderes als Genre-Filme. So einen Film wollte ich nicht machen. Von Anfang an hatte ich das Bedürfnis, die Geschichte aus den Blickwinkeln der weiblichen Figuren zu erzählen, weil mir das interessanter erschien und so noch nicht da gewesen ist. Bei einer kalabrischen Familie geht das auch kaum anders.“ [Fernando Muraca]"
    ],
    "image": "la-terra-dei-santi.jpg"
  },
  {
    "title": "La tigre e la neve (Der Tiger und der Schnee)",
    "director": "Roberto Benigni",
    "country": "Italien",
    "releaseYear": 2005,
    "runtime": 114,
    "version": "OmU",
    "screeningDate": "11.10.2007",
    "readableDate": "2007-10-11",
    "screeningTime": "19:00",
    "actors": "Roberto Benigni, Nicoletta Braschi, Jean Reno, Tom Walts, Emilia Fox, Giuseppe Battiston, Andrea Renzi, Abdelhafid Metalsi, Francesco De Vito",
    "subtitle": [""],
    "bodycopy": [
      "Italien 2003: Die Welt redet vom Irakkrieg, aber der verträumte Dichter Attilio (Roberto Benigni) hat nur Augen für die Autorin Vittoria (Nicoletta Braschi). Als diese sich zur Recherche in den Irak begibt, wird sie durch einen Bombenanschlag schwer verletzt. Spontan reist Attilio ihr in das kriegsgeschüttelte Land nach, um sie zu retten. Wie in allen Benignis Filmen ist die Handlung aber nur Anlass von der Kraft der Liebe in einer grausamen Welt zu träumen und das Leben als Spielplatz für die eigenen burlesken Einfälle zu sehen."
    ],
    "image": "la-tigre-e-la-neve.jpg"
  },
  {
    "title": "LA VITA CHE VORREI (Das Leben, das ich immer wollte)",
    "director": "Giuseppe Piccioni",
    "country": "Italien",
    "releaseYear": 2004,
    "runtime": 125,
    "version": "OmU",
    "screeningDate": "17.01.2007",
    "readableDate": "2007-01-17",
    "screeningTime": "19:00",
    "actors": "Luigi Lo Cascio, Sandra Ceccarelli, Ninni Bruschetta, Galatea Ranzi, Fabio Camilli, Gea Lionello, Roberto Citran, Camilla Filippi, Paolo Bassanelli",
    "subtitle": [""],
    "bodycopy": [
      "Giuseppe Piccioni war in allen seinen Filmen (u.a. „Fuori dal mondo“ und „Luce dei miei occhi“) ein genauer Beobachter der Menschen und ihrer Leben. In „La vita che vorrei” erzählt er die Liebesgeschichte von Stefano und Laura, die im gleichen Film als Schauspieler arbeiten und dort ein Liebespaar darstellen. So verwischen sich die Grenzen zwischen Spiel und Leben. Nie kann man sicher sein, was Darstellung auf dem Set, was Ausdruck echter Gefühle ist. Die in Italien berühmten Schauspieler Luigi Lo Cascio und Sandra Ceccarelli wurden von einigen Filmkritikern zum neuen„Traumpaar“ des Italienischen Films gekürt."
    ],
    "image": "la-vita-che-vorrei.jpg"
  },
  {
    "title": "LA VITA È BELLA (DAS LEBEN IST SCHÖN)",
    "director": "Roberto Benigni",
    "country": "Italien",
    "releaseYear": 1997,
    "runtime": 116,
    "version": "OmU",
    "screeningDate": "17.05.2018",
    "readableDate": "2018-05-17",
    "screeningTime": "20:00",
    "actors": " Roberto Benigni, Nicoletta Braschi, Giorgio Cantarini, Giustino Durano, Horst Buchholz, Lidia Alfonsi, Marisa Paredes, Sergio Bustric",
    "subtitle": [
      "Darf der Holocaust zum Stoff einer Komödie gemacht werden? Dass dies mit der Person Hitlers möglich ist, haben Chaplin und Lubitsch mit ihren Meisterwerken bewiesen. Aber den industriell organisierten Massenmord an der jüdischen Bevölkerung komödiantisch zu erzählen: kann das gut gehen? So bleibt Begninis Film ein ambivalentes Ereignis, eine in einer schrecklichen Zeit angesiedelte Erzählung, die sensibel versucht, besondere Kinobilder für die Würde der Holocaust-Opfer zu finden"
    ],
    "bodycopy": [
      "Guido gelingt es Anfang der 30er Jahre, seine geliebte Dora zu gewinnen, indem er sie mit originellen Einfällen von ihrer Verlobungsfeier entführt und mit ihr eine Familie gründet. Er arbeitet als Buchhändler, sie als Lehrerin. So könnte das lustige Leben weitergehen, bräche nicht die Deportation über das glückliche Paar und ihren Sohn Giosuè herein.",
      "Um seinem Sohn die grausame Wahrheit zu ersparen, gaukelt Guido ihm vor, Deportation und Konzentrationslager seien nur ein groß angelegtes Spiel und sie müssten genau die Regeln befolgen, um es zu gewinnen.",
      "„Der als Loblied auf die Kraft der Fantasie und den menschlichen (Über-)Lebenswillen angelegte Film beginnt als beschwingte Romanze mit märchenhaften Untertönen und endet in einer bitter-absurden Tragödie, in der das Lachen zum schmerzhaften Reflex gefriert.“ (Lexikon des internationalen Films)"
    ],
    "image": "la-vita-e-bella.jpg"
  },
  {
    "title": "Ladri di biciclette (Fahrraddiebe)",
    "director": "Vittorio de Sica",
    "country": "Italien",
    "releaseYear": 1948,
    "runtime": 90,
    "version": "OmitU",
    "screeningDate": "05.10.2005",
    "readableDate": "2005-10-05",
    "screeningTime": "18:00",
    "actors": "Lamberto Maggiorani, Enzo Staiola, Lianella Carell, Elena Altieri, Gino Saltamerenda, Giulio Chiari, Vittorio Antonucci, Michele Sakara, Fausto Guerzoni, Massimo Randisi, Ida Bracci",
    "subtitle": [""],
    "bodycopy": [
      "Dieses Meisterwerk des Neorealismus (Oskar 1949) zeigt anhand der Suche eines Arbeitslosen nach dem Dieb seines für die neue Arbeit notwendigen Fahrrads das Rom der unmittelbaren Nachkriegszeit. Dabei stoßen er und sein Sohn sowohl auf Solidarität, aber auch auf Gleichgültigkeit und offene Feindlichkeit, wenn sich ein ganzes Viertel offen mit den Dieben verbündet."
    ],
    "image": "ladri-di-biciclette.jpg"
  },
  {
    "title": "LAMERICA (LAMERICA)",
    "director": "Gianni Amelio",
    "country": "Italien",
    "releaseYear": 1994,
    "runtime": 116,
    "version": "OmU",
    "screeningDate": "21.03.2013",
    "readableDate": "2013-03-21",
    "screeningTime": "20:00",
    "actors": "Enrico Lo Verso, Carmelo di Mazzarelli, Michele Placido, Pio Mikani, Carmelo Di Mazzarelli, Elida Janushi, Sefer Pema, Idajet Sejda, Marieta Ljarja, Elina Ndrei, Artan Marina",
    "subtitle": [""],
    "bodycopy": [
      "Der Versuch einer Subventionserschleichung erfordert von einem Italiener eine Scheinfirma in Albanien. Was als einfacher Betrugsversuch beginnt, wird zur Erkundung eines Landes am Rande Europas und eine bildgewaltige Reflexion über Migration."
    ],
    "image": "lamerica.jpg"
  },
  {
    "title": "LAMERICA (LAMERICA)",
    "director": "Gianni Amelio",
    "country": "Italien",
    "releaseYear": 1994,
    "runtime": 116,
    "version": "OmU",
    "screeningDate": "19.06.2014",
    "readableDate": "2014-06-19",
    "screeningTime": "20:00",
    "actors": " Enrico Lo Verso, Carmelo di Mazzarelli, Michele Placido, Pio Mikani, Carmelo Di Mazzarelli, Elida Janushi, Sefer Pema, Idajet Sejda, Marieta Ljarja, Elina Ndrei, Artan Marina",
    "subtitle": ["Höhepunkte aus 10 Jahren „Italienischer Filmclub“"],
    "bodycopy": [
      "Der Versuch einer Subventionserschleichung erfordert von einem Italiener eine Scheinfirma in Albanien. Was als einfacher Betrugsversuch beginnt, wird zur Erkundung eines Landes am Rande Europas und eine bildgewaltige Reflexion über Migration."
    ],
    "image": "lamerica2.jpg"
  },
  {
    "title": "LAZZARO FELICE (GLÜCKLICH WIE LAZZARO)",
    "director": "Alice Rohrwacher",
    "country": "Italien/Schweiz/Frankreich/Deutschland",
    "releaseYear": 2018,
    "runtime": 128,
    "version": "OmU",
    "screeningDate": "19.12.2019",
    "readableDate": "2019-12-19",
    "screeningTime": "20:00",
    "actors": " Adriano Tardiolo, Agnese Graziani, Alba Rohrwacher,  Luca Chikovani, Tommaso Ragno, Sergi López, Natalino Balasso, Nicoletta Braschi",
    "subtitle": [
      "Ob der Film eine Parabel über den biblischen Lazarus ist oder nicht, kann offen bleiben. Mit teils märchenhafter Phantasie erzählt Alice Rohrwacher die Geschichte der Armut im Feudalsystem und der randständigen Gesellschaftsschichten der Moderne. Dabei steht sie in der Tradition der italienischen Filmgeschichte, nimmt aber auch Anregungen des Magischen Realismus auf."
    ],
    "bodycopy": [
      "Lazzaro ist ein stiller Beobachter, er schaut, als müsse die Welt seine Augen durchdringen, um eine bessere zu werden. Im Alltag ist er der Depp, der allen zur Hand geht und auch nicht protestiert, als ihm der Marsala vor dem Mund weggetrunken wird. Er lebt in einer Gesellschaft, die, offensichtlich in der zweiten Hälfte des 20. Jahrhunderts angesiedelt, wie in einer feudalistischen Ausbeutung arbeiten. Über allen thront die Marchesa in ihrer Villa. Deren angeödeter Sohn freundet sich mit Lazzaro an, der ihm sklavisch folgt. Dann räumt auf einmal die Polizei das Gelände und Lazzaro stirbt.",
      "Als er von den Toten aufersteht, begibt er sich in die Stadt und trifft seine alten Bekannten wieder, die obdachlos auf einer Art Schrottplatz hausen. Sie haben die ländliche Armut mit dem urbanen Elend getauscht.",
      "Insofern ist der Film auch eine komprimierte Darstellung der Folgen der Landflucht und über die Armut, deren Gestalt sich nur gewandelt hat.",
      "Angereichert wird die Erzählung durch mythische Elemente wie einem die Erzählstränge verbindenden Wolf, eine mondwerdende Bratpfanne oder einem Steinschleuderer, der mit seiner Schleuder einen Zeitensprung verursacht."
    ],
    "image": "lazzaro-felice.jpg"
  },
  {
    "title": "Le avventure di Pinocchio (Pinocchio-Episode 1 und 2)",
    "director": "Luigi Comencini",
    "country": "Italien",
    "releaseYear": 1972,
    "runtime": 120,
    "version": "OmitU",
    "screeningDate": "04.07.2007",
    "readableDate": "2007-07-04",
    "screeningTime": "19:00",
    "actors": " Andrea Balestri, Nino Manfredi, Gina Lollobrigida, Franco Franchi, Ciccio Ingrassia, Vittorio de Sica, Lionel Stander, Ugo D'Alessio, Mario Adorf, Enzo Cannavale",
    "subtitle": ["Die Familie Comencini"],
    "bodycopy": [
      " Luigi Comencinis Film gilt auch heute noch als die beste Umsetzung des berühmten Kinderbuches von Carlo Collodi, obwohl oder gerade weil er die phantastischen Elemente des Buches weitgehend in die Realität überführt und sehr frei mit dem Stoff umgeht. Da Pinocchio die meiste Zeit ein Junge aus Fleisch und Blut ist, bekommt das Märchen einen realistischen Charakter, der es auch für Erwachsene sehenswert macht. Nicht zuletzt überzeugt Comencini durch eine interessante Bildregie."
    ],
    "image": "pinocchio.jpg"
  },
  {
    "title": "LE CHIAVI DI CASA (Die Hausschlüssel)",
    "director": "Gianni Amelio",
    "country": "Italien/Frankreich/Deutschlad",
    "releaseYear": 2004,
    "runtime": 110,
    "version": "OmU",
    "screeningDate": "20.03.2008",
    "readableDate": "2008-03-20",
    "screeningTime": "19:00",
    "actors": "Kim Rossi Stuart, Charlotte Rampling, Andrea Rossi, Alla Faerovich, Pierfrancesco Favino, Manuel Katzy",
    "subtitle": [""],
    "bodycopy": [
      "Die Geschichte einer vorsichtigen und problematischen Annäherung. Nach 15 Jahren sieht der Vater seinen behinderten Sohn wieder. Der spastische Teenager muss sich in Berlin einer Operation unterziehen und sein Vater soll ihn begleiten – gerade als dessen Gedanken seiner neuen Familie gelten. So ist das Treffen durch Unsicherheit und Misstrauen auf beiden Seiten geprägt. Ist es beim Vater ein Hinundher geworfen sein zwischen Beschützerinstinkt und dem Versuch der Distanzierung von der Behinderung des Kindes, versucht der Junge durch die neue Situation seine Unabhängigkeit zu vergrößern. Indem Amelio die Personen seines Films sehr ernst nimmt, ist ihm ein poetischer und sensibler Film gelungen."
    ],
    "image": "le-chiavi-di-casa.jpg"
  },
  {
    "title": "LE CONSEGUENZE DELL’AMORE (DIE FOLGEN DER LIEBE)",
    "director": "Paolo Sorrentino",
    "country": "Italien",
    "releaseYear": 2004,
    "runtime": 100,
    "version": "OmU",
    "screeningDate": "18.11.2021",
    "readableDate": "2021-11-18",
    "screeningTime": "20:00",
    "actors": "Sorrentinos aktuelleren Filme stießen auf ein breites Publikumsinteresse (Cheyenne I/F 2011, La Grande Bellezza F/I 2013, Loro I/F 2018), seine frühen Filme sind in Deutschland hingegen weitgehend unbekannt. Anders als seine späteren Werke haben diese eine formale Strenge, welche die Filmerzählung zwar nicht dominiert, aber ihre dramaturgische Struktur beeinflusst: Form und Erzählung verschmelzen zu einem visuell-narrativen Erlebnis.",
    "subtitle": [""],
    "bodycopy": [
      "Toni Servillo wartet in der Rolle des Steuerberaters Tita di Girolamo seit fast einem Jahrzehnt in einem Hotelzimmer auf einen regelmäßig vorbeigebrachten Koffer, den er dann zuverlässig zur Bank bringt, wo das darin enthaltene Geld eingezahlt wird. Seine emotionslos ablaufende Routine wird auf einmal belebt, als er Sofia, die Barkellnerin kennenlernt. Aus Gesprächen entsteht Sympathie, aus Sympathie Liebe und die verführt ihn dazu, aus dem transportierten Geld einen gewissen Anteil „abzuzapfen“. Das kann natürlich nicht unbemerkt bleiben und so sieht sich der Verliebte von seinen Auftraggebern unter Druck gesetzt. Zu allem Überfluss ist gerade jetzt eine mafiaähnliche Bande hinter dem Koffer her. Es bleibt wenig Zeit für die Liebe, die auch ihren Preis hat, der sich schließlich nicht nur in Geld ausdrückt."
    ],
    "image": "conseguenze.jpg"
  },
  {
    "title": "Le fate ignoranti (Die Ahnungslosen)",
    "director": "Ferzan Özpetek",
    "country": "Italien",
    "releaseYear": 2000,
    "runtime": 105,
    "version": "OmU",
    "screeningDate": "21.10.2004",
    "readableDate": "2004-10-21",
    "screeningTime": "19:30",
    "actors": "Margherita Buy, Stefano Accorsi, Serra Yilmaz, Andrea Renzi, Gabriele Garko",
    "subtitle": [""],
    "bodycopy": [
      "Ein Museum. Eine Frau besichtigt ausgestellte Skulpturen. Ein Mann nährt sich, wird anzüglich. Frau und Mann verlassen das Museum: Seit Jahren sind sie verheiratet und bewohnen eine Villa am Stadtrand von Rom.",
      "Eine belebte Straße, das Mobiltelefon schellt. Unaufmerksamkeit. Und kurz darauf lebt der Mann nicht mehr. Zurück bleibt ein Bild. Auf der Rückseite ein Text, der keine Zweifel lässt: Der Mann hatte ein Verhältnis mit „Michele“.",
      "Verstörend die Entdeckung der Frau, dass „die“ Geliebte „ein“ Liebhaber ist. Langsam erkennt sie, dass ihr Mann in einer Gruppe von Homo- und Transsexuellen eine zweite Familie gefunden hatte. Zwischen Enttäuschung, Wut und Faszination hin und hergerissen sucht sie nach den Gründen, warum ihr Mann diese unkonventionelle Welt liebte. Und mit der Zeit scheint die Frau fast unmerklich die Rolle ihres Mannes in diesem sonderbaren Kosmos zu übernehmen. Doch nichts ist, wie es scheint. Denn wenn Feen (fate) ahnungslos und unwissend (ignoranti) zaubern, sind die Folgen unabsehbar."
    ],
    "image": "le-fate-ignoranti.jpg"
  },
  {
    "title": "LE MERAVIGLIE (LAND DER WUNDER)",
    "director": "Alice Rohrwacher",
    "country": "Italien/Deutschland/Schweiz",
    "releaseYear": 2013,
    "runtime": 110,
    "version": "OmU",
    "screeningDate": "17.12.2015",
    "readableDate": "2015-12-17",
    "screeningTime": "20:00",
    "actors": "Alba Rohrwacher, Maria Alexandra Lungu, Sam Louwyck, Monica Bellucci",
    "subtitle": [""],
    "bodycopy": [
      "Gelsomina lebt mit ihren Schwestern und Aussteigereltern auf einem heruntergekommenen Bauernhof in der Toskana. Der Traum vom alternativen Leben ist für die Eltern ausgeträumt, doch Gelsomina unternimmt alles, um die Familienbeziehungen und den Hof zu retten. Dieser Film zwischen Märchen und Realität erhielt den „Großen Preis der Jury“ in Cannes."
    ],
    "image": "le-meraviglie.jpg"
  },
  {
    "title": "Le mura di Sana’a (Die Mauer von Sana’a)",
    "director": "Pier Paolo Pasolini",
    "country": "Italien",
    "releaseYear": 1971,
    "runtime": 14,
    "version": "OmU",
    "screeningDate": "27.02.2011",
    "readableDate": "2011-02-27",
    "screeningTime": "15:00",
    "actors": "",
    "subtitle": [""],
    "bodycopy": [
      "Dokumentation „in Form eines Appells an die UNESCO“ über die bedrohten historischen Bauten in der jemenitischen Hauptstadt Sana‘a, die der Drehort für eine aus der endgültigen Fassung von IL DECAMERON herausgeschnittenen Sequenz war."
    ],
    "image": "le mura di sana.jpg"
  },
  {
    "title": "Libera terra (Libera terra)",
    "director": "Monica Colautti und Frank Wittlinger",
    "country": "Deutschland",
    "releaseYear": 2007,
    "runtime": 48,
    "version": "OmU",
    "screeningDate": "23.06.2007",
    "readableDate": "2007-06-23",
    "screeningTime": "19:30",
    "actors": "",
    "subtitle": [""],
    "bodycopy": [
      "Corleone – der Name steht spätestens seit Hollywood sich des Themas annahm für Mafia und Mafiaverbrechen. Corleone – der Ort, von dem aus der Boss der Bosse Bernardo Provenzano bis zur Verhaftung am 11. April 2006 vierzig Jahre lang seine Fäden spinnen konnte. Corleone – heute ein Ort, der mit seinen Nachbargemeinden die gegen die Mafia gerichtete Landwirtschaftskooperative „Placido Rizzotto - Libera Terra“ umgibt. Vor 10 Jahren hatte der Turiner Geistliche, Don Luigi Ciotti, die Idee, eine Kooperative zu initiieren, um die konfiszierten Mafia-Gutshöfe wieder ihrem ursprünglichen landwirtschaftlichen Nutzen zuzuführen. Dank des Engagements vieler Gruppen konnte vor 5 Jahren dieses Projekt verwirklicht werden und wird nach anfänglichen Schwierigkeiten heute von den Bewohnern akzeptiert und italienweit unterstützt. Die Mitglieder der Kooperative ließen sich weder durch massive Behinderungen noch durch Warnungen (zerstörte Saat, erhängter Hund auf dem Feld u.ä.) entmutigen. Der Film stellt die Kooperative und die Situation kurz nach der Verhaftung Provenzanos dar, lässt deren Mitglieder, die Bewohner und die Antimafiaaktivisten zu Wort kommen und zeigt dabei eine Mafia, die zwar im Film nicht erscheint, aber allgegenwärtig ist."
    ],
    "image": "libera-terra-7.jpg"
  },
  {
    "title": "LO CHIAMAVANO JEEG ROBOT (SIE NANNTEN IHN JEEG ROBOT)",
    "director": "Gabriele Mainetti",
    "country": "Italien",
    "releaseYear": 2015,
    "runtime": 118,
    "version": "OmU",
    "screeningDate": "21.04.2022",
    "readableDate": "2022-04-21",
    "screeningTime": "20:00",
    "actors": "Claudio Santamaria, Ilenia Pastorelli, Luca Marinelli, Stefano Ambrogi u.a",
    "subtitle": [
      "„Italien hat endlich seinen eigenen Superhelden“ titelte Vanity nach Erscheinen dieses Films. Doch dieser Held ist weniger super als verloren in der Welt und gammelt mit kriminellen Nebenjobs vor sich hin. Er bekommt es mit dem Bösen zu tun, das in Gestalt eines durchgeknallten Bandenchefs blutiges Unheil um sich ausbreitet. Der Film enthält einen reichen Zitatenschatz des Superhelden-Genres, der eingesetzt wird, um die Absurditäten dieser Erzählform offenzulegen. Dabei unterhält der Film spannend und vergnüglich. Wer sich aber in dem Genre nicht auskennt, wird eine Kriminalkomödie erleben, in dem die Protagonisten besondere Kräfte haben, ansonsten aber wie gewohnt gierig, naiv, ungeschickt und bauernschlau agieren."
    ],
    "bodycopy": [
      "Der misanthropische Kleinkriminelle Enzo stürzt, von der Polizei verfolgt, in den Tiber, kommt mit radioaktiven Chemikalien in Berührung und verfügt fortan über Superkräfte. Über einen „Kollegen“ lernt er dessen Tochter kennen, die geistig gestört ist und die Handlung des Anime „Steel Jeeg“ mit dem Geschehen in der Realität vermischt. Enzo ist für sie „Hiroshi Shiba“, der Held ihrer Fernsehserie. Daher entwickelt sie eine große Anhänglichkeit",
      "Inzwischen entsteht beim kriminellen Bandenchef Fabio Neid auf den mysteriösen vermummten Superkriminellen (Enzo), der einen Bankautomaten einfach aus der Wand reißt und mitnimmt. Als dieser ihm auch noch beim Überfall auf einen Geldtransporter vor seinen Augen zuvorkommt, wird sein Spielraum eng. Fabio schuldet der Mafiaclanchefin Nunzia die Zahlung für eine Lieferung Rauschgift und muss nun um sein Leben fürchten.",
      "Aus dieser Konstellation entstehen eine Reihe von Verwicklungen, bis es zum Show-down zwischen dem inzwischen zum Guten konvertierten Enzo und dem teuflisch gewordenen Fabio kommt, der inzwischen auch Superkräfte erlangt hat.",
      "Der Film wurde in 17 Kategorien für den Filmpreis David di Donatello nominiert und gewann in 8 Kategorie. Inspiriert wurde er von der Anime-Serie „Steel Jeeg“ (ital. „Jeeg robot d’acciaio“)."
    ],
    "image": "sie-nannten-ihn-jeeg-robot-1.jpg"
  },
  {
    "title": "LORO (DIE VERFÜHRTEN)",
    "director": "Paolo Sorrentino",
    "country": "Italien/Frankreich",
    "releaseYear": 2018,
    "runtime": 157,
    "version": "OmU",
    "screeningDate": "17.06.2021",
    "readableDate": "2021-06-17",
    "screeningTime": "20:00",
    "actors": "Toni Servillo, Elena Sofia Ricci, Riccardo Scamarcio, Fabrizio Bentivoglio u.a",
    "subtitle": [
      "Die Meinungen zu diesem Film gehen weit auseinander. Meint Dirk Schümer in einer Besprechung, Sorrentino sei der erste Filmemacher, der das immense optische Potenzial der Berlusconi Epoche begriffen habe (Sex und Macht – Geschäft und Politik), äußert sich Lars-Olav Beier negativ: „Statt sich in die Tiefe zu wagen, geht der Film in die Breite und hinterlässt ein Gefühl der Leere...“ Jedenfalls brilliert Sorrentino in der optisch hervorragenden Inszenierung von Partys und Festen, in die der von Toni Servillo gespielte Berlusconi mit stoischem Lächeln hereinragt."
    ],
    "bodycopy": [
      "Sergio betreibt einen Callgirl-Ring und will sich den größten und reichsten Kunden Italiens angeln: Silvio Berlusconi. So mietet er eine Yacht und das von dessen Grundstück einsehbaren Nachbarhaus, organisiert rauschende Partys und sorgt für Lautstärke, um die Aufmerksamkeit Berlusconis auf sich zu ziehen. Ihn und sein Umfeld fasziniert die Vorstellung von der Nähe zur Macht und so strickt er ein Intrigennetz, um zu seinem Ziel zu kommen.",
      "Berlusconi hingegen, scheinbar der mächtigste Mann des Landes, langweilt sich derweilen auf seinem Landsitz und brütet Banalitäten aus. Der Reiz von Sex und Macht ist verbraucht und in der Ehe kriselt es, denn: seine Ehefrau Veronica verachtet ihn. Als er von engen Vertrauten verraten wird, beschließt er, erneut ins Regierungsamt zu gelangen.",
      "Sorrentino versucht das Phänomen Berlusconi von der privaten Seite aufzurollen, stößt dabei aber auf Banalität und Leere, die er durch humoristische Einfälle zu überbrücken versucht. Ob er damit der Erklärung der Berlusconi Epoche nahe kommt, ist fraglich."
    ],
    "image": "loro-5.jpg"
  },
  {
    "title": "Luce dei miei occhi (Licht meiner Augen)",
    "director": "Giuseppe Piccioni",
    "country": "Italien",
    "releaseYear": 2001,
    "runtime": 114,
    "version": "OmU",
    "screeningDate": "16.06.2005",
    "readableDate": "2005-06-16",
    "screeningTime": "19:30",
    "actors": "Luigi Lo Cascio, Sandra Ceccarelli, Silvio Orlando, Barbara Valente, Tony Bertorelli, Mario Paolo Pierobon",
    "subtitle": ["Werkschau: Luigi Lo Cascio"],
    "bodycopy": [
      "Die allein erzeihende Mutter Maria versucht mit leidlichem Erfolg, sich und ihre Tochter Lisa mit einem Tiefkühlwarengeschäft durchzubringen. Dem Chauffeur Antonio ist das Leben nur durch die Flucht in eine Science-Fiction-Gedankenwelt erträglich. Als Antonio sich in Maria verliebt und diese ihn anfänglich abweist, müssen beide lernen, ihren selbst gesponnenen Kokon zu verlassen und die Probleme des Lebens gemeinsam anzugehen.Die allein erzeihende Mutter Maria versucht mit leidlichem Erfolg, sich und ihre Tochter Lisa mit einem Tiefkühlwarengeschäft durchzubringen. Dem Chauffeur Antonio ist das Leben nur durch die Flucht in eine Science-Fiction-Gedankenwelt erträglich. Als Antonio sich in Maria verliebt und diese ihn anfänglich abweist, müssen beide lernen, ihren selbst gesponnenen Kokon zu verlassen und die Probleme des Lebens gemeinsam anzugehen.Prominent besetzter Film, der zahlreiche Auszeichnungen erhielt."
    ],
    "image": "luce-dei-miei-occhi-3.jpg"
  },
  {
    "title": "Ludwig (Ludwig II)",
    "director": "Luchino Visconti",
    "country": "Italien/Frankreich/Deutschland",
    "releaseYear": 1972,
    "runtime": 244,
    "version": "OmU",
    "screeningDate": "22.07.2004",
    "readableDate": "2004-07-22",
    "screeningTime": "19:30",
    "actors": "Helmut Berger, Trevor Howard, Romy Schneider, Silvana Mangano, Gert Fröbe",
    "subtitle": [""],
    "bodycopy": [
      "Eine einmalige Gelegenheit für Freunde des italienischen Films. Wir zeigen nicht die gewöhnlich vorgeführte gekürzte Synchronfassung von Viscontis Meisterwerk, sondern die untertitelte Originalfassung in Originallänge!",
      "Als letzter Film der deutschen Trilogie („La caduta degli dei (Die Verdammten)“, „Morte a Venezia (Der Tod in Venedig)“ widmet Visconti der Geschichte des „Märchenkönigs“ Ludwig II von Bayern.",
      "Der Film umspannt die mehr als 20 Jahre von dessen Krönung bis 1886 und beschreibt seine immer stärkere Abwendung von der Realität und seine Flucht in Traumwelten und schöne Künste, die er ausgiebig fördert. Der vor seinen Schuldnern geflohene Richard Wagner wird von Ludwig zur Rückkehr bewegt, was dieser weidlich ausnutzt. Eine Seelenverwandte findet er in seiner Cousine Elisabeth von Österreich, die von der auf der Höhe ihrer Schauspielkunst stehende Romy Schneider verkörpert wird. Unfähig, sexuelle Beziehungen zum weiblichen Geschlecht einzugehen, zieht es ihn zu Männern, ohne dass es aber zu einer wirklichen homosexuellen Beziehung kommt.",
      "Der mysteriöse Tod im Starnberger See scheint so die zwingende Konsequenz eines Lebens am Rande des Untergangs zu sein, dem Untergang eines Herrschers, aber auch einer Epoche.",
      "„Helmut Berger verkörpert diesen Ludwig „wie aus einem Guss“, scheint geboren für diese Rolle eines Königs, dem gegenüber man Verachtung wie Mitgefühl entgegenbringen kann.“ (Ulrich Behrens)"
    ],
    "image": "ludwig.gif"
  },
  {
    "title": "Malena (Der Zauber von Malena)",
    "director": "Giuseppe Tornatore",
    "country": "Italien",
    "releaseYear": 2000,
    "runtime": 105,
    "version": "OmU",
    "screeningDate": "18.05.2005",
    "readableDate": "2005-05-18",
    "screeningTime": "19:30",
    "actors": "Monica Bellucci, Giuseppe Sulfaro, Luciano Federico, Matilde Piana, Gaetano Aronica, Gabriella di Luzio, Angelo Pellegrino",
    "subtitle": [""],
    "bodycopy": [
      "Kurz vor Ausbruch des Zweiten Weltkriegs in Catelcutò/Sizilien: „Der Zauber von Malena“ lässt alle Männer des Ortes verrückt werden, verrückt vor Leidenschaft für diese schöne Frau. Aber auch ein pubertierender Junge verliebt sich in die schöne, für ihn unerreichbare Witwe. Er beobachtet sie und leidet darunter, wie sie von anderen sowohl verehrt als auch missbraucht und aus dem Dorf geprügelt wird. Tornatore (Cinema Paradiso, Die Legende vom Ozeanpianisten) hat für seinen Jugenderinnerungen Filmbilder geschaffen."
    ],
    "image": "malena.jpg"
  },
  {
    "title": "MAMMA ROMA (Mamma Roma)",
    "director": "Pier Paolo Pasolini",
    "country": "Italien",
    "releaseYear": 1962,
    "runtime": 105,
    "version": "OmU",
    "screeningDate": "14.01.2023",
    "readableDate": "2023-01-14",
    "screeningTime": "21:00",
    "actors": "Anna Magnani, Ettore Garofolo, Franco Citti, Silvana Corsini u.a.",
    "subtitle": [
      " Die Restaurierung von MAMMA ROMA wurde 2022 durch das Centro Sperimentale di Cinematografia Cineteca Nazionale aus den Bildnegativen und dem Soundtrack durchgeführt, die von RTI-Mediaset in Zusammenarbeit mit Infinity+ und Cine 34 zur Verfügung gestellt wurden. Um eine vollständige Version des Films zu erstellen, wurden einige Teile, die in den Bildnegativen fehlten oder beschädigt waren, mit einem in der Cineteca Nazionale konservierten Positiv kombiniert. "
    ],
    "bodycopy": [
      "Mamma Roma versucht ihre Vergangenheit hinter sich zu lassen. Carmine, ihr Zuhälter und Vater ihres Kindes, heiratet eine andere Frau. Ein neues Leben steht auf der Tagesordnung. Mamma Roma zieht mit ihrem 16-jährigen Sohn, der auf dem Land in einem Internat aufgewachsen ist, in eine bürgerliche Gegend und betreibt einen Gemüsestand. Das neue gemeinsame Leben entpuppt sich als äußerst spannungsgeladen und plötzlich ist Carmine zurück, inzwischen von seiner neuen Frau getrennt. Er stellt Mamma Roma vor ein Ultimatum.",
      "„Es gibt in diesem Film Augenblicke von bestürzender Schönheit, die gleich neben Bildern des Untergangs stehen, mehr noch, die aus diesem wachsen und wieder in ihn zurückfließen. Als Ettore nach einem schäbigen Diebstahl und einem Selbstmordversuch in der Psychiatrie landet, rezitiert einer der Mit-Insassen aus Dantes „Inferno“. Kurz darauf erklingt Vivaldi. Man muss das im Kino erleben, um zu glauben, dass dieser Moment nicht in Kitsch umkippt.“ (Claus Löser) "
    ],
    "image": "mamma-roma-1.jpg"
  },
  {
    "title": "Mamma Roma",
    "director": "Pier Paolo Pasolini",
    "country": "Italien",
    "releaseYear": 1962,
    "runtime": 110,
    "version": "OmitU",
    "screeningDate": "02.09.2009",
    "readableDate": "2009-09-02",
    "screeningTime": "20:00",
    "actors": "Anna Magnani, Ettore Garololo, Franco Citti, Silvana Corsini, Luisa Loiano, Paolo Volponi, Luciano Gonini, Vittorio La Paglia, Piero Morgia, Lanfranco Ceccarelli",
    "subtitle": ["Werkschau: Pier Paolo Pasolini"],
    "bodycopy": [
      "Mit diesem frühen Meisterwerk stellt sich Pasolini quer zu jeder Form der Ideologie. Als radikaler Marxist orientiert er sich am Neorealismus, um ein Portrait des Subproletariats im Spannungsbogen zwischen kleinbürgerlichen Einstellungen und dem existenziellen Kampf gegen Ausbeutung und Ungerechtigkeit zu zeichnen: Die Prostituierte „Mamma Roma“ (Anna Magnani) setzt sich mit ganzer Kraft dafür ein, ihrem Sohn einen Platz in sozial besser gestellten Schichten zu verschaffen, scheitert aber an den starren und unüberwindbaren gesellschaftlichen Verhältnissen."
    ],
    "image": "mammaroma.jpg"
  },
  {
    "title": "MARRAKECH EXPRESS (MARRAKECH EXPRESS)",
    "director": "Gabriele Salvatores",
    "country": "Italien",
    "releaseYear": 1989,
    "runtime": 110,
    "version": "OmitU",
    "screeningDate": "07.10.2009",
    "readableDate": "2009-10-07",
    "screeningTime": "20:00",
    "actors": "Diego Abantantuono, Fabrizio Bentivoglio, Cristina Marsillach, Giuseppe Cederna, Gigio Alberti",
    "subtitle": [
      "Werkschau: Ein Fall für zwei Gabriele Salvatores (Regisseur) und Diego Abantantuono (Schauspieler)"
    ],
    "bodycopy": [
      "Nachdem sie sich fast zehn Jahren nicht gesehen haben, entscheidet eine Freundesgruppe, eine Reise zu unternehmen, um ein wegen Drogenbesitz inhaftiertes altes Mitglied ihrer alten Gruppe zu befreien. Sie führt von Italien über Frankreich und Spanien nach Marokko und diese abenteuerliche, vom Rausch der Flucht geprägte Reise erlaubt den Männern, taub gewordene Beziehungen wieder zu entdecken."
    ],
    "image": "marrakech-express.jpg"
  },
  {
    "title": "MARTIN EDEN (MARTIN EDEN)",
    "director": "Pietro Marcello",
    "country": "Italien/Frankreich/Deutschland",
    "releaseYear": 2019,
    "runtime": 129,
    "version": "OmU",
    "screeningDate": "16.06.2022",
    "readableDate": "2022-06-16",
    "screeningTime": "20:00",
    "actors": "Luca Marinelli, Jessica Cress, Denise Sardisc, Vincenzo Nemolato, Carmen Pommella, Elisabetta Volagoi u.a.",
    "subtitle": [
      "Als der Matrose Martin Eden die großbürgerliche Elena Orsini kennen lernt, wächst der Wunsch in ihm, in die bürgerliche Welt hineinzuwachsen. Er beginnt mit dem Studium der Literatur und liest alles, was ihm in die Finger kommt. Doch nicht nur bei der Familie Orsini, sondern auch bei seiner Freundin Elena stößt seine Bildungswut und die schriftstellerischen Ambitionen auf wohlwollende Herablassung. Auch als sich der erste Erfolg einstellt, ändert sich daran nichts. Dies hat schwerwiegende Folgen."
    ],
    "bodycopy": [
      "Kann die Liebe trotz Klassenschranken Bestand haben, gar die Klassengegensätze überwinden? Wie weit muss sich der Proletarier Martin Eden verbiegen, um in das großbürgerliche Leben einzutauchen? Wie weit kann ein Schriftsteller gehen, bevor er sich selbst verliert?",
      "Regisseur Pietro Marcello hat Jack Londons autobiografisch gefärbten Roman ins Neapel des frühen 20. Jahrhundert versetzt und verwebt Biografisches mit den politischen Prozessen Europas. Ein Kostümfilm, der nicht Kleider und Ausstattung ausstellt, sondern das Leben von Menschen in ihrem Jahrhundert lebhaft schildert.",
      "Neben zahlreichen anderen Auszeichnungen erhielt Luca Marinelli in Venedig 2019 den Coppa Volpi als Bester Schauspieler."
    ],
    "image": "martin-eden-liest-am-hafen.jpg"
  },
  {
    "title": "MATRIMONIO ALL’ITALIANA (Hochzeit auf Italienisch)",
    "director": "Vittorio De Sica",
    "country": "Italien",
    "releaseYear": 1963,
    "runtime": 101,
    "version": "OmU",
    "screeningDate": "16.06.2011",
    "readableDate": "2011-06-16",
    "screeningTime": "20:00",
    "actors": "Sophia Loren, Marcello Mastroianni, Aldo Puglisi, Tecia Scarano, Marilù Tolo, Gianni Ridolfi, Vito Moricone, Generoso Cortini, Enzo Aita",
    "subtitle": ["Hommage an Vittorio De Sica"],
    "bodycopy": [
      "Erneut brillieren Mastroianni und Loren in einer De-Sica-Komödie: Als die Prostituierte Filumena ihren Liebhaber Domenico an eine andere Frau zu verlieren droht, spielt sie ihm eine zum Tod führende Krankheit vor. Ihr letzter Wunsch: Sie will Domenico heiraten. Der willigt ein, schnell ist ein Priester gefunden, der aber nicht nur die Ehe schließt, sondern gleichzeitig eine „Wunderheilung“ vollbringt. Ab sofort hat Domenico nur noch einen Gedanken: Wie kann er sich aus dieser Falle wieder befreien."
    ],
    "image": "matrimonio-allitaliana.jpg"
  },
  {
    "title": "Medea (Medea)",
    "director": "Pier Paolo Pasolini",
    "country": "Italien/Deutschland/Frankreich",
    "releaseYear": 1969,
    "runtime": 110,
    "version": "OmU",
    "screeningDate": "27.01.2021",
    "readableDate": "2021-01-27",
    "screeningTime": "20:00",
    "actors": "Maria Callas, Massimo GIrotti, Laurent Terzeiff, Giuseppe Gentile, ;argareth Clémenti, Gerard Weiss, Sergio Tramonti, Luigi Barbini, Anna Maria Chio",
    "subtitle": [""],
    "bodycopy": [
      "Pasolinis Absicht ist klar: keinen weiteren Klassiker aus dem Geist humanistischer Verlogenheit zu inszenieren, sondern ein ethnologisches Drama der Kulturkonfrontation."
    ],
    "image": "Medea.png"
  },
  {
    "title": "Mediterraneo (Mediterraneo)",
    "director": "Gabriele Salvatores",
    "country": "Italien",
    "releaseYear": 1991,
    "runtime": 99,
    "version": "OmU",
    "screeningDate": "07.03.2007",
    "readableDate": "2007-03-07",
    "screeningTime": "19:00",
    "actors": "Diego Abantantuono, Claudio Bigagli, Giuseppe Cederna, Claudio Bisio, Luigi Alberti, Ugo Conti, Memo Dini, Vasco Mirandola, Vana Barba ",
    "subtitle": [""],
    "bodycopy": [
      "Im Frühjahr 1941 besetzt ein achtköpfiger Trupp italienischer Soldaten die kleine abgelegene griechische Insel Syrna. Die Insel scheint zuerst verlassen und karg. Doch dann stellt sich heraus, dass sie von Frauen, Alten und Kindern und einem geistreichen Popen bewohnt wird, da die Männer von den Deutschen deportiert wurden. Schnell vergessen die Soldaten den Krieg und der Krieg die Soldaten. Oscar 1992 für den besten ausländischen Film."
    ],
    "image": "mediterraneo.jpg"
  },
  {
    "title": "Mia madre (Mia Madre)",
    "director": "Nanni Moretti",
    "country": "Italien/Frankreich/Deutschland",
    "releaseYear": 2015,
    "runtime": 106,
    "version": "OmU",
    "screeningDate": "18.05.2017",
    "readableDate": "2017-05-18",
    "screeningTime": "20:00",
    "actors": "Margherita Buy, John Turturro, Giulia Lazzarini, Nanni Moretti, Beatrice Mancini, Stefano Abbati, Anna Bellato, Lorenzo Gioielli",
    "subtitle": [
      "In seinem neusten Film verarbeitet Nanni Moretti den Tod seiner Mutter, indem er die drückende Atmosphäre eines Krankenhauses mit dem Chaos an einem Filmset kontrastiert. Erinnerungen und Träume der Protagonistin (Margherita Buy) ergänzen das Gesamtbild"
    ],
    "bodycopy": [
      "Die Filmregisseurin Margherita hat sich von ihrem Freund getrennt, ihre Tochter geht langsam eigene Wege und am Set treibt der amerikanische Star alle in den Wahnsinn. Gleichzeitig liegt ihre Mutter ohne Hoffnung auf Gesundung im Krankenhaus. Ihr Bruder kümmert sich fürsorglich um sie, die Schwester ist überfordert.",
      "In dieser Situation begibt sich Margherita auf die Suche nach dem wirklich Wichtigen im Leben.",
      "Moretti gedenkt mit dem Film seiner verstorbenen Mutter, spricht aber auch über die Bedeutung von Kino, über Realität und Fiktion sowie über die Rolle der Arbeit, und deren Wichtigkeit sie für den Einzelnen."
    ],
    "image": "mia-madre.jpg"
  },
  {
    "title": "Milano Calibro 9 (Milano Kaliber 9)",
    "director": "Fernando di Leo",
    "country": "Italien",
    "releaseYear": 1972,
    "runtime": 98,
    "version": "OmU",
    "screeningDate": "14.12.2005",
    "readableDate": "2005-12-14",
    "screeningTime": "21:30",
    "actors": "Gastone Moschin, Barbara Bouchet, Mario Adorf, Frank Wolff, Luigi Pistilli, Ivo Garrani, Philippe Leroy, Lionel Stander",
    "subtitle": ["Werkschau: Mario Adorf"],
    "bodycopy": [
      "Einer der bedeutensten „Poliziotti“-Filme: Ugo Piazza hat eine dreijährige Haftstrafe beendet. Der „Amerikaner“ glaubt, er habe ihm 300.000 Dollar unterschlagen und setzt den skrupellosen Schläger Rocco Musco (Mario Adorf) auf ihn an. Aber nicht nur er ist hinter dem Geld her... Und so schlägt die Handlung immer wieder unerwartete Kapriolen.Ein modern fotografierter Film mit einer spannenden Filmmusik von Oscar-Preisträger Luis Enríquez Bacalov (\"Der Postmann\", \"Das erste Evangelium Matthäus\").Wir zeigen die vollständige Originalfassung. Die deutsche Synchronfassung wurde seinerzeit stark gekürzt."
    ],
    "image": "calibro-9.jpg"
  },
  {
    "title": "MIMÌ METALLURGICO FERITO NELL'ONORE (MIMI-IN SEINER EHRE GEKRÄNKT)",
    "director": "Lina Wertmüller",
    "country": "Italien",
    "releaseYear": 1972,
    "runtime": 115,
    "version": "OmU",
    "screeningDate": "15.08.2013",
    "readableDate": "2013-08-15",
    "screeningTime": "20:00",
    "actors": "Giancarlo Giannini, Mariangela Melato, Turi Ferro, Agostina Belli, Turi Ferro, Luigi Diberti",
    "subtitle": ["Lina Wertmüller zum 85. Geburtstag"],
    "bodycopy": [
      "Weil Mimi bei einer „geheimen“ Wahl links gewählt hat, muss er in den Norden fliehen und findet eine Anstellung bei Fiat. Er verliebt sich in die Kommunistin Fiore, die sich als sehr possessiv erweist. Das wird zum Problem, als er nach Sizilien zurückversetzt wird und seine Ehefrau die „ehelichen Pflichten“ einfordert. Als sie schließlich mit dem Kind eines anderen Mannes schwanger wird, erwarten alle, dass Mimi seine Ehre verteidigt. Das bringt ihn auf eine unkonventionelle Idee. Eine brillante Gesellschaftssatire."
    ],
    "image": "Mimì metallurgico.jpg"
  },
  {
    "title": "MINE VAGANTI (Männer al dente)",
    "director": "Ferzan Özpetek",
    "country": "Italien",
    "releaseYear": 2010,
    "runtime": 100,
    "version": "OmU",
    "screeningDate": "20-10-2011",
    "readableDate": "2011-10-20",
    "screeningTime": "20:00",
    "actors": "Riccardo Scamarcio, Nicole Grimaudo, Lunetta Savino, Elena Sofia Ricci, Ennio Fantastichini, Ilaria Occhini, Alessandro Preziosi, Bianca Nappi, Massimiliano Gallo, Daniele Pecci",
    "subtitle": [""],
    "bodycopy": [
      "Im Leben kommt es auf den richtigen Zeitpunkt an. Tommaso will sich vorder Familie als schwul bekennen, doch sein älterer Bruder kommt ihm mit fatalen Folgen zuvor: der Vater erleidet einen Herzinfarkt. Auf einmal findeter sich in der Nachfolgerrolle im väterlichen Unternehmen wieder, die ihm garnicht behagt. Zu allem Überfluss wird ihm eine „Partnerin“ zur Seite gestellt und auch Oma ist nicht, was sie zu sein scheint. Es lohnt, diesen aktuellen Film Özpeteks mit dem Film zu vergleichen, der zu seinem internationalen Renommee führte."
    ],
    "image": "mine-vaganti.jpg"
  },
  {
    "title": "MIO FRATELLO È FIGLIO UNICO (MEIN BRUDER IST EIN EINZELKIND)",
    "director": "Daniele Luchetti",
    "country": "Italien/Frankreich",
    "releaseYear": 2007,
    "runtime": 104,
    "version": "OmU",
    "screeningDate": "18.02.2016",
    "readableDate": "2016-02-18",
    "screeningTime": "20:00",
    "actors": "Elio Germano, Riccardo Scamarcio, Angela Finocchiaro, Massimo Popolizio, Alba Rohrwacher, Luca Zingaretti, Anna Bonaiuto, Diane Fleri, Ascanio Celestini, Vittorio Emanuele Propizio",
    "subtitle": [""],
    "bodycopy": [
      "60er/70er-Jahre: Die Geschichte des Erwachsenwerdens des „schwarzen Schafs“ einer Arbeiterfamilie, der seinem links eingestellten Bruder die Freundin auszuspannen versucht und provokant mit den Faschisten liebäugelt. Doch die Bindung zwischen den Brüdern bleibt über die Jahre intakt – bis der Kontakt zu den „Brigade rosse“ einschneidenden Einfluss auf sie gewinnt."
    ],
    "image": "mio-fratello-e-figlio-unico.jpg"
  },
  {
    "title": "Miracolo a Milano (Das Wunder von Mailand)",
    "director": "Vittorio de Sica",
    "country": "Italien",
    "releaseYear": 1951,
    "runtime": 100,
    "version": "OmitU",
    "screeningDate": "03.12.2008",
    "readableDate": "2008-12-03",
    "screeningTime": "19:00",
    "actors": "Emma Grammatica, Francesco Golisano, Paolo Stoppa, Guglielmo Barnabò, Brunella Bovo",
    "subtitle": [""],
    "bodycopy": [
      "De Sicas auch heute noch anrührende surrealistische Märchen vom guten Totò, der als Waise aufgewachsen im Elendsquartier am Rande Mailands endet. Als man dort Öl findet, werden die Armen vertrieben und ins Land geschickt, wo „Buongiorno voglia davvero dire buongiorno“. Ein Schutzengel und die ihm von seiner Pflegemutter überlassene magische Taube vertreiben die Spekulanten schließlich. Kommunisten kritisierten den Film als „katholisches Trostpflaster“. Andere sahen in ihm das Manifest des gesellschaftlichen Umsturzes. Für Cineasten ist der Film eines der Meisterwerke der Filmgeschichte."
    ],
    "image": "miracolo-a-milano.jpg"
  },
  {
    "title": "Mobbing - Mi piace lavorare",
    "director": "Francesca Comencini",
    "country": "Italien",
    "releaseYear": 2007,
    "runtime": 89,
    "version": "OmitU",
    "screeningDate": "05.09.2021",
    "readableDate": "2021-09-05",
    "screeningTime": "89",
    "actors": "Nicoletta Braschi, Camille Dugay Comencini, Marina Buoncristiani, Roberta Celea, Assunta Cestaro, Stefano Colace, Claudia Coli",
    "subtitle": [""],
    "bodycopy": [
      "Was mit kleinen „Unaufmerksamkeiten“ nach der Fusion des Unternehmens, in dem sie arbeitet, beginnt, wird für Anna zu einer Kaskade immer größerer Demütigungen. Darunter leidet auch die Beziehung zur eigenen Tochter, zu der sie nach ihrer Scheidung ein gutes Verhältnis hatte. Dieser Film der sozialkritischen und politisch engagierten Francesca Comencini lief im Panorama der Berlinale und hat bisher keinen deutschen Verleih gefunden. Nutzen Sie die einmalige Gelegenheit, diese bisher weitegehend unbekannte Regisseurin kennen zu lernen."
    ],
    "image": "mobbing.jpg"
  },
  {
    "title": "MÖRDERISCHE GESELLSCHAFTEN - Die Geschichte der Mafia",
    "director": "Bernhard Pfletschinger",
    "country": "Deutschland",
    "releaseYear": 2010,
    "runtime": 90,
    "version": "OmU",
    "screeningDate": "06.10.2021",
    "readableDate": "2021-10-06",
    "screeningTime": "20:00",
    "actors": "",
    "subtitle": [
      "Arte-Vorpremiere in Anwesenheit des Regisseurs und weiteren Gästen"
    ],
    "bodycopy": [
      "Die eine Mafia gibt es nicht – zu unterschiedliche sind die mafiösen Strukturen der kampanischen „Camorra“, der kalabresischen „`Ndrangheta“, sowie der sizilianischen „Cosa Nostra“ und ihrer jeweiligen Geschichte. Bernd Pfletschinger hat sich auf die Suche nach den Wurzeln und der Entwicklung der einzelnen Organisationen gemacht und zeigt, wie tief deren Organisation in der Geschichte Italiens und ihrer Bevölkerung verankert ist. Doch sind diekriminellen Machenschaften nicht auf Italien begrenzt, sondern internationalisieren sich zunehmend und werden damit zur Bedrohung für die Demokratien der Welt. In diesem Film kommen Historiker, Strafrichter und Angehörige von Opfern mit ihren Einsichten und Erinnerungen zu Wort und versuchen den unaufhaltsame Aufstieg und die fast grenzenlose Macht der Mafien zu erklären. Bernhard Pfletschinger wird seinen Film vorstellen und mit weiteren Gästen mit dem Publikum sprechen. Mit einem Umtrunk im Foyer wird er Abend ausklingen."
    ],
    "image": "moerderische-gesellschaften.jpg"
  },
  {
    "title": "NAPOLI VELATA (DAS GEHEIMNIS VON NEAPEL)",
    "director": "Ferzan Özpetek",
    "country": "Italien",
    "releaseYear": 2017,
    "runtime": 112,
    "version": "OmU",
    "screeningDate": "21.02.2019",
    "readableDate": "2019-02-21",
    "screeningTime": "20:00",
    "actors": "Giovanna Mezzogiorno, Alessandro Borghi, Anna Bonaiuto, Peppe Barra, Biagio Forestieri, Lina Sastri, Isabella Ferrari, Luisa Ranieri, Maria Pia Calzone, Carmine Recano, Loredana Cannata, Angela Pagano, Maria Luisa Santella",
    "subtitle": [
      "In diesem Film ist keinem Bild zu trauen. Özpetek schafft eine künstliche Welt in der realen und spielt umfangreich mit Genregrenzen. Es entsteht eine reich bebilderte, enigmatische Atmosphäre, die den Zuschauer immer wieder irritiert und das Gesehene in neuem Licht erscheinen lässt. Der Zuschauer wird am Ende mit der Frage aus dem Kinosaal geschickt, was er da wirklich gesehen hat."
    ],
    "bodycopy": [
      "Die Gerichtsmedizinerin Adriana, die ihre jugendlichen Jahre hinter sich gelassen hat, wird auf einer eleganten Party von dem jüngeren und attraktiven Andrea angesprochen und verführt. Er schwört ihr Liebe, erscheint am Folgetag jedoch nicht am verabredeten Treffpunkt. Stunden später liegt er hingegen brutal ermordet und mit ausgestochenen Augen auf ihrem Seziertisch.",
      "Als sie ihn später in Neapels Gassen und schließlich sogar in ihrem Garten sieht, zweifelt sie an ihrem Verstand. Währenddessen wird sie von der Polizei verdächtigt, den Mord begangen zu haben und Adriana, von ihren Eindrücken und Erinnerungen verwirrt, verstrickt sich in Widersprüche. Das wird nicht besser, als sich der vermeintlich Tote als Lebender materialisiert. Zwar stellt sich schnell eine Erklärung dafür ein, doch kann man ihr trauen?"
    ],
    "image": "napoli-velata.jpg"
  },
  {
    "title": "NIRVANA (Jagd im Cyberspace)",
    "director": "Gabriele Salvatores",
    "country": "Italien/Frankreich",
    "releaseYear": 1997,
    "runtime": 112,
    "version": "OmU",
    "screeningDate": "15.03.2007",
    "readableDate": "2007-03-15",
    "screeningTime": "19:00",
    "actors": "Christopher Lambert, Diego Abantantuono, Stefania Rocca, Emmanuelle Seigner, Amanda Sandrelli",
    "subtitle": [""],
    "bodycopy": [
      "\"Was mache ich hier, und warum bin ich hier und nicht woanders?“ Diese Frage stellt sich Solo, Protagonist eines Computerspiels, der durch einen Virus Bewusstsein erlangt hat, aber als virtuelle Figur zu Wiederholung immer wieder des gleichen „Lebens“ verdammt ist. So nimmt er Kontakt mit seinem „Schöpfer“ auf und bittet ihn, das Programm zu zerstören. Mit diesem Film lotet Salvatores Grundfragen der realen menschlichen Existenz im modernen Gewand der virtuellen Realität aus. Ein in Deutschland zu Unrecht kaum wahrgenommener Film, der nur noch selten zu sehen ist.\""
    ],
    "image": "nirvana.gif"
  },
  {
    "title": "NOME DI DONNA (NOME DI DONNA)",
    "director": "Marco Tullio Giordana",
    "country": "Italien",
    "releaseYear": 2018,
    "runtime": 87,
    "version": "OmU",
    "screeningDate": "16.05.2019",
    "readableDate": "2019-05-16",
    "screeningTime": "20:00",
    "actors": "Cristiana Capotondi, Anita Kravos, Michela Cescon, Stefano Scandaletti, Bebo Storti, Laura Marinoni, Anita Kravos, Stefania Monaco",
    "subtitle": [
      "Hätte die Produktion des Films nicht vor dem Anfang der “Me-too-Bewegung” begonnen, könnte man meinen, er sei der perfekte Kommentar zum Thema. Kollegiale Freundschaft und Solidarität zählt auf einmal nicht mehr. Alle wissen „Es“, viele machen aus Angst um den Arbeitsplatz, die Karriere oder aus falsch verstandener Sympathie mit und: schweigen."
    ],
    "bodycopy": [
      "Nina ist glücklich: in der Lombardei hat sie in einem gepflegten, luxuriösen Pflegeheim eine Stelle bekommen, die es ihr erlaubt, sich privat auch um ihre Tochter zu kümmern. Schnell lebt sie sich in ihre neue Arbeit ein und schließt Freundschaft mit ihren Kolleginnen. Als sie unerwartet zu einem Gespräch nach Dienstschluss zum Leiter der Klinik gebeten wird, weiß sie nicht,was sie davon halten soll. Auf Fragen antworten die Kolleginnen ausweichend und so geht sie, für den Heimweg gekleidet zum Termin. Warum sie nicht in ihrer Dienstkleidung erschienen sei, ist die erst Frage des Leiters und schnell wird deutlich, dass er fetischorientiert sexuelle Ansprüche geltend machen will.",
      "Als Nina versucht, die Kolleginnen anzusprechen und ihnen zu verstehen gibt, dass sie sich den Übergriffen widersetzt hat, wird sie immer mehr isoliert und gemobbt. Auch der Pfarrer, der ihr die Stelle vermittelt hat, meint, nicht weiterhelfen zu können. Der kirchliche Direktor der Einrichtung versucht sie zuerst zu beschwichtigen, geht dann aber immer mehr zu empfindlichen Drohungen über.",
      "Unterstützt wird Nina durch eine soziale Einrichtung, deren Mitglieder zuerst aber auch nichts ausrichten können. Doch dann kann Nina den Kampf aufnehmen."
    ],
    "image": "nome-di-donna.jpg"
  },
  {
    "title": "NON CI È STATO REGALATO NIENTE (geschenkt WURDE uns NICHTS)",
    "director": "Eric Esser",
    "country": "Deutschland",
    "releaseYear": 2014,
    "runtime": 58,
    "version": "OmU",
    "screeningDate": "19.11.2015",
    "readableDate": "2015-11-19",
    "screeningTime": "20:00",
    "actors": "Anita „Laila” Malavasi, Pierina „Iva Bonilauri”, Gina „Sonia” Moncigoli u.a.",
    "subtitle": [""],
    "bodycopy": [
      "Ein Porträt von Anita Malavasi, die 1943 mit 22 Jahren als Partisanin „Leila“ gegen die deutsche Besatzung durch die Nationalsozialisten kämpfte und eine der wenigen weiblichen Kommandanten des italienischen Widerstands war. Sie und zwei Genossinnen erzählen von ihrer Zeit in der Resistenza und deren Bedeutung für eine lebenslange Emanzipation."
    ],
    "image": "non-ci-e-stato-regalato-niente.png"
  },
  {
    "title": "Non è giusto (Es ist nicht fair)",
    "director": "Antonietta De Lillo",
    "country": "Italien",
    "releaseYear": 2001,
    "runtime": 102,
    "version": "OmU",
    "screeningDate": "14.05.2004",
    "readableDate": "2004-05-14",
    "screeningTime": "19:30",
    "actors": "Maddalena Polistina, Daniel Podromo, Antonio Manzini, Valerio Binasco",
    "subtitle": [""],
    "bodycopy": [
      "Valerio lebt bei seiner Mutter in Stockholm. Die Sommerfe­rien soll er bei seinem chaotischen Vater in Neapel verbringen, der ihm eine Afrikareise versprochen hat. Am Strand lernt er Sofia kennen. Ihre Eltern sind ebenfalls geschieden. Valerio und Sofia tauschen Erfahrungen, Beobachtungen und Hoffnungen aus. Langsam keimen erste Anzeichen erwa­chender Gefühle..."
    ],
    "image": "non-e-giusto.jpg"
  },
  {
    "title": "NON ESSERE CATTIVO (TU NICHTS BÖSES)",
    "director": "Claudio Caligari",
    "country": "Italien",
    "releaseYear": 2015,
    "runtime": 100,
    "version": "OmU",
    "screeningDate": "21.12.2017",
    "readableDate": "2017-12-21",
    "screeningTime": "20:00",
    "actors": "Luca Marinelli, Alessandro Borghi, Silvia D'Amico, Roberta Mattei, Valentino Campitelli, Alessandro Bernardini, Danilo Cappanelli, Manuel Rulli, Elisabetta De Vito",
    "subtitle": [
      "Pasolinis “Ragazzi di vita” (Straßenjungen), versetzt in unsere Zeit: Drogen, Sex und Konsum bestimmen ihr Leben mit Müßiggang, Kleinkriminalität und immer wieder ausbrechender eruptiver Gewalt. "
    ],
    "bodycopy": [
      "Vittorio und Cesare versuchen mit Drogen und Nachtlokalbesuchen die Leere ihres Lebens zu füllen. Finanziert werden die Exzesse durch Drogengeschäfte im kleinen Stil und Überfälle auf Kioske. Als Vittorio sich verliebt, versucht er, einen Weg ins geregelte Leben zu finden. Cesare hingegen verstrickt sich immer mehr in Drogenkonsum und –handel und kommt mit Vittorios Hilfeversuchen nicht zurecht.",
      "Anhand einer kleinen Geschichte entfaltet sich das Bild eines Milieus sozial Marginalisierter, wie es das italienische Kino seit dem Neorealismus selten geschaffen hat. Es werden keine großen filmischen Gesten benötigt, um diese Welt zu etablieren, es reichen die großartig ausgewählten und von Maurizio Calvesi (VIVA LA LIBERTÀ (DIE GROSSE FREIHEIT), MINE VAGANTI (MÄNNER AL DENTE)) beeindruckend fotografierten Originalschauplätze, die für sich selbst sprechen: nicht asphaltierte Straßen vor baufälligen Häusern, verdreckte Sandstrände, die sich freilich jederzeit zu malerischen Meerespanoramen weiten können, ausgebleichte Steinmauern und viele mehr."
    ],
    "image": "non-essere-cattivo.jpg"
  },
  {
    "title": "Non pensarci (Nicht daran denken)",
    "director": "Gianni Zanasi",
    "country": "Italien",
    "releaseYear": 2007,
    "runtime": 104,
    "version": "OmU",
    "screeningDate": "15.09.2011",
    "readableDate": "2011-09-15",
    "screeningTime": "20:00",
    "actors": "Valerio Mastandrea, Anita Caprioli, Giuseppe Battiston, Teco Celio, Gisella Burinato, Caterina Murino, Paolo Briguglia, Dino Abbrescia",
    "subtitle": [""],
    "bodycopy": [
      "Generationen- und Geschwisterkonflikt, Identitätskrisen undBeziehungsprobleme. Hollywood würde daraus melodramatisches Kapitalschlagen. Zanasi erzählt auf italienische Art mit Augenzwinkern die Geschichte eines leichtlebigen Punk-Musikers, in den in kurzer Zeit alle Familienmitglieder ihre Stütze zu finden hoffen. Der Film ist ein unterhaltsames und sensibel beobachtetes Bild der italienischen Mittelstandsgesellschaft unserer Tage."
    ],
    "image": "non-pensarci.jpg"
  },
  {
    "title": "Novecento (1900)",
    "director": "Bernardo Bertolucci",
    "country": "Italien/Frankreich/Deutschland",
    "releaseYear": 1976,
    "runtime": 310,
    "version": "OmU",
    "screeningDate": "06.07.2011",
    "readableDate": "2011-07-06",
    "screeningTime": "18:00",
    "actors": "Robert De Niro, Gérard Depardieu, Dominique Sanda, Stefania Sandrelli, Laura Betti, Donald Sutherland, Burt Lancaster Berlinghieri, Sterling Hayden, Werner Bruhns, Romolo Valli, Anna Maria Gherardi, Roberto Maccanti, Paolo Pavesi, Alida Valli, Anna Henkel, Stefania Casini, Francesca Bertini, Ellen Schwiers",
    "subtitle": ["150 Jahre Italien"],
    "bodycopy": [
      "Zwei am selben Tag zur Jahrhundertwende auf einem Gut geborene Männer sind als Kinder befreundet, werden aber durch historische Umstände und soziale Herkunft auf dem Lebensweg zu Gegnern. Auf diesem Hintergrund entwirft Betrolucci ein fulminantes Bild der politischen und sozialen Entwicklung Italiens von der Jahrhundertwende bis zum Ende des Faschismus. Wir zeigen Teil 1 und 2,unterbrochen von einer kurzen Pause."
    ],
    "image": "novecento.jpg"
  },
  {
    "title": "NUOVOMONDO (GOLDEN DOOR)",
    "director": "Emanuele Crialese",
    "country": "Italien/Frankreich",
    "releaseYear": 2006,
    "runtime": 118,
    "version": "OmU",
    "screeningDate": "20.02.2014",
    "readableDate": "2014-02-20",
    "screeningTime": "20:00",
    "actors": "Charlotte Gainsbourg, Vincenzo Amato, Aurora Quattrocchi, Francesco Casisa, Filippo Pucillo, Federica de Cola, Isabella Ragonese, Vincent Schiavelli, Massimo Laguardia, Filippo Luna, Adrea Prodan, Ernesto Mahierux",
    "subtitle": ["Höhepunkte aus 10 Jahren „Italienischer Filmclub“"],
    "bodycopy": [
      "Anfang des 20. Jahrhunderts: In Sizilien herrscht bittere Not. Dies verführt den ungebildeten verwitweten Bauern, den Legenden des Traumlandes USA zu folgen und mit seiner Familie auszuwandern. Auf der Reise gesellt sich eine geheimnisvolle elegante Engländerin zu der Gruppe (Charlotte Gainsbourg in einer unvergesslichen Rolle). Nicht nur die Überfahrt, auch die harte Prüfung der Neuankömmlinge auf Ellis Island fordert den Auswanderern viel ab. Dieser intensive und bildgewaltige Film erhielt beim Filmfestival Venedig den Goldenen Löwen."
    ],
    "image": "nuovomondo.jpg"
  },
  {
    "title": "NUOVOMONDO (Golden Door)",
    "director": "Emanuele Crialese",
    "country": "Italien/Frankreich",
    "releaseYear": 2006,
    "runtime": 118,
    "version": "OmU",
    "screeningDate": "15.11.2007",
    "readableDate": "2007-11-15",
    "screeningTime": "19:00",
    "actors": "Charlotte Gainsbourg, Vincenzo Amato, Aurora Quattrocchi, Francesco Casisa, Filippo Pucillo, Federica de Cola, Isabella Ragonese, Vincent Schiavelli, Massimo Laguardia, Filippo Luna, Adrea Prodan, Ernesto Mahierux",
    "subtitle": [""],
    "bodycopy": [
      "Anfang des 20. Jahrhunderts: In Sizilien herrscht bittere Not. Dies verführt den ungebildeten verwitweten Bauern, den Legenden des Traumlandes USA zu folgen und mit seiner Familie auszuwandern. Auf der Reise gesellt sich eine geheimnisvolle elegante Engländerin zu der Gruppe (Charlotte Gainsbourg in einer unvergesslichen Rolle). Nicht nur die Überfahrt, auch die harte Prüfung der Neuankömmlinge auf Ellis Island fordert den Auswanderern viel ab. Dieser intensive und bildgewaltige Film erhielt beim Filmfestival Venedig den Goldenen Löwen."
    ],
    "image": "nuovomondo2.jpg"
  },
  {
    "title": "OLTRE IL GUADO (ACROSS THE RIVER)",
    "director": "Lorenzo Bianchini",
    "country": "Italien",
    "releaseYear": 2013,
    "runtime": 88,
    "version": "OmU",
    "screeningDate": "18.03.2021",
    "readableDate": "2021-03-18",
    "screeningTime": "20:00",
    "actors": "Lidia Zabrieszach, Marco Marchese, Renzo Gariup",
    "subtitle": [""],
    "bodycopy": [
      "Die zur Überwachung von Tieren aufgestellten Kameras führen einen Verhaltensforscher in ein entlegenes Dorf, auf dem ein alter Fluch lastet. Starker Regen verursacht eine Überflutung, die den einzigen Zugang abschneidet... Mit rätselhaften Bildern meldet sich das Horrorgenre aus Italien zurück und präsentiert einen modernen, unter die Haut gehenden Film."
    ],
    "image": "il-guado.jpg"
  },
  {
    "title": "Orecchie (Ohrensausen)",
    "director": "Alessandro Aronadio",
    "country": "Italia",
    "releaseYear": 2016,
    "runtime": 90,
    "version": "OmU",
    "screeningDate": "31.10.2019",
    "readableDate": "2019-10-31",
    "screeningTime": "20:00",
    "actors": "Daniele Parisi, Silvia D'Amico, Rocco Papaleo, Pamela Villoresi, Ivan Franek, Piera Degli Esposti, Milena Vukotic, Paolo Giovannucci, Andrea Purgatori, Massimo Wertmüller, Francesca Antonelli, Niccolò Senni, Masaria Colucci, Silvana Bosi, Sonia Gessner",
    "subtitle": [
      "In Schwarz-Weiss gedreht, behandelt diese Komödie beiläufig existenzielle Fragen in einer Aufeinanderfolge augenzwinkernder, skurriler und absurder Situationen. Eine strenge Fotografie und ein fast akademischer Bildaufbau schaffen dazu eine Ernsthaftigkeit vermittelnde Kontrastfolie.",
      "In Zusammenarbeit mit dem Italienischen Kulturinstitut Köln.",
      "Mit der freundlicher Unterstützung des Hotel Orangerie, Düsseldorf."
    ],
    "bodycopy": [
      "Er wird morgens mit einem Pfeifen im Ohr wach ... und es den ganzen Film über nicht mehr los. Am Kühlschrank findet Er einen Zettel „Dein Freund Luigi ist tot.“ Wer aber ist dieser Luigi? Das ist der Start in einen tragikomischen Tag mit sadistischen Ärzten, aufdringlichen Nonnen, einem Hip-Hop-Star im abgefahrenen Ambiente, der Frage, wie Er seiner Verlobten ein Lächeln entlocken kann, und der Begegnung mit der Mutter, die mit einem „Performance“-Künstler ihren neuen Frühling durchlebt. Und da ist immer wieder dieser Luigi, an den er sich beim besten Willen nicht erinnern kann."
    ],
    "image": "orecchie-5.jpg"
  },
  {
    "title": "Otto e mezzo (Achteinhalb)",
    "director": "Federico Fellini",
    "country": "Italien/Frankreich",
    "releaseYear": 1962,
    "runtime": 138,
    "version": "OmitU",
    "screeningDate": "03.05.2006",
    "readableDate": "2006-05-03",
    "screeningTime": "18:00",
    "actors": "Marcello Mastroianni, Claudia Cardinale, Anouk Aimée, Sandra Milo, Barbara Steele, Rossella Falk, Madeleine Lebeau, Guido Alberti, Caterina Boratto, Giuditta Rissone, Annibale Ninchi",
    "subtitle": [""],
    "bodycopy": [
      "Selbstporträt oder Spielen mit und gegen die Erwartungen seines Publikums? Der Film erzählt von einem ausgebrannten Regisseur, der passiv den Vorbereitungen zu seinem nächsten Film zusieht, den er nie drehen wird. Thematisiert Fellini damit seine eigene Schaffenskrise? Wohl kaum, denn der Film sprengt die formalen Konventionen seiner Zeit und gilt als eines von Fellinis Meisterwerken."
    ],
    "image": "otto-e-mezzo.jpg"
  },
  {
    "title": "Pane e tulipani (Brot und Tulpen)",
    "director": "Silvio Soldini",
    "country": "Italien",
    "releaseYear": 2000,
    "runtime": 118,
    "version": "OmU",
    "screeningDate": "21.02.2009",
    "readableDate": "2009-02-21",
    "screeningTime": "20:00",
    "actors": "Licia Maglietta, Bruno Ganz, Giuseppe Battiston, Antonio Catania, Marna Massironi, Felice Andreasi",
    "subtitle": ["Werkschau Silvio Soldini"],
    "bodycopy": [
      "Die „Abstimmung mit den Füßen“ hat diesen Film zu Soldinis größtem Erfolg gemacht. Humorvoll beschreibt er die Geschichte der an einem Rastplatz vergessenen unscheinbaren Hausfrau und Mutter zur selbstbewussten Frau. Kommödienhaft und zugleich tief menschlich begegnet sie originellen und skurrilen Menschen und bahnt sich ihren eigenen Weg. Besonders: Bruno Ganz als isländischer Kellner in einem heruntergekommenen Restaurant in Venedig."
    ],
    "image": "pane-e-tulipani.jpg"
  },
  {
    "title": "Pane e tulipani (Brot und Tulpen)",
    "director": "Silvio Soldini",
    "country": "Italien/Schweiz",
    "releaseYear": 2000,
    "runtime": 115,
    "version": "OmU",
    "screeningDate": "19.02.2004",
    "readableDate": "2004-02-19",
    "screeningTime": "19:30",
    "actors": "Licia Maglietta, Bruno Ganz, Giuseppe Battiston, Antonio Catania",
    "subtitle": [""],
    "bodycopy": [
      "Bruno Ganz sitzt in seiner Rolle als isländischer Kellner Fernando vor einem Strauß verwelkender Tulpen und je mehr die Blütenblätter fallen, desto stärker wird sein Entschluss, Rosalba (Licia Maglietta) vor die Frage ihres Lebens zu stellen. In diesem Moment aber neigt sich der Film schon seinem Ende zu und es bleibt nur noch abzuwarten, welche Konsequenzen die Beteiligten aus ihren Erfahrungen ziehen werden.",
      "Weil ihre Familie sie auf einer Autobahnraststätte vergessen hatte, war Rosalba im venezianischen Restaurant „gestrandet“, in dem Fernando arbeitet. Zwischen beiden entwickelt sich eine diskrete menschliche Beziehung, um die sich eine „tatkräftige“ Masseurin und ein von Rosalbas Mann beauftragter Amateurdetektiv scharen.",
      "„Eine erotische Komödie ohne nacktes Fleisch, die auf den holzschnitzartigen Gestus mancher deutschen Komödie verzichten kann.“, urteilte ein Zuschauer im Cineforum.",
      "Einer der erfolgreichsten Programmkinofilme der letzten Jahre in Düsseldorf. Meist nur in der Synchronfassung gezeigt, gibt es hier eine der seltenen Gelegenheiten, in der Originalversion (mit deutschen Untertiteln) unter anderem Bruno Ganz anrührend italienisch reden zu hören."
    ],
    "image": "pane-e-tulipani2.jpg"
  },
  {
    "title": "Pane, amore e... (Liebe, Brot und 1000 Küsse)",
    "director": "Dino Risi",
    "country": "Italien",
    "releaseYear": 1955,
    "runtime": 98,
    "version": "OmU",
    "screeningDate": "07.07.2010",
    "readableDate": "2010-07-07",
    "screeningTime": "20:00",
    "actors": "Vittorio De Sica, Sophia Loren, Lea Padovani, Antonio Cifariello, Tica Pica, Mario Carotenuto, Yoka Berretty, Virgilio Riento",
    "subtitle": ["Werkschau: Dino Risi"],
    "bodycopy": [
      "Als Luigi Comencini keine weitere Folge eines Pane-Amore- Films drehen wollte, trat Sophia Loren kurzerhand in die Rolle von Gina Lollobrigida ein und der junge Dino Risi übernahm die Regie. Vittorio de Sica spielt den Polizeikommandanten Carotenuto, der bei der Rückkehr in den Heimatort seine Wohnung von einer widerborstigen Schönheit bewohnt vorfindet. Das stellt die Unwiderstehlichkeit des selbstbewussten Casanovas ziemlich auf die Probe. Eine typische Commedia all’Italiana."
    ],
    "image": "pane-amore.jpg"
  },
  {
    "title": "PASQUALINO SETTEBELLEZZE (Sieben Schönheiten)",
    "director": "Lina Wertmüller",
    "country": "Italien",
    "releaseYear": 1975,
    "runtime": 116,
    "version": "OmU",
    "screeningDate": "16.10.2008",
    "readableDate": "2008-10-16",
    "screeningTime": "19:00",
    "actors": "Giancarlo Giannini, Fernando Rey, Shirley Stoler, Elena Fiore",
    "subtitle": ["Lina Wertmüller zum 80. Geburtstag"],
    "bodycopy": [
      "Ein neapolitanischer Gangster weiß, was er der Ehre schuldet: Er bringt den Liebhaber einer seiner sieben Schwestern um. Als er auf seinem Lebensweg ins KZ kommt, kann er nur durch Liebesdienste für eine hässlich-sadistische Aufseherin überleben. Die Frage nach der Moralstellt sich auf einmal neu. \"Ein effektvoll inszeniertes Groteskmelodram, makaberer Humor.\" – „Einer der wichtigsten Filmeder 70er Jahre, der sowohl als schräge Komödie wie als Anti-Kriegsfilm funktioniert.\""
    ],
    "image": "pasqualino-settebellezze.jpg"
  },
  {
    "title": "Pianese Nunzio - 14 anni a maggio (Pianese Nunzio – Vierzehn im Mai)",
    "director": "Antonio Capuano",
    "country": "Italien",
    "releaseYear": 1996,
    "runtime": 115,
    "version": "OmU",
    "screeningDate": "16.03.2006",
    "readableDate": "2006-03-16",
    "screeningTime": "19:30",
    "actors": "Fabrizio Bentivoglio, Emanuele Gargiulo, Rosaria De Cicco, Teresa Saponangelo, Tonino Taiuti",
    "subtitle": [""],
    "bodycopy": [
      "Als der Priester Lorenzo in Neapel beginnt, gegen die Camorra zu agitieren, versucht diese, dessen Freundschaft mit dem 13-jährigen Nunzio für eine Rufmordkampagne zu nutzten. Doch es erweist sich für Camorra, Polizei und gehobene Gesellschaft als gar nicht so einfach, an den aus zerrütteten Familienverhältnissen stammenden Jungen heranzukommen. Als Lorenzo bemerkt, dass Nunzio sich durch sein Schweigen in Gefahr bringt, beginnt er zu handeln.Als der Priester Lorenzo in Neapel beginnt, gegen die Camorra zu agitieren, versucht diese, dessen Freundschaft mit dem 13-jährigen Nunzio für eine Rufmordkampagne zu nutzten. Doch es erweist sich für Camorra, Polizei und gehobene Gesellschaft als gar nicht so einfach, an den aus zerrütteten Familienverhältnissen stammenden Jungen heranzukommen. Als Lorenzo bemerkt, dass Nunzio sich durch sein Schweigen in Gefahr bringt, beginnt er zu handeln.Dieser vor zehn Jahren gedrehte Film hat durch die Weisung des Vatikans zu homosexuellen Priestern eine neue Aktualität erhalten."
    ],
    "image": "pianese-nunzio.jpg"
  },
  {
    "title": "Piazza delle Cinque Lune",
    "director": "Renzo Martinelli",
    "country": "Italia/Gran Bretagna",
    "releaseYear": 2003,
    "runtime": 125,
    "version": "OmitU",
    "screeningDate": "02.11.2011",
    "readableDate": "2011-11-02",
    "screeningTime": "20:00",
    "actors": "Donald Sutherland, Giancarlo Giannini, Stefania Rocca, F. Murray Abraham, Aisha Cerami, Greg Wise, Nicola Di Pinto, Pino Calabrese, Federica Martinelli, Massimo Tellini, Philippe Leroy",
    "subtitle": ["150 Jahre Italien"],
    "bodycopy": [
      "Gerade von seiner Verabschiedung in den Ruhestand zurückgekehrt, erhält der Provinzrichter Saracini einen Super-8-Film. Zu seiner Überraschung zeigt dieser die Entführung Aldo Moros vor 25 Jahren und wirft ganz neue Fragen auf. Sein todkranker Informant war am Attentat beteiligt und will sein Wissen nicht mit ins Grab nehmen. So rollen der pensionierte Saracini und seine Nachfolgerin diskret den Fall wieder auf und legen Verstrickungen und Vertuschungen frei. Ein spannender Politthriller."
    ],
    "image": "piazza-delle-cinque-lune.jpg"
  },
  {
    "title": "PRANZO DI FERRAGOSTO (DAS FESTMAL IM AUGUST)",
    "director": "Gianni Di Gregorio",
    "country": "Italien",
    "releaseYear": 2008,
    "runtime": 75,
    "version": "OmU",
    "screeningDate": "16.08.2012",
    "readableDate": "2012-08-16",
    "screeningTime": "20:00",
    "actors": " Gianni Di Gregorio, Valeria De Franciscis, Alfonso Santagata, Marina Cacciotti, Maria Cali, Grazia Cesarini Sforza",
    "subtitle": [""],
    "bodycopy": [
      "Da er sich schon so fürsorglich um seine Mutter kümmert, lädt ein Freund auch seine Mutter für die Urlaubszeit bei ihm ab. Das Beispiel macht Schule und schließlich findet er sich als Diener und Unterhalter von fünf sehr aktiven Seniorinnen wieder. Eine sommerlich Kommödie zum „demografischen Faktor“."
    ],
    "image": "pranzo-di-ferragosto.jpg"
  },
  {
    "title": "PREFERISCO IL RUMORE DEL MARE (Ich liebe das Rauschen des Meeres)",
    "director": "Mimmo Calopresti",
    "country": "Italien",
    "releaseYear": 2000,
    "runtime": 84,
    "version": "OmU",
    "screeningDate": "21.06.2012",
    "readableDate": "2012-06-21",
    "screeningTime": "20:00",
    "actors": "Silvio Orlando, Polo Cirio, Fabrizio Sacchi, Michele Raso, Mimmo Calopresti, Andrea Occhipinti, Lorenzo Ventavoli",
    "subtitle": [""],
    "bodycopy": [
      "Luigi meint es gut, als er den aus ärmlichen Verhältnissen in Kalabrien stammenden Rosario nach Turin bringt. Versuche, ihn mit seinem Sohn anzufreunden, scheitern an sozialen und charakterlichen Problemen."
    ],
    "image": "preferisco-il-rumore-del-mare.jpg"
  },
  {
    "title": "Puccini e la fanciulla",
    "director": "Paolo Benvenuti, Paola Baroni",
    "country": "Italien",
    "releaseYear": 2009,
    "runtime": 78,
    "version": "S",
    "screeningDate": "16.09.2012",
    "readableDate": "2012-09-16",
    "screeningTime": "20:00",
    "actors": "Riccardo Moretti, Tania Squiliano, Giovanna Daddi, Debora Mattiello, Federica Chezzi",
    "subtitle": ["Ohne Dialoge"],
    "bodycopy": [
      "Während Puccini seine Oper „La fanciulla del West“ komponiert, verfangen sich die Personen in seiner Umgebung in sexuellen Intrigen und Beziehungen. Das beeinflusst auch Puccini und seinen Schaffensprozess."
    ],
    "image": "puccini-e-la-fanciulla.jpg"
  },
  {
    "title": "Qualunquemente",
    "director": "Giulio Manfredonia",
    "country": "Italien",
    "releaseYear": 2011,
    "runtime": 93,
    "version": "OmitU",
    "screeningDate": "01.02.2012",
    "readableDate": "2012-02-01",
    "screeningTime": "20:00",
    "actors": "Antonio Albanese, Sergio Rubini, Lorenza Indovina, Davide Giordano, Salvatore Cantalupo",
    "subtitle": [""],
    "bodycopy": [
      "Als zeitgemäße Weiterentwicklung der anspruchsvolleren Form der Comedia all’Italiana hat Manfredonia eine Satire auf das Berlusconi-Regieme gedreht. Als der Unternehmer Cetto La Qualunque erwarten muss, dass Gesetze gegen ihn angewendet werden („Steuern erheben, Gesetze anwenden .... ist das denn legal?“), beschließt er einfach Bürgermeister zu werden."
    ],
    "image": "qualunquemente.jpg"
  },
  {
    "title": "Quo Vadis, Baby?",
    "director": "Gabriele Salvatores",
    "country": "Italien",
    "releaseYear": 2005,
    "runtime": 105,
    "version": "OmitU",
    "screeningDate": "03.01.2007",
    "readableDate": "2007-01-03",
    "screeningTime": "19:00",
    "actors": "Angela Baraldi, Gigio Alberti, Claudia Zanella, Elio Germano, Luigi Maria Burruano, Andrea Renzi, Alessandra D'Elia, Gennaro Diana, Bebo Storti",
    "subtitle": [""],
    "bodycopy": [
      "Ein „filme noir“ dieses Starregisseurs. Angeregt durch die Tagebuchvideos ihrer Schwester, die sie Jahre nach deren Selbstmord zufällig erhält, begibt sich die Privatdetektivin Giorgia auf die Suche nach einer tragischen Vergangenheit, von der sie noch immer geprägt ist. Dieser Film ist bisher nicht in die deutschen Kinos gekommen."
    ],
    "image": "quo-vadis-baby.jpg"
  },
  {
    "title": "QUO VADO? (DER VOLLPOSTEN)",
    "director": "Gennaro Nunziante",
    "country": "Italien",
    "releaseYear": 2016,
    "runtime": 86,
    "version": "OmU",
    "screeningDate": "16.02.2017",
    "readableDate": "2017-02-16",
    "screeningTime": "20:00",
    "actors": "Checco Zalone, Eleonora Giovanardi, Sonia Bergamasco, Ludovica Modugno, Maurizio Micheli, Ninni Bruschetta, Paolo Pierobon, Lino Banfi, Azzurra Martino",
    "subtitle": [
      "STAR WARS und HARRY POTTER haben es nicht geschafft: der Publikumsliebling der Italiener war Checco Zalone in QUO VADO? ."
    ],
    "bodycopy": [
      "Die Filme mit der vom Musiker und Komiker Luca Pasquale Medici geschaffenen Kunstfigur Checco Zalone verzeichnen in Italien einen Publikumsrekord nach dem anderen. Der ich-bezogene und naiv-beharrliche Typ, der sich durch den Trubel und die Widrigkeiten der Welt nicht von seinem Weg abbringen lässt, trifft mit seinem großen Herz und seiner leidenschaftlichen Liebe offensichtlich die Befindlichkeiten der italienischen Seele.",
      "In QUO VADO? versucht Checco seinen „posto fisso“ (eine beamtenähnliche Stelle) zu verteidigen, der durch eine absurde Verwaltungsreform gefährdet ist. Das führt ihn durch absurde, amüsante und satirische Situationen, in denen auch Krisen und Erfüllungen der Liebe nicht zu kurz kommen.",
      "Mit dem Sinn für gut gesetzte Pointen und Situationskomik fügt die Figur des Checco Zalone dem italienischen Komödienfilm ein qualitativ neues Kapitel hinzu und spielt dabei auch mit Klischees und Vorurteilen."
    ],
    "image": "quo-vado.jpg"
  },
  {
    "title": "Respiro (Lampedusa)",
    "director": "Emanuele Crialese",
    "country": "Italien/Frankreich",
    "releaseYear": 2002,
    "runtime": 90,
    "version": "OmU",
    "screeningDate": "17.06.2004",
    "readableDate": "2004-06-17",
    "screeningTime": "19:30",
    "actors": "Valeria Golino, Vincenzo Amato, Francesco Casisa, Veronica D’Agostino",
    "subtitle": [""],
    "bodycopy": [
      "In Italien und Frankreich spielt der Titel dieses Films, „Respiro“, mit dem Begriffsspektrum „Atem – Ruhe – Galgenfrist“. Der deutsche  Verleih bevorzugte den Namen der Insel „Lampedusa“ Filmtitel. Die englische Fassung konzentriert mit dem Titel „Gracia’s Island“ den ganzen Film auf die Hauptdarstellerin. Diese unterschiedliche Betitelung weist auf die Vielfalt der möglichen Sichtweisen dieses Films hin.",
      "Grazia, eine junge Mutter neigt zu extremen Reaktionen zwischen Euphorie und Depression und ihr Egozentrismus ist den Inselbewohnern verdächtig. „La matta“ soll ärztlicher Aufsicht unterstellt werden, einem Verlangen, dem sich schließlich auch ihr Ehemann beugt. Um das zu verhindern, inszeniert ihr Sohn Pasquale ein mysteriöses Verschwinden und eine große Suchaktion. So weit, so kurz die Geschichte.",
      "Doch dieser Film erzählt auch die Geschichte einer nackten, unter der Sonne brütenden Landschaft, erzählt von den Problemen heranwachsender Kinder untereinander, aber auch von deren Schwierigkeiten, mit den Streitigkeiten der Eltern umzugehen. Nicht zuletzt ist dieser Film aber auch eine Sozialstudie des Gleichgewichts von Individualität und Gemeinschaft.",
      "Und wem dies nicht genügt, kann sich an der ästhetischen Fotografie von Fabio Zamarion erfreuen."
    ],
    "image": "respiro.jpg"
  },
  {
    "title": "Ribelli per caso (Die Rebellion)",
    "director": "Vincenzo Terracciano",
    "country": "Italien",
    "releaseYear": 2001,
    "runtime": 100,
    "version": "OmU",
    "screeningDate": "02.05.2009",
    "readableDate": "2009-05-02",
    "screeningTime": "20:00",
    "actors": " Antonio Catania, Giovanni Esposito, Franco Javarone, Renato Scarpa",
    "subtitle": [
      "Fünf Highlights aus fünf Jahren „Italienischer Filmclub“ in der Black Box"
    ],
    "bodycopy": [
      "Im Krankenhaus der Hausordnung genügen und dabei Diät halten! Da muss man doch für Abhilfe sorgen. Und plötzlich steht das Krankenhaus Kopf: eine zufällig entstandene Rebellion des Genusses und der Freude am Leben gegen kleine und große Katastrophen, die es begleiten."
    ],
    "image": "ribelli-per-caso.jpg"
  },
  {
    "title": "Ribelli per caso (Die Rebellion)",
    "director": "Vincenzo Terracciano",
    "country": "Italien",
    "releaseYear": 2001,
    "runtime": 100,
    "version": "OmU",
    "screeningDate": "20.05.2004",
    "readableDate": "2004-05-20",
    "screeningTime": "19:30",
    "actors": "Antonio Catania, Giovanni Esposito, Franco Javarone, Renato Scarpa",
    "subtitle": [""],
    "bodycopy": [
      "Gibt es Wichtigeres als Genuss und Lebensfreude? Leider gibt es auch Krankheiten, Krankenhäuser und deren Personal. Unterstützt von Verwandten versuchen Ärzte und Krankenschwestern jeglichen Gaumenkitzel von ihren Patienten fern zu halten, alles zum Wohl ihrer Kranken. Die empfinden das aber ganz anders, denn welche Perspektive bietet ein Leben mit Verzicht auf die Vielfalt der italienischen Küche?",
      "Und so organisieren ein Lehrer, ein Obstverkäufer, ein Angestellter, ein Weinhändler und ein Bankangestellter, die der Zufall in einem Krankenhauszimmer zusammengeführt hat, heimlich ein Bankett im Krankenzimmer. Zuerst scheint dieses aberwitzige Unternehmen tatsächlich zu funktionieren, doch dann reiht sich eine kleine Panne an die andere und schließlich steht das ganze Krankenhaus Kopf: eine zufällig entstandene Rebellion des Genusses und der Lebensfreude gegen kleine und große Katastrophen des Lebens, aber auch gegen das, was wir häufig zu schnell als „vernünftig“ akzeptieren."
    ],
    "image": "ribelli-per-caso.jpg"
  },
  {
    "title": "Ribelli per caso (DIE REBELLION)",
    "director": "Vincenzo Terracciano",
    "country": "Italien",
    "releaseYear": 2001,
    "runtime": 100,
    "version": "OmU",
    "screeningDate": "16.01.2014",
    "readableDate": "2014-01-16",
    "screeningTime": "20:00",
    "actors": "Antonio Catania, Giovanni Esposito, Franco Javarone, Renato Scarpa",
    "subtitle": ["Höhepunkte aus 10 Jahren „Italienischer Filmclub“"],
    "bodycopy": [
      "Im Krankenhaus der Hausordnung genügen und dabei Diät halten! Da muss man doch für Abhilfe sorgen. Und plötzlich steht das Krankenhaus Kopf: eine zufällig entstandene Rebellion des Genusses und der Freude am Leben gegen kleine und große Katastrophen, die es begleiten."
    ],
    "image": "ribelli-per-caso2.jpg"
  },
  {
    "title": "ROCCO UND SEINE BRÜDER (ROCCO E I SUOI FRATELLI)",
    "director": "Luchino Visconti",
    "country": "Italien/Frankreich",
    "releaseYear": 1960,
    "runtime": 177,
    "version": "OmU",
    "screeningDate": "19.01.2017",
    "readableDate": "2017-01-19",
    "screeningTime": "20:00",
    "actors": " Alain Delon, Renato Salvatori, Annie Girardot, Alessandra Panaro, Katina Paxinou, Max Cartier, Spiros Focas, Rocco Vidolazzi, Claudia Cardinale, Roger Hanin, Paolo Stoppa",
    "subtitle": [
      "„Lärmende Szenen in einem Mailänder Kino, Androhung der Beschlagnahme, Anfrage im Parlament wegen Bruchs der Grundrechte, Verdammung durch die Katholische Aktion, Enthüllung eines ‚klerikalen Komplotts‘ gegen künstlerische Freiheit durch die Kommunisten, Gefährdung des italienischen Rufs im Ausland“, so addierte die Londoner TIMES in einem Bericht aus Italien die Ereignisse anlässlich der Premiere von ROCCO E I SUOI FRATELLI."
    ],
    "bodycopy": [
      "Was war geschehen?",
      "Visconti wagte es, in prüder Zeit eine Vergewaltigungsszene zu präsentieren und den Optimismus der Nachkriegsjahre mit „düsteren Darstellungen“ der sozialen Realität zu konfrontieren. Er greift zurück auf neorealistische Stilformen, um seine Erzählung episch auszubreiten. Packend erzählt er die dramatische Geschichte einer Familie aus dem Süden Italiens: eine Mutter und ihre halbwüchsigen und herangewachsenen Kinder suchen ihr Glück in Norditalien. Dabei stützen sie sich auf den ältesten Sohn, der schon im Norden lebt.",
      "Anhand eines Familienkosmos wird ein Gesellschaftsporträt Italiens der Filmentstehungszeit präsentiert. Der Mentalitätskonflikt der italienischen Süd-Nord-Migration Anfang der 60er Jahre weist dabei manche Parallelen zur heutigen Integrationsproblematik auf. Für Alain Delon war die Rolle des Rocco der Durchbruch für seine erfolgreiche Karriere."
    ],
    "image": "rocco-e-i-suoi-fratelli.jpg"
  },
  {
    "title": "Roma (Fellinis Roma)",
    "director": "Federico Fellini",
    "country": "Italien/Frankreich",
    "releaseYear": 1972,
    "runtime": 127,
    "version": "OmitU",
    "screeningDate": "18.02.2010",
    "readableDate": "2010-02-18",
    "screeningTime": "20:00",
    "actors": "Peter Gonzales, Fiona Florence, Pia De Doses, Renato Giovannoli",
    "subtitle": ["90 Jahre Fellini (20.01.1920-31.10.1993)"],
    "bodycopy": [
      "Fellinis Hommage an die Stadt Rom ist ein phantastisches Filmportrait der italienischen Realität und der Eigenarten seiner Mitmenschen. Gleichzeitig präsentiert er mit einem Augenzwinkern einen unterhaltsamen Diskurs über das cineastische Erzählen. Scheinbar unschuldig gibt er sich bei seiner ersten Begegnung mit der „großen Stadt“, um dann mit Raffinesse und enormem Aufwand Italien in all seinen absurden Facetten darzustellen."
    ],
    "image": "roma.jpg"
  },
  {
    "title": "Roma città aperta (Rom, offene Stadt)",
    "director": "Roberto Rossellini",
    "country": "Italien",
    "releaseYear": 1944,
    "runtime": 98,
    "version": "OmitU",
    "screeningDate": "01.03.2006",
    "readableDate": "2006-03-01",
    "screeningTime": "18:00",
    "actors": "Aldo Fabrizi, Anna Magnani, Marcello Pagliero, Vito Annichiarico, Harry Feist, Giovanna Galletti, Nando Bruno",
    "subtitle": [""],
    "bodycopy": [
      "Anhand miteinander verbundener Episoden erzählt Rosselini das Schicksal einer Frau aus dem Volk, eines Priesters und eines kommunistischen Ingenieurs während der deutschen Besatzung Roms 1943-44. Der Film basiert auf tatsächlichen Ereignissen, die in einem dokumentarischen Stil verfilmt wurden und Opfer und Leid der Bevölkerung unter der Besatzung zeigen."
    ],
    "image": "roma-citta-aperta2.gif"
  },
  {
    "title": "ROMEO E GIULIETTA (Romeo und Julia)",
    "director": "Franco Zeffirelli",
    "country": "talien/Großbritannien",
    "releaseYear": 1968,
    "runtime": 133,
    "version": "OmU",
    "screeningDate": "20.12.2007",
    "readableDate": "2007-12-20",
    "screeningTime": "19:30",
    "actors": "Leonard Whiting, Olivia Hussey, John McEnery, Milo O'Shea, Pat Heywood, Robert Stephens, Michael York, Bruce Robinson",
    "subtitle": [""],
    "bodycopy": [
      "Zeffirellis legendäre Verfilmung des Shakespearedramas hat auch heute nichts an Faszinität verloren. Zeffirelli hat für die Rollen von Romeo und Julia den 17jährigen Leonard Whiting und die 15jährige Olivia Hussey gewählt, beide damals vollkommen unbekannt, um der Vorlagegerecht zu werden. Auch in Kostümen und Schauplätzen suchte er die Nähe zum Original. Herausgekommen ist eine schauprächtige Bildkomposition mit einer schauspielerischen Darstellung, die den Menschen in seinen tragischen Verstrickungen zeigt. Auch wenn man das Ende kennt: Man wünscht den beiden jungen Menschen, dass es anders ausgehen möge. (4 Oscar-Nominierungen, 7 BAFTA Award-Nominierungen, 5 Golden-Globe-Nominierungen, davon 3 mit Auszeichnung, 5 SilverRibbon-Auszeichnungen, 1 National Board of Review, 2 Laurel Awards)."
    ],
    "image": "romeo.jpg"
  },
  {
    "title": "Sacco e Vanzetti (Sacco und Vanzetti)",
    "director": "Giuliano Montaldo",
    "country": "Italien",
    "releaseYear": 1971,
    "runtime": 120,
    "version": "OmitU",
    "screeningDate": "05.04.2006",
    "readableDate": "2006-04-05",
    "screeningTime": "18:00",
    "actors": "Gian Maria Volonté, Riccardo Cucciolla, Cyril Cusack, Rosana Fratello, Geoffrey Keen, Milo O'Shea, William Prince, Claude Mann",
    "subtitle": [""],
    "bodycopy": [
      "Boston 1920: zwei italienische Einwanderer, Nicola Sacco und Bartolomeo Vanzetti, werden unberechtigter Weise des Raubmordes beschuldigt. Obwohl die Verteidigung ihre Unschuld nachweisen kann, werden beide zum Tode verurteilt. Starben Sie für ihre politische Überzeugung? Beide waren bekennende Anarchisten."
    ],
    "image": "sacco.jpg"
  },
  {
    "title": "SALÒ O LE 120 GIORNATE DI SODOMA (Die 120 Tage von Sodom)",
    "director": "Pier Paolo Pasolini",
    "country": "Italien/Frankreich",
    "releaseYear": 1975,
    "runtime": 116,
    "version": "OmU",
    "screeningDate": "15.04.2010",
    "readableDate": "2010-04-15",
    "screeningTime": "20:00",
    "actors": "Paolo Bonacelli, Giorgio Cataldi, Umberto Paolo Quintavalle, Aldo Valletti, Hélène Surgére, Caterina Boratto, Elsa De Giorgi",
    "subtitle": [""],
    "bodycopy": [
      "Pasolini wohl umstrittenstes Werk. Indem er eine Gruppe Großbürger im letzten faschistischen Refugium der Mussolini-Herrschaft, der Republik von Salò, eine sadistische Orgie voller Terror veranstalten lässt, wollte er auf die sexuell-autoritären Grundlagen faschistischer Strukturen verweisen: Junge Menschen werden zusammengetrieben und als Lust- und Folterobjekte pervers zu Tode gequält, während sich die Folterer amüsieren und als Anhänger des feinen Genusses gebären. Schliengensief griff den Stoff für seinen Film DIE 120 TAGE VON BOTTROP auf, der in der Retrospektive des Käutnerpreisträgers läuft."
    ],
    "image": "salo.jpg"
  },
  {
    "title": "Salvatore Giuliano (Salvatore Giuliano)",
    "director": "Francesco Rosi",
    "country": "Italien",
    "releaseYear": 1961,
    "runtime": 107,
    "version": "OmitU",
    "screeningDate": "04.01.2006",
    "readableDate": "2006-01-04",
    "screeningTime": "18:00",
    "actors": "Pietro Cammarata, Frank Wolff, Salvo Randone, Federico Zardi, Mario Lorito Fricano, Nando Cicero, Sannunccio Benelli, Bruno Ukmar",
    "subtitle": [""],
    "bodycopy": [
      "Der damals weltbekannte Bandit Salvatore Giuliano wird am 5. Juli 1950 erschossen. Schon bei der Beweisaufnahme ergeben sich Widersprüche. Im Stil einer dokumentarischen Recherche geht Rosi in seinem Spielfilm diesen Widersprüchen nach, die sich immer mehr ausweiten. Auf diese Weise entsteht ein Bild der Verflechtungen von Politik und organisierter Kriminalität."
    ],
    "image": "salvatore-giuliano.jpg"
  },
  {
    "title": "Saturno contro (In Ewigkeit Liebe)",
    "director": "Ferzan Özpetek",
    "country": "Italien",
    "releaseYear": 2007,
    "runtime": 110,
    "version": "OmU",
    "screeningDate": "21.07.2011",
    "readableDate": "2011-07-21",
    "screeningTime": "20:00",
    "actors": "Pierfrancesco Favino, Stefano Accorsi, Margherita Buy, Ennio Fantastichini, Ambra Angiolini, Luca Argentero, Michelangelo Tommaso, Serrra Yilmaz",
    "subtitle": [""],
    "bodycopy": [
      " Tafelfreuden sind bei Özpetek häufig Anlass Biographien verwirrender Ereignisse. Diesmal stellt die drogensüchtige Horoskopexpertin in der das homosexuelle Traumpaar Davide/Lorenzo umgebenden illustren heterosexuellen Tischgemeinschaft den „gegenläufigen Saturn“ fest. Unvermittelt erleidet Lorenzo einen Zusammenbruch und die Freunde sind plötzlich mit Fragen nach Leben und Tod konfrontiert."
    ],
    "image": "saturno-contro.jpg"
  },
  {
    "title": "Scialla! (Scialla! Eine Geschichte aus Rom)",
    "director": "Francesco Bruni",
    "country": "Italien",
    "releaseYear": 2011,
    "runtime": 95,
    "version": "OmU",
    "screeningDate": "15.01.2015",
    "readableDate": "2015-01-15",
    "screeningTime": "20:00",
    "actors": "Fabrizio Bentivoglio, Filippo Scicchitano, Barbara Bobulova, Vinicio Marchioni, Giuseppe Guarino, Prince Chidozie Manujibeya, Arianna Scommegna, Giacomo Ceccarelli, Raffaella Lebboroni, Alessandro Tuzzi",
    "subtitle": [""],
    "bodycopy": [
      "Bruno hat die Nase vom Lehrerberuf voll und sich in ein ruhiges Leben mit Nachhilfestunden und Arbeit als Ghostwriter zurückgezogen. Bis der 15-jährige Luca auf der Bildfläche erscheint: lernschwach, aber energiegeladen und ... Brunos Sohn. Die temporeiche Komödie schlägt Funken aus dem Zusammenprall dieser gegensätzlichen Charaktere. Da kann man den Protagonisten nur wünschen: „Schialla!“, römisch für „Nimm es locker!“."
    ],
    "image": "scialla.jpg"
  },
  {
    "title": "SE DIO VUOLE (UM GOTTES WILLEN)",
    "director": "Eduardo Maria Falcone",
    "country": "Italien",
    "releaseYear": 2015,
    "runtime": 87,
    "version": "OmU",
    "screeningDate": "15.11.2018",
    "readableDate": "2018-11-15",
    "screeningTime": "20:00",
    "actors": "Marco Giallini, Alessandro Gassman, Laura Morante, Ilaria Spada, Edoardo Pesce, Enrico Oetiker, Giuseppina Cervizzi",
    "subtitle": [
      "„Ist der Junge vielleicht schwul?“ Trotz seiner Arroganz und Selbstgefälligkeit merkt Tommaso, dass sein Sohn sich sonderbar benimmt. Wäre kein Problem, denn man ist ja zähneknirschend tolerant. Doch als der Filius zu erkennen gibt, dass er Priester werden will, ist es mit jedem Verständnis vorbei."
    ],
    "bodycopy": [
      "Der Herzchirurg Tommaso sonnt sich im Ansehen, das er wegen seines Erfolges genießt. Er hält sich für liberal, auch wenn er Frau und Tochter vernachlässigt und nur Augen für seinen Stammhalter hat, der Medizin studiert und in Vaters Fußstapfen treten soll. Doch als dieser sich von Gott berufen fühlt und Priester werden will, ist es mit Toleranz und Liberalität vorbei. Er sucht den Kontakt zum eigenwilligen Priester Don Pietro, den er für diese Wandlung verantwortlich macht und versucht ihn als Scharlatan zu „entlarven“.  Der jedoch dreht die Verhältnisse um und Tommaso findet sich als dessen Hilfskraft wieder. Und je mehr er zu rebellieren versucht, desto mehr entgleitet ihm sein bisheriges Leben. Eine ironische Komödie über Selbstgefälligkeit, Selbstfindung und Selbstbehauptung. Edoardo Falcone erhielt den italienischen Filmpreis David di Donatello als bester Debutregisseur."
    ],
    "image": "se-dio-vuole.jpg"
  },
  {
    "title": "Segreti di stato",
    "director": "Paolo Benvenuti",
    "country": "Italien",
    "releaseYear": 2003,
    "runtime": 85,
    "version": "OmitU",
    "screeningDate": "05.10.2011",
    "readableDate": "2011-10-05",
    "screeningTime": "20:00",
    "actors": "David Coco, Antonio Catania, Sergio Graziani, Aldo Puglisi, Francesco Guzzo",
    "subtitle": ["150 Jahre Italien"],
    "bodycopy": [
      "Anhand in den USA freigegebener staatlicher Dokumente hat Benvenuti die Ereignisse und Vertuschungsversuche des Anschlags der Portella della Ginestra im Mai1947 rekonstruiert. Entstanden ist ein visuell überzeugender Film, der nicht nur kriminelle Verbindungen aufdeckt, sondern auch ein Bild Italiens der Nachkriegszeit zeigt."
    ],
    "image": "segreti-di-stato.jpg"
  },
  {
    "title": "SEI VENEZIA (6 X VENEDIG)",
    "director": "Carlo Mazzacurati",
    "country": "Italien",
    "releaseYear": 2010,
    "runtime": 92,
    "version": "OmU",
    "screeningDate": "21.02.2013",
    "readableDate": "2013-02-21",
    "screeningTime": "20:00",
    "actors": "",
    "subtitle": [""],
    "bodycopy": [
      "Altregisseur Carlo Mazzacurati durchstreift Stadt und Lagune und gibt das Gefühl der Stadt anhand der Geschichten von 6 Venezianern wieder."
    ],
    "image": "sei-venezia.jpg"
  },
  {
    "title": "SENSO (Sehnsucht)",
    "director": "Luchino Visconti",
    "country": "Italien",
    "releaseYear": 1953,
    "runtime": 116,
    "version": "OmU",
    "screeningDate": "18.12.2008",
    "readableDate": "2008-12-18",
    "screeningTime": "19:00",
    "actors": "Alida Valli, Farley Granger, Massimo Girotti, Heinz Moog, Rina Morelli, Chstian Marquand, Sergio Fantoni",
    "subtitle": [""],
    "bodycopy": [
      "Als Einstimmung zum Weihnachtsfest zeigen wir dieses visuell beeindruckende Meisterwerk Viscontis. Diese Liebesgeschichte vor dem Hintergrund des italienischen Befreiungskrieges ist im wahrsten Wortsinn ein Historiengemälde. Musik, Kameraführung und Schauspielkunst vereinigen sich zu einem Gesamtkunstwerk, einem Epos über Liebe und Verrat, in dem sich individuelles Schicksal und historischer Entwicklung dramatisch ineinander verschränken. Ein neorealistischer Film mit historischem Thema."
    ],
    "image": "senso.jpg"
  },
  {
    "title": "Sessomatto (Niemand ist vollkommen)",
    "director": "Dino Risi",
    "country": "Italien",
    "releaseYear": 1974,
    "runtime": 82,
    "version": "OmitU",
    "screeningDate": "01.09.2010",
    "readableDate": "2010-09-01",
    "screeningTime": "20:00",
    "actors": "Giancarlo Giannini, Laura Antonelli, Paola Borboni, Alberto LIonello, Duilio Del Prete, Carla Mancini, Franca Scagnetti, Lino Puglisi",
    "subtitle": ["Werkschau: Dino Risi"],
    "bodycopy": [
      "Klamaukhaft geht Dino Risi in sechs Episoden mit dem damals noch tabuisiertem Thema Sex um. Für heutige Verhältnisse eher als spießig wahrgenommen, verhalf der u.a dieser Film Laura Antonelli, der späteren Lebensgefährtin Belmondos, zum Ruf, als „maggiorata“ eine zweite Sophia Loren zu sein."
    ],
    "image": "sesso-matto.jpg"
  },
  {
    "title": "Si può fare (Wir schaffen das schon)",
    "director": "Giulio Manfredonia",
    "country": "Italien",
    "releaseYear": 2008,
    "runtime": 111,
    "version": "OmU",
    "screeningDate": "16.02.2012",
    "readableDate": "2012-02-16",
    "screeningTime": "20:00",
    "actors": "Claudio Bisio, Giuseppe Battiston, Anita Caprioli, Andrea Bosca, Giovanni Calcagno, Michele De Virgilio, Carlo Giuseppe GabardiniClaudio Bisio, Giuseppe Battiston, Anita Caprioli, Andrea Bosca, Giovanni Calcagno, Michele De Virgilio, Carlo Giuseppe Gabardini",
    "subtitle": [""],
    "bodycopy": [
      "80er Jahre: „Irrenhäuser“ wurden Kooperativen. Der engagierte Nello versucht mit den Behinderten ein Handwerksunternehmen zu gründen. Optimistische Komödie über menschliche Grenzen und Möglichkeiten."
    ],
    "image": "si-puo-fare.jpg"
  },
  {
    "title": "SOGNI DI NUMERI (Die Träume Neapels)",
    "director": "Anna Bacchetti",
    "country": "Italien/Niederlande",
    "releaseYear": 2005,
    "runtime": 75,
    "version": "OmU",
    "screeningDate": "17.09.2009",
    "readableDate": "2009-09-17",
    "screeningTime": "20:00",
    "actors": "",
    "subtitle": [
      "„Italienische Portraits“ - Dokumentarfilme zu italienischen Themen"
    ],
    "bodycopy": [
      "Um das Lotterieannahmegeschäft der Schwestern Anna und Maria zeichnet Anna Bucchetti das Portrait der Altstadt Neapels und seiner Bewohner. Denen bleibt nicht viel mehr, als von einer glücklicheren Zukunft zu träumen – und so setzen Anna und Maria die Träume ihrer Kundschaft „wissenschaftlich“ in Zahlenreihen für das Glücksspiel um. Ein Film über Menschen auf der Suche nach dem Glück, die Kraft der Zahlen und eine traditionsreiche italienische Stadt - kunstvoll inschwarz-weißen Bildern fotografiert."
    ],
    "image": "sogni-di-numeri.jpg"
  },
  {
    "title": "Solino (Solino)",
    "director": "Fatih Akin",
    "country": "Deutschland",
    "releaseYear": 2002,
    "runtime": 123,
    "version": "OmU",
    "screeningDate": "11.03.2021",
    "readableDate": "2021-03-11",
    "screeningTime": "19:00",
    "actors": "Barnaby Metschurat, Moritz Bleibtreu, Antonella Atilli, Gigi Savoia",
    "subtitle": [""],
    "bodycopy": [
      "Verloren steht sie da, die Familie Amato. Im Jahr 1964 aus Italien ausgewandert, findet sie sich in einem Deutschland wieder, das weder Risotto, Spaghetti oder Pizza kennt. Die Auswahl an Gemüse lässt zu wünschen übrig und die Mutter Rosa, die erst gar nicht nach Deutschland kommen wollte, empfindet die Deutschen nur noch als „Barbaren“.",
      "Als sie gegenüber ihrer Wohnung ein leer stehendes Ladenlokal, eine ehemalige Eisdiele, entdeckt, weiß sie, was zu tun ist. Schnell überzeugt sie die Familie, ihre Landsleute mit italienischer Küche zu versorgen. Schnell finden auch die Deutschen Geschmack an der italienischen Küche und Vater Romano an deutschen Frauen. Als auch noch die beiden Söhne ein Leben jenseits der Pizzeria suchen, wird die Familie im fremden Deutschland vor unerwartete Probleme gestellt.",
      "Bevor Fatih Akin seinen mit dem Goldenen Bären in Berlin ausgezeichneten Film „Gegen die Wand“ über türkischstämmige Deutsche drehte, identifizierte er sich sofort mit dem Drehbuch für „Solino“, das er ursprünglich nur begutachten sollte. 1973 geboren, lebt er selbst den Spagat zwischen zwei Lebenswelten. Seit seiner Kindheit träumte er vom Filmen, so wie einer der beiden jungen Brüder der Familie Amato, Gigi, vom Fotografieren.",
      "So konnte Akin einen Film schaffen, der einen wichtigen Teil aktueller deutsch-italienischer Geschichte beleuchtet."
    ],
    "image": "solino.jpg"
  },
  {
    "title": "Sopralluoghi in Palestina (Motivsuche in Palästina)",
    "director": "Pier Paolo Pasolini",
    "country": "Italien",
    "releaseYear": 1965,
    "runtime": 55,
    "version": "OmU",
    "screeningDate": "14.03.2011",
    "readableDate": "2011-03-14",
    "screeningTime": "20:00",
    "actors": "Pier Paolo Pasolini, Adrea Carraro",
    "subtitle": [""],
    "bodycopy": [
      "Damit er historische Orte für den Film Das erste Evangelium - Matthäus rekonstruieren kann, reiste Pasolini nach Israel, um die notwendigen Untersuchungen anzustellen. Dies ist ein Rechenschaftsbericht, geschrieben mit der Kamera."
    ],
    "image": "sopralluoghi.jpg"
  },
  {
    "title": "Sostiene Pereira (Erklärt Pereira)",
    "director": "Roberto Faenza",
    "country": "Italien/Frankreich",
    "releaseYear": 1995,
    "runtime": 104,
    "version": "OmU",
    "screeningDate": "02.05.2009",
    "readableDate": "2009.05.02",
    "screeningTime": "20:00",
    "actors": "Marcello Mastroianni, Daniel Auteuil, Stafano Dionisi, Nicoletta Braschi, Joaquim de Almeida, Marthe Keller",
    "subtitle": [
      "Fünf Highlights aus fünf Jahren „Italienischer Filmclub“ in der Black Box"
    ],
    "bodycopy": [
      "Marcello Mastroianni stellt einen alt, fett und müde gewordenen Literaturredakteur im faschistischen Portugal der späten 30er Jahre dar. Ein kommunistischer Student, sein Arzt und die Willkür seiner Zeit lassen den Mann, der täglich mit dem Bild seiner verstorbenen Frau spricht, zu einem stillen kleinen Helden werden."
    ],
    "image": "sostiene-pereira.png"
  },
  {
    "title": "Sostiene Pereira (Erklärt Pereira)",
    "director": "Roberto Faenza",
    "country": "Italien/Frankreich",
    "releaseYear": 1995,
    "runtime": 104,
    "version": "OmU",
    "screeningDate": "17.02.2005",
    "readableDate": "2005-02-17",
    "screeningTime": "19:30",
    "actors": "Marcello Mastroianni, Daniel Auteuil, Stafano Dionisi, Nicoletta Braschi, Joaquim de Almeida, Marthe Keller",
    "subtitle": [""],
    "bodycopy": [
      "Marcello Mastroianni verkörpert in seiner vorletzten Rolle einen alt, fett und müde gewordenen Literaturredakteur im faschistischen Portugal der späten 30er Jahre. Die Bekanntschaft mit einem kommunistischen Studenten, Diskussionen mit seinem Arzt und die Erlebnisse der Willkür seiner Zeit, lassen den einsamen Mann, der jeden Tag dem Bild seiner verstorbenen Frau von seinem Alltag erzählt, zu einem stillen kleinen Helden werden.",
      "Verfilmung nach dem berühmten Buch von Antonio Tabucchi."
    ],
    "image": "sostiene-pereira.png"
  },
  {
    "title": "Stromboli - Terra di Dio (Stromboli)",
    "director": "Roberto Rossellini",
    "country": "Italien/USA",
    "releaseYear": 1950,
    "runtime": 107,
    "version": "OmitU",
    "screeningDate": "04.04.2007",
    "readableDate": "2007-04-04",
    "screeningTime": "19:00",
    "actors": "Ingrid Bergmann, Mario Vitale, Renzo Cesana, Mario Sponza",
    "subtitle": ["Werlschau: Roberto Rossellini"],
    "bodycopy": [
      "Erzählt wird die Geschichte eines Flüchtlingsmädchens, das in der Ehe mit einem Fischer auf der Vulkaninsel Stromboli Geborgenheit sucht, aber von allen Dorfbewohnern als Fremde angefeindet wird. Das Drama kommt zum Höhepunkt, als alle Bewohner durch den drohenden Vulkanausbruch zusammengedrängt in ihren Booten aufs Meer flüchten müssen. Rossellinis erste Zusammenarbeit mit Ingrid Bergmann. Ihre gemeinsame Affäre erregte seinerzeit Skandal."
    ],
    "image": "stromboli.jpg"
  },
  {
    "title": "SUBURRA (Suburra – 7 Tage bis zur Apokalypse)",
    "director": "Stefano Sollima",
    "country": "Italien/Frankreich",
    "releaseYear": 2017,
    "runtime": 130,
    "version": "OmU",
    "screeningDate": "19.10.2007",
    "readableDate": "2007-10-19",
    "screeningTime": "20:00",
    "actors": "Pierfrancesco Favino, Greta Scarano, Claudio Amendola, Alessandro Borghi, Greta Scarano, Giulia Elettra Gorietti",
    "subtitle": [
      "Eine tödlich endende Liebesnacht, ein als „Samurai“ auftretender Pate, ein mit Korruption verbundenes Bauprojekt, Vatikanintrigen und Clan-Rivalitäten. Als sich diese Ereignisse vermischen, wird ein Mafia-Clan aktiv und die Apokalypse beginnt."
    ],
    "bodycopy": [
      "In dunklen Bildern fragmentarisch erzählter Thriller über Korruption, organisiertes Verbrechen und Kleinkriminalität, schmutzige politische Verflechtungen und krankhafte Karrieresucht. Der Gesamtüberblick ergibt sich erst am Ende, was den Zuschauer gelegentlich so spannungsgeladen orientierungslos lässt wie die Protagonisten im Film. Ein besonderer Genuss sind die im Stile eines modernen, farbigen „Film Noir“ gehaltene Fotografie und Montage.",
      "Stefano Sollima (ROMANZO CRIMINALE (DER PATE VON ROM)) ist der Sohn von Sergio Sollima, der wegen seiner politkritischen Western und Thriller unter Genrefans hoch angesehen ist. Diese Themen des Genrekino der Siebziger greift SUBURRA auf und erzählt sie als höchst aktuelles und modernes Kino."
    ],
    "image": "suburra.jpg"
  },
  {
    "title": "Sud",
    "director": "Gabriele Salvatores",
    "country": "Italien",
    "releaseYear": 1993,
    "runtime": 85,
    "version": "OmitU",
    "screeningDate": "07.02.2007",
    "readableDate": "2007-02-07",
    "screeningTime": "19:00",
    "actors": "Silvio Orlando, Francesca Neri, Gigio Alberti, Marco Marchisi, Claudio Bisio, Antonio Catania, Renato Carpentieri, Antonio PetroncelliSilvio Orlando, Francesca Neri, Gigio Alberti, Marco Marchisi, Claudio Bisio, Antonio Catania, Renato Carpentieri, Antonio Petroncelli",
    "subtitle": [""],
    "bodycopy": [
      "Vier Arbeitslose wollen aus Protest das Wahllokal in Marzamemi besetzen, um ein Zeichen gegen die finsteren Machenschaften eines lokalen Politikers zu setzen. Dabei nehmen sie zufällig die Tochter des Wahlfavoriten und dessen Verlobten als Geisel. Trotz massiven Polizeiaufgebots ziehen mangelnde Entscheidungsfähigkeit und sich widersprechende Interessen die Situation in die Länge – bis in die Nacht des Wahltages. Dieser Film ist bisher nicht in die deutschen Kinos gekommen."
    ],
    "image": "sud.jpg"
  },
  {
    "title": "Tano da morire (Oh Tano!)",
    "director": "Roberta Torre",
    "country": "Italien",
    "releaseYear": 1997,
    "runtime": 80,
    "version": "OmU",
    "screeningDate": "16.04.2004",
    "readableDate": "2004-04-16",
    "screeningTime": "19:30",
    "actors": "Andrea Di Stefano, Donatella Finocchiaro, Mario Pupella",
    "subtitle": [""],
    "bodycopy": [
      "Angela ist in Ballarò, dem Markt-Viertel Palermos auf­gewachsen. Mit zwanzig heiratet sie Saro. Das junge Pärchen schlägt sich mit Drogenhandel und schnel­len Geschäften durch. Als sie Masino begegnet, der zum rechten Arm ihres Mannes wird, beginnt sie mit ihm eine leiden­schaftliche Affäre."
    ],
    "image": "Tano-da-morire.jpg"
  },
  {
    "title": "Tartarughe sul dorso",
    "director": "Stefano Pasetto",
    "country": "Italien",
    "releaseYear": 2005,
    "runtime": 92,
    "version": "OmitU",
    "screeningDate": "05.03.2008",
    "readableDate": "2008-03-05",
    "screeningTime": "19:00",
    "actors": "Barbora Bobulova, Fabrizio Rongione, Gordana Miletic, Luigi Diberti, Vittorio Amandola, Antonio Manzini, Caterina Casini, Lucia Mascino, Chiara Sani, Giulietta Ravel",
    "subtitle": ["Filmort: Triest"],
    "bodycopy": [
      "Am Anfang steht eine Partie Scrabble. Wie sich bei diesem Spiel aus Buchhstaben Worte bilden, die nie zu ganzen Sätzen werden, entwickelt sich das Verhältnis zweier Außenseiter vor dem Hintergrund eines intim gefilmten Triest jenseits touristischer Pfade. Der aus dem Gefängnis entlassene „Er“ und die als Putzfrau arbeitende Studienabbrecherin „Sie“ begegnen sich immer wieder. Doch bleibt es bei mehr oder weniger intensiven Begegnungen, auch wenn eine tiefere Beziehung möglich scheint."
    ],
    "image": "tartarughe-sul-dorso.jpg"
  },
  {
    "title": "Teorema (Geometrie der Liebe)",
    "director": "Pier Paolo Pasolini",
    "country": "Italien",
    "releaseYear": 1968,
    "runtime": 105,
    "version": "OmitU",
    "screeningDate": "01.07.2009",
    "readableDate": "2009-07-01",
    "screeningTime": "20:00",
    "actors": "Silvana Mangano, Massimo Girotti, Andrés José Cruz Soublette, Anne Wiazemsky, Laura Betti, Terence Stamp, Ninetto Davoli",
    "subtitle": ["Werkschau: Pier Paolo Pasolini"],
    "bodycopy": [
      "Pasolinis durch Molières TARTÜFFE inspirierte Gesellschaftskritik. Führt Tartüffe als Betrüger jedoch ein Familiengefüge zum Zusammenbruch, indem er gesellschaftliche Verwerflichkeiten ausnutzt, konfrontiert Pasolini eine wohlhabende Familie mit einem gottesgleich schönen Gast, dem alle Familienmitglieder aus eigenem Antrieb verfallen. Als dieser als Projektionsfläche der Befreiung aus eigenen Zwängen plötzlich verschwindet, bricht das Gewebe aus spießbürgerlichen Verhaltensweisen auseinander."
    ],
    "image": "teorema.jpg"
  },
  {
    "title": "Teorema Venezia (DAS VENEDIG-PRINZIP)",
    "director": "Andreas Pichler",
    "country": "Deutschland",
    "releaseYear": 2012,
    "runtime": 80,
    "version": "OmitU",
    "screeningDate": "21.08.2014",
    "readableDate": "2014-08-21",
    "screeningTime": "20:00",
    "actors": "",
    "subtitle": [""],
    "bodycopy": [
      "Venedig ohne Venizianer: Dies wird für 2003 prognostiziert, sollte die Umgestaltung Venedigs in eine Mischung aus Freilichtmuseum und Vergnügungspark weiter fortschreiten, wird dies für 2030 prognostiziert. Andreas Pichler geht mit seinem beeindruckend fotografierten Dokumentarfilm dieser Entwicklung nach und zeichnet ein außergewöhnliches Bild Venedigs."
    ],
    "image": "teorema-venezia.jpg"
  },
  {
    "title": "THE SPECIAL NEED ((K)EIN BESONDERES BEDÜRFNIS)",
    "director": "Carlo Zoratti",
    "country": "Italien/Deutschland/Österreich/Frankreich",
    "releaseYear": 2013,
    "runtime": 84,
    "version": "OmU",
    "screeningDate": "15.02.2018",
    "readableDate": "2018-02-15",
    "screeningTime": "20:00",
    "actors": "Carlo Zoratti, Alex Nazzi, Enea Gabino und alle, die sie auf ihrer Reise treffen",
    "subtitle": [
      "Eine Doku-Fiction über einen geistig Behinderten in Verbindung mit dem Thema Sexualität kann peinlich werden – oder es kommt ein so sympathischer Film dabei heraus wie in diesem Fall."
    ],
    "bodycopy": [
      "Mit seinen dreißig Jahren hat Enea zwar einen Arbeitsplatz, aber auch ein Problem, oder besser gesagt, ein Bedürfnis: er wünscht sich eine sexuelle Beziehung. Keine einfache Angelegenheit, denn er ist geistig behindert. Doch wozu hat man seine Freunde Carlo und Alex, die ihm entschieden helfen wollen. So machen sie sich auf den Weg, Eneas Traum mit großer Sensibilität zu verwirklichen.",
      "Dabei stoßen sie jedoch auf unerwartete Hindernisse, aber auch ungewöhnliche Unterstützung – Episoden, die unserer „normalen“ Gesellschaft en passant den Spiegel vorhalten. Vor allem aber wächst dem Zuschauer Enea in dem Ringen ans Herz, sein inniges Bedürfnis zu befriedigen."
    ],
    "image": "the-special-need.jpg"
  },
  {
    "title": "TRE PIANI (DREI ETAGEN)",
    "director": "Nanni Moretti",
    "country": "Italien",
    "releaseYear": 2019,
    "runtime": 121,
    "version": "OmU",
    "screeningDate": "20.10.2022",
    "readableDate": "2022-10-20",
    "screeningTime": "20:00",
    "actors": "Margherita Buy, Nanni Moretti, Riccardo Scamarcio, Alba Rohrwacher u.aMargherita Buy, Nanni Moretti, Riccardo Scamarcio, Alba Rohrwacher u.a",
    "subtitle": [
      "Mit seinem neusten Film erweist sich Moretti erneut als guter Menschenkenner und packender Erzähler. Das erste Mal nimmt er sich des Buches eines fremden Autors (Eshkol Nevo: Über uns / dtv) an, strukturiert dieses jedoch vollkommen um. Die Ereignisse werden mehr ineinander verschachtelt und die Zeichnung der Personen konturenschärfer ausgeführt. Kleine Gesten und kurze Bemerkungen reichen oftmals, eine Situation oder Befindlichkeit deutlich zu machen. Im Gegensatz zum Film IL PARADISO DEL PAVONE des Folgemonats (November 2022), der ein verwandtes Thema behandelt, sich aber eher einer enigmatischen Erzählweise bedient, ist Morettis Film immer auf dem Punkt und um Klarheit bemüht."
    ],
    "bodycopy": [
      "Es beginnt mit einer schwangeren Frau auf der Straße. Ein Auto rast Schlangenlinien fahrend an ihr vorbei in das Erdgeschoß eines Hauses.",
      "Und schon sind wir im Inneren des Gebäudes und lernen kurz darauf die Bewohner kennen, die erschreckt und verwirrt den Unfall in Augenschein nehmen und Hilfe leisten: das alte Ehepaar, das sich fürsorglich um die Tochter der Etagennachbarn kümmert, wenn deren Kombination aus Familienleben und Beruf für die töchterliche Betreuung keine Zeit lässt, sowie den Richter und seine Frau, deren Sohn den Unfall verursacht hat. Es fehlt nur die Familie aus dem obersten Stockwerk: der Mann ist auf Montage und die Frau, es ist die Schwangere aus der Eingangssequenz, wird zunehmend unter Zwangsvorstellungen leiden.",
      "Dieser Personenkosmos erlebt im Laufe der Zeit Höhen und Tiefen. Oft ist es das Festhalten an Gewohnheiten oder das Verrennen in starre Vorstellungen, die den Mitmenschen das Leben schwer machen. Nicht zuletzt leiden darunter auch die Betroffenen selbst.",
      "Mit Interesse und einer gewissen Portion Selbsterkenntnis folgen wir den Entwicklungen und werden mit einem angedeuteten Happy End entlassen, das der Film nun wirklich nicht gebraucht hätte."
    ],
    "image": "tre-piani-03.jpg"
  },
  {
    "title": "Turné",
    "director": "Gabriele Salvatores",
    "country": "Italien",
    "releaseYear": 1990,
    "runtime": 91,
    "version": "OmitU",
    "screeningDate": "02.12.2009",
    "readableDate": "2009-12-02",
    "screeningTime": "20:00",
    "actors": "Fabrizio Bentivoglio, Diego Abantantuono, Laura Morante, Ugo Conti",
    "subtitle": [
      "Werkschau: Ein Fall für zwei Gabriele Salvatores (Regisseur) und Diego Abantantuono (Schauspieler)"
    ],
    "bodycopy": [
      "Tschechows „Kirschgarten“ – die untrennbar scheinenden Freunde Dario und Federico gehen mit dem Stück auf Tournee durch Italien. Ihre unterschiedlichen Temperamente und Biografien drohen sie schon zu entfremden, als die gemeinsame Liebe zur selben Frau die Freundschaft auf eine noch entscheidendere Probe stellt."
    ],
    "image": "turne.png"
  },
  {
    "title": "TUTTA LA VITA DAVANTI (DAS GANZE LEBEN LIEGT VOR DIR)",
    "director": "Paolo Virzì",
    "country": "Italien",
    "releaseYear": 2008,
    "runtime": 117,
    "version": "OmU",
    "screeningDate": "20.10.2016",
    "readableDate": "2016-10-20",
    "screeningTime": "20:00",
    "actors": "Isabella Ragonese, Sabrina Ferilli, Elio Germano, Massimo Ghini, Valerio Mastandrea, Micaela Ramazzotti, Valentina Carnelutti, Edoardo Gabbriellini",
    "subtitle": [""],
    "bodycopy": [
      "Nach Beendigung des Philosophiestudiums steht Marta die Welt offen. Doch als sie optimistisch in einem Call-Center anfängt, lernt sie Italien als ein Land kennen, in dem man immer freundlich seien muss, aber nur mit Manipulationen erfolgreich seien kann und an seiner Quote gemessen wird. Komödiantisches Porträt Italiens der Berlusconi-Zeit."
    ],
    "image": "tutta-la-vita-davanti.jpg"
  },
  {
    "title": "TUTTI I SANTI GIORNI (TAGEIN TAGAUS)",
    "director": "Paolo Virzì",
    "country": "Italien",
    "releaseYear": 2012,
    "runtime": 102,
    "version": "OmU",
    "screeningDate": "19.09.2019",
    "readableDate": "2019-09-19",
    "screeningTime": "20:00",
    "actors": "Luca Marinelli, Thony, Micol Azzurro, Claudio Pallitto, Frank Crudele, Christian Ginepro, Regina Orioli, Giovanni La Parola",
    "subtitle": [
      "Wenn Lieben einfach nur „sich lieben“ wäre. Aber da gibt es sich nicht erfüllen wollende Kinderwünsche, freundliche Mitmenschen mit wohlmeinenden Ratschlägen, Erfolgsnachfragen der Eltern und eine berufliche Realität mit ihrem Einfluss auf die Beziehung. Helfen in dieser Situation moderne Reproduktionstechniken, wissen namhafte Ärzte wirklich zu raten? Oder erstickt die Liebe unter dieser intensiven Teilnahme?"
    ],
    "bodycopy": [
      "Guido kommt aus der Toskana, begeistert sich für antike Sprachen sowie frühchristliche Heilige und arbeitet als Nachtportier. Er liebt die Sizilianerin Antonia, Angestellte eines Autoverleihs, die ihrerseits Guido liebt. Gemeinsam verbindet sie die Leidenschaft zur Musik. Sie spielt in einer Bar. Dort haben sie sich kennengelernt und trotz ihres unterschiedlichen Charakters ineinander verliebt.",
      "Beide wünschen sich ein Kind, das aber auf sich warten lässt. Je mehr Zeit vergeht, desto drängender werden die Nachfragen von den Eltern, die gerne Enkel hätten, und Freunden, welche dem Paar den Eintritt in die Schicksalsgemeinschaft eines Lebens mit Kindern wünschen. Da auch die Segnungen der modernen Medizin nicht helfen, gerät die Beziehung unter Druck und es droht ein sich auseinanderleben. Wird es den Beiden gelingen, die Krise zu meistern?"
    ],
    "image": "tutti-i-santi-giorni.jpg"
  },
  {
    "title": "TUTTO A POSTO E NIENTE IN ORDINE (OPERATION GELUNGEN - PATIENT TOT)",
    "director": "Lina Wertmüller",
    "country": "Italien",
    "releaseYear": 1974,
    "runtime": 194,
    "version": "OmU",
    "screeningDate": "19.09.2013",
    "readableDate": "2013-09-19",
    "screeningTime": "20:00",
    "actors": " Luigi Diberti, Lina Polito, Giuliana Calandra, Isa Danieli, Sara Rapisarda, Nino Bignamini",
    "subtitle": ["Lina Wertmüller zum 85. Geburtstag"],
    "bodycopy": [
      "Wer sind die wahren Ochsen? Die Tiere, deren Hälften sich choreografisch durch den Schlachthof bewegen oder die naiven süditalienischen Bauern, die sich hier zur Arbeit verdingt haben? Mailand als ihre Wunderschachtel, aber auch als ihr Schicksal zwischen Prostitution, Kleinkriminalität und Anpassung. Eine in Wertmüller’scher Drastik ausgebreiteter satirischer Kosmos, eine Kritik italienischer Verhältnisse, aber auch kapitalistischer Ausbeutung. Ein Film,, der selten in deutschen Kinos zu sehen ist."
    ],
    "image": "tutto-a-posto.jpg"
  },
  {
    "title": "TUTTO QUELLO CHE VUOI (ALLES WAS DU WILLST)",
    "director": "Francesco Bruni",
    "country": "Italien",
    "releaseYear": 2017,
    "runtime": 106,
    "version": "OmU",
    "screeningDate": "16.01.2020",
    "readableDate": "2020-01-16",
    "screeningTime": "20:00",
    "actors": "Andrea  Carpenzano, Giuliano Montaldo, Donatella Finocchiaro, Arturo Bruni, Antonio Gerardi",
    "subtitle": [
      "Ein Film mit oder über Behinderte gerät leicht ins Kitschige und Klischeehafte. Auch dieser Film von Francesco Bruni (SCIALLA) ist nicht ganz frei davon. Doch er kombiniert das Thema der Demenzerkrankung mit der Erzählung um die Veränderung sozial randständiger Jugendlicher, die durch die Begegnung mit der Lebensgeschichte eines alten dementen Mannes eine neue Entwicklungsperspektive bekommen. "
    ],
    "bodycopy": [
      "Ursprünglich wittert der 22jährige Alessandro die große Chance, den dementen alten, längst vergessenen Poeten Giorgio um seinen Schatz zu bringen. Von diesem hatte der Literat wegen seiner Demenz sehr fragmentarisch erzählt, nachdem der Jugendliche auf Druck seines Vaters widerwillig dessen Pflege übernehmen musste. Er und seine Freunde beginnen sich in der Wohnung des Alten einzunisten, der über die Gesellschaft sehr erfreut ist und sich durch das vulgäre und ignorante Benehmen der Jugendliche nicht stören lässt. So etwas wie eine kuriose Freundschaft der unterschiedlichen Menschen entsteht. Während von der Würde und Eleganz des Alten ein verändernder Einfluss auf die Jugendliche ausgeht, lebt der Poet auf und seine Erinnerungen an die Vergangenheit werden geweckt. Was wiederum die Jugendlichen nutzen wollen, denn es ist immer wieder von einem Schatz die Rede, den der Alte zusammen mit befreundeten US-Soldaten irgendwo verborgen hat. Ein Zimmer des Poeten voller auf die Wand geschriebener Notizen soll ihnen weiterhelfen, bringt sie aber auch mit dem Reiz der Literatur in Kontakt. Und so fahren die Freunde mit dem Alten schließlich auf Schatzsuche in die Toskana.",
      "Ausgezeichnet mit zwei italienischen Filmpreisen „David di Donatello“ und Publikumspreis der Cinema! Italia!-Tournee 2018"
    ],
    "image": "tutto-quello-che-vuoi-01.jpg"
  },
  {
    "title": "Uccellacci e uccellini (Große Vögel, kleine Vögel)",
    "director": "Pier Paolo Pasolini",
    "country": "Italien",
    "releaseYear": 1966,
    "runtime": 88,
    "version": "OmU",
    "screeningDate": "19.02.2011",
    "readableDate": "2011-02-19",
    "screeningTime": "20:00",
    "actors": "Totò, Ninetto Davoli, Femi Benussi, Umberto Bevilacqua, Renato Capogna, Alfredo Leggi, Renato Montalbano, Flaminia Siciliano, Giovanni Tarallo, Vittorio Vittori, Domenico Modugno, Gabriele Baldini",
    "subtitle": [""],
    "bodycopy": [
      "Vater und Sohn sind unterwegs. Wohin, bleibt unklar. Sie werden begleitet von einem sprechenden Raben, der ihnen die Welt erklärt, der doziert, bis sie ihn kurzerhand verspeisen und alleine weiterziehen. Der Stil der Inszenierung und Montage ist ein Kompendium filmsprachlicher Möglichkeiten."
    ],
    "image": "uccellacci e uccellini.jpg"
  },
  {
    "title": "UMBERTO D. (Umberto D.)",
    "director": "Vittorio De Sica",
    "country": "Italien",
    "releaseYear": 1951,
    "runtime": 90,
    "version": "OmU",
    "screeningDate": "21.04.2011",
    "readableDate": "2011-04-21",
    "screeningTime": "20:00",
    "actors": " Carlo Battisti, Maria Pia Casilio, Lina Gennari, Ileana Simova, Elena Rea, Memmo Carotenuto, Alberto Albani Barbieri",
    "subtitle": ["Hommage an Vittorio De Sica"],
    "bodycopy": [
      "Der Film ist Teil der Filmmuseums-Reihe „Minimal Cinema“. De Sica ist eine Tragikomödie gelungen, die den Zuschauer mit reduzierten Mitteln fesselt: Ein verzweifelter Mann kann seinem Leben kein Ende bereiten, da er es nicht schafft, seinen Hund allein zu lassen, ihn aber auch nicht in den Tod mitnehmen möchte. Anhand dieser Mensch-Tier-Liebe entwickelt De Sica eine unterschwellige Kritik an einer Gesellschaft, der das menschliche Mitgefühl abhanden gekommen ist. Als Komödiant gelingt es De Sica, dieses tragische Thema mit viel Empathie und unterhaltsam zu präsentieren. Ein filmgeschichtliches Meisterwerk."
    ],
    "image": "umberto-d.jpg"
  },
  {
    "title": "Un amore (Eine Liebesgeschichte)",
    "director": "Gianluca Tavarelli",
    "country": "Italien",
    "releaseYear": 1999,
    "runtime": 105,
    "version": "OmU",
    "screeningDate": "16.02.2006",
    "readableDate": "2006-02-16",
    "screeningTime": "19:30",
    "actors": "Lorenza Indovina, Fabrizio Gifuni, Luciano Federico, Roberta Lena, Riccardo Montanaro",
    "subtitle": [""],
    "bodycopy": [
      "Zwölf Episoden – zwölf Einstellungen: eine Liebesgeschichte, wie sie Sara und Marco ihren Enkeln erzählen könnten. Eine lebenslange Liebesgesichte mit vielen Brüchen und Unterbrechungen. Der introvertierten Träumer und die dickköpfige wilde Dynamikerin können nicht miteinander leben, aber auch nicht voneinander lassen. Beide heiraten jeweils andere Partner, treffen sich jedoch immer wieder, teils zufällig, teils, weil sie sich suchen. Zwölf Episoden aus zwei Leben: „Ein paar entscheidende Minuten sagen etwas aus über dieses Leben als Ganzes“ ist Regisseur Tavarelli überzeugt."
    ],
    "image": "un-amore.jpg"
  },
  {
    "title": "UN BACIO (EIN KUSS)",
    "director": "Ivan Cotroneo",
    "country": "Italien",
    "releaseYear": 2016,
    "runtime": 102,
    "version": "OmU",
    "screeningDate": "21.06.2018",
    "readableDate": "2018-06-21",
    "screeningTime": "20:00",
    "actors": "Rimau Ritzberger Grillo, Valentina Romani, Leonardo Pazzagli, Susy Laude: Stefania, Thomas Trabacchi, Laura Mazzi",
    "subtitle": [
      "Außenseiter oder eine besondere Persönlichkeit? Als Jugendliche(r) kann das keiner so genau über sich sagen. Auf der Suche nach der Antwort finden sich die von-ihren Gleichalterigen ausgegrenzten Lorenzo, Blu und Antonio. Lorenzo ist schwul und lebt in Selbstbestätigungsphantasien, Blu gilt als Schulschlampe, da sie Sex mit vier Männern gehabt haben soll und der in sich gekehrte Antonio ist zwar ein guter Basketball-Spieler, wird jedoch für ein dumpfes Gemüt gehalten."
    ],
    "bodycopy": [
      "Zwischen den Dreien entsteht eine tiefe Freundschaft und solidarisch gelingt es ihnen, sich gegen das soziale Mobbing zu wehren und gemeinsam unbändige Lebensfreude zu entfalten.",
      "Die Beziehung bekommt einen Bruch als Lorenzo sich in Verkennung der Situation Antonio erotisch zu nähren versucht und Blu die Wahrheit über ihr sexuelles „Abenteuer“ erfährt.",
      "Ein leichtfüßig, mit fröhlichen Bildern erzähltes Jugenddrama, das dem Entstehen und Zerbrechen tiefer Freundschaft folgt und sensibel das Empfinden der Jugendlichen schildert."
    ],
    "image": "un-bacio.jpg"
  },
  {
    "title": "Un'agenzia matrimoniale (Heiratsvermittlung)",
    "director": "Federico Fellini",
    "country": "Italien/Frankreich",
    "releaseYear": 1973,
    "runtime": 90,
    "version": "OmU",
    "screeningDate": "21.01.2010",
    "readableDate": "2010-01-21",
    "screeningTime": "20:00",
    "actors": "Pina Renzi, Erminio Macario, Delia Scala, Aroldo Tieri, Fulvia Franco, Eva Vanicek, Vittorio Mangano, Vera Carini, Laura Gore, Ernesto Almirante, Oscar Blando, Gisella Monaldi, Galeazzo Benti",
    "subtitle": ["90 Jahre Fellini (20.01.1920-31.10.1993)"],
    "bodycopy": [
      "1953 taten sich 7 italienische Regisseure zusammen, um dem Verhältnis der beiden Geschlechter nachzugehen. Dieses filmgeschichtliche Dokument ist in der deutschuntertiteln Fassung nur verstümmelt überliefert. Wir zeigen die verbliebenen Episoden, darunter von Federico Fellini \"AGENZIA MATRIMONIALE - Heiratsvermittlung\"."
    ],
    "image": "unagenzia-matrimoniale.jpg"
  },
  {
    "title": "Una giornata particolare (Ein besonderer Tag)",
    "director": "Ettore Scola",
    "country": "Italien/Kanada",
    "releaseYear": 1977,
    "runtime": 105,
    "version": "OmitU",
    "screeningDate": "06.07.2011",
    "readableDate": "2011-07-06",
    "screeningTime": "20:00",
    "actors": "Sophia Loren, Marcello Mastroianni, John  Vernon, Alessandra Mussolini, Vittorio Guerrieri, Nicole Magny, Patrizia Basso, Tiziano De Persio, Maurizio Di Paolantonio, Antonio Garibaldi",
    "subtitle": ["150 Jahre Italien"],
    "bodycopy": [
      "Eine schauspielerische Meisterleistung von Sophia Loren und Marcello Mastoinanni, Eine schauspielerische Meisterleistung von Sophia Loren und Marcello Mastoinanni, die eine ganze Epoche im Hinterzimmer aufscheinen lässt. 3.5.1938: Während ganz Rom den historischen Besuch Hitlers feiert, treffen sich eine im Hinterhaus „zurückgelassene“ Mutter von sechs Kindern mit einem ausgegrenzten homosexuellen Radiosprecher. Dies wird für beide ein „besonderer Tag“ werden."
    ],
    "image": "una-giornata-particolare.gif"
  },
  {
    "title": "Una pura formalità (Ein pure Formalität)",
    "director": "Giuseppe Tornatore",
    "country": "Italien",
    "releaseYear": 1994,
    "runtime": 108,
    "version": "OmitU",
    "screeningDate": "05.05.2010",
    "readableDate": "2010-05-05",
    "screeningTime": "20:00",
    "actors": "Gérard Depardieu, Roman Polanski, Sergio Rubini, Nicola Di Pinto, Paolo Lombardi, Maria Rosa Spagnolo, Tano Cimarosa",
    "subtitle": [""],
    "bodycopy": [
      "Ein kafkeskes Rededuell zwischen einem Polizeibeamten in den Abruzzen (Roman Polanski) und einem aufgegriffenen Mann ohne Ausweispapiere (Gérard Depardieu), der behauptet ein berühmter Autor zu sein. Als guter Kenner dessen Werks verwickelt der Polizeibeamte den Mann in Widersprüche – Wirklichkeit und Fiktion beginnen sich bedohlich zu vermischen .."
    ],
    "image": "una-pura-formalita.jpg"
  },
  {
    "title": "UNA QUESTIONE PRIVATA (EINE PRIVATE ANGELEGENHEIT)",
    "director": "Paolo e Vittorio Taviani",
    "country": "Italien/Frankreich",
    "releaseYear": 2017,
    "runtime": 85,
    "version": "OmU",
    "screeningDate": "19.05.2022",
    "readableDate": "2022-05-19",
    "screeningTime": "20:00",
    "actors": "Luca Marinelli, Lorenzo Richelm, Valentina Bellé, Giulio Beranek, Francesca Agostini, Alessandro Sperduti, Andrea Di Maria u.a.",
    "subtitle": [
      "Mit dem Film „Die Nacht von San Lorenzo“ meinten die Gebrüder Taviani, das Thema Resistenza und Partisanentum hinter sich gelassen zu haben. Mit diesem, ihrem letzten Film greifen Sie das Thema erneut auf. „Der Antifaschismus ist zurück als ein Thema von großer Aktualität“, geben Sie als Begründung an. Dabei soll der Blick zurück auch ein Denkanstoß für die Gegenwart sein. In den letzten Wochen des Zweiten Weltkriegs konnte der einstige Feind Freund und der langjährige Freund Feind sein – oft ging der Riss durch die Familie. „Una questione privata“ lotet das Spannungsfeld zwischen Privatem und Politischem in einer gewalttätigen Zeit aus."
    ],
    "bodycopy": [
      "Sowohl Milton als auch Giorgio lieben Fulvia. Sie sind Freunde und Rivalen. Doch das erfährt man im Einzelnen erst aus Rückblenden und Dialogen im Laufe des Films. Der Zuschauer folgt vielmehr Milton durch die nebelige Landschaft des Piemont auf der Suche nach Giorgio. Er trifft auf verschiedene Widerstandsgruppen, die konkurrierend teils eifersüchtig aufeinander   teils solidarisch gegen die deutschen Truppen und die heimischen Schwarzhemden kämpfen. Niemand hat den Überblick, Nebel liegt über der Landschaft und es herrscht das Misstrauen, ob man Freund oder Feind vor sich hat.",
      "Die Brüder Taviani haben den Film gemeinsam konzipiert, als der ältere der beiden, Vittorio, vor den Dreharbeiten in Rom von einem Auto angefahren wurde und im April 2018 starb. So wurde dieser Film ihr gemeinsames Vermächtnis."
    ],
    "image": "privateangelegenheit05.jpg"
  },
  {
    "title": "UNA VITA TRANQUILLA (EIN RUHIGES LEBEN - Die Mafia vergisst nicht)",
    "director": "Claudio Cupellini",
    "country": "Italien/Deutschlanf/Frankreich",
    "releaseYear": 2010,
    "runtime": 105,
    "version": "OmU",
    "screeningDate": "16.05.2013",
    "readableDate": "2013-05-16",
    "screeningTime": "20:00",
    "actors": "Toni Servillo, Marco D'Amore, Francesco Di Leva, Juliane Köhler, Maurizio Donadoni, Alice Dwyer, Leonardo Sprengler",
    "subtitle": [""],
    "bodycopy": [
      "Toni Servillo erhielt auf dem Filmfestival Rom mit Recht die Auszeichnung als bester männlicher Darsteller für seine Rolle als ausgestiegener Mafiosi, der als Restaurantbesitzer und Ehemann einer deutschen Frau unerwartet von seiner Vergangenheit eingeholt wird."
    ],
    "image": "una-vita-tranquilla.jpg"
  },
  {
    "title": "UNA VITA TRANQUILLA (EIN RUHIGES LEBEN - Die Mafia vergisst nicht)",
    "director": "Claudio Cupellini",
    "country": "Italien/Deutschlanf/Frankreich",
    "releaseYear": 2010,
    "runtime": 105,
    "version": "OmU",
    "screeningDate": "27.04.2015",
    "readableDate": "2013-05-16",
    "screeningTime": "20:00",
    "actors": "Toni Servillo, Marco D'Amore, Francesco Di Leva, Juliane Köhler, Maurizio Donadoni, Alice Dwyer, Leonardo Sprengler",
    "subtitle": [""],
    "bodycopy": [
      "Toni Servillo erhielt auf dem Filmfestival Rom mit Recht die Auszeichnung als bester männlicher Darsteller für seine Rolle als ausgestiegener Mafiosi, der als Restaurantbesitzer und Ehemann einer deutschen Frau unerwartet von seiner Vergangenheit eingeholt wird."
    ],
    "image": "una-vita-tranquilla.jpg"
  },
  {
    "title": "Va' dove ti porta il cuore (Geh', wohin dein Herz dich trägt)",
    "director": "Cristina Comencini",
    "country": "Italien/Frankreich",
    "releaseYear": 1996,
    "runtime": 110,
    "version": "OmU",
    "screeningDate": "17.03.2005",
    "readableDate": "2005-03-17",
    "screeningTime": "19:30",
    "actors": "Virna Lisi, Margherita Buy, Galatea Ranzi, Massimo Ghini, Tchéky Kayro",
    "subtitle": [""],
    "bodycopy": [
      "In der Geschichte dreier Frauen aus drei Generationen spiegelt sich das 20. Jahrhundert. Erzählt wird sie im Film mit der Stimme der 80jährigen Grossmutter Olga, die kurz vor ihrem Tod ein Brieftagebuch verfasst hat. Dieses Buch hilft ihrer Enkelin Marta, sich in den über Generationen spannenden Irrungen und Wirrungen in ihrer Familie zurechtzufinden und die Wahrheit über das Leben ihrer Mutter zu erfahren.",
      "Glaubt man der Kritik, ist der Film interessanter als seine literarische Vorlage."
    ],
    "image": "cuore.png"
  },
  {
    "title": "VELOCE COME IL VENTO (GIULIAS GROSSES RENNEN)",
    "director": "Matteo Rovere",
    "country": "Italien",
    "releaseYear": 2016,
    "runtime": 119,
    "version": "OmU",
    "screeningDate": "16.11.2017",
    "readableDate": "2017-11-16",
    "screeningTime": "20:00",
    "actors": "Stefano Accorsi, Matilda De Angelis, Roberta Mattei, Paolo Graziosi, Lorenzo Gioielli, Giulio Pugnaghi, Cristina Spina",
    "subtitle": [
      "Der Kampf für den Sieg im Motorsport verbindet sich für Giulia nach dem plötzlichen Tod des Vaters mit der Auseinandersetzung um familiären Streit und Zusammenhalt."
    ],
    "bodycopy": [
      "Taucht doch nach der Beerdigung unerwartet ihr drogenabhängiger Bruder Loris mit seiner „Braut“ auf und beansprucht seinen Teil des Hauses mit der Werkstatt. Die sind jedoch verpfändet, in der Hoffnung auf den Sieg der 17-jährigen Giulia im Motorrennsportwettkampf. So versucht Loris, einstmals genialer Fahrer und jetzt nur noch ein Schatten seiner selbst, seinen strategischen Instinkt zu wecken und Giulia zu trainieren. Aber was kann man von einem Drogenabhängigen schon erwarten?",
      "Die Kamera von Michele D’Attanasio (IN GRAZIA DI DIO (EIN NEUES LEBEN)) lässt selbst Motorrennsportmuffel nicht kalt und Stefano Accorsi (SATURNO CONTRO (IN EWIGKEIT LIEBE), L’ULTIMO BACIO (DER LETZTE KUSS)) glänzt als Loris in seiner vielleicht besten Rolle."
    ],
    "image": "veloce-come-il-vento.jpg"
  },
  {
    "title": "Vesna va veloce",
    "director": "Carlo Mazzacurati",
    "country": "Italien",
    "releaseYear": 1996,
    "runtime": 92,
    "version": "OmitU",
    "screeningDate": "06.02.2008",
    "readableDate": "2008-02-06",
    "screeningTime": "19:00",
    "actors": "Tereza Zajickova, Antonio Albanese, Silvio Orlando, Ivano Marescutti, Antonio Catania, Stefano Accorsi, Paolo Montevecchi, Tony Sperandeo, Marco Messeri",
    "subtitle": ["Filmort: Triest"],
    "bodycopy": [
      "Die tschechoslowakische Vesna kommt mit dem Bus in Triest an und entscheidet in Italien zu bleiben. Ihr Kampf um ein würdiges Leben im „gelobten Land“ endet in der Prostitution. Endlich kann sie sich in der Konsumwelt leisten, was ihr altes Lebennicht ermöglichte. Aber um welchen Preis? Der Film beleuchtet die Rolle dieser Stadt als „Einfalltor“ der Migration aus dem Osten in der Zeit zwischen dem Fall der Mauer und der Osterweiterung der EU."
    ],
    "image": "vesna-va-veloce.jpg"
  },
  {
    "title": "Viaggio segreto",
    "director": "Roberto Andò",
    "country": "Italien",
    "releaseYear": 2007,
    "runtime": 1,
    "version": "OmitU",
    "screeningDate": "04.02.2009",
    "readableDate": "2009-02-04",
    "screeningTime": "20:00",
    "actors": "Alessio Boni, Donatella Finocchiaro, Valeria Solarino, Claudia Gerini, Marco Baliani, Emir Kusturica, Roebrto Herlitzka",
    "subtitle": [""],
    "bodycopy": [
      "Die Rückkehr Leos nach Sizilien wird zu seiner Selbstfindung. Die Insel hatte er mit seiner jüngeren Schwester vor 25 Jahren verlassen. Jetzt kommt nach und nach eintragisches und vergangenes Geheimnis ans Tageslicht, das ihrer beiden Leben geprägt hat. Wie beim Entflechten eines Zopfes tritt Verborgenes zutage, das Erinnerungen wecken, aber auch Schrecken und Leidenschaft verursachen kann."
    ],
    "image": "viaggio-segreto.jpg"
  },
  {
    "title": "VIVA LA LIBERTÀ (DIE GROSSE FREIHEIT)",
    "director": "Roberto Andò",
    "country": "Italien",
    "releaseYear": 2013,
    "runtime": 94,
    "version": "OmU",
    "screeningDate": "16.10.2014",
    "readableDate": "2014-10-16",
    "screeningTime": "20:00",
    "actors": "Toni Servillo, Valerio Mastandrea, Valeria Bruni Tedeschi, Michela Cescon, Anna Bonaiuto, Eric Nguyen, Judith Davis, Andrea Renzi, Massimo De Francovich, Renato Scarpa",
    "subtitle": [""],
    "bodycopy": [
      "„Sein Wahnsinn hat Methode“  (C’è del metodo nella sua follia) lautet der italienische Untertitel dieses Films. Tatsächlich hat Andò mit der Geschichte des zermürbten Politikers, der durch seinen verrückten Zwillingsbruder ersetzt wird und mit leeren Phrasen die Menschen hinter sich schart, eine unterhaltsame und tiefgründige Satire der Politik Italiens erschaffen."
    ],
    "image": "viva-la-liberta.jpg"
  },
  {
    "title": "WHAT IS LEFT",
    "director": "Gustav Hofer und Luca Ragazzi",
    "country": "Italien",
    "releaseYear": 2013,
    "runtime": 74,
    "version": "OmU",
    "screeningDate": "17.03.2014",
    "readableDate": "2014-03-17",
    "screeningTime": "20:00",
    "actors": "Lucia Mascino, Fabrizio Barca, Celeste Costantino",
    "subtitle": [""],
    "bodycopy": [
      "In ihrem neuen Film begeben sich die Autoren von ITALY – LOVE IT OR LEAVE IT in die Wirren der italienischen Politik. Nachdem die Hoffnungen der Mitte-Links-Wähler bei den Wahlen 2013 enttäuscht wurden, sind viele Italiener orientierungslos. Luca und Gustav beschreiben das Auf und Ab ihrer Gefühle in diesem politisch wichtigen Jahr und porträtieren unterhaltsam ein tief verunsichertes Land."
    ],
    "image": "what-is-left.jpg"
  },
  {
    "title": "ZORAN, IL MIO NIPOTE SCEMO (ZORAN – MEIN NEFFE, DER IDIOT)",
    "director": "Matteo Oleotto",
    "country": "Italien",
    "releaseYear": 2013,
    "runtime": 112,
    "version": "OmU",
    "screeningDate": "16.04.2015",
    "readableDate": "2015-04-16",
    "screeningTime": "20:00",
    "actors": "Giuseppe Battiston, Teco Celio, Rok Prasnikar, Roberto Citran, Marjuta Slamic, Riccardo Maranzana, Doina Komissarov",
    "subtitle": [""],
    "bodycopy": [
      "Vor dem sympathischen Versager Paolo, dem im Leben so ziemlich alles daneben gegangen ist, steht auf einmal der geistig zurückgebliebene 15-jährige Zoran, behauptet mit ihm verwandt zu sein und fordert von ihm die Vaterrolle ein. Anfänglich wenig begeistert, entdeckt er Zorans außergewöhnliche Fähigkeiten, die er zu seinem Vorteil nutzen will. Langsam aber kehren sich die Verhältnisse um und Zoran wacht über den unsteten Paolo."
    ],
    "image": "zoran-mio-nipote-scemo.jpg"
  }
]
